// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"jT2kU":[function(require,module,exports,__globalThis) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(this, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 11);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            function ParsedResult(result) {
                result = result || {};
                this.ref = result.ref;
                this.index = result.index;
                this.text = result.text;
                this.tags = result.tags || {};
                this.start = new ParsedComponents(result.start, result.ref);
                if (result.end) this.end = new ParsedComponents(result.end, result.ref);
            }
            ParsedResult.prototype.clone = function() {
                var result = new ParsedResult(this);
                result.tags = JSON.parse(JSON.stringify(this.tags));
                result.start = this.start.clone();
                if (this.end) result.end = this.end.clone();
                return result;
            };
            ParsedResult.prototype.date = function() {
                return this.start.date();
            };
            ParsedResult.prototype.hasPossibleDates = function() {
                return this.start.isPossibleDate() && (!this.end || this.end.isPossibleDate());
            };
            ParsedResult.prototype.isOnlyWeekday = function() {
                return this.start.isOnlyWeekdayComponent();
            };
            ParsedResult.prototype.isOnlyDayMonth = function() {
                return this.start.isOnlyDayMonthComponent();
            };
            function ParsedComponents(components, ref) {
                this.knownValues = {};
                this.impliedValues = {};
                if (components) for(var key in components)this.knownValues[key] = components[key];
                if (ref) {
                    ref = dayjs(ref);
                    this.imply('day', ref.date());
                    this.imply('month', ref.month() + 1);
                    this.imply('year', ref.year());
                }
                this.imply('hour', 12);
                this.imply('minute', 0);
                this.imply('second', 0);
                this.imply('millisecond', 0);
            }
            ParsedComponents.prototype.clone = function() {
                var component = new ParsedComponents();
                component.knownValues = JSON.parse(JSON.stringify(this.knownValues));
                component.impliedValues = JSON.parse(JSON.stringify(this.impliedValues));
                return component;
            };
            ParsedComponents.prototype.get = function(component, value) {
                if (component in this.knownValues) return this.knownValues[component];
                if (component in this.impliedValues) return this.impliedValues[component];
            };
            ParsedComponents.prototype.assign = function(component, value) {
                this.knownValues[component] = value;
                delete this.impliedValues[component];
            };
            ParsedComponents.prototype.imply = function(component, value) {
                if (component in this.knownValues) return;
                this.impliedValues[component] = value;
            };
            ParsedComponents.prototype.isCertain = function(component) {
                return component in this.knownValues;
            };
            ParsedComponents.prototype.isOnlyWeekdayComponent = function() {
                return this.isCertain('weekday') && !this.isCertain('day') && !this.isCertain('month');
            };
            ParsedComponents.prototype.isOnlyDayMonthComponent = function() {
                return this.isCertain('day') && this.isCertain('month') && !this.isCertain('year');
            };
            ParsedComponents.prototype.isPossibleDate = function() {
                var dateMoment = this.dayjs();
                if (this.isCertain('timezoneOffset')) {
                    var adjustTimezoneOffset = this.get('timezoneOffset') - dateMoment.utcOffset();
                    dateMoment = dateMoment.add(adjustTimezoneOffset, 'minutes');
                }
                if (dateMoment.get('year') != this.get('year')) return false;
                if (dateMoment.get('month') != this.get('month') - 1) return false;
                if (dateMoment.get('date') != this.get('day')) return false;
                if (dateMoment.get('hour') != this.get('hour')) return false;
                if (dateMoment.get('minute') != this.get('minute')) return false;
                return true;
            };
            ParsedComponents.prototype.date = function() {
                var result = this.dayjs();
                return result.toDate();
            };
            ParsedComponents.prototype.dayjs = function() {
                var result = dayjs();
                result = result.year(this.get('year'));
                result = result.month(this.get('month') - 1);
                result = result.date(this.get('day'));
                result = result.hour(this.get('hour'));
                result = result.minute(this.get('minute'));
                result = result.second(this.get('second'));
                result = result.millisecond(this.get('millisecond')); // Javascript Date Object return minus timezone offset
                var currentTimezoneOffset = result.utcOffset();
                var targetTimezoneOffset = this.get('timezoneOffset') !== undefined ? this.get('timezoneOffset') : currentTimezoneOffset;
                var adjustTimezoneOffset = targetTimezoneOffset - currentTimezoneOffset;
                result = result.add(-adjustTimezoneOffset, 'minute');
                return result;
            };
            ParsedComponents.prototype.moment = function() {
                // Keep for compatibility
                return this.dayjs();
            };
            exports.ParsedComponents = ParsedComponents;
            exports.ParsedResult = ParsedResult;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            exports.Parser = function(config) {
                config = config || {};
                var strictMode = config.strict;
                this.isStrictMode = function() {
                    return strictMode == true;
                };
                this.pattern = function() {
                    return /./i;
                };
                this.extract = function(text, ref, match, opt) {
                    return null;
                };
                this.execute = function(text, ref, opt) {
                    var results = [];
                    var regex = this.pattern();
                    var remainingText = text;
                    var match = regex.exec(remainingText);
                    while(match){
                        // Calculate match index on the full text;
                        match.index += text.length - remainingText.length;
                        var result = this.extract(text, ref, match, opt);
                        if (result) {
                            // If success, start from the end of the result
                            remainingText = text.substring(result.index + result.text.length);
                            if (!this.isStrictMode() || result.hasPossibleDates()) results.push(result);
                        } else // If fail, move on by 1
                        remainingText = text.substring(match.index + 1);
                        match = regex.exec(remainingText);
                    }
                    if (this.refiners) this.refiners.forEach(function() {
                        results = refiner.refine(results, text, options);
                    });
                    return results;
                };
            };
            exports.findYearClosestToRef = function(ref, day, month) {
                //Find the most appropriated year
                var refMoment = dayjs(ref);
                var dateMoment = refMoment;
                dateMoment = dateMoment.month(month - 1);
                dateMoment = dateMoment.date(day);
                dateMoment = dateMoment.year(refMoment.year());
                var nextYear = dateMoment.add(1, 'y');
                var lastYear = dateMoment.add(-1, 'y');
                if (Math.abs(nextYear.diff(refMoment)) < Math.abs(dateMoment.diff(refMoment))) dateMoment = nextYear;
                else if (Math.abs(lastYear.diff(refMoment)) < Math.abs(dateMoment.diff(refMoment))) dateMoment = lastYear;
                return dateMoment.year();
            };
            exports.ENISOFormatParser = __webpack_require__(13).Parser;
            exports.ENDeadlineFormatParser = __webpack_require__(14).Parser;
            exports.ENRelativeDateFormatParser = __webpack_require__(15).Parser;
            exports.ENMonthNameLittleEndianParser = __webpack_require__(16).Parser;
            exports.ENMonthNameMiddleEndianParser = __webpack_require__(17).Parser;
            exports.ENMonthNameParser = __webpack_require__(18).Parser;
            exports.ENSlashDateFormatParser = __webpack_require__(19).Parser;
            exports.ENSlashDateFormatStartWithYearParser = __webpack_require__(20).Parser;
            exports.ENSlashMonthFormatParser = __webpack_require__(21).Parser;
            exports.ENTimeAgoFormatParser = __webpack_require__(22).Parser;
            exports.ENTimeExpressionParser = __webpack_require__(23).Parser;
            exports.ENTimeLaterFormatParser = __webpack_require__(24).Parser;
            exports.ENWeekdayParser = __webpack_require__(5).Parser;
            exports.ENCasualDateParser = __webpack_require__(25).Parser;
            exports.ENCasualTimeParser = __webpack_require__(26).Parser;
            exports.JPStandardParser = __webpack_require__(27).Parser;
            exports.JPCasualDateParser = __webpack_require__(29).Parser;
            exports.PTCasualDateParser = __webpack_require__(30).Parser;
            exports.PTDeadlineFormatParser = __webpack_require__(31).Parser;
            exports.PTMonthNameLittleEndianParser = __webpack_require__(32).Parser;
            exports.PTSlashDateFormatParser = __webpack_require__(34).Parser;
            exports.PTTimeAgoFormatParser = __webpack_require__(35).Parser;
            exports.PTTimeExpressionParser = __webpack_require__(36).Parser;
            exports.PTWeekdayParser = __webpack_require__(37).Parser;
            exports.ESCasualDateParser = __webpack_require__(38).Parser;
            exports.ESDeadlineFormatParser = __webpack_require__(39).Parser;
            exports.ESTimeAgoFormatParser = __webpack_require__(40).Parser;
            exports.ESTimeExpressionParser = __webpack_require__(41).Parser;
            exports.ESWeekdayParser = __webpack_require__(42).Parser;
            exports.ESMonthNameLittleEndianParser = __webpack_require__(43).Parser;
            exports.ESSlashDateFormatParser = __webpack_require__(45).Parser;
            exports.FRCasualDateParser = __webpack_require__(46).Parser;
            exports.FRDeadlineFormatParser = __webpack_require__(47).Parser;
            exports.FRMonthNameLittleEndianParser = __webpack_require__(48).Parser;
            exports.FRSlashDateFormatParser = __webpack_require__(49).Parser;
            exports.FRTimeAgoFormatParser = __webpack_require__(50).Parser;
            exports.FRTimeExpressionParser = __webpack_require__(51).Parser;
            exports.FRWeekdayParser = __webpack_require__(52).Parser;
            exports.FRRelativeDateFormatParser = __webpack_require__(53).Parser;
            exports.ZHHantDateParser = __webpack_require__(55).Parser;
            exports.ZHHantWeekdayParser = __webpack_require__(56).Parser;
            exports.ZHHantTimeExpressionParser = __webpack_require__(57).Parser;
            exports.ZHHantCasualDateParser = __webpack_require__(58).Parser;
            exports.ZHHantDeadlineFormatParser = __webpack_require__(59).Parser;
            exports.DEDeadlineFormatParser = __webpack_require__(60).Parser;
            exports.DEMonthNameLittleEndianParser = __webpack_require__(61).Parser;
            exports.DEMonthNameParser = __webpack_require__(62).Parser;
            exports.DESlashDateFormatParser = __webpack_require__(63).Parser;
            exports.DETimeAgoFormatParser = __webpack_require__(64).Parser;
            exports.DETimeExpressionParser = __webpack_require__(65).Parser;
            exports.DEWeekdayParser = __webpack_require__(66).Parser;
            exports.DECasualDateParser = __webpack_require__(67).Parser;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            !function(t, n) {
                module1.exports = n();
            }(this, function() {
                "use strict";
                var t = "millisecond", n = "second", e = "minute", r = "hour", i = "day", s = "week", u = "month", o = "quarter", a = "year", h = /^(\d{4})-?(\d{1,2})-?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d{1,3})?$/, f = /\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, c = function(t, n, e) {
                    var r = String(t);
                    return !r || r.length >= n ? t : "" + Array(n + 1 - r.length).join(e) + t;
                }, d = {
                    s: c,
                    z: function(t) {
                        var n = -t.utcOffset(), e = Math.abs(n), r = Math.floor(e / 60), i = e % 60;
                        return (n <= 0 ? "+" : "-") + c(r, 2, "0") + ":" + c(i, 2, "0");
                    },
                    m: function(t, n) {
                        var e = 12 * (n.year() - t.year()) + (n.month() - t.month()), r = t.clone().add(e, u), i = n - r < 0, s = t.clone().add(e + (i ? -1 : 1), u);
                        return Number(-(e + (n - r) / (i ? r - s : s - r)) || 0);
                    },
                    a: function(t) {
                        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
                    },
                    p: function(h) {
                        return ({
                            M: u,
                            y: a,
                            w: s,
                            d: i,
                            D: "date",
                            h: r,
                            m: e,
                            s: n,
                            ms: t,
                            Q: o
                        })[h] || String(h || "").toLowerCase().replace(/s$/, "");
                    },
                    u: function(t) {
                        return void 0 === t;
                    }
                }, $ = {
                    name: "en",
                    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
                }, l = "en", m = {};
                m[l] = $;
                var y = function(t) {
                    return t instanceof v;
                }, M = function(t, n, e) {
                    var r;
                    if (!t) return l;
                    if ("string" == typeof t) m[t] && (r = t), n && (m[t] = n, r = t);
                    else {
                        var i = t.name;
                        m[i] = t, r = i;
                    }
                    return !e && r && (l = r), r || !e && l;
                }, g = function(t, n, e) {
                    if (y(t)) return t.clone();
                    var r = n ? "string" == typeof n ? {
                        format: n,
                        pl: e
                    } : n : {};
                    return r.date = t, new v(r);
                }, D = d;
                D.l = M, D.i = y, D.w = function(t, n) {
                    return g(t, {
                        locale: n.$L,
                        utc: n.$u,
                        $offset: n.$offset
                    });
                };
                var v = function() {
                    function c(t) {
                        this.$L = this.$L || M(t.locale, null, !0), this.parse(t);
                    }
                    var d = c.prototype;
                    return d.parse = function(t) {
                        this.$d = function(t) {
                            var n = t.date, e = t.utc;
                            if (null === n) return new Date(NaN);
                            if (D.u(n)) return new Date;
                            if (n instanceof Date) return new Date(n);
                            if ("string" == typeof n && !/Z$/i.test(n)) {
                                var r = n.match(h);
                                if (r) return e ? new Date(Date.UTC(r[1], r[2] - 1, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, r[7] || 0)) : new Date(r[1], r[2] - 1, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, r[7] || 0);
                            }
                            return new Date(n);
                        }(t), this.init();
                    }, d.init = function() {
                        var t = this.$d;
                        this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
                    }, d.$utils = function() {
                        return D;
                    }, d.isValid = function() {
                        return !("Invalid Date" === this.$d.toString());
                    }, d.isSame = function(t, n) {
                        var e = g(t);
                        return this.startOf(n) <= e && e <= this.endOf(n);
                    }, d.isAfter = function(t, n) {
                        return g(t) < this.startOf(n);
                    }, d.isBefore = function(t, n) {
                        return this.endOf(n) < g(t);
                    }, d.$g = function(t, n, e) {
                        return D.u(t) ? this[n] : this.set(e, t);
                    }, d.year = function(t) {
                        return this.$g(t, "$y", a);
                    }, d.month = function(t) {
                        return this.$g(t, "$M", u);
                    }, d.day = function(t) {
                        return this.$g(t, "$W", i);
                    }, d.date = function(t) {
                        return this.$g(t, "$D", "date");
                    }, d.hour = function(t) {
                        return this.$g(t, "$H", r);
                    }, d.minute = function(t) {
                        return this.$g(t, "$m", e);
                    }, d.second = function(t) {
                        return this.$g(t, "$s", n);
                    }, d.millisecond = function(n) {
                        return this.$g(n, "$ms", t);
                    }, d.unix = function() {
                        return Math.floor(this.valueOf() / 1e3);
                    }, d.valueOf = function() {
                        return this.$d.getTime();
                    }, d.startOf = function(t, o) {
                        var h = this, f = !!D.u(o) || o, c = D.p(t), d = function(t, n) {
                            var e = D.w(h.$u ? Date.UTC(h.$y, n, t) : new Date(h.$y, n, t), h);
                            return f ? e : e.endOf(i);
                        }, $ = function(t, n) {
                            return D.w(h.toDate()[t].apply(h.toDate("s"), (f ? [
                                0,
                                0,
                                0,
                                0
                            ] : [
                                23,
                                59,
                                59,
                                999
                            ]).slice(n)), h);
                        }, l = this.$W, m = this.$M, y = this.$D, M = "set" + (this.$u ? "UTC" : "");
                        switch(c){
                            case a:
                                return f ? d(1, 0) : d(31, 11);
                            case u:
                                return f ? d(1, m) : d(0, m + 1);
                            case s:
                                var g = this.$locale().weekStart || 0, v = (l < g ? l + 7 : l) - g;
                                return d(f ? y - v : y + (6 - v), m);
                            case i:
                            case "date":
                                return $(M + "Hours", 0);
                            case r:
                                return $(M + "Minutes", 1);
                            case e:
                                return $(M + "Seconds", 2);
                            case n:
                                return $(M + "Milliseconds", 3);
                            default:
                                return this.clone();
                        }
                    }, d.endOf = function(t) {
                        return this.startOf(t, !1);
                    }, d.$set = function(s, o) {
                        var h, f = D.p(s), c = "set" + (this.$u ? "UTC" : ""), d = (h = {}, h[i] = c + "Date", h.date = c + "Date", h[u] = c + "Month", h[a] = c + "FullYear", h[r] = c + "Hours", h[e] = c + "Minutes", h[n] = c + "Seconds", h[t] = c + "Milliseconds", h)[f], $ = f === i ? this.$D + (o - this.$W) : o;
                        if (f === u || f === a) {
                            var l = this.clone().set("date", 1);
                            l.$d[d]($), l.init(), this.$d = l.set("date", Math.min(this.$D, l.daysInMonth())).toDate();
                        } else d && this.$d[d]($);
                        return this.init(), this;
                    }, d.set = function(t, n) {
                        return this.clone().$set(t, n);
                    }, d.get = function(t) {
                        return this[D.p(t)]();
                    }, d.add = function(t, o) {
                        var h, f = this;
                        t = Number(t);
                        var c = D.p(o), d = function(n) {
                            var e = g(f);
                            return D.w(e.date(e.date() + Math.round(n * t)), f);
                        };
                        if (c === u) return this.set(u, this.$M + t);
                        if (c === a) return this.set(a, this.$y + t);
                        if (c === i) return d(1);
                        if (c === s) return d(7);
                        var $ = (h = {}, h[e] = 6e4, h[r] = 36e5, h[n] = 1e3, h)[c] || 1, l = this.$d.getTime() + t * $;
                        return D.w(l, this);
                    }, d.subtract = function(t, n) {
                        return this.add(-1 * t, n);
                    }, d.format = function(t) {
                        var n = this;
                        if (!this.isValid()) return "Invalid Date";
                        var e = t || "YYYY-MM-DDTHH:mm:ssZ", r = D.z(this), i = this.$locale(), s = this.$H, u = this.$m, o = this.$M, a = i.weekdays, h = i.months, c = function(t, r, i, s) {
                            return t && (t[r] || t(n, e)) || i[r].substr(0, s);
                        }, d = function(t) {
                            return D.s(s % 12 || 12, t, "0");
                        }, $ = i.meridiem || function(t, n, e) {
                            var r = t < 12 ? "AM" : "PM";
                            return e ? r.toLowerCase() : r;
                        }, l = {
                            YY: String(this.$y).slice(-2),
                            YYYY: this.$y,
                            M: o + 1,
                            MM: D.s(o + 1, 2, "0"),
                            MMM: c(i.monthsShort, o, h, 3),
                            MMMM: h[o] || h(this, e),
                            D: this.$D,
                            DD: D.s(this.$D, 2, "0"),
                            d: String(this.$W),
                            dd: c(i.weekdaysMin, this.$W, a, 2),
                            ddd: c(i.weekdaysShort, this.$W, a, 3),
                            dddd: a[this.$W],
                            H: String(s),
                            HH: D.s(s, 2, "0"),
                            h: d(1),
                            hh: d(2),
                            a: $(s, u, !0),
                            A: $(s, u, !1),
                            m: String(u),
                            mm: D.s(u, 2, "0"),
                            s: String(this.$s),
                            ss: D.s(this.$s, 2, "0"),
                            SSS: D.s(this.$ms, 3, "0"),
                            Z: r
                        };
                        return e.replace(f, function(t, n) {
                            return n || l[t] || r.replace(":", "");
                        });
                    }, d.utcOffset = function() {
                        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
                    }, d.diff = function(t, h, f) {
                        var c, d = D.p(h), $ = g(t), l = 6e4 * ($.utcOffset() - this.utcOffset()), m = this - $, y = D.m(this, $);
                        return y = (c = {}, c[a] = y / 12, c[u] = y, c[o] = y / 3, c[s] = (m - l) / 6048e5, c[i] = (m - l) / 864e5, c[r] = m / 36e5, c[e] = m / 6e4, c[n] = m / 1e3, c)[d] || m, f ? y : D.a(y);
                    }, d.daysInMonth = function() {
                        return this.endOf(u).$D;
                    }, d.$locale = function() {
                        return m[this.$L];
                    }, d.locale = function(t, n) {
                        if (!t) return this.$L;
                        var e = this.clone(), r = M(t, n, !0);
                        return r && (e.$L = r), e;
                    }, d.clone = function() {
                        return D.w(this.$d, this);
                    }, d.toDate = function() {
                        return new Date(this.valueOf());
                    }, d.toJSON = function() {
                        return this.isValid() ? this.toISOString() : null;
                    }, d.toISOString = function() {
                        return this.$d.toISOString();
                    }, d.toString = function() {
                        return this.$d.toUTCString();
                    }, c;
                }();
                return g.prototype = v.prototype, g.extend = function(t, n) {
                    return t(n, v, g), g;
                }, g.locale = M, g.isDayjs = y, g.unix = function(t) {
                    return g(1e3 * t);
                }, g.en = m[l], g.Ls = m, g;
            });
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            exports.Refiner = function Refiner() {
                this.refine = function(text, results, opt) {
                    return results;
                };
            };
            exports.Filter = function Filter() {
                exports.Refiner.call(this);
                this.isValid = function(text, result, opt) {
                    return true;
                };
                this.refine = function(text, results, opt) {
                    var filteredResult = [];
                    for(var i = 0; i < results.length; i++){
                        var result = results[i];
                        if (this.isValid(text, result, opt)) filteredResult.push(result);
                    }
                    return filteredResult;
                };
            }; // Common refiners
            exports.OverlapRemovalRefiner = __webpack_require__(68).Refiner;
            exports.ExtractTimezoneOffsetRefiner = __webpack_require__(69).Refiner;
            exports.ExtractTimezoneAbbrRefiner = __webpack_require__(70).Refiner;
            exports.ForwardDateRefiner = __webpack_require__(71).Refiner;
            exports.UnlikelyFormatFilter = __webpack_require__(72).Refiner; // en refiners
            exports.ENMergeDateTimeRefiner = __webpack_require__(6).Refiner;
            exports.ENMergeDateRangeRefiner = __webpack_require__(10).Refiner;
            exports.ENPrioritizeSpecificDateRefiner = __webpack_require__(73).Refiner; // ja refiners
            exports.JPMergeDateRangeRefiner = __webpack_require__(74).Refiner; // fr refiners
            exports.FRMergeDateRangeRefiner = __webpack_require__(75).Refiner;
            exports.FRMergeDateTimeRefiner = __webpack_require__(76).Refiner; // de refiners
            exports.DEMergeDateRangeRefiner = __webpack_require__(77).Refiner;
            exports.DEMergeDateTimeRefiner = __webpack_require__(78).Refiner;
        /***/ },
        /* 4 */ /***/ function(module1, exports) {
            exports.WEEKDAY_OFFSET = {
                'sunday': 0,
                'sun': 0,
                'monday': 1,
                'mon': 1,
                'tuesday': 2,
                'tue': 2,
                'wednesday': 3,
                'wed': 3,
                'thursday': 4,
                'thur': 4,
                'thu': 4,
                'friday': 5,
                'fri': 5,
                'saturday': 6,
                'sat': 6
            };
            exports.MONTH_OFFSET = {
                'january': 1,
                'jan': 1,
                'jan.': 1,
                'february': 2,
                'feb': 2,
                'feb.': 2,
                'march': 3,
                'mar': 3,
                'mar.': 3,
                'april': 4,
                'apr': 4,
                'apr.': 4,
                'may': 5,
                'june': 6,
                'jun': 6,
                'jun.': 6,
                'july': 7,
                'jul': 7,
                'jul.': 7,
                'august': 8,
                'aug': 8,
                'aug.': 8,
                'september': 9,
                'sep': 9,
                'sep.': 9,
                'sept': 9,
                'sept.': 9,
                'october': 10,
                'oct': 10,
                'oct.': 10,
                'november': 11,
                'nov': 11,
                'nov.': 11,
                'december': 12,
                'dec': 12,
                'dec.': 12
            };
            exports.MONTH_PATTERN = '(?:' + Object.keys(exports.MONTH_OFFSET).join('|').replace(/\./g, '\\.') + ')';
            exports.INTEGER_WORDS = {
                'one': 1,
                'two': 2,
                'three': 3,
                'four': 4,
                'five': 5,
                'six': 6,
                'seven': 7,
                'eight': 8,
                'nine': 9,
                'ten': 10,
                'eleven': 11,
                'twelve': 12
            };
            exports.INTEGER_WORDS_PATTERN = '(?:' + Object.keys(exports.INTEGER_WORDS).join('|') + ')';
            exports.ORDINAL_WORDS = {
                'first': 1,
                'second': 2,
                'third': 3,
                'fourth': 4,
                'fifth': 5,
                'sixth': 6,
                'seventh': 7,
                'eighth': 8,
                'ninth': 9,
                'tenth': 10,
                'eleventh': 11,
                'twelfth': 12,
                'thirteenth': 13,
                'fourteenth': 14,
                'fifteenth': 15,
                'sixteenth': 16,
                'seventeenth': 17,
                'eighteenth': 18,
                'nineteenth': 19,
                'twentieth': 20,
                'twenty first': 21,
                'twenty second': 22,
                'twenty third': 23,
                'twenty fourth': 24,
                'twenty fifth': 25,
                'twenty sixth': 26,
                'twenty seventh': 27,
                'twenty eighth': 28,
                'twenty ninth': 29,
                'thirtieth': 30,
                'thirty first': 31
            };
            exports.ORDINAL_WORDS_PATTERN = '(?:' + Object.keys(exports.ORDINAL_WORDS).join('|').replace(/ /g, '[ -]') + ')';
            var TIME_UNIT = '(' + exports.INTEGER_WORDS_PATTERN + '|[0-9]+|[0-9]+\.[0-9]+|an?(?:\\s*few)?|half(?:\\s*an?)?)\\s*' + '(sec(?:onds?)?|min(?:ute)?s?|h(?:r|rs|our|ours)?|weeks?|days?|months?|years?|fortnights?)\\s*';
            var TIME_UNIT_STRICT = "(?:[0-9]+|an?)\\s*(?:seconds?|minutes?|hours?|days?|fortnights?)\\s*";
            var PATTERN_TIME_UNIT = new RegExp(TIME_UNIT, 'i');
            exports.TIME_UNIT_PATTERN = '(?:' + TIME_UNIT + ')+';
            exports.TIME_UNIT_STRICT_PATTERN = '(?:' + TIME_UNIT_STRICT + ')+';
            exports.extractDateTimeUnitFragments = function(timeunitText) {
                var fragments = {};
                var remainingText = timeunitText;
                var match = PATTERN_TIME_UNIT.exec(remainingText);
                while(match){
                    collectDateTimeFragment(match, fragments);
                    remainingText = remainingText.substring(match[0].length);
                    match = PATTERN_TIME_UNIT.exec(remainingText);
                }
                return fragments;
            };
            function collectDateTimeFragment(match, fragments) {
                var num = match[1].toLowerCase();
                if (exports.INTEGER_WORDS[num] !== undefined) num = exports.INTEGER_WORDS[num];
                else if (num === 'a' || num === 'an') num = 1;
                else if (num.match(/few/)) num = 3;
                else if (num.match(/half/)) num = 0.5;
                else num = parseFloat(num);
                if (match[2].match(/^h/i)) fragments['hour'] = num;
                else if (match[2].match(/min/i)) fragments['minute'] = num;
                else if (match[2].match(/sec/i)) fragments['second'] = num;
                else if (match[2].match(/week/i)) fragments['week'] = num;
                else if (match[2].match(/day/i)) fragments['d'] = num;
                else if (match[2].match(/month/i)) fragments['month'] = num;
                else if (match[2].match(/year/i)) fragments['year'] = num;
                else if (match[2].match(/fortnight/i)) fragments['week'] = num * 2;
                return fragments;
            }
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var DAYS_OFFSET = {
                'sunday': 0,
                'sun': 0,
                'monday': 1,
                'mon': 1,
                'tuesday': 2,
                'tues': 2,
                'tue': 2,
                'wednesday': 3,
                'wed': 3,
                'thursday': 4,
                'thurs': 4,
                'thur': 4,
                'thu': 4,
                'friday': 5,
                'fri': 5,
                'saturday': 6,
                'sat': 6
            };
            var PATTERN = new RegExp("(\\W|^)(?:(?:\\,|\\(|\\\uFF08)\\s*)?(?:on\\s*?)?(?:(this|last|past|next)\\s*)?(" + Object.keys(DAYS_OFFSET).join('|') + ')' + "(?:\\s*(?:\\,|\\)|\\\uFF09))?" + '(?:\\s*(this|last|past|next)\\s*week)?' + '(?=\\W|$)', 'i');
            var PREFIX_GROUP = 2;
            var WEEKDAY_GROUP = 3;
            var POSTFIX_GROUP = 4;
            exports.updateParsedComponent = function updateParsedComponent(result, ref, offset, modifier) {
                var startMoment = dayjs(ref);
                var startMomentFixed = false;
                var refOffset = startMoment.day();
                if (modifier == 'last' || modifier == 'past') {
                    startMoment = startMoment.day(offset - 7);
                    startMomentFixed = true;
                } else if (modifier == 'next') {
                    startMoment = startMoment.day(offset + 7);
                    startMomentFixed = true;
                } else if (modifier == 'this') startMoment = startMoment.day(offset);
                else {
                    if (Math.abs(offset - 7 - refOffset) < Math.abs(offset - refOffset)) startMoment = startMoment.day(offset - 7);
                    else if (Math.abs(offset + 7 - refOffset) < Math.abs(offset - refOffset)) startMoment = startMoment.day(offset + 7);
                    else startMoment = startMoment.day(offset);
                }
                result.start.assign('weekday', offset);
                if (startMomentFixed) {
                    result.start.assign('day', startMoment.date());
                    result.start.assign('month', startMoment.month() + 1);
                    result.start.assign('year', startMoment.year());
                } else {
                    result.start.imply('day', startMoment.date());
                    result.start.imply('month', startMoment.month() + 1);
                    result.start.imply('year', startMoment.year());
                }
                return result;
            };
            exports.Parser = function ENWeekdayParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
                    var offset = DAYS_OFFSET[dayOfWeek];
                    if (offset === undefined) return null;
                    var prefix = match[PREFIX_GROUP];
                    var postfix = match[POSTFIX_GROUP];
                    var norm = prefix || postfix;
                    norm = norm || '';
                    norm = norm.toLowerCase();
                    exports.updateParsedComponent(result, ref, offset, norm);
                    result.tags['ENWeekdayParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    
*/ var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var Refiner = __webpack_require__(3).Refiner;
            var PATTERN = new RegExp("^\\s*(T|at|after|before|on|of|,|-)?\\s*$");
            var isDateOnly = exports.isDateOnly = function(result) {
                return !result.start.isCertain('hour');
            };
            var isTimeOnly = exports.isTimeOnly = function(result) {
                return !result.start.isCertain('month') && !result.start.isCertain('weekday');
            };
            var isAbleToMerge = exports.isAbleToMerge = function(text, prevResult, curResult) {
                var textBetween = text.substring(prevResult.index + prevResult.text.length, curResult.index);
                return textBetween.match(PATTERN);
            };
            var mergeDateTimeComponent = exports.mergeDateTimeComponent = function(dateComponent, timeComponent) {
                var dateTimeComponent = dateComponent.clone();
                if (timeComponent.isCertain('hour')) {
                    dateTimeComponent.assign('hour', timeComponent.get('hour'));
                    dateTimeComponent.assign('minute', timeComponent.get('minute'));
                    if (timeComponent.isCertain('second')) {
                        dateTimeComponent.assign('second', timeComponent.get('second'));
                        if (timeComponent.isCertain('millisecond')) dateTimeComponent.assign('millisecond', timeComponent.get('millisecond'));
                        else dateTimeComponent.imply('millisecond', timeComponent.get('millisecond'));
                    } else {
                        dateTimeComponent.imply('second', timeComponent.get('second'));
                        dateTimeComponent.imply('millisecond', timeComponent.get('millisecond'));
                    }
                } else {
                    dateTimeComponent.imply('hour', timeComponent.get('hour'));
                    dateTimeComponent.imply('minute', timeComponent.get('minute'));
                    dateTimeComponent.imply('second', timeComponent.get('second'));
                    dateTimeComponent.imply('millisecond', timeComponent.get('millisecond'));
                }
                if (timeComponent.isCertain('meridiem')) dateTimeComponent.assign('meridiem', timeComponent.get('meridiem'));
                else if (timeComponent.get('meridiem') !== undefined && dateTimeComponent.get('meridiem') === undefined) dateTimeComponent.imply('meridiem', timeComponent.get('meridiem'));
                if (dateTimeComponent.get('meridiem') == 1 && dateTimeComponent.get('hour') < 12) {
                    if (timeComponent.isCertain('hour')) dateTimeComponent.assign('hour', dateTimeComponent.get('hour') + 12);
                    else dateTimeComponent.imply('hour', dateTimeComponent.get('hour') + 12);
                }
                return dateTimeComponent;
            };
            function mergeResult(text, dateResult, timeResult) {
                var beginDate = dateResult.start;
                var beginTime = timeResult.start;
                var beginDateTime = mergeDateTimeComponent(beginDate, beginTime);
                if (dateResult.end != null || timeResult.end != null) {
                    var endDate = dateResult.end == null ? dateResult.start : dateResult.end;
                    var endTime = timeResult.end == null ? timeResult.start : timeResult.end;
                    var endDateTime = mergeDateTimeComponent(endDate, endTime);
                    if (dateResult.end == null && endDateTime.date().getTime() < beginDateTime.date().getTime()) {
                        // Ex. 9pm - 1am
                        if (endDateTime.isCertain('day')) endDateTime.assign('day', endDateTime.get('day') + 1);
                        else endDateTime.imply('day', endDateTime.get('day') + 1);
                    }
                    dateResult.end = endDateTime;
                }
                dateResult.start = beginDateTime;
                var startIndex = Math.min(dateResult.index, timeResult.index);
                var endIndex = Math.max(dateResult.index + dateResult.text.length, timeResult.index + timeResult.text.length);
                dateResult.index = startIndex;
                dateResult.text = text.substring(startIndex, endIndex);
                for(var tag in timeResult.tags)dateResult.tags[tag] = true;
                dateResult.tags['ENMergeDateAndTimeRefiner'] = true;
                return dateResult;
            }
            exports.Refiner = function ENMergeDateTimeRefiner() {
                Refiner.call(this);
                this.refine = function(text, results, opt) {
                    if (results.length < 2) return results;
                    var mergedResult = [];
                    var currResult = null;
                    var prevResult = null;
                    for(var i = 1; i < results.length; i++){
                        currResult = results[i];
                        prevResult = results[i - 1];
                        if (isDateOnly(prevResult) && isTimeOnly(currResult) && isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = mergeResult(text, prevResult, currResult);
                            currResult = results[i + 1];
                            i += 1;
                        } else if (isDateOnly(currResult) && isTimeOnly(prevResult) && isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = mergeResult(text, currResult, prevResult);
                            currResult = results[i + 1];
                            i += 1;
                        }
                        mergedResult.push(prevResult);
                    }
                    if (currResult != null) mergedResult.push(currResult);
                    return mergedResult;
                };
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports) {
            var NUMBER = {
                "\u96F6": 0,
                "\u4E00": 1,
                "\u4E8C": 2,
                "\u5169": 2,
                "\u4E09": 3,
                "\u56DB": 4,
                "\u4E94": 5,
                "\u516D": 6,
                "\u4E03": 7,
                "\u516B": 8,
                "\u4E5D": 9,
                "\u5341": 10,
                "\u5EFF": 20,
                "\u5345": 30
            };
            var WEEKDAY_OFFSET = {
                "\u5929": 0,
                "\u65E5": 0,
                "\u4E00": 1,
                "\u4E8C": 2,
                "\u4E09": 3,
                "\u56DB": 4,
                "\u4E94": 5,
                "\u516D": 6
            };
            exports.NUMBER = NUMBER;
            exports.WEEKDAY_OFFSET = WEEKDAY_OFFSET;
            exports.zhStringToNumber = function(text) {
                var number = 0;
                for(var i = 0; i < text.length; i++){
                    var _char = text[i];
                    if (_char === "\u5341") number = number === 0 ? NUMBER[_char] : number * NUMBER[_char];
                    else number += NUMBER[_char];
                }
                return number;
            };
            exports.zhStringToYear = function(text) {
                var string = '';
                for(var i = 0; i < text.length; i++){
                    var _char2 = text[i];
                    string = string + NUMBER[_char2];
                }
                return parseInt(string);
            };
        /***/ },
        /* 8 */ /***/ function(module1, exports) {
            exports.WEEKDAY_OFFSET = {
                'sonntag': 0,
                'so': 0,
                'montag': 1,
                'mo': 1,
                'dienstag': 2,
                'di': 2,
                'mittwoch': 3,
                'mi': 3,
                'donnerstag': 4,
                'do': 4,
                'freitag': 5,
                'fr': 5,
                'samstag': 6,
                'sa': 6
            };
            exports.MONTH_OFFSET = {
                'januar': 1,
                'jan': 1,
                'jan.': 1,
                'februar': 2,
                'feb': 2,
                'feb.': 2,
                "m\xe4rz": 3,
                'maerz': 3,
                "m\xe4r": 3,
                "m\xe4r.": 3,
                'mrz': 3,
                'mrz.': 3,
                'april': 4,
                'apr': 4,
                'apr.': 4,
                'mai': 5,
                'juni': 6,
                'jun': 6,
                'jun.': 6,
                'juli': 7,
                'jul': 7,
                'jul.': 7,
                'august': 8,
                'aug': 8,
                'aug.': 8,
                'september': 9,
                'sep': 9,
                'sep.': 9,
                'sept': 9,
                'sept.': 9,
                'oktober': 10,
                'okt': 10,
                'okt.': 10,
                'november': 11,
                'nov': 11,
                'nov.': 11,
                'dezember': 12,
                'dez': 12,
                'dez.': 12
            };
            exports.INTEGER_WORDS_PATTERN = "(?:eins|zwei|drei|vier|f\xfcnf|fuenf|sechs|sieben|acht|neun|zehn|elf|zw\xf6lf|zwoelf)";
            exports.INTEGER_WORDS = {
                'eins': 1,
                'zwei': 2,
                'drei': 3,
                'vier': 4,
                "f\xfcnf": 5,
                'fuenf': 5,
                'sechs': 6,
                'sieben': 7,
                'acht': 8,
                'neun': 9,
                'zehn': 10,
                'elf': 11,
                "zw\xf6lf": 12,
                'zwoelf': 12
            };
        /***/ },
        /* 9 */ /***/ function(module1, exports) {
            exports.WEEKDAY_OFFSET = {
                'dimanche': 0,
                'dim': 0,
                'lundi': 1,
                'lun': 1,
                'mardi': 2,
                'mar': 2,
                'mercredi': 3,
                'mer': 3,
                'jeudi': 4,
                'jeu': 4,
                'vendredi': 5,
                'ven': 5,
                'samedi': 6,
                'sam': 6
            };
            exports.MONTH_OFFSET = {
                'janvier': 1,
                'jan': 1,
                'jan.': 1,
                "f\xe9vrier": 2,
                "f\xe9v": 2,
                "f\xe9v.": 2,
                'fevrier': 2,
                'fev': 2,
                'fev.': 2,
                'mars': 3,
                'mar': 3,
                'mar.': 3,
                'avril': 4,
                'avr': 4,
                'avr.': 4,
                'mai': 5,
                'juin': 6,
                'jun': 6,
                'juillet': 7,
                'jul': 7,
                'jul.': 7,
                "ao\xfbt": 8,
                'aout': 8,
                'septembre': 9,
                'sep': 9,
                'sep.': 9,
                'sept': 9,
                'sept.': 9,
                'octobre': 10,
                'oct': 10,
                'oct.': 10,
                'novembre': 11,
                'nov': 11,
                'nov.': 11,
                "d\xe9cembre": 12,
                'decembre': 12,
                'dec': 12,
                'dec.': 12
            };
            exports.INTEGER_WORDS_PATTERN = '(?:un|deux|trois|quatre|cinq|six|sept|huit|neuf|dix|onze|douze|treize)';
            exports.INTEGER_WORDS = {
                'un': 1,
                'deux': 2,
                'trois': 3,
                'quatre': 4,
                'cinq': 5,
                'six': 6,
                'sept': 7,
                'huit': 8,
                'neuf': 9,
                'dix': 10,
                'onze': 11,
                'douze': 12,
                'treize': 13
            };
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            /*
  
*/ var Refiner = __webpack_require__(3).Refiner;
            exports.Refiner = function ENMergeDateRangeRefiner() {
                Refiner.call(this);
                this.pattern = function() {
                    return /^\s*(to|\-)\s*$/i;
                };
                this.refine = function(text, results, opt) {
                    if (results.length < 2) return results;
                    var mergedResult = [];
                    var currResult = null;
                    var prevResult = null;
                    for(var i = 1; i < results.length; i++){
                        currResult = results[i];
                        prevResult = results[i - 1];
                        if (!prevResult.end && !currResult.end && this.isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = this.mergeResult(text, prevResult, currResult);
                            currResult = null;
                            i += 1;
                        }
                        mergedResult.push(prevResult);
                    }
                    if (currResult != null) mergedResult.push(currResult);
                    return mergedResult;
                };
                this.isAbleToMerge = function(text, result1, result2) {
                    var begin = result1.index + result1.text.length;
                    var end = result2.index;
                    var textBetween = text.substring(begin, end);
                    return textBetween.match(this.pattern());
                };
                this.mergeResult = function(text, fromResult, toResult) {
                    if (!fromResult.isOnlyWeekday() && !toResult.isOnlyWeekday()) {
                        var timeKeys = {
                            'hour': true,
                            'minute': true,
                            'second': true
                        };
                        for(var key in toResult.start.knownValues)if (!fromResult.start.isCertain(key)) fromResult.start.assign(key, toResult.start.get(key));
                        for(var key in fromResult.start.knownValues)if (!toResult.start.isCertain(key)) toResult.start.assign(key, fromResult.start.get(key));
                    }
                    if (fromResult.start.date().getTime() > toResult.start.date().getTime()) {
                        var fromMoment = fromResult.start.dayjs();
                        var toMoment = toResult.start.dayjs();
                        if (fromResult.isOnlyWeekday() && fromMoment.add(-7, 'days').isBefore(toMoment)) {
                            fromMoment = fromMoment.add(-7, 'days');
                            fromResult.start.imply('day', fromMoment.date());
                            fromResult.start.imply('month', fromMoment.month() + 1);
                            fromResult.start.imply('year', fromMoment.year());
                        } else if (toResult.isOnlyWeekday() && toMoment.add(7, 'days').isAfter(fromMoment)) {
                            toMoment = toMoment.add(7, 'days');
                            toResult.start.imply('day', toMoment.date());
                            toResult.start.imply('month', toMoment.month() + 1);
                            toResult.start.imply('year', toMoment.year());
                        } else {
                            var tmp = toResult;
                            toResult = fromResult;
                            fromResult = tmp;
                        }
                    }
                    fromResult.end = toResult.start;
                    for(var tag in toResult.tags)fromResult.tags[tag] = true;
                    var startIndex = Math.min(fromResult.index, toResult.index);
                    var endIndex = Math.max(fromResult.index + fromResult.text.length, toResult.index + toResult.text.length);
                    fromResult.index = startIndex;
                    fromResult.text = text.substring(startIndex, endIndex);
                    fromResult.tags[this.constructor.name] = true;
                    return fromResult;
                };
            };
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            var options1 = exports.options = __webpack_require__(12);
            exports.parser = __webpack_require__(1);
            exports.refiner = __webpack_require__(3);
            exports.Parser = exports.parser.Parser;
            exports.Refiner = exports.refiner.Refiner;
            exports.Filter = exports.refiner.Filter;
            exports.ParsedResult = __webpack_require__(0).ParsedResult;
            exports.ParsedComponents = __webpack_require__(0).ParsedComponents;
            var Chrono = function Chrono(option) {
                option = option || exports.options.casualOption();
                this.parsers = new Object(option.parsers);
                this.refiners = new Object(option.refiners);
            };
            Chrono.prototype.parse = function(text, refDate, opt) {
                refDate = refDate || new Date();
                opt = opt || {};
                opt.forwardDate = opt.forwardDate || opt.forwardDate;
                var allResults = [];
                this.parsers.forEach(function(parser) {
                    var results = parser.execute(text, refDate, opt);
                    allResults = allResults.concat(results);
                });
                allResults.sort(function(a, b) {
                    return a.index - b.index;
                });
                this.refiners.forEach(function(refiner1) {
                    allResults = refiner1.refine(text, allResults, opt);
                });
                return allResults;
            };
            Chrono.prototype.parseDate = function(text, refDate, opt) {
                var results = this.parse(text, refDate, opt);
                if (results.length > 0) return results[0].start.date();
                return null;
            };
            exports.Chrono = Chrono;
            exports.strict = new Chrono(options1.strictOption());
            exports.casual = new Chrono(options1.casualOption());
            exports.en = new Chrono(options1.mergeOptions([
                options1.en.casual,
                options1.commonPostProcessing
            ]));
            exports.en_GB = new Chrono(options1.mergeOptions([
                options1.en_GB.casual,
                options1.commonPostProcessing
            ]));
            exports.de = new Chrono(options1.mergeOptions([
                options1.de.casual,
                options1.en,
                options1.commonPostProcessing
            ]));
            exports.pt = new Chrono(options1.mergeOptions([
                options1.pt.casual,
                options1.en,
                options1.commonPostProcessing
            ]));
            exports.es = new Chrono(options1.mergeOptions([
                options1.es.casual,
                options1.en,
                options1.commonPostProcessing
            ]));
            exports.fr = new Chrono(options1.mergeOptions([
                options1.fr.casual,
                options1.en,
                options1.commonPostProcessing
            ]));
            exports.ja = new Chrono(options1.mergeOptions([
                options1.ja.casual,
                options1.en,
                options1.commonPostProcessing
            ]));
            exports.parse = function() {
                return exports.casual.parse.apply(exports.casual, arguments);
            };
            exports.parseDate = function() {
                return exports.casual.parseDate.apply(exports.casual, arguments);
            };
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            var parser = __webpack_require__(1);
            var refiner1 = __webpack_require__(3);
            exports.mergeOptions = function(options1) {
                var addedTypes = {};
                var mergedOption = {
                    parsers: [],
                    refiners: []
                };
                options1.forEach(function(option) {
                    if (option.call) option = option.call();
                    if (option.parsers) option.parsers.forEach(function(p) {
                        if (!addedTypes[p.constructor]) {
                            mergedOption.parsers.push(p);
                            addedTypes[p.constructor] = true;
                        }
                    });
                    if (option.refiners) option.refiners.forEach(function(r) {
                        if (!addedTypes[r.constructor]) {
                            mergedOption.refiners.push(r);
                            addedTypes[r.constructor] = true;
                        }
                    });
                });
                return mergedOption;
            };
            exports.commonPostProcessing = function() {
                return {
                    refiners: [
                        new refiner1.ExtractTimezoneOffsetRefiner(),
                        new refiner1.ExtractTimezoneAbbrRefiner(),
                        new refiner1.UnlikelyFormatFilter()
                    ]
                };
            }; // -------------------------------------------------------------
            exports.strictOption = function() {
                var strictConfig = {
                    strict: true
                };
                return exports.mergeOptions([
                    exports.en(strictConfig),
                    exports.de(strictConfig),
                    exports.pt(strictConfig),
                    exports.es(strictConfig),
                    exports.fr(strictConfig),
                    exports.ja(strictConfig),
                    exports.zh,
                    exports.commonPostProcessing
                ]);
            };
            exports.casualOption = function() {
                return exports.mergeOptions([
                    exports.en.casual,
                    exports.de({
                        strict: true
                    }),
                    exports.pt,
                    exports.es,
                    exports.fr,
                    exports.ja,
                    exports.zh,
                    exports.commonPostProcessing
                ]);
            }; // -------------------------------------------------------------
            exports.de = function(config) {
                return {
                    parsers: [
                        new parser.DEDeadlineFormatParser(config),
                        new parser.DEMonthNameLittleEndianParser(config),
                        new parser.DEMonthNameParser(config),
                        new parser.DESlashDateFormatParser(config),
                        new parser.DETimeAgoFormatParser(config),
                        new parser.DETimeExpressionParser(config)
                    ],
                    refiners: [
                        new refiner1.OverlapRemovalRefiner(),
                        new refiner1.ForwardDateRefiner(),
                        new refiner1.DEMergeDateTimeRefiner(),
                        new refiner1.DEMergeDateRangeRefiner()
                    ]
                };
            };
            exports.de.casual = function() {
                var option = exports.de({
                    strict: false
                });
                option.parsers.unshift(new parser.DECasualDateParser());
                option.parsers.unshift(new parser.DEWeekdayParser());
                return option;
            }; // -------------------------------------------------------------
            exports.en = function(config) {
                return {
                    parsers: [
                        new parser.ENISOFormatParser(config),
                        new parser.ENDeadlineFormatParser(config),
                        new parser.ENMonthNameLittleEndianParser(config),
                        new parser.ENMonthNameMiddleEndianParser(config),
                        new parser.ENMonthNameParser(config),
                        new parser.ENSlashDateFormatParser(config),
                        new parser.ENSlashDateFormatStartWithYearParser(config),
                        new parser.ENSlashMonthFormatParser(config),
                        new parser.ENTimeAgoFormatParser(config),
                        new parser.ENTimeLaterFormatParser(config),
                        new parser.ENTimeExpressionParser(config)
                    ],
                    refiners: [
                        new refiner1.OverlapRemovalRefiner(),
                        new refiner1.ForwardDateRefiner(),
                        new refiner1.ENMergeDateTimeRefiner(),
                        new refiner1.ENMergeDateRangeRefiner(),
                        new refiner1.ENPrioritizeSpecificDateRefiner()
                    ]
                };
            };
            exports.en.casual = function(config) {
                config = config || {};
                config.strict = false;
                var option = exports.en(config); // en
                option.parsers.unshift(new parser.ENCasualDateParser());
                option.parsers.unshift(new parser.ENCasualTimeParser());
                option.parsers.unshift(new parser.ENWeekdayParser());
                option.parsers.unshift(new parser.ENRelativeDateFormatParser());
                return option;
            };
            exports.en_GB = function(config) {
                config = config || {};
                config.littleEndian = true;
                return exports.en(config);
            };
            exports.en_GB.casual = function(config) {
                config = config || {};
                config.littleEndian = true;
                return exports.en.casual(config);
            }; // -------------------------------------------------------------
            exports.ja = function() {
                return {
                    parsers: [
                        new parser.JPStandardParser()
                    ],
                    refiners: [
                        new refiner1.OverlapRemovalRefiner(),
                        new refiner1.ForwardDateRefiner(),
                        new refiner1.JPMergeDateRangeRefiner()
                    ]
                };
            };
            exports.ja.casual = function() {
                var option = exports.ja();
                option.parsers.unshift(new parser.JPCasualDateParser());
                return option;
            }; // -------------------------------------------------------------
            exports.pt = function(config) {
                return {
                    parsers: [
                        new parser.PTTimeAgoFormatParser(config),
                        new parser.PTDeadlineFormatParser(config),
                        new parser.PTTimeExpressionParser(config),
                        new parser.PTMonthNameLittleEndianParser(config),
                        new parser.PTSlashDateFormatParser(config)
                    ],
                    refiners: [
                        new refiner1.OverlapRemovalRefiner(),
                        new refiner1.ForwardDateRefiner()
                    ]
                };
            };
            exports.pt.casual = function() {
                var option = exports.pt({
                    strict: false
                });
                option.parsers.unshift(new parser.PTCasualDateParser());
                option.parsers.unshift(new parser.PTWeekdayParser());
                return option;
            }; // -------------------------------------------------------------
            exports.es = function(config) {
                return {
                    parsers: [
                        new parser.ESTimeAgoFormatParser(config),
                        new parser.ESDeadlineFormatParser(config),
                        new parser.ESTimeExpressionParser(config),
                        new parser.ESMonthNameLittleEndianParser(config),
                        new parser.ESSlashDateFormatParser(config)
                    ],
                    refiners: [
                        new refiner1.OverlapRemovalRefiner(),
                        new refiner1.ForwardDateRefiner()
                    ]
                };
            };
            exports.es.casual = function() {
                var option = exports.es({
                    strict: false
                });
                option.parsers.unshift(new parser.ESCasualDateParser());
                option.parsers.unshift(new parser.ESWeekdayParser());
                return option;
            }; // -------------------------------------------------------------
            exports.fr = function(config) {
                return {
                    parsers: [
                        new parser.FRDeadlineFormatParser(config),
                        new parser.FRMonthNameLittleEndianParser(config),
                        new parser.FRSlashDateFormatParser(config),
                        new parser.FRTimeAgoFormatParser(config),
                        new parser.FRTimeExpressionParser(config)
                    ],
                    refiners: [
                        new refiner1.OverlapRemovalRefiner(),
                        new refiner1.ForwardDateRefiner(),
                        new refiner1.FRMergeDateRangeRefiner(),
                        new refiner1.FRMergeDateTimeRefiner()
                    ]
                };
            };
            exports.fr.casual = function() {
                var option = exports.fr({
                    strict: false
                });
                option.parsers.unshift(new parser.FRCasualDateParser());
                option.parsers.unshift(new parser.FRWeekdayParser());
                option.parsers.unshift(new parser.FRRelativeDateFormatParser());
                return option;
            }; // -------------------------------------------------------------
            exports.zh = function() {
                return {
                    parsers: [
                        new parser.ZHHantDateParser(),
                        new parser.ZHHantWeekdayParser(),
                        new parser.ZHHantTimeExpressionParser(),
                        new parser.ZHHantCasualDateParser(),
                        new parser.ZHHantDeadlineFormatParser()
                    ],
                    refiners: [
                        new refiner1.OverlapRemovalRefiner(),
                        new refiner1.ForwardDateRefiner()
                    ]
                };
            };
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    ISO 8601
    http://www.w3.org/TR/NOTE-datetime
    - YYYY-MM-DD
    - YYYY-MM-DDThh:mmTZD
    - YYYY-MM-DDThh:mm:ssTZD
    - YYYY-MM-DDThh:mm:ss.sTZD 
    - TZD = (Z or +hh:mm or -hh:mm)
*/ var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = new RegExp("(\\W|^)([0-9]{4})\\-([0-9]{1,2})\\-([0-9]{1,2})(?:T([0-9]{1,2}):([0-9]{1,2})(?::([0-9]{1,2})(?:\\.(\\d{1,4}))?)?(?:Z|([+-]\\d{2}):?(\\d{2})?)?)?(?=\\W|$)", 'i');
            var YEAR_NUMBER_GROUP = 2;
            var MONTH_NUMBER_GROUP = 3;
            var DATE_NUMBER_GROUP = 4;
            var HOUR_NUMBER_GROUP = 5;
            var MINUTE_NUMBER_GROUP = 6;
            var SECOND_NUMBER_GROUP = 7;
            var MILLISECOND_NUMBER_GROUP = 8;
            var TZD_HOUR_OFFSET_GROUP = 9;
            var TZD_MINUTE_OFFSET_GROUP = 10;
            exports.Parser = function ENISOFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var text = match[0].substr(match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        text: text,
                        index: index,
                        ref: ref
                    });
                    result.start.assign('year', parseInt(match[YEAR_NUMBER_GROUP]));
                    result.start.assign('month', parseInt(match[MONTH_NUMBER_GROUP]));
                    result.start.assign('day', parseInt(match[DATE_NUMBER_GROUP]));
                    if (dayjs(result.start.get('month')) > 12 || dayjs(result.start.get('month')) < 1 || dayjs(result.start.get('day')) > 31 || dayjs(result.start.get('day')) < 1) return null;
                    if (match[HOUR_NUMBER_GROUP] != null) {
                        result.start.assign('hour', parseInt(match[HOUR_NUMBER_GROUP]));
                        result.start.assign('minute', parseInt(match[MINUTE_NUMBER_GROUP]));
                        if (match[SECOND_NUMBER_GROUP] != null) result.start.assign('second', parseInt(match[SECOND_NUMBER_GROUP]));
                        if (match[MILLISECOND_NUMBER_GROUP] != null) result.start.assign('millisecond', parseInt(match[MILLISECOND_NUMBER_GROUP]));
                        if (match[TZD_HOUR_OFFSET_GROUP] == null) result.start.assign('timezoneOffset', 0);
                        else {
                            var minuteOffset = 0;
                            var hourOffset = parseInt(match[TZD_HOUR_OFFSET_GROUP]);
                            if (match[TZD_MINUTE_OFFSET_GROUP] != null) minuteOffset = parseInt(match[TZD_MINUTE_OFFSET_GROUP]);
                            var offset = hourOffset * 60;
                            if (offset < 0) offset -= minuteOffset;
                            else offset += minuteOffset;
                            result.start.assign('timezoneOffset', offset);
                        }
                    }
                    result.tags['ENISOFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(4);
            var PATTERN = new RegExp("(\\W|^)(within|in)\\s*(" + util.INTEGER_WORDS_PATTERN + "|[0-9]+|an?(?:\\s*few)?|half(?:\\s*an?)?)\\s*" + "(seconds?|min(?:ute)?s?|hours?|days?|weeks?|months?|years?|fortnights?)\\s*" + "(?=\\W|$)", "i");
            var STRICT_PATTERN = new RegExp("(\\W|^)(within|in)\\s*(" + util.INTEGER_WORDS_PATTERN + "|[0-9]+|an?)\\s*" + "(seconds?|minutes?|hours?|days?|fortnights?)\\s*" + "(?=\\W|$)", "i");
            exports.Parser = function ENDeadlineFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return this.isStrictMode() ? STRICT_PATTERN : PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var num = match[3].toLowerCase();
                    if (util.INTEGER_WORDS[num] !== undefined) num = util.INTEGER_WORDS[num];
                    else if (num === "a" || num === "an") num = 1;
                    else if (num.match(/few/i)) num = 3;
                    else if (num.match(/half/i)) num = 0.5;
                    else num = parseInt(num);
                    var date = dayjs(ref);
                    if (match[4].match(/day|week|month|year|fortnight/i)) {
                        if (match[4].match(/day/i)) date = date.add(num, "d");
                        else if (match[4].match(/week/i)) date = date.add(num * 7, "d");
                        else if (match[4].match(/month/i)) date = date.add(num, "month");
                        else if (match[4].match(/year/i)) date = date.add(num, "year");
                        else if (match[4].match(/fortnight/i)) date = date.add(num * 14, "d");
                        result.start.imply("year", date.year());
                        result.start.imply("month", date.month() + 1);
                        result.start.imply("day", date.date());
                        return result;
                    }
                    if (match[4].match(/hour/i)) date = date.add(num, "hour");
                    else if (match[4].match(/min/i)) date = date.add(num, "minute");
                    else if (match[4].match(/second/i)) date = date.add(num, "second");
                    result.start.imply("year", date.year());
                    result.start.imply("month", date.month() + 1);
                    result.start.imply("day", date.date());
                    result.start.imply("hour", date.hour());
                    result.start.imply("minute", date.minute());
                    result.start.imply("second", date.second());
                    result.tags["ENDeadlineFormatParser"] = true;
                    return result;
                };
            };
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(4);
            var PATTERN = new RegExp("(\\W|^)(this|next|last|past)\\s*(" + util.INTEGER_WORDS_PATTERN + '|[0-9]+|few|half(?:\\s*an?)?)?\\s*' + '(seconds?|min(?:ute)?s?|hours?|days?|weeks?|months?|years?|fortnights?)(?=\\s*)' + '(?=\\W|$)', 'i');
            var MODIFIER_WORD_GROUP = 2;
            var MULTIPLIER_WORD_GROUP = 3;
            var RELATIVE_WORD_GROUP = 4;
            exports.Parser = function ENRelativeDateFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var modifier = match[MODIFIER_WORD_GROUP].toLowerCase().match(/^next/) ? 1 : -1;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    result.tags['ENRelativeDateFormatParser'] = true;
                    var num = match[MULTIPLIER_WORD_GROUP] === undefined ? '' : match[3].toLowerCase();
                    if (util.INTEGER_WORDS[num] !== undefined) num = util.INTEGER_WORDS[num];
                    else if (num === '') num = 1;
                    else if (num.match(/few/i)) num = 3;
                    else if (num.match(/half/i)) num = 0.5;
                    else num = parseInt(num);
                    num *= modifier;
                    var date = dayjs(ref);
                    if (match[MODIFIER_WORD_GROUP].toLowerCase().match(/^this/)) {
                        if (match[MULTIPLIER_WORD_GROUP]) return null;
                        if (match[RELATIVE_WORD_GROUP].match(/day|week|month|year/i)) {
                            // This week
                            if (match[RELATIVE_WORD_GROUP].match(/week/i)) {
                                date = date.add(-date.get('d'), 'd');
                                result.start.imply('day', date.date());
                                result.start.imply('month', date.month() + 1);
                                result.start.imply('year', date.year());
                            } else if (match[RELATIVE_WORD_GROUP].match(/month/i)) {
                                date = date.add(-date.date() + 1, 'd');
                                result.start.imply('day', date.date());
                                result.start.assign('year', date.year());
                                result.start.assign('month', date.month() + 1);
                            } else if (match[RELATIVE_WORD_GROUP].match(/year/i)) {
                                date = date.add(-date.date() + 1, 'd');
                                date = date.add(-date.month(), 'month');
                                result.start.imply('day', date.date());
                                result.start.imply('month', date.month() + 1);
                                result.start.assign('year', date.year());
                            }
                            return result;
                        }
                    }
                    if (match[RELATIVE_WORD_GROUP].match(/day|week|month|year|fortnight/i)) {
                        if (match[RELATIVE_WORD_GROUP].match(/day/i)) {
                            date = date.add(num, 'd');
                            result.start.assign('year', date.year());
                            result.start.assign('month', date.month() + 1);
                            result.start.assign('day', date.date());
                        } else if (match[RELATIVE_WORD_GROUP].match(/week/i)) {
                            date = date.add(num * 7, 'd'); // We don't know the exact date for next/last week so we imply
                            // them
                            result.start.imply('day', date.date());
                            result.start.imply('month', date.month() + 1);
                            result.start.imply('year', date.year());
                        } else if (match[RELATIVE_WORD_GROUP].match(/month/i)) {
                            date = date.add(num, 'month'); // We don't know the exact day for next/last month
                            result.start.imply('day', date.date());
                            result.start.assign('year', date.year());
                            result.start.assign('month', date.month() + 1);
                        } else if (match[RELATIVE_WORD_GROUP].match(/year/i)) {
                            date = date.add(num, 'year'); // We don't know the exact day for month on next/last year
                            result.start.imply('day', date.date());
                            result.start.imply('month', date.month() + 1);
                            result.start.assign('year', date.year());
                        } else if (match[RELATIVE_WORD_GROUP].match(/fortnight/i)) {
                            date.add(num * 14, 'd'); // We don't know the exact date for next/last week so we imply
                            // them
                            result.start.imply('day', date.date());
                            result.start.imply('month', date.month() + 1);
                            result.start.imply('year', date.year());
                        }
                        return result;
                    }
                    if (match[RELATIVE_WORD_GROUP].match(/hour/i)) {
                        date = date.add(num, 'hour');
                        result.start.imply('minute', date.minute());
                        result.start.imply('second', date.second());
                    } else if (match[RELATIVE_WORD_GROUP].match(/min/i)) {
                        date = date.add(num, 'minute');
                        result.start.assign('minute', date.minute());
                        result.start.imply('second', date.second());
                    } else if (match[RELATIVE_WORD_GROUP].match(/second/i)) {
                        date = date.add(num, 'second');
                        result.start.assign('second', date.second());
                        result.start.assign('minute', date.minute());
                    }
                    result.start.assign('hour', date.hour());
                    result.start.assign('year', date.year());
                    result.start.assign('month', date.month() + 1);
                    result.start.assign('day', date.date());
                    return result;
                };
            };
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(4);
            var PATTERN = new RegExp("(\\W|^)(?:on\\s*?)?(?:(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sun|Mon|Tue|Wed|Thu|Fri|Sat)\\s*,?\\s*)?(([0-9]{1,2})(?:st|nd|rd|th)?|" + util.ORDINAL_WORDS_PATTERN + ')' + '(?:\\s*' + "(?:to|\\-|\\\u2013|until|through|till|\\s)\\s*" + '(([0-9]{1,2})(?:st|nd|rd|th)?|' + util.ORDINAL_WORDS_PATTERN + ')' + ')?' + '(?:-|\/|\\s*(?:of)?\\s*)' + '(' + util.MONTH_PATTERN + ')' + '(?:' + '(?:-|\/|,?\\s*)' + '((?:' + '[1-9][0-9]{0,3}\\s*(?:BE|AD|BC)|' + '[1-2][0-9]{3}|' + '[5-9][0-9]' + ')(?![^\\s]\\d))' + ')?' + '(?=\\W|$)', 'i');
            var WEEKDAY_GROUP = 2;
            var DATE_GROUP = 3;
            var DATE_NUM_GROUP = 4;
            var DATE_TO_GROUP = 5;
            var DATE_TO_NUM_GROUP = 6;
            var MONTH_NAME_GROUP = 7;
            var YEAR_GROUP = 8;
            exports.Parser = function ENMonthNameLittleEndianParser() {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var result = new ParsedResult({
                        text: match[0].substr(match[1].length, match[0].length - match[1].length),
                        index: match.index + match[1].length,
                        ref: ref
                    });
                    var month = match[MONTH_NAME_GROUP];
                    month = util.MONTH_OFFSET[month.toLowerCase()];
                    var day = match[DATE_NUM_GROUP] ? parseInt(match[DATE_NUM_GROUP]) : util.ORDINAL_WORDS[match[DATE_GROUP].trim().replace('-', ' ').toLowerCase()];
                    var year = null;
                    if (match[YEAR_GROUP]) {
                        year = match[YEAR_GROUP];
                        if (/BE/i.test(year)) {
                            // Buddhist Era
                            year = year.replace(/BE/i, '');
                            year = parseInt(year) - 543;
                        } else if (/BC/i.test(year)) {
                            // Before Christ
                            year = year.replace(/BC/i, '');
                            year = -parseInt(year);
                        } else if (/AD/i.test(year)) {
                            year = year.replace(/AD/i, '');
                            year = parseInt(year);
                        } else {
                            year = parseInt(year);
                            if (year < 100) {
                                if (year > 50) year = year + 1900;
                                else year = year + 2000;
                            }
                        }
                    }
                    if (year) {
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.assign('year', year);
                    } else {
                        year = parser.findYearClosestToRef(ref, day, month);
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.imply('year', year);
                    } // Weekday component
                    if (match[WEEKDAY_GROUP]) {
                        var weekday = match[WEEKDAY_GROUP];
                        weekday = util.WEEKDAY_OFFSET[weekday.toLowerCase()];
                        result.start.assign('weekday', weekday);
                    } // Text can be 'range' value. Such as '12 - 13 January 2012'
                    if (match[DATE_TO_GROUP]) {
                        var endDate = match[DATE_TO_NUM_GROUP] ? parseInt(match[DATE_TO_NUM_GROUP]) : util.ORDINAL_WORDS[match[DATE_TO_GROUP].trim().replace('-', ' ').toLowerCase()];
                        result.end = result.start.clone();
                        result.end.assign('day', endDate);
                    }
                    result.tags['ENMonthNameLittleEndianParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            /*

    The parser for parsing US's date format that begin with month's name.

    EX.
        - January 13
        - January 13, 2012
        - January 13 - 15, 2012
        - Tuesday, January 13, 2012

    Watch out for:
        - January 12:00
        - January 12.44
        - January 1222344
*/ var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(4);
            var PATTERN = new RegExp("(\\W|^)(?:(?:on\\s*?)?(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sun\\.?|Mon\\.?|Tue\\.?|Wed\\.?|Thu\\.?|Fri\\.?|Sat\\.?)\\s*,?\\s*)?(" + util.MONTH_PATTERN + ')' + '(?:-|\/|\\s*,?\\s*)' + '(([0-9]{1,2})(?:st|nd|rd|th)?|' + util.ORDINAL_WORDS_PATTERN + ')(?!\\s*(?:am|pm))\\s*' + '' + '(?:' + '(?:to|\\-)\\s*' + '(([0-9]{1,2})(?:st|nd|rd|th)?| ' + util.ORDINAL_WORDS_PATTERN + ')\\s*' + ')?' + '(?:' + '(?:-|\/|\\s*,?\\s*)' + '(?:([0-9]{4})\\s*(BE|AD|BC)?|([0-9]{1,4})\\s*(AD|BC))\\s*' + ')?' + '(?=\\W|$)(?!\\:\\d)', 'i');
            var WEEKDAY_GROUP = 2;
            var MONTH_NAME_GROUP = 3;
            var DATE_GROUP = 4;
            var DATE_NUM_GROUP = 5;
            var DATE_TO_GROUP = 6;
            var DATE_TO_NUM_GROUP = 7;
            var YEAR_GROUP = 8;
            var YEAR_BE_GROUP = 9;
            var YEAR_GROUP2 = 10;
            var YEAR_BE_GROUP2 = 11;
            exports.Parser = function ENMonthNameMiddleEndianParser() {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var result = new ParsedResult({
                        text: match[0].substr(match[1].length, match[0].length - match[1].length),
                        index: match.index + match[1].length,
                        ref: ref
                    });
                    var month = match[MONTH_NAME_GROUP];
                    month = util.MONTH_OFFSET[month.toLowerCase()];
                    var day = match[DATE_NUM_GROUP] ? parseInt(match[DATE_NUM_GROUP]) : util.ORDINAL_WORDS[match[DATE_GROUP].trim().replace('-', ' ').toLowerCase()];
                    var year = null;
                    if (match[YEAR_GROUP] || match[YEAR_GROUP2]) {
                        year = match[YEAR_GROUP] || match[YEAR_GROUP2];
                        year = parseInt(year);
                        var yearBE = match[YEAR_BE_GROUP] || match[YEAR_BE_GROUP2];
                        if (yearBE) {
                            if (/BE/i.test(yearBE)) // Buddhist Era
                            year = year - 543;
                            else if (/BC/i.test(yearBE)) // Before Christ
                            year = -year;
                        } else if (year < 100) year = year + 2000;
                    }
                    if (year) {
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.assign('year', year);
                    } else {
                        year = parser.findYearClosestToRef(ref, day, month);
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.imply('year', year);
                    } // Weekday component
                    if (match[WEEKDAY_GROUP]) {
                        var weekday = match[WEEKDAY_GROUP];
                        weekday = util.WEEKDAY_OFFSET[weekday.toLowerCase()];
                        result.start.assign('weekday', weekday);
                    } // Text can be 'range' value. Such as 'January 12 - 13, 2012'
                    if (match[DATE_TO_GROUP]) {
                        var endDate = match[DATE_TO_NUM_GROUP] ? endDate = parseInt(match[DATE_TO_NUM_GROUP]) : util.ORDINAL_WORDS[match[DATE_TO_GROUP].replace('-', ' ').trim().toLowerCase()];
                        result.end = result.start.clone();
                        result.end.assign('day', endDate);
                    }
                    result.tags['ENMonthNameMiddleEndianParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    
    The parser for parsing month name and year.
    
    EX. 
        - January
        - January 2012
        - January, 2012
*/ var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(4);
            var PATTERN = new RegExp("(^|\\D\\s+|[^\\w\\s])(" + util.MONTH_PATTERN + ')' + '\\s*' + '(?:' + '[,-]?\\s*([0-9]{4})(\\s*BE|AD|BC)?' + ')?' + '(?=[^\\s\\w]|\\s+[^0-9]|\\s+$|$)', 'i');
            var MONTH_NAME_GROUP = 2;
            var YEAR_GROUP = 3;
            var YEAR_BE_GROUP = 4;
            exports.Parser = function ENMonthNameParser() {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var result = new ParsedResult({
                        text: match[0].substr(match[1].length, match[0].length - match[1].length),
                        index: match.index + match[1].length,
                        ref: ref
                    });
                    var day = 1;
                    var monthName = match[MONTH_NAME_GROUP];
                    var month = util.MONTH_OFFSET[monthName.toLowerCase()];
                    var year = null;
                    if (match[YEAR_GROUP]) {
                        year = match[YEAR_GROUP];
                        year = parseInt(year);
                        if (match[YEAR_BE_GROUP]) {
                            if (match[YEAR_BE_GROUP].match(/BE/)) // Buddhist Era
                            year = year - 543;
                            else if (match[YEAR_BE_GROUP].match(/BC/)) // Before Christ
                            year = -year;
                        } else if (year < 100) year = year + 2000;
                    }
                    if (year) {
                        result.start.imply('day', day);
                        result.start.assign('month', month);
                        result.start.assign('year', year);
                    } else {
                        year = parser.findYearClosestToRef(ref, day, month);
                        result.start.imply('day', day);
                        result.start.assign('month', month);
                        result.start.imply('year', year);
                    }
                    if (result.text.match(/^\w{3}$/)) return false;
                    result.tags['ENMonthNameParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    Date format with slash "/" (also "-" and ".") between numbers
    - Tuesday 11/3/2015 
    - 11/3/2015
    - 11/3

    By default the paser us "middle-endien" format (US English),
    then fallback to little-endian if failed.
    - 11/3/2015 = November 3rd, 2015
    - 23/4/2015 = April 23th, 2015

    If "littleEndian" config is set, the parser will try the little-endian first. 
    - 11/3/2015 = March 11th, 2015
*/ var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = new RegExp("(\\W|^)(?:(?:on\\s*?)?((?:sun|mon|tues?|wed(?:nes)?|thu(?:rs?)?|fri|sat(?:ur)?)(?:day)?)\\s*\\,?\\s*)?([0-3]{0,1}[0-9]{1})[\\/\\.\\-]([0-3]{0,1}[0-9]{1})(?:[\\/\\.\\-]([0-9]{4}s*,?s*|[0-9]{2}s*,?s*))?(\\W|$)", 'i');
            var DAYS_OFFSET = {
                'sunday': 0,
                'sun': 0,
                'monday': 1,
                'mon': 1,
                'tuesday': 2,
                'wednesday': 3,
                'wed': 3,
                'thursday': 4,
                'thur': 4,
                'friday': 5,
                'fri': 5,
                'saturday': 6,
                'sat': 6
            };
            var OPENNING_GROUP = 1;
            var ENDING_GROUP = 6;
            var WEEKDAY_GROUP = 2;
            var FIRST_NUMBERS_GROUP = 3;
            var SECOND_NUMBERS_GROUP = 4;
            var YEAR_GROUP = 5;
            exports.Parser = function ENSlashDateFormatParser(config) {
                Parser.apply(this, arguments);
                config = config || {};
                var littleEndian = config.littleEndian;
                var MONTH_GROUP = littleEndian ? SECOND_NUMBERS_GROUP : FIRST_NUMBERS_GROUP;
                var DAY_GROUP = littleEndian ? FIRST_NUMBERS_GROUP : SECOND_NUMBERS_GROUP;
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match[OPENNING_GROUP] == '/' || match[ENDING_GROUP] == '/') {
                        // Long skip, if there is some overlapping like:
                        // XX[/YY/ZZ]
                        // [XX/YY/]ZZ
                        match.index += match[0].length;
                        return;
                    }
                    var index = match.index + match[OPENNING_GROUP].length;
                    var text = match[0].substr(match[OPENNING_GROUP].length, match[0].length - match[ENDING_GROUP].length);
                    var result = new ParsedResult({
                        text: text,
                        index: index,
                        ref: ref
                    });
                    if (text.match(/^\d\.\d$/)) return;
                    if (text.match(/^\d\.\d{1,2}\.\d{1,2}$/)) return; // MM/dd -> OK
                    // MM.dd -> NG
                    if (!match[YEAR_GROUP] && match[0].indexOf('/') < 0) return;
                    var date = null;
                    var year = match[YEAR_GROUP] || dayjs(ref).year() + '';
                    var month = match[MONTH_GROUP];
                    var day = match[DAY_GROUP];
                    month = parseInt(month);
                    day = parseInt(day);
                    year = parseInt(year);
                    if (month < 1 || month > 12) {
                        if (month > 12) {
                            // dd/mm/yyyy date format if day looks like a month, and month
                            // looks like a day.
                            if (day >= 1 && day <= 12 && month >= 13 && month <= 31) {
                                // unambiguous
                                var tday = month;
                                month = day;
                                day = tday;
                            } else // both month and day are <= 12
                            return null;
                        }
                    }
                    if (day < 1 || day > 31) return null;
                    if (year < 100) {
                        if (year > 50) year = year + 1900;
                        else year = year + 2000;
                    }
                    result.start.assign('day', day);
                    result.start.assign('month', month);
                    if (match[YEAR_GROUP]) result.start.assign('year', year);
                    else result.start.imply('year', year);
                     //Day of week
                    if (match[WEEKDAY_GROUP]) result.start.assign('weekday', DAYS_OFFSET[match[WEEKDAY_GROUP].toLowerCase()]);
                    result.tags['ENSlashDateFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    Date format with slash "/" between numbers like ENSlashDateFormatParser,
    but this parser expect year before month and date. 
    - YYYY/MM/DD
    - YYYY-MM-DD
    - YYYY.MM.DD
*/ var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(4);
            var PATTERN = new RegExp("(\\W|^)([0-9]{4})[\\-\\.\\/]((?:" + util.MONTH_PATTERN + '|[0-9]{1,2}))[\\-\\.\\/]' + '([0-9]{1,2})' + '(?=\\W|$)', 'i');
            var YEAR_NUMBER_GROUP = 2;
            var MONTH_NUMBER_GROUP = 3;
            var DATE_NUMBER_GROUP = 4;
            exports.Parser = function ENSlashDateFormatStartWithYearParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var text = match[0].substr(match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        text: text,
                        index: index,
                        ref: ref
                    });
                    var month = match[MONTH_NUMBER_GROUP].toLowerCase();
                    month = util.MONTH_OFFSET[month] | month;
                    result.start.assign('year', parseInt(match[YEAR_NUMBER_GROUP]));
                    result.start.assign('month', parseInt(month));
                    result.start.assign('day', parseInt(match[DATE_NUMBER_GROUP]));
                    if (dayjs(result.start.get('month')) > 12 || dayjs(result.start.get('month')) < 1 || dayjs(result.start.get('day')) > 31 || dayjs(result.start.get('day')) < 1) return null;
                    result.tags['ENDateFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 21 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    Month/Year date format with slash "/" (also "-" and ".") between numbers 
    - 11/05
    - 06/2005
*/ var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = new RegExp("(^|[^\\d/]\\s+|[^\\w\\s])([0-9]|0[1-9]|1[012])/([0-9]{4})(?=[^\\d/]|$)", 'i');
            var OPENNING_GROUP = 1;
            var MONTH_GROUP = 2;
            var YEAR_GROUP = 3;
            exports.Parser = function ENSlashMonthFormatParser(argument) {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[OPENNING_GROUP].length;
                    var text = match[0].substr(match[OPENNING_GROUP].length, match[0].length).trim();
                    var result = new ParsedResult({
                        text: text,
                        index: index,
                        ref: ref
                    });
                    var year = match[YEAR_GROUP];
                    var month = match[MONTH_GROUP];
                    var day = 1;
                    month = parseInt(month);
                    year = parseInt(year);
                    result.start.imply('day', day);
                    result.start.assign('month', month);
                    result.start.assign('year', year);
                    result.tags['ENSlashMonthFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(4);
            var PATTERN = new RegExp("(\\W|^)(?:within\\s*)?(" + util.TIME_UNIT_PATTERN + ')' + '(?:ago|before|earlier)(?=(?:\\W|$))', 'i');
            var STRICT_PATTERN = new RegExp("(\\W|^)(?:within\\s*)?(" + util.TIME_UNIT_STRICT_PATTERN + ')' + 'ago(?=(?:\\W|$))', 'i');
            exports.Parser = function ENTimeAgoFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return this.isStrictMode() ? STRICT_PATTERN : PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var fragments = util.extractDateTimeUnitFragments(match[2]);
                    var date = dayjs(ref);
                    for(var key in fragments)date = date.add(-fragments[key], key);
                    if (fragments['hour'] > 0 || fragments['minute'] > 0 || fragments['second'] > 0) {
                        result.start.assign('hour', date.hour());
                        result.start.assign('minute', date.minute());
                        result.start.assign('second', date.second());
                        result.tags['ENTimeAgoFormatParser'] = true;
                    }
                    if (fragments['d'] > 0 || fragments['month'] > 0 || fragments['year'] > 0) {
                        result.start.assign('day', date.date());
                        result.start.assign('month', date.month() + 1);
                        result.start.assign('year', date.year());
                    } else {
                        if (fragments['week'] > 0) result.start.imply('weekday', date.day());
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                    }
                    return result;
                };
            };
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var FIRST_REG_PATTERN = new RegExp("(^|\\s|T)(?:(?:at|from)\\s*)??(\\d{1,4}|noon|midnight)(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2})(?:(?:\\:|\\\uFF1A)(\\d{2})(?:\\.(\\d{1,6}))?)?)?(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?|O\\W*CLOCK))?(?=\\W|$)", 'i');
            var SECOND_REG_PATTERN = new RegExp("^\\s*(\\-|\\\u2013|\\~|\\\u301C|to|\\?)\\s*(\\d{1,4})(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2})(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2})(?:\\.(\\d{1,6}))?)?)?(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?|O\\W*CLOCK))?(?=\\W|$)", 'i');
            var HOUR_GROUP = 2;
            var MINUTE_GROUP = 3;
            var SECOND_GROUP = 4;
            var MILLI_SECOND_GROUP = 5;
            var AM_PM_HOUR_GROUP = 6;
            exports.Parser = function ENTimeExpressionParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return FIRST_REG_PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    // This pattern can be overlapped Ex. [12] AM, 1[2] AM
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var refMoment = dayjs(ref);
                    var result = new ParsedResult();
                    result.ref = ref;
                    result.index = match.index + match[1].length;
                    result.text = match[0].substring(match[1].length);
                    result.tags['ENTimeExpressionParser'] = true;
                    result.start.imply('day', refMoment.date());
                    result.start.imply('month', refMoment.month() + 1);
                    result.start.imply('year', refMoment.year());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Millisecond
                    if (match[MILLI_SECOND_GROUP] != null) {
                        var millisecond = parseInt(match[MILLI_SECOND_GROUP].substring(0, 3));
                        if (millisecond >= 1000) return null;
                        result.start.assign('millisecond', millisecond);
                    } // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.start.assign('second', second);
                    } // ----- Hours
                    if (match[HOUR_GROUP].toLowerCase() == "noon") {
                        meridiem = 1;
                        hour = 12;
                    } else if (match[HOUR_GROUP].toLowerCase() == "midnight") {
                        meridiem = 0;
                        hour = 0;
                    } else hour = parseInt(match[HOUR_GROUP]);
                     // ----- Minutes
                    if (match[MINUTE_GROUP] != null) minute = parseInt(match[MINUTE_GROUP]);
                    else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM  
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm == "a") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        }
                        if (ampm == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    }
                    result.start.assign('hour', hour);
                    result.start.assign('minute', minute);
                    if (meridiem >= 0) result.start.assign('meridiem', meridiem);
                    else if (hour < 12) result.start.imply('meridiem', 0);
                    else result.start.imply('meridiem', 1);
                     // ==============================================================
                    //                  Extracting the 'to' chunk
                    // ==============================================================
                    match = SECOND_REG_PATTERN.exec(text.substring(result.index + result.text.length));
                    if (!match) return result;
                     // Pattern "YY.YY -XXXX" is more like timezone offset
                    if (match[0].match(/^\s*(\+|\-)\s*\d{3,4}$/)) return result;
                    if (result.end == null) result.end = new ParsedComponents(null, result.start.date());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Millisecond
                    if (match[MILLI_SECOND_GROUP] != null) {
                        var millisecond = parseInt(match[MILLI_SECOND_GROUP].substring(0, 3));
                        if (millisecond >= 1000) return null;
                        result.end.assign('millisecond', millisecond);
                    } // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.end.assign('second', second);
                    }
                    hour = parseInt(match[2]); // ----- Minute
                    if (match[MINUTE_GROUP] != null) {
                        minute = parseInt(match[MINUTE_GROUP]);
                        if (minute >= 60) return result;
                    } else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM 
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm == "a") {
                            meridiem = 0;
                            if (hour == 12) {
                                hour = 0;
                                if (!result.end.isCertain('day')) result.end.imply('day', result.end.get('day') + 1);
                            }
                        }
                        if (ampm == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                        if (!result.start.isCertain('meridiem')) {
                            if (meridiem == 0) {
                                result.start.imply('meridiem', 0);
                                if (result.start.get('hour') == 12) result.start.assign('hour', 0);
                            } else {
                                result.start.imply('meridiem', 1);
                                if (result.start.get('hour') != 12) result.start.assign('hour', result.start.get('hour') + 12);
                            }
                        }
                    }
                    result.text = result.text + match[0];
                    result.end.assign('hour', hour);
                    result.end.assign('minute', minute);
                    if (meridiem >= 0) result.end.assign('meridiem', meridiem);
                    else {
                        var startAtPM = result.start.isCertain('meridiem') && result.start.get('meridiem') == 1;
                        if (startAtPM && result.start.get('hour') > hour) // 10pm - 1 (am)
                        result.end.imply('meridiem', 0);
                        else if (hour > 12) result.end.imply('meridiem', 1);
                    }
                    if (result.end.date().getTime() < result.start.date().getTime()) result.end.imply('day', result.end.get('day') + 1);
                    return result;
                };
            };
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(4);
            var PATTERN = new RegExp("(\\W|^)(in )?(" + util.TIME_UNIT_PATTERN + ')' + /*match[4]*/ '(later|after|from now|henceforth|forward|out)?' + /*match[5]*/ '(?=(?:\\W|$))', 'i');
            var STRICT_PATTERN = new RegExp("(\\W|^)(in )?(" + util.TIME_UNIT_STRICT_PATTERN + ')' + /*match[4]*/ '(later|from now)?' + /*match[5]*/ '(?=(?:\\W|$))', 'i');
            exports.Parser = function ENTimeLaterFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return this.isStrictMode() ? STRICT_PATTERN : PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var prefix = match[2];
                    var suffix = match[4];
                    if (!prefix && !suffix) return null;
                    var preamble = match[1];
                    var text = match[0].substr(preamble.length, match[0].length - preamble.length);
                    var index = match.index + preamble.length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var fragments = util.extractDateTimeUnitFragments(match[3]);
                    var date = dayjs(ref);
                    for(var key in fragments)date = date.add(fragments[key], key);
                    if (fragments['hour'] > 0 || fragments['minute'] > 0 || fragments['second'] > 0) {
                        result.start.assign('hour', date.hour());
                        result.start.assign('minute', date.minute());
                        result.start.assign('second', date.second());
                        result.tags['ENTimeAgoFormatParser'] = true;
                    }
                    if (fragments['d'] > 0 || fragments['month'] > 0 || fragments['year'] > 0) {
                        result.start.assign('day', date.date());
                        result.start.assign('month', date.month() + 1);
                        result.start.assign('year', date.year());
                    } else {
                        if (fragments['week'] > 0) result.start.imply('weekday', date.day());
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                    }
                    return result;
                };
            };
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = /(\W|^)(now|today|tonight|last\s*night|(?:tomorrow|tmr|yesterday)\s*|tomorrow|tmr|yesterday)(?=\W|$)/i;
            exports.Parser = function ENCasualDateParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var text = match[0].substr(match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var refMoment = dayjs(ref);
                    var startMoment = refMoment;
                    var lowerText = text.toLowerCase();
                    if (lowerText == 'tonight') {
                        // Normally means this coming midnight
                        result.start.imply('hour', 22);
                        result.start.imply('meridiem', 1);
                    } else if (/^tomorrow|^tmr/.test(lowerText)) // Check not "Tomorrow" on late night
                    {
                        if (refMoment.hour() > 1) startMoment = startMoment.add(1, 'day');
                    } else if (/^yesterday/.test(lowerText)) startMoment = startMoment.add(-1, 'day');
                    else if (lowerText.match(/last\s*night/)) {
                        result.start.imply('hour', 0);
                        if (refMoment.hour() > 6) startMoment = startMoment.add(-1, 'day');
                    } else if (lowerText.match("now")) {
                        result.start.assign('hour', refMoment.hour());
                        result.start.assign('minute', refMoment.minute());
                        result.start.assign('second', refMoment.second());
                        result.start.assign('millisecond', refMoment.millisecond());
                    }
                    result.start.assign('day', startMoment.date());
                    result.start.assign('month', startMoment.month() + 1);
                    result.start.assign('year', startMoment.year());
                    result.tags['ENCasualDateParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = /(\W|^)((this)?\s*(morning|afternoon|evening|noon|night))/i;
            var TIME_MATCH = 4;
            exports.Parser = function ENCasualTimeParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var text = match[0].substr(match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    if (!match[TIME_MATCH]) TIME_MATCH = 3;
                    switch(match[TIME_MATCH].toLowerCase()){
                        case 'afternoon':
                            result.start.imply('meridiem', 1);
                            result.start.imply('hour', 15);
                            break;
                        case 'evening':
                        case 'night':
                            result.start.imply('meridiem', 1);
                            result.start.imply('hour', 20);
                            break;
                        case 'morning':
                            result.start.imply('meridiem', 0);
                            result.start.imply('hour', 6);
                            break;
                        case 'noon':
                            result.start.imply('meridiem', 0);
                            result.start.imply('hour', 12);
                            break;
                    }
                    result.tags['ENCasualTimeParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(28);
            var PATTERN = /(?:(同|今|本|((昭和|平成|令和)?([0-9０-９]{1,4}|元)))年\s*)?([0-9０-９]{1,2})月\s*([0-9０-９]{1,2})日/i;
            var SPECIAL_YEAR_GROUP = 1;
            var TYPICAL_YEAR_GROUP = 2;
            var ERA_GROUP = 3;
            var YEAR_NUMBER_GROUP = 4;
            var MONTH_GROUP = 5;
            var DAY_GROUP = 6;
            exports.Parser = function JPStandardParser() {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var result = new ParsedResult({
                        text: match[0],
                        index: match.index,
                        ref: ref
                    });
                    var month = match[MONTH_GROUP];
                    month = util.toHankaku(month);
                    month = parseInt(month);
                    var day = match[DAY_GROUP];
                    day = util.toHankaku(day);
                    day = parseInt(day);
                    result.start.assign('day', day);
                    result.start.assign('month', month);
                    if (match[TYPICAL_YEAR_GROUP]) {
                        var year = match[YEAR_NUMBER_GROUP];
                        if (year == "\u5143") year = 1;
                        else {
                            year = util.toHankaku(year);
                            year = parseInt(year);
                        }
                        if (match[ERA_GROUP] == "\u4EE4\u548C") year += 2018;
                        else if (match[ERA_GROUP] == "\u5E73\u6210") year += 1988;
                        else if (match[ERA_GROUP] == "\u662D\u548C") year += 1925;
                        result.start.assign('year', year);
                    } else if (match[SPECIAL_YEAR_GROUP] && match[SPECIAL_YEAR_GROUP].match("\u540C|\u4ECA|\u672C")) {
                        var moment = dayjs(ref);
                        result.start.assign('year', moment.year());
                    } else {
                        var _year = parser.findYearClosestToRef(ref, day, month);
                        result.start.imply('year', _year);
                    }
                    result.tags['JPStandardParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 28 */ /***/ function(module1, exports) {
            /**
 * to-hankaku.js
 * convert to ascii code strings.
 *
 * @version 1.0.1
 * @author think49
 * @url https://gist.github.com/964592
 * @license http://www.opensource.org/licenses/mit-license.php (The MIT License)
 */ exports.toHankaku = function(String1, fromCharCode) {
                function toHankaku(string) {
                    return String1(string).replace(/\u2019/g, "'").replace(/\u201D/g, "\"").replace(/\u3000/g, " ").replace(/\uFFE5/g, "\xA5").replace(/[\uFF01\uFF03-\uFF06\uFF08\uFF09\uFF0C-\uFF19\uFF1C-\uFF1F\uFF21-\uFF3B\uFF3D\uFF3F\uFF41-\uFF5B\uFF5D\uFF5E]/g, alphaNum);
                }
                function alphaNum(token) {
                    return fromCharCode(token.charCodeAt(0) - 65248);
                }
                return toHankaku;
            }(String, String.fromCharCode);
            /**
 * to-zenkaku.js
 * convert to multi byte strings.
 *
 * @version 1.0.2
 * @author think49
 * @url https://gist.github.com/964592
 * @license http://www.opensource.org/licenses/mit-license.php (The MIT License)
 */ exports.toZenkaku = function(String1, fromCharCode) {
                function toZenkaku(string) {
                    return String1(string).replace(/\u0020/g, "\u3000").replace(/\u0022/g, "\u201D").replace(/\u0027/g, "\u2019").replace(/\u00A5/g, "\uFFE5").replace(/[!#-&(),-9\u003C-?A-[\u005D_a-{}~]/g, alphaNum);
                }
                function alphaNum(token) {
                    return fromCharCode(token.charCodeAt(0) + 65248);
                }
                return toZenkaku;
            }(String, String.fromCharCode);
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = /今日|当日|昨日|明日|今夜|今夕|今晩|今朝/i;
            exports.Parser = function JPCasualDateParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index;
                    var text = match[0];
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var refMoment = dayjs(ref);
                    var startMoment = refMoment;
                    if (text == "\u4ECA\u591C" || text == "\u4ECA\u5915" || text == "\u4ECA\u6669") {
                        // Normally means this coming midnight 
                        result.start.imply('hour', 22);
                        result.start.imply('meridiem', 1);
                    } else if (text == "\u660E\u65E5") // Check not "Tomorrow" on late night
                    {
                        if (refMoment.hour() > 4) startMoment = startMoment.add(1, 'day');
                    } else if (text == "\u6628\u65E5") startMoment = startMoment.add(-1, 'day');
                    else if (text.match("\u4ECA\u671D")) {
                        result.start.imply('hour', 6);
                        result.start.imply('meridiem', 0);
                    }
                    result.start.assign('day', startMoment.date());
                    result.start.assign('month', startMoment.month() + 1);
                    result.start.assign('year', startMoment.year());
                    result.tags['JPCasualDateParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            /*
  Valid patterns:
  - esta manhã -> today in the morning
  - esta tarde -> today in the afternoon/evening
  - esta noite -> tonight
  - ontem de -> yesterday in the morning
  - ontem a tarde -> yesterday in the afternoon/evening
  - ontem a noite -> yesterday at night
  - amanhã de manhã -> tomorrow in the morning
  - amanhã a tarde -> tomorrow in the afternoon/evening
  - amanhã a noite -> tomorrow at night
  - hoje -> today
  - ontem -> yesterday
  - amanhã -> tomorrow
 */ var PATTERN = /(\W|^)(agora|esta\s*(manhã|tarde|noite)|(ontem|amanhã)\s*(de|à)\s*(manhã|tarde|noite)|hoje|amanhã|ontem|noite)(?=\W|$)/i;
            exports.Parser = function PTCasualDateParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var text = match[0].substr(match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var refMoment = dayjs(ref);
                    var startMoment = refMoment;
                    var lowerText = text.toLowerCase().replace(/\s+/g, ' ');
                    if (lowerText == "amanh\xe3") // Check not "Tomorrow" on late night
                    {
                        if (refMoment.hour() > 1) startMoment = startMoment.add(1, 'day');
                    } else if (lowerText == 'ontem') startMoment = startMoment.add(-1, 'day');
                    else if (lowerText == 'noite') {
                        result.start.imply('hour', 0);
                        if (refMoment.hour() > 6) startMoment = startMoment.add(-1, 'day');
                    } else if (lowerText.match("esta")) {
                        var secondMatch = match[3].toLowerCase();
                        if (secondMatch == "tarde") result.start.imply('hour', 18);
                        else if (secondMatch == "manh\xe3") result.start.imply('hour', 6);
                        else if (secondMatch == "noite") {
                            // Normally means this coming midnight
                            result.start.imply('hour', 22);
                            result.start.imply('meridiem', 1);
                        }
                    } else if (lowerText.match(/de|à/)) {
                        var firstMatch = match[4].toLowerCase();
                        if (firstMatch === 'ontem') startMoment = startMoment.add(-1, 'day');
                        else if (firstMatch === "amanh\xe3") startMoment = startMoment.add(1, 'day');
                        var secondMatch = match[6].toLowerCase();
                        if (secondMatch == "tarde") result.start.imply('hour', 18);
                        else if (secondMatch == "manh\xe3") result.start.imply('hour', 9);
                        else if (secondMatch == "noite") {
                            // Normally means this coming midnight
                            result.start.imply('hour', 22);
                            result.start.imply('meridiem', 1);
                        }
                    } else if (lowerText.match("agora")) {
                        result.start.imply('hour', refMoment.hour());
                        result.start.imply('minute', refMoment.minute());
                        result.start.imply('second', refMoment.second());
                        result.start.imply('millisecond', refMoment.millisecond());
                    }
                    result.start.assign('day', startMoment.date());
                    result.start.assign('month', startMoment.month() + 1);
                    result.start.assign('year', startMoment.year());
                    result.tags['PTCasualDateParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = /(\W|^)(dentro\s*de|em|em*até)\s*([0-9]+|mei[oa]|uma?)\s*(minutos?|horas?|dias?)\s*(?=(?:\W|$))/i;
            exports.Parser = function PTDeadlineFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var num = parseInt(match[3]);
                    if (isNaN(num)) {
                        if (match[3].match(/(meio|meia)/)) num = 0.5;
                        else num = 1;
                    }
                    var date = dayjs(ref);
                    if (match[4].match(/dia/)) {
                        date = date.add(num, 'd');
                        result.start.assign('year', date.year());
                        result.start.assign('month', date.month() + 1);
                        result.start.assign('day', date.date());
                        return result;
                    }
                    if (match[4].match(/hora/)) date = date.add(num, 'hour');
                    else if (match[4].match(/minuto/)) date = date.add(num, 'minute');
                    result.start.imply('year', date.year());
                    result.start.imply('month', date.month() + 1);
                    result.start.imply('day', date.date());
                    result.start.assign('hour', date.hour());
                    result.start.assign('minute', date.minute());
                    result.tags['PTDeadlineFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 32 */ /***/ function(module1, exports, __webpack_require__) {
            var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(33);
            var DAYS_OFFSET = util.WEEKDAY_OFFSET;
            var PATTERN = new RegExp("(\\W|^)(?:(domingo|segunda|segunda-feira|ter\xe7a|ter\xe7a-feira|quarta|quarta-feira|quinta|quinta-feira|sexta|sexta-feira|s\xe1bado|sabado|dom|seg|ter|qua|qui|sex|sab)\\s*,?\\s*)?([0-9]{1,2})(?:\xba|\xaa|\xb0)?(?:\\s*(?:desde|de|\\-|\\\u2013|ao?|\\s)\\s*([0-9]{1,2})(?:\xba|\xaa|\xb0)?)?\\s*(?:de)?\\s*(Jan(?:eiro|\\.)?|Fev(?:ereiro|\\.)?|Mar(?:\xe7o|\\.)?|Abr(?:il|\\.)?|Mai(?:o|\\.)?|Jun(?:ho|\\.)?|Jul(?:ho|\\.)?|Ago(?:sto|\\.)?|Set(?:embro|\\.)?|Out(?:ubro|\\.)?|Nov(?:embro|\\.)?|Dez(?:embro|\\.)?)(?:\\s*(?:de?)?(\\s*[0-9]{1,4}(?![^\\s]\\d))(\\s*[ad]\\.?\\s*c\\.?|a\\.?\\s*d\\.?)?)?(?=\\W|$)", 'i');
            var WEEKDAY_GROUP = 2;
            var DATE_GROUP = 3;
            var DATE_TO_GROUP = 4;
            var MONTH_NAME_GROUP = 5;
            var YEAR_GROUP = 6;
            var YEAR_BE_GROUP = 7;
            exports.Parser = function PTMonthNameLittleEndianParser() {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var result = new ParsedResult({
                        text: match[0].substr(match[1].length, match[0].length - match[1].length),
                        index: match.index + match[1].length,
                        ref: ref
                    });
                    var month = match[MONTH_NAME_GROUP];
                    month = util.MONTH_OFFSET[month.toLowerCase()];
                    var day = match[DATE_GROUP];
                    day = parseInt(day);
                    var year = null;
                    if (match[YEAR_GROUP]) {
                        year = match[YEAR_GROUP];
                        year = parseInt(year);
                        if (match[YEAR_BE_GROUP]) {
                            if (/a\.?\s*c\.?/i.test(match[YEAR_BE_GROUP])) // antes de Cristo
                            year = -year;
                        } else if (year < 100) year = year + 2000;
                    }
                    if (year) {
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.assign('year', year);
                    } else {
                        year = parser.findYearClosestToRef(ref, day, month);
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.imply('year', year);
                    } // Weekday component
                    if (match[WEEKDAY_GROUP]) {
                        var weekday = match[WEEKDAY_GROUP];
                        weekday = util.WEEKDAY_OFFSET[weekday.toLowerCase()];
                        result.start.assign('weekday', weekday);
                    } // Text can be 'range' value. Such as '12 - 13 January 2012'
                    if (match[DATE_TO_GROUP]) {
                        result.end = result.start.clone();
                        result.end.assign('day', parseInt(match[DATE_TO_GROUP]));
                    }
                    result.tags['PTMonthNameLittleEndianParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 33 */ /***/ function(module1, exports) {
            exports.WEEKDAY_OFFSET = {
                'domingo': 0,
                'dom': 0,
                'segunda': 1,
                'segunda-feira': 1,
                'seg': 1,
                "ter\xe7a": 2,
                'terca': 2,
                "ter\xe7a-feira": 2,
                'terca-feira': 2,
                'ter': 2,
                'quarta': 3,
                'quarta-feira': 3,
                'qua': 3,
                'quinta': 4,
                'quinta-feira': 4,
                'qui': 4,
                'sexta': 5,
                'sexta-feira': 5,
                'sex': 5,
                "s\xe1bado": 6,
                'sabado': 6,
                'sab': 6
            };
            exports.MONTH_OFFSET = {
                'janeiro': 1,
                'jan': 1,
                'jan.': 1,
                'fevereiro': 2,
                'fev': 2,
                'fev.': 2,
                "mar\xe7o": 3,
                'mar': 3,
                'mar.': 3,
                'abril': 4,
                'abr': 4,
                'abr.': 4,
                'maio': 5,
                'mai': 5,
                'mai.': 5,
                'junho': 6,
                'jun': 6,
                'jun.': 6,
                'julho': 7,
                'jul': 7,
                'jul.': 7,
                'agosto': 8,
                'ago': 8,
                'ago.': 8,
                'setembro': 9,
                'set': 9,
                'set.': 9,
                'outubro': 10,
                'out': 10,
                'out.': 10,
                'novembro': 11,
                'nov': 11,
                'nov.': 11,
                'dezembro': 12,
                'dez': 12,
                'dez.': 12
            };
        /***/ },
        /* 34 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    Date format with slash "/" (also "-" and ".") between numbers
    - Martes 3/11/2015
    - 3/11/2015
    - 3/11
*/ var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = new RegExp("(\\W|^)(?:((?:domingo|dom|segunda|segunda-feira|seg|ter\xe7a|ter\xe7a-feira|ter|quarta|quarta-feira|qua|quinta|quinta-feira|qui|sexta|sexta-feira|sex|s[\xe1a]bado|sab))\\s*\\,?\\s*)?([0-1]{0,1}[0-9]{1})[\\/\\.\\-]([0-3]{0,1}[0-9]{1})(?:[\\/\\.\\-]([0-9]{4}s*,?s*|[0-9]{2}s*,?s*))?(\\W|$)", 'i');
            var DAYS_OFFSET = {
                'domingo': 0,
                'dom': 0,
                'segunda': 1,
                'segunda-feira': 1,
                'seg': 1,
                "ter\xe7a": 2,
                "ter\xe7a-feira": 2,
                'ter': 2,
                'quarta': 3,
                'quarta-feira': 3,
                'qua': 3,
                'quinta': 4,
                'quinta-feira': 4,
                'qui': 4,
                'sexta': 5,
                'sexta-feira': 5,
                'sex': 5,
                "s\xe1bado": 6,
                'sabado': 6,
                'sab': 6
            };
            var OPENNING_GROUP = 1;
            var ENDING_GROUP = 6; // in Spanish we use day/month/year
            var WEEKDAY_GROUP = 2;
            var MONTH_GROUP = 4;
            var DAY_GROUP = 3;
            var YEAR_GROUP = 5;
            exports.Parser = function PTSlashDateFormatParser(argument) {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match[OPENNING_GROUP] == '/' || match[ENDING_GROUP] == '/') {
                        // Long skip, if there is some overlapping like:
                        // XX[/YY/ZZ]
                        // [XX/YY/]ZZ
                        match.index += match[0].length;
                        return;
                    }
                    var index = match.index + match[OPENNING_GROUP].length;
                    var text = match[0].substr(match[OPENNING_GROUP].length, match[0].length - match[ENDING_GROUP].length);
                    var result = new ParsedResult({
                        text: text,
                        index: index,
                        ref: ref
                    });
                    if (text.match(/^\d\.\d$/)) return;
                    if (text.match(/^\d\.\d{1,2}\.\d{1,2}$/)) return; // MM/dd -> OK
                    // MM.dd -> NG
                    if (!match[YEAR_GROUP] && match[0].indexOf('/') < 0) return;
                    var date = null;
                    var year = match[YEAR_GROUP] || dayjs(ref).year() + '';
                    var month = match[MONTH_GROUP];
                    var day = match[DAY_GROUP];
                    month = parseInt(month);
                    day = parseInt(day);
                    year = parseInt(year);
                    if (month < 1 || month > 12) {
                        if (month > 12) {
                            // dd/mm/yyyy date format if day looks like a month, and month
                            // looks like a day.
                            if (day >= 1 && day <= 12 && month >= 13 && month <= 31) {
                                // unambiguous
                                var tday = month;
                                month = day;
                                day = tday;
                            } else // both month and day are <= 12
                            return null;
                        }
                    }
                    if (day < 1 || day > 31) return null;
                    if (year < 100) {
                        if (year > 50) year = year + 1900;
                        else year = year + 2000;
                    }
                    result.start.assign('day', day);
                    result.start.assign('month', month);
                    result.start.assign('year', year); //Day of week
                    if (match[WEEKDAY_GROUP]) result.start.assign('weekday', DAYS_OFFSET[match[WEEKDAY_GROUP].toLowerCase()]);
                    result.tags['PTSlashDateFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = /(\W|^)há\s*([0-9]+|mei[oa]|uma?)\s*(minutos?|horas?|semanas?|dias?|mes(es)?|anos?)(?=(?:\W|$))/i;
            exports.Parser = function PTTimeAgoFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var num = parseInt(match[2]);
                    if (isNaN(num)) {
                        if (match[2].match(/mei/)) num = 0.5;
                        else num = 1;
                    }
                    var date = dayjs(ref);
                    if (match[3].match(/hora/) || match[3].match(/minuto/)) {
                        if (match[3].match(/hora/)) date = date.add(-num, 'hour');
                        else if (match[3].match(/minuto/)) date = date.add(-num, 'minute');
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                        result.start.assign('hour', date.hour());
                        result.start.assign('minute', date.minute());
                        result.tags['PTTimeAgoFormatParser'] = true;
                        return result;
                    }
                    if (match[3].match(/semana/)) {
                        date = date.add(-num, 'week');
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                        result.start.imply('weekday', date.day());
                        return result;
                    }
                    if (match[3].match(/dia/)) date = date.add(-num, 'd');
                    if (match[3].match(/mes/)) date = date.add(-num, 'month');
                    if (match[3].match(/ano/)) date = date.add(-num, 'year');
                    result.start.assign('day', date.date());
                    result.start.assign('month', date.month() + 1);
                    result.start.assign('year', date.year());
                    return result;
                };
            };
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var FIRST_REG_PATTERN = new RegExp("(^|\\s|T)(?:(?:ao?|\xe0s?|das|da|de|do)\\s*)?(\\d{1,4}|meio-dia|meia-noite|meio dia|meia noite)(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2})(?:(?:\\:|\\\uFF1A)(\\d{2}))?)?(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?(?=\\W|$)", 'i');
            var SECOND_REG_PATTERN = new RegExp("^\\s*(\\-|\\\u2013|\\~|\\\u301C|a(?:o)?|\\?)\\s*(\\d{1,4})(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2})(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2}))?)?(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?(?=\\W|$)", 'i');
            var HOUR_GROUP = 2;
            var MINUTE_GROUP = 3;
            var SECOND_GROUP = 4;
            var AM_PM_HOUR_GROUP = 5;
            exports.Parser = function PTTimeExpressionParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return FIRST_REG_PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    // This pattern can be overlaped Ex. [12] AM, 1[2] AM
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var refMoment = dayjs(ref);
                    var result = new ParsedResult();
                    result.ref = ref;
                    result.index = match.index + match[1].length;
                    result.text = match[0].substring(match[1].length);
                    result.tags['PTTimeExpressionParser'] = true;
                    result.start.imply('day', refMoment.date());
                    result.start.imply('month', refMoment.month() + 1);
                    result.start.imply('year', refMoment.year());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.start.assign('second', second);
                    } // ----- Hours
                    if (match[HOUR_GROUP].toLowerCase().match(/meio\-di/)) {
                        meridiem = 1;
                        hour = 12;
                    } else if (match[HOUR_GROUP].toLowerCase() == "meia-noite") {
                        meridiem = 0;
                        hour = 0;
                    } else hour = parseInt(match[HOUR_GROUP]);
                     // ----- Minutes
                    if (match[MINUTE_GROUP] != null) minute = parseInt(match[MINUTE_GROUP]);
                    else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm == "a") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        }
                        if (ampm == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    }
                    result.start.assign('hour', hour);
                    result.start.assign('minute', minute);
                    if (meridiem >= 0) result.start.assign('meridiem', meridiem);
                     // ==============================================================
                    //                  Extracting the 'to' chunk
                    // ==============================================================
                    match = SECOND_REG_PATTERN.exec(text.substring(result.index + result.text.length));
                    if (!match) {
                        // Not accept number only result
                        if (result.text.match(/^\d+$/)) return null;
                        return result;
                    } // Pattern "YY.YY -XXXX" is more like timezone offset
                    if (match[0].match(/^\s*(\+|\-)\s*\d{3,4}$/)) return result;
                    if (result.end == null) result.end = new ParsedComponents(null, result.start.date());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.end.assign('second', second);
                    }
                    hour = parseInt(match[2]); // ----- Minute
                    if (match[MINUTE_GROUP] != null) {
                        minute = parseInt(match[MINUTE_GROUP]);
                        if (minute >= 60) return result;
                    } else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        if (match[AM_PM_HOUR_GROUP][0].toLowerCase() == "a") {
                            meridiem = 0;
                            if (hour == 12) {
                                hour = 0;
                                if (!result.end.isCertain('day')) result.end.imply('day', result.end.get('day') + 1);
                            }
                        }
                        if (match[AM_PM_HOUR_GROUP][0].toLowerCase() == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                        if (!result.start.isCertain('meridiem')) {
                            if (meridiem == 0) {
                                result.start.imply('meridiem', 0);
                                if (result.start.get('hour') == 12) result.start.assign('hour', 0);
                            } else {
                                result.start.imply('meridiem', 1);
                                if (result.start.get('hour') != 12) result.start.assign('hour', result.start.get('hour') + 12);
                            }
                        }
                    } else if (hour >= 12) meridiem = 1;
                    result.text = result.text + match[0];
                    result.end.assign('hour', hour);
                    result.end.assign('minute', minute);
                    if (meridiem >= 0) result.end.assign('meridiem', meridiem);
                    if (result.end.date().getTime() < result.start.date().getTime()) result.end.imply('day', result.end.get('day') + 1);
                    return result;
                };
            };
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var updateParsedComponent = __webpack_require__(5).updateParsedComponent;
            var DAYS_OFFSET = {
                'domingo': 0,
                'dom': 0,
                'segunda': 1,
                'segunda-feira': 1,
                'seg': 1,
                "ter\xe7a": 2,
                "ter\xe7a-feira": 2,
                'ter': 2,
                'quarta': 3,
                'quarta-feira': 3,
                'qua': 3,
                'quinta': 4,
                'quinta-feira': 4,
                'qui': 4,
                'sexta': 5,
                'sexta-feira': 5,
                'sex': 5,
                "s\xe1bado": 6,
                'sabado': 6,
                'sab': 6
            };
            var PATTERN = new RegExp("(\\W|^)(?:(?:\\,|\\(|\\\uFF08)\\s*)?(?:(este|esta|passado|pr[o\xf3]ximo)\\s*)?(" + Object.keys(DAYS_OFFSET).join('|') + ')' + "(?:\\s*(?:\\,|\\)|\\\uFF09))?" + "(?:\\s*(este|esta|passado|pr[\xf3o]ximo)\\s*semana)?" + '(?=\\W|$)', 'i');
            var PREFIX_GROUP = 2;
            var WEEKDAY_GROUP = 3;
            var POSTFIX_GROUP = 4;
            exports.Parser = function PTWeekdayParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
                    var offset = DAYS_OFFSET[dayOfWeek];
                    if (offset === undefined) return null;
                    var modifier = null;
                    var prefix = match[PREFIX_GROUP];
                    var postfix = match[POSTFIX_GROUP];
                    if (prefix || postfix) {
                        var norm = prefix || postfix;
                        norm = norm.toLowerCase();
                        if (norm == 'passado') modifier = 'this';
                        else if (norm == "pr\xf3ximo" || norm == 'proximo') modifier = 'next';
                        else if (norm == 'este') modifier = 'this';
                    }
                    updateParsedComponent(result, ref, offset, modifier);
                    result.tags['PTWeekdayParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            /*
  Valid patterns:
  - esta mañana -> today in the morning
  - esta tarde -> today in the afternoon/evening
  - esta noche -> tonight
  - ayer por la mañana -> yesterday in the morning
  - ayer por la tarde -> yesterday in the afternoon/evening
  - ayer por la noche -> yesterday at night
  - mañana por la mañana -> tomorrow in the morning
  - mañana por la tarde -> tomorrow in the afternoon/evening
  - mañana por la noche -> tomorrow at night
  - anoche -> tomorrow at night
  - hoy -> today
  - ayer -> yesterday
  - mañana -> tomorrow
 */ var PATTERN = /(\W|^)(ahora|esta\s*(mañana|tarde|noche)|(ayer|mañana)\s*por\s*la\s*(mañana|tarde|noche)|hoy|mañana|ayer|anoche)(?=\W|$)/i;
            exports.Parser = function ESCasualDateParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var text = match[0].substr(match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var refMoment = dayjs(ref);
                    var startMoment = refMoment;
                    var lowerText = text.toLowerCase().replace(/\s+/g, ' ');
                    if (lowerText == "ma\xf1ana") // Check not "Tomorrow" on late night
                    {
                        if (refMoment.hour() > 1) startMoment = startMoment.add(1, 'day');
                    } else if (lowerText == 'ayer') startMoment = startMoment.add(-1, 'day');
                    else if (lowerText == 'anoche') {
                        result.start.imply('hour', 0);
                        if (refMoment.hour() > 6) startMoment = startMoment.add(-1, 'day');
                    } else if (lowerText.match("esta")) {
                        var secondMatch = match[3].toLowerCase();
                        if (secondMatch == "tarde") result.start.imply('hour', 18);
                        else if (secondMatch == "ma\xf1ana") result.start.imply('hour', 6);
                        else if (secondMatch == "noche") {
                            // Normally means this coming midnight
                            result.start.imply('hour', 22);
                            result.start.imply('meridiem', 1);
                        }
                    } else if (lowerText.match(/por\s*la/)) {
                        var firstMatch = match[4].toLowerCase();
                        if (firstMatch === 'ayer') startMoment = startMoment.add(-1, 'day');
                        else if (firstMatch === "ma\xf1ana") startMoment = startMoment.add(1, 'day');
                        var secondMatch = match[5].toLowerCase();
                        if (secondMatch == "tarde") result.start.imply('hour', 18);
                        else if (secondMatch == "ma\xf1ana") result.start.imply('hour', 9);
                        else if (secondMatch == "noche") {
                            // Normally means this coming midnight
                            result.start.imply('hour', 22);
                            result.start.imply('meridiem', 1);
                        }
                    } else if (lowerText.match("ahora")) {
                        result.start.imply('hour', refMoment.hour());
                        result.start.imply('minute', refMoment.minute());
                        result.start.imply('second', refMoment.second());
                        result.start.imply('millisecond', refMoment.millisecond());
                    }
                    result.start.assign('day', startMoment.date());
                    result.start.assign('month', startMoment.month() + 1);
                    result.start.assign('year', startMoment.year());
                    result.tags['ESCasualDateParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 39 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = /(\W|^)(dentro\s*de|en)\s*([0-9]+|medi[oa]|una?)\s*(minutos?|horas?|d[ií]as?)\s*(?=(?:\W|$))/i;
            exports.Parser = function ESDeadlineFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var num = parseInt(match[3]);
                    if (isNaN(num)) {
                        if (match[3].match(/medi/)) num = 0.5;
                        else num = 1;
                    }
                    var date = dayjs(ref);
                    if (match[4].match(/d[ií]a/)) {
                        date = date.add(num, 'd');
                        result.start.assign('year', date.year());
                        result.start.assign('month', date.month() + 1);
                        result.start.assign('day', date.date());
                        return result;
                    }
                    if (match[4].match(/hora/)) date = date.add(num, 'hour');
                    else if (match[4].match(/minuto/)) date = date.add(num, 'minute');
                    result.start.imply('year', date.year());
                    result.start.imply('month', date.month() + 1);
                    result.start.imply('day', date.date());
                    result.start.assign('hour', date.hour());
                    result.start.assign('minute', date.minute());
                    result.tags['ESDeadlineFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 40 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = /(\W|^)hace\s*([0-9]+|medi[oa]|una?)\s*(minutos?|horas?|semanas?|d[ií]as?|mes(es)?|años?)(?=(?:\W|$))/i;
            exports.Parser = function ESTimeAgoFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var num = parseInt(match[2]);
                    if (isNaN(num)) {
                        if (match[2].match(/medi/)) num = 0.5;
                        else num = 1;
                    }
                    var date = dayjs(ref);
                    if (match[3].match(/hora/) || match[3].match(/minuto/)) {
                        if (match[3].match(/hora/)) date = date.add(-num, 'hour');
                        else if (match[3].match(/minuto/)) date = date.add(-num, 'minute');
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                        result.start.assign('hour', date.hour());
                        result.start.assign('minute', date.minute());
                        result.tags['ESTimeAgoFormatParser'] = true;
                        return result;
                    }
                    if (match[3].match(/semana/)) {
                        date = date.add(-num, 'week');
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                        result.start.imply('weekday', date.day());
                        return result;
                    }
                    if (match[3].match(/d[ií]a/)) date = date.add(-num, 'd');
                    if (match[3].match(/mes/)) date = date.add(-num, 'month');
                    if (match[3].match(/año/)) date = date.add(-num, 'year');
                    result.start.assign('day', date.date());
                    result.start.assign('month', date.month() + 1);
                    result.start.assign('year', date.year());
                    return result;
                };
            };
        /***/ },
        /* 41 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var FIRST_REG_PATTERN = new RegExp("(^|\\s|T)(?:(?:a las?|al?|desde|de)\\s*)?(\\d{1,4}|mediod[i\xed]a|medianoche)(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2})(?:(?:\\:|\\\uFF1A)(\\d{2}))?)?(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?(?=\\W|$)", 'i');
            var SECOND_REG_PATTERN = new RegExp("^\\s*(\\-|\\\u2013|\\~|\\\u301C|a(?:s*las)?|\\?)\\s*(\\d{1,4})(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2})(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2}))?)?(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?(?=\\W|$)", 'i');
            var HOUR_GROUP = 2;
            var MINUTE_GROUP = 3;
            var SECOND_GROUP = 4;
            var AM_PM_HOUR_GROUP = 5;
            exports.Parser = function ESTimeExpressionParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return FIRST_REG_PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    // This pattern can be overlaped Ex. [12] AM, 1[2] AM
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var refMoment = dayjs(ref);
                    var result = new ParsedResult();
                    result.ref = ref;
                    result.index = match.index + match[1].length;
                    result.text = match[0].substring(match[1].length);
                    result.tags['ESTimeExpressionParser'] = true;
                    result.start.imply('day', refMoment.date());
                    result.start.imply('month', refMoment.month() + 1);
                    result.start.imply('year', refMoment.year());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.start.assign('second', second);
                    } // ----- Hours
                    if (match[HOUR_GROUP].toLowerCase().match(/mediod/)) {
                        meridiem = 1;
                        hour = 12;
                    } else if (match[HOUR_GROUP].toLowerCase() == "medianoche") {
                        meridiem = 0;
                        hour = 0;
                    } else hour = parseInt(match[HOUR_GROUP]);
                     // ----- Minutes
                    if (match[MINUTE_GROUP] != null) minute = parseInt(match[MINUTE_GROUP]);
                    else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm == "a") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        }
                        if (ampm == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    }
                    result.start.assign('hour', hour);
                    result.start.assign('minute', minute);
                    if (meridiem >= 0) result.start.assign('meridiem', meridiem);
                     // ==============================================================
                    //                  Extracting the 'to' chunk
                    // ==============================================================
                    match = SECOND_REG_PATTERN.exec(text.substring(result.index + result.text.length));
                    if (!match) {
                        // Not accept number only result
                        if (result.text.match(/^\d+$/)) return null;
                        return result;
                    } // Pattern "YY.YY -XXXX" is more like timezone offset
                    if (match[0].match(/^\s*(\+|\-)\s*\d{3,4}$/)) return result;
                    if (result.end == null) result.end = new ParsedComponents(null, result.start.date());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.end.assign('second', second);
                    }
                    hour = parseInt(match[2]); // ----- Minute
                    if (match[MINUTE_GROUP] != null) {
                        minute = parseInt(match[MINUTE_GROUP]);
                        if (minute >= 60) return result;
                    } else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        if (match[AM_PM_HOUR_GROUP][0].toLowerCase() == "a") {
                            meridiem = 0;
                            if (hour == 12) {
                                hour = 0;
                                if (!result.end.isCertain('day')) result.end.imply('day', result.end.get('day') + 1);
                            }
                        }
                        if (match[AM_PM_HOUR_GROUP][0].toLowerCase() == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                        if (!result.start.isCertain('meridiem')) {
                            if (meridiem == 0) {
                                result.start.imply('meridiem', 0);
                                if (result.start.get('hour') == 12) result.start.assign('hour', 0);
                            } else {
                                result.start.imply('meridiem', 1);
                                if (result.start.get('hour') != 12) result.start.assign('hour', result.start.get('hour') + 12);
                            }
                        }
                    } else if (hour >= 12) meridiem = 1;
                    result.text = result.text + match[0];
                    result.end.assign('hour', hour);
                    result.end.assign('minute', minute);
                    if (meridiem >= 0) result.end.assign('meridiem', meridiem);
                    if (result.end.date().getTime() < result.start.date().getTime()) result.end.imply('day', result.end.get('day') + 1);
                    return result;
                };
            };
        /***/ },
        /* 42 */ /***/ function(module1, exports, __webpack_require__) {
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var updateParsedComponent = __webpack_require__(5).updateParsedComponent;
            var DAYS_OFFSET = {
                'domingo': 0,
                'dom': 0,
                'lunes': 1,
                'lun': 1,
                'martes': 2,
                'mar': 2,
                'miercoles': 3,
                "mi\xe9rcoles": 3,
                'mie': 3,
                'jueves': 4,
                'jue': 4,
                'viernes': 5,
                'vier': 5,
                'sabado': 6,
                "s\xe1bado": 6,
                'sab': 6
            };
            var PATTERN = new RegExp("(\\W|^)(?:(?:\\,|\\(|\\\uFF08)\\s*)?(?:(este|pasado|pr[o\xf3]ximo)\\s*)?(" + Object.keys(DAYS_OFFSET).join('|') + ')' + "(?:\\s*(?:\\,|\\)|\\\uFF09))?" + "(?:\\s*(este|pasado|pr[\xf3o]ximo)\\s*week)?" + '(?=\\W|$)', 'i');
            var PREFIX_GROUP = 2;
            var WEEKDAY_GROUP = 3;
            var POSTFIX_GROUP = 4;
            exports.Parser = function ESWeekdayParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
                    var offset = DAYS_OFFSET[dayOfWeek];
                    if (offset === undefined) return null;
                    var modifier = null;
                    var prefix = match[PREFIX_GROUP];
                    var postfix = match[POSTFIX_GROUP];
                    if (prefix || postfix) {
                        var norm = prefix || postfix;
                        norm = norm.toLowerCase();
                        if (norm == 'pasado') modifier = 'this';
                        else if (norm == "pr\xf3ximo" || norm == 'proximo') modifier = 'next';
                        else if (norm == 'este') modifier = 'this';
                    }
                    updateParsedComponent(result, ref, offset, modifier);
                    result.tags['ESWeekdayParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 43 */ /***/ function(module1, exports, __webpack_require__) {
            var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(44);
            var DAYS_OFFSET = util.WEEKDAY_OFFSET;
            var PATTERN = new RegExp("(\\W|^)(?:(Domingo|Lunes|Martes|Mi\xe9rcoles|Miercoles|Jueves|Viernes|S\xe1bado|Sabado|Dom|Lun|Mar|Mie|Jue|Vie|Sab)\\s*,?\\s*)?([0-9]{1,2})(?:\xba|\xaa|\xb0)?(?:\\s*(?:desde|de|\\-|\\\u2013|al?|hasta|\\s)\\s*([0-9]{1,2})(?:\xba|\xaa|\xb0)?)?\\s*(?:de)?\\s*(Ene(?:ro|\\.)?|Feb(?:rero|\\.)?|Mar(?:zo|\\.)?|Abr(?:il|\\.)?|May(?:o|\\.)?|Jun(?:io|\\.)?|Jul(?:io|\\.)?|Ago(?:sto|\\.)?|Sep(?:tiembre|\\.)?|Set(?:iembre|\\.)?|Oct(?:ubre|\\.)?|Nov(?:iembre|\\.)?|Dic(?:iembre|\\.)?)(?:\\s*(?:del?)?(\\s*[0-9]{1,4}(?![^\\s]\\d))(\\s*[ad]\\.?\\s*c\\.?|a\\.?\\s*d\\.?)?)?(?=\\W|$)", 'i');
            var WEEKDAY_GROUP = 2;
            var DATE_GROUP = 3;
            var DATE_TO_GROUP = 4;
            var MONTH_NAME_GROUP = 5;
            var YEAR_GROUP = 6;
            var YEAR_BE_GROUP = 7;
            exports.Parser = function ESMonthNameLittleEndianParser() {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var result = new ParsedResult({
                        text: match[0].substr(match[1].length, match[0].length - match[1].length),
                        index: match.index + match[1].length,
                        ref: ref
                    });
                    var month = match[MONTH_NAME_GROUP];
                    month = util.MONTH_OFFSET[month.toLowerCase()];
                    var day = match[DATE_GROUP];
                    day = parseInt(day);
                    var year = null;
                    if (match[YEAR_GROUP]) {
                        year = match[YEAR_GROUP];
                        year = parseInt(year);
                        if (match[YEAR_BE_GROUP]) {
                            if (/a\.?\s*c\.?/i.test(match[YEAR_BE_GROUP])) // antes de Cristo
                            year = -year;
                        } else if (year < 100) year = year + 2000;
                    }
                    if (year) {
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.assign('year', year);
                    } else {
                        year = parser.findYearClosestToRef(ref, day, month);
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.imply('year', year);
                    } // Weekday component
                    if (match[WEEKDAY_GROUP]) {
                        var weekday = match[WEEKDAY_GROUP];
                        weekday = util.WEEKDAY_OFFSET[weekday.toLowerCase()];
                        result.start.assign('weekday', weekday);
                    } // Text can be 'range' value. Such as '12 - 13 January 2012'
                    if (match[DATE_TO_GROUP]) {
                        result.end = result.start.clone();
                        result.end.assign('day', parseInt(match[DATE_TO_GROUP]));
                    }
                    result.tags['ESMonthNameLittleEndianParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 44 */ /***/ function(module1, exports) {
            exports.WEEKDAY_OFFSET = {
                'domingo': 0,
                'dom': 0,
                'lunes': 1,
                'lun': 1,
                'martes': 2,
                'mar': 2,
                "mi\xe9rcoles": 3,
                'miercoles': 3,
                'mie': 3,
                'jueves': 4,
                'jue': 4,
                'viernes': 5,
                'vie': 5,
                "s\xe1bado": 6,
                'sabado': 6,
                'sab': 6
            };
            exports.MONTH_OFFSET = {
                'enero': 1,
                'ene': 1,
                'ene.': 1,
                'febrero': 2,
                'feb': 2,
                'feb.': 2,
                'marzo': 3,
                'mar': 3,
                'mar.': 3,
                'abril': 4,
                'abr': 4,
                'abr.': 4,
                'mayo': 5,
                'may': 5,
                'may.': 5,
                'junio': 6,
                'jun': 6,
                'jun.': 6,
                'julio': 7,
                'jul': 7,
                'jul.': 7,
                'agosto': 8,
                'ago': 8,
                'ago.': 8,
                'septiembre': 9,
                'sep': 9,
                'sept': 9,
                'sep.': 9,
                'sept.': 9,
                'octubre': 10,
                'oct': 10,
                'oct.': 10,
                'noviembre': 11,
                'nov': 11,
                'nov.': 11,
                'diciembre': 12,
                'dic': 12,
                'dic.': 12
            };
        /***/ },
        /* 45 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    Date format with slash "/" (also "-" and ".") between numbers
    - Martes 3/11/2015
    - 3/11/2015
    - 3/11
*/ var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = new RegExp("(\\W|^)(?:((?:domingo|dom|lunes|lun|martes|mar|mi[\xe9e]rcoles|mie|jueves|jue|viernes|vie|s[\xe1a]bado|sab))\\s*\\,?\\s*)?([0-1]{0,1}[0-9]{1})[\\/\\.\\-]([0-3]{0,1}[0-9]{1})(?:[\\/\\.\\-]([0-9]{4}s*,?s*|[0-9]{2}s*,?s*))?(\\W|$)", 'i');
            var DAYS_OFFSET = {
                'domingo': 0,
                'dom': 0,
                'lunes': 1,
                'lun': 1,
                'martes': 2,
                'mar': 2,
                'miercoles': 3,
                "mi\xe9rcoles": 3,
                'mie': 3,
                'jueves': 4,
                'jue': 4,
                'viernes': 5,
                'vier': 5,
                "s\xe1bado": 6,
                'sabado': 6,
                'sab': 6
            };
            var OPENNING_GROUP = 1;
            var ENDING_GROUP = 6; // in Spanish we use day/month/year
            var WEEKDAY_GROUP = 2;
            var MONTH_GROUP = 4;
            var DAY_GROUP = 3;
            var YEAR_GROUP = 5;
            exports.Parser = function ESSlashDateFormatParser(argument) {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match[OPENNING_GROUP] == '/' || match[ENDING_GROUP] == '/') {
                        // Long skip, if there is some overlapping like:
                        // XX[/YY/ZZ]
                        // [XX/YY/]ZZ
                        match.index += match[0].length;
                        return;
                    }
                    var index = match.index + match[OPENNING_GROUP].length;
                    var text = match[0].substr(match[OPENNING_GROUP].length, match[0].length - match[ENDING_GROUP].length);
                    var result = new ParsedResult({
                        text: text,
                        index: index,
                        ref: ref
                    });
                    if (text.match(/^\d\.\d$/)) return;
                    if (text.match(/^\d\.\d{1,2}\.\d{1,2}$/)) return; // MM/dd -> OK
                    // MM.dd -> NG
                    if (!match[YEAR_GROUP] && match[0].indexOf('/') < 0) return;
                    var date = null;
                    var year = match[YEAR_GROUP] || dayjs(ref).year() + '';
                    var month = match[MONTH_GROUP];
                    var day = match[DAY_GROUP];
                    month = parseInt(month);
                    day = parseInt(day);
                    year = parseInt(year);
                    if (month < 1 || month > 12) {
                        if (month > 12) {
                            // dd/mm/yyyy date format if day looks like a month, and month
                            // looks like a day.
                            if (day >= 1 && day <= 12 && month >= 13 && month <= 31) {
                                // unambiguous
                                var tday = month;
                                month = day;
                                day = tday;
                            } else // both month and day are <= 12
                            return null;
                        }
                    }
                    if (day < 1 || day > 31) return null;
                    if (year < 100) {
                        if (year > 50) year = year + 1900;
                        else year = year + 2000;
                    }
                    result.start.assign('day', day);
                    result.start.assign('month', month);
                    result.start.assign('year', year); //Day of week
                    if (match[WEEKDAY_GROUP]) result.start.assign('weekday', DAYS_OFFSET[match[WEEKDAY_GROUP].toLowerCase()]);
                    result.tags['ESSlashDateFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 46 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = /(\W|^)(maintenant|aujourd'hui|ajd|cette\s*nuit|la\s*veille|(demain|hier)(\s*(matin|soir|aprem|après-midi))?|ce\s*(matin|soir)|cet\s*(après-midi|aprem))(?=\W|$)/i;
            exports.Parser = function FRCasualDateParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var text = match[0].substr(match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var refMoment = dayjs(ref);
                    var startMoment = refMoment;
                    var lowerText = text.toLowerCase();
                    if (lowerText.match(/demain/)) // Check not "Tomorrow" on late night
                    {
                        if (refMoment.hour() > 1) startMoment = startMoment.add(1, 'day');
                    }
                    if (lowerText.match(/hier/)) startMoment = startMoment.add(-1, 'day');
                    if (lowerText.match(/cette\s*nuit/)) {
                        // Normally means this coming midnight
                        result.start.imply('hour', 22);
                        result.start.imply('meridiem', 1);
                    } else if (lowerText.match(/la\s*veille/)) {
                        result.start.imply('hour', 0);
                        if (refMoment.hour() > 6) startMoment = startMoment.add(-1, 'day');
                    } else if (lowerText.match(/(après-midi|aprem)/)) result.start.imply('hour', 14);
                    else if (lowerText.match(/(soir)/)) result.start.imply('hour', 18);
                    else if (lowerText.match(/matin/)) result.start.imply('hour', 8);
                    else if (lowerText.match("maintenant")) {
                        result.start.imply('hour', refMoment.hour());
                        result.start.imply('minute', refMoment.minute());
                        result.start.imply('second', refMoment.second());
                        result.start.imply('millisecond', refMoment.millisecond());
                    }
                    result.start.assign('day', startMoment.date());
                    result.start.assign('month', startMoment.month() + 1);
                    result.start.assign('year', startMoment.year());
                    result.tags['FRCasualDateParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 47 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(9);
            var PATTERN = new RegExp("(\\W|^)(dans|en)\\s*(" + util.INTEGER_WORDS_PATTERN + '|[0-9]+|une?|(?:\\s*quelques)?|demi(?:\\s*|-?)?)\\s*' + "(secondes?|min(?:ute)?s?|heures?|jours?|semaines?|mois|ann\xe9es?)\\s*" + '(?=\\W|$)', 'i');
            var STRICT_PATTERN = new RegExp("(\\W|^)(dans|en)\\s*(" + util.INTEGER_WORDS_PATTERN + '|[0-9]+|un?)\\s*' + '(secondes?|minutes?|heures?|jours?)\\s*' + '(?=\\W|$)', 'i');
            exports.Parser = function FRDeadlineFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return this.isStrictMode() ? STRICT_PATTERN : PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var num = match[3];
                    if (util.INTEGER_WORDS[num] !== undefined) num = util.INTEGER_WORDS[num];
                    else if (num === 'un' || num === 'une') num = 1;
                    else if (num.match(/quelques?/i)) num = 3;
                    else if (num.match(/demi-?/i)) num = 0.5;
                    else num = parseInt(num);
                    var date = dayjs(ref);
                    if (match[4].match(/jour|semaine|mois|année/i)) {
                        if (match[4].match(/jour/)) date = date.add(num, 'd');
                        else if (match[4].match(/semaine/i)) date = date.add(num * 7, 'd');
                        else if (match[4].match(/mois/i)) date = date.add(num, 'month');
                        else if (match[4].match(/année/i)) date = date.add(num, 'year');
                        result.start.assign('year', date.year());
                        result.start.assign('month', date.month() + 1);
                        result.start.assign('day', date.date());
                        return result;
                    }
                    if (match[4].match(/heure/i)) date = date.add(num, 'hour');
                    else if (match[4].match(/min/i)) date = date.add(num, 'minutes');
                    else if (match[4].match(/secondes/i)) date = date.add(num, 'second');
                    result.start.imply('year', date.year());
                    result.start.imply('month', date.month() + 1);
                    result.start.imply('day', date.date());
                    result.start.assign('hour', date.hour());
                    result.start.assign('minute', date.minute());
                    result.start.assign('second', date.second());
                    result.tags['FRDeadlineFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 48 */ /***/ function(module1, exports, __webpack_require__) {
            var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(9);
            var DAYS_OFFSET = util.WEEKDAY_OFFSET;
            var PATTERN = new RegExp("(\\W|^)(?:(Dimanche|Lundi|Mardi|mercredi|Jeudi|Vendredi|Samedi|Dim|Lun|Mar|Mer|Jeu|Ven|Sam)\\s*,?\\s*)?([0-9]{1,2}|1er)(?:\\s*(?:au|\\-|\\\u2013|jusqu'au?|\\s)\\s*([0-9]{1,2})(?:er)?)?\\s*(?:de)?\\s*(Jan(?:vier|\\.)?|F[\xe9e]v(?:rier|\\.)?|Mars|Avr(?:il|\\.)?|Mai|Juin|Juil(?:let|\\.)?|Ao[u\xfb]t|Sept(?:embre|\\.)?|Oct(?:obre|\\.)?|Nov(?:embre|\\.)?|d[\xe9e]c(?:embre|\\.)?)(?:\\s*(\\s*[0-9]{1,4}(?![^\\s]\\d))(?:\\s*(AC|[ap]\\.?\\s*c(?:h(?:r)?)?\\.?\\s*n\\.?))?)?(?=\\W|$)", 'i');
            var WEEKDAY_GROUP = 2;
            var DATE_GROUP = 3;
            var DATE_TO_GROUP = 4;
            var MONTH_NAME_GROUP = 5;
            var YEAR_GROUP = 6;
            var YEAR_BE_GROUP = 7;
            exports.Parser = function FRMonthNameLittleEndianParser() {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var result = new ParsedResult({
                        text: match[0].substr(match[1].length, match[0].length - match[1].length),
                        index: match.index + match[1].length,
                        ref: ref
                    });
                    var month = match[MONTH_NAME_GROUP];
                    month = util.MONTH_OFFSET[month.toLowerCase()];
                    var day = match[DATE_GROUP];
                    day = parseInt(day);
                    var year = null;
                    if (match[YEAR_GROUP]) {
                        year = match[YEAR_GROUP];
                        year = parseInt(year);
                        if (match[YEAR_BE_GROUP]) {
                            if (/a/i.test(match[YEAR_BE_GROUP])) // Ante Christe natum
                            year = -year;
                        } else if (year < 100) year = year + 2000;
                    }
                    if (year) {
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.assign('year', year);
                    } else {
                        year = parser.findYearClosestToRef(ref, day, month);
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.imply('year', year);
                    } // Weekday component
                    if (match[WEEKDAY_GROUP]) {
                        var weekday = match[WEEKDAY_GROUP];
                        weekday = util.WEEKDAY_OFFSET[weekday.toLowerCase()];
                        result.start.assign('weekday', weekday);
                    } // Text can be 'range' value. Such as '12 - 13 janvier 2012'
                    if (match[DATE_TO_GROUP]) {
                        result.end = result.start.clone();
                        result.end.assign('day', parseInt(match[DATE_TO_GROUP]));
                    }
                    result.tags['FRMonthNameLittleEndianParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 49 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    Date format with slash "/" (also "-" and ".") between numbers
    - Martes 3/11/2015
    - 3/11/2015
    - 3/11
*/ var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = new RegExp("(\\W|^)(?:((?:dimanche|dim|lundi|lun|mardi|mar|mercredi|mer|jeudi|jeu|vendredi|ven|samedi|sam|le))\\s*\\,?\\s*)?([0-3]{0,1}[0-9]{1})[\\/\\.\\-]([0-3]{0,1}[0-9]{1})(?:[\\/\\.\\-]([0-9]{4}s*,?s*|[0-9]{2}s*,?s*))?(\\W|$)", 'i');
            var DAYS_OFFSET = {
                'dimanche': 0,
                'dim': 0,
                'lundi': 1,
                'lun': 1,
                'mardi': 2,
                'mar': 2,
                'mercredi': 3,
                'mer': 3,
                'jeudi': 4,
                'jeu': 4,
                'vendredi': 5,
                'ven': 5,
                'samedi': 6,
                'sam': 6
            };
            var OPENNING_GROUP = 1;
            var ENDING_GROUP = 6; // In French we use day/month/year
            var WEEKDAY_GROUP = 2;
            var DAY_GROUP = 3;
            var MONTH_GROUP = 4;
            var YEAR_GROUP = 5;
            exports.Parser = function FRSlashDateFormatParser(argument) {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match[OPENNING_GROUP] == '/' || match[ENDING_GROUP] == '/') {
                        // Long skip, if there is some overlapping like:
                        // XX[/YY/ZZ]
                        // [XX/YY/]ZZ
                        match.index += match[0].length;
                        return;
                    }
                    var index = match.index + match[OPENNING_GROUP].length;
                    var text = match[0].substr(match[OPENNING_GROUP].length, match[0].length - match[ENDING_GROUP].length);
                    var result = new ParsedResult({
                        text: text,
                        index: index,
                        ref: ref
                    });
                    if (text.match(/^\d\.\d$/)) return;
                    if (text.match(/^\d\.\d{1,2}\.\d{1,2}$/)) return; // MM/dd -> OK
                    // MM.dd -> NG
                    if (!match[YEAR_GROUP] && match[0].indexOf('/') < 0) return;
                    var date = null;
                    var month = match[MONTH_GROUP];
                    var day = match[DAY_GROUP];
                    day = parseInt(day);
                    month = parseInt(month);
                    var year = null;
                    if (match[YEAR_GROUP]) {
                        year = match[YEAR_GROUP];
                        year = parseInt(year);
                        if (year < 100) year = year + 2000;
                    }
                    if (month < 1 || month > 12) {
                        if (month > 12) {
                            // dd/mm/yyyy date format if day looks like a month, and month looks like a day.
                            if (day >= 1 && day <= 12 && month >= 13 && month <= 31) {
                                // unambiguous
                                var tday = month;
                                month = day;
                                day = tday;
                            } else // both month and day are <= 12
                            return null;
                        }
                    }
                    if (day < 1 || day > 31) return null;
                    if (year) {
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.assign('year', year);
                    } else {
                        year = parser.findYearClosestToRef(ref, day, month);
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.imply('year', year);
                    } // Day of week
                    if (match[WEEKDAY_GROUP]) result.start.assign('weekday', DAYS_OFFSET[match[WEEKDAY_GROUP].toLowerCase()]);
                    result.tags['FRSlashDateFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 50 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = /(\W|^)il y a\s*([0-9]+|une?)\s*(minutes?|heures?|semaines?|jours?|mois|années?|ans?)(?=(?:\W|$))/i;
            exports.Parser = function FRTimeAgoFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    result.tags['FRTimeAgoFormatParser'] = true;
                    var num = parseInt(match[2]);
                    if (isNaN(num)) {
                        if (match[2].match(/demi/)) num = 0.5;
                        else num = 1;
                    }
                    var date = dayjs(ref);
                    if (match[3].match(/heure/) || match[3].match(/minute/)) {
                        if (match[3].match(/heure/)) date = date.add(-num, 'hour');
                        else if (match[3].match(/minute/)) date = date.add(-num, 'minute');
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                        result.start.assign('hour', date.hour());
                        result.start.assign('minute', date.minute());
                        return result;
                    }
                    if (match[3].match(/semaine/)) {
                        date = date.add(-num, 'week');
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                        result.start.imply('weekday', date.day());
                        return result;
                    }
                    if (match[3].match(/jour/)) date = date.add(-num, 'd');
                    if (match[3].match(/mois/)) date = date.add(-num, 'month');
                    if (match[3].match(/années?|ans?/)) date = date.add(-num, 'year');
                    result.start.assign('day', date.date());
                    result.start.assign('month', date.month() + 1);
                    result.start.assign('year', date.year());
                    return result;
                };
            };
        /***/ },
        /* 51 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var FIRST_REG_PATTERN = new RegExp("(^|\\s|T)(?:(?:[\xe0a])\\s*)?(\\d{1,2}(?:h)?|midi|minuit)(?:(?:\\.|\\:|\\\uFF1A|h)(\\d{1,2})(?:m)?(?:(?:\\:|\\\uFF1A|m)(\\d{0,2})(?:s)?)?)?(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?(?=\\W|$)", 'i');
            var SECOND_REG_PATTERN = new RegExp("^\\s*(\\-|\\\u2013|\\~|\\\u301C|[\xe0a]|\\?)\\s*(\\d{1,2}(?:h)?)(?:(?:\\.|\\:|\\\uFF1A|h)(\\d{1,2})(?:m)?(?:(?:\\.|\\:|\\\uFF1A|m)(\\d{1,2})(?:s)?)?)?(?:\\s*(A\\.M\\.|P\\.M\\.|AM?|PM?))?(?=\\W|$)", 'i');
            var HOUR_GROUP = 2;
            var MINUTE_GROUP = 3;
            var SECOND_GROUP = 4;
            var AM_PM_HOUR_GROUP = 5;
            exports.Parser = function FRTimeExpressionParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return FIRST_REG_PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    // This pattern can be overlaped Ex. [12] AM, 1[2] AM
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var refMoment = dayjs(ref);
                    var result = new ParsedResult();
                    result.ref = ref;
                    result.index = match.index + match[1].length;
                    result.text = match[0].substring(match[1].length);
                    result.tags['FRTimeExpressionParser'] = true;
                    result.start.imply('day', refMoment.date());
                    result.start.imply('month', refMoment.month() + 1);
                    result.start.imply('year', refMoment.year());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.start.assign('second', second);
                    } // ----- Hours
                    if (match[HOUR_GROUP].toLowerCase() == "midi") {
                        meridiem = 1;
                        hour = 12;
                    } else if (match[HOUR_GROUP].toLowerCase() == "minuit") {
                        meridiem = 0;
                        hour = 0;
                    } else hour = parseInt(match[HOUR_GROUP]);
                     // ----- Minutes
                    if (match[MINUTE_GROUP] != null) minute = parseInt(match[MINUTE_GROUP]);
                    else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm == "a") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        }
                        if (ampm == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    }
                    result.start.assign('hour', hour);
                    result.start.assign('minute', minute);
                    if (meridiem >= 0) result.start.assign('meridiem', meridiem);
                     // ==============================================================
                    //                  Extracting the 'to' chunk
                    // ==============================================================
                    match = SECOND_REG_PATTERN.exec(text.substring(result.index + result.text.length));
                    if (!match) {
                        // Not accept number only result
                        if (result.text.match(/^\d+$/)) return null;
                        return result;
                    } // Pattern "YY.YY -XXXX" is more like timezone offset
                    if (match[0].match(/^\s*(\+|\-)\s*\d{3,4}$/)) return result;
                    if (result.end == null) result.end = new ParsedComponents(null, result.start.date());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.end.assign('second', second);
                    }
                    hour = parseInt(match[2]); // ----- Minute
                    if (match[MINUTE_GROUP] != null) {
                        minute = parseInt(match[MINUTE_GROUP]);
                        if (minute >= 60) return result;
                    } else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm == "a") {
                            meridiem = 0;
                            if (hour == 12) {
                                hour = 0;
                                if (!result.end.isCertain('day')) result.end.imply('day', result.end.get('day') + 1);
                            }
                        }
                        if (ampm == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                        if (!result.start.isCertain('meridiem')) {
                            if (meridiem == 0) {
                                result.start.imply('meridiem', 0);
                                if (result.start.get('hour') == 12) result.start.assign('hour', 0);
                            } else {
                                result.start.imply('meridiem', 1);
                                if (result.start.get('hour') != 12) result.start.assign('hour', result.start.get('hour') + 12);
                            }
                        }
                    }
                    result.text = result.text + match[0];
                    result.end.assign('hour', hour);
                    result.end.assign('minute', minute);
                    if (meridiem >= 0) result.end.assign('meridiem', meridiem);
                    else {
                        var startAtPM = result.start.isCertain('meridiem') && result.start.get('meridiem') == 1;
                        if (startAtPM && result.start.get('hour') > hour) // 10pm - 1 (am)
                        result.end.imply('meridiem', 0);
                        else if (hour > 12) result.end.imply('meridiem', 1);
                    }
                    if (result.end.date().getTime() < result.start.date().getTime()) result.end.imply('day', result.end.get('day') + 1);
                    return result;
                };
            };
        /***/ },
        /* 52 */ /***/ function(module1, exports, __webpack_require__) {
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var updateParsedComponent = __webpack_require__(5).updateParsedComponent;
            var DAYS_OFFSET = {
                'dimanche': 0,
                'dim': 0,
                'lundi': 1,
                'lun': 1,
                'mardi': 2,
                'mar': 2,
                'mercredi': 3,
                'mer': 3,
                'jeudi': 4,
                'jeu': 4,
                'vendredi': 5,
                'ven': 5,
                'samedi': 6,
                'sam': 6
            };
            var PATTERN = new RegExp("(\\s|^)(?:(?:\\,|\\(|\\\uFF08)\\s*)?(?:(ce)\\s*)?(" + Object.keys(DAYS_OFFSET).join('|') + ')' + "(?:\\s*(?:\\,|\\)|\\\uFF09))?" + '(?:\\s*(dernier|prochain)\\s*)?' + '(?=\\W|$)', 'i');
            var PREFIX_GROUP = 2;
            var WEEKDAY_GROUP = 3;
            var POSTFIX_GROUP = 4;
            exports.Parser = function FRWeekdayParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
                    var offset = DAYS_OFFSET[dayOfWeek];
                    if (offset === undefined) return null;
                    var modifier = null;
                    var prefix = match[PREFIX_GROUP];
                    var postfix = match[POSTFIX_GROUP];
                    if (prefix || postfix) {
                        var norm = prefix || postfix;
                        norm = norm.toLowerCase();
                        if (norm == 'dernier') modifier = 'last';
                        else if (norm == 'prochain') modifier = 'next';
                        else if (norm == 'ce') modifier = 'this';
                    }
                    updateParsedComponent(result, ref, offset, modifier);
                    result.tags['FRWeekdayParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 53 */ /***/ function(module1, exports, __webpack_require__) {
            var quarterOfYear = __webpack_require__(54);
            var dayjs = __webpack_require__(2);
            dayjs.extend(quarterOfYear);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(9);
            var PATTERN = new RegExp("(\\W|^)(?:les?|la|l'|du|des?)\\s*(" + util.INTEGER_WORDS_PATTERN + '|\\d+)?\\s*' + "(prochaine?s?|derni[e\xe8]re?s?|pass[\xe9e]e?s?|pr[\xe9e]c[\xe9e]dents?|suivante?s?)?\\s*" + "(secondes?|min(?:ute)?s?|heures?|jours?|semaines?|mois|trimestres?|ann\xe9es?)\\s*" + "(prochaine?s?|derni[e\xe8]re?s?|pass[\xe9e]e?s?|pr[\xe9e]c[\xe9e]dents?|suivante?s?)?" + '(?=\\W|$)', 'i');
            var MULTIPLIER_GROUP = 2;
            var MODIFIER_1_GROUP = 3;
            var RELATIVE_WORD_GROUP = 4;
            var MODIFIER_2_GROUP = 5;
            exports.Parser = function FRRelativeDateFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length); // Multiplier
                    var multiplier = match[MULTIPLIER_GROUP] === undefined ? '1' : match[MULTIPLIER_GROUP];
                    if (util.INTEGER_WORDS[multiplier] !== undefined) multiplier = util.INTEGER_WORDS[multiplier];
                    else multiplier = parseInt(multiplier);
                     // Modifier
                    var modifier = match[MODIFIER_1_GROUP] === undefined ? match[MODIFIER_2_GROUP] === undefined ? '' : match[MODIFIER_2_GROUP].toLowerCase() : match[MODIFIER_1_GROUP].toLowerCase();
                    if (!modifier) // At least one modifier is mandatory to match this parser
                    return;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    result.tags['FRRelativeDateFormatParser'] = true;
                    var modifierFactor;
                    switch(true){
                        case /prochaine?s?/.test(modifier):
                        case /suivants?/.test(modifier):
                            modifierFactor = 1;
                            break;
                        case /derni[eè]re?s?/.test(modifier):
                        case /pass[ée]e?s?/.test(modifier):
                        case /pr[ée]c[ée]dents?/.test(modifier):
                            modifierFactor = -1;
                            break;
                    }
                    var total = multiplier * modifierFactor;
                    var dateFrom = dayjs(ref);
                    var dateTo = dayjs(ref);
                    var relative = match[RELATIVE_WORD_GROUP];
                    var startOf;
                    switch(true){
                        case /secondes?/.test(relative):
                            dateFrom = dateFrom.add(total, 's');
                            dateTo = dateTo.add(modifierFactor, 's');
                            startOf = 'second';
                            break;
                        case /min(?:ute)?s?/.test(relative):
                            dateFrom = dateFrom.add(total, 'm');
                            dateTo = dateTo.add(modifierFactor, 'm');
                            startOf = 'minute';
                            break;
                        case /heures?/.test(relative):
                            dateFrom = dateFrom.add(total, 'h');
                            dateTo = dateTo.add(modifierFactor, 'h');
                            startOf = 'hour';
                            break;
                        case /jours?/.test(relative):
                            dateFrom = dateFrom.add(total, 'd');
                            dateTo = dateTo.add(modifierFactor, 'd');
                            startOf = 'day';
                            break;
                        case /semaines?/.test(relative):
                            dateFrom = dateFrom.add(total, 'w');
                            dateTo = dateTo.add(modifierFactor, 'w');
                            startOf = 'week';
                            break;
                        case /mois?/.test(relative):
                            dateFrom = dateFrom.add(total, 'M');
                            dateTo = dateTo.add(modifierFactor, 'M');
                            startOf = 'month';
                            break;
                        case /trimestres?/.test(relative):
                            dateFrom = dateFrom.add(total, 'Q');
                            dateTo = dateTo.add(modifierFactor, 'Q');
                            startOf = 'quarter';
                            break;
                        case /années?/.test(relative):
                            dateFrom = dateFrom.add(total, 'y');
                            dateTo = dateTo.add(modifierFactor, 'y');
                            startOf = 'year';
                            break;
                    } // if we go forward, switch the start and end dates
                    if (modifierFactor > 0) {
                        var dateTmp = dateFrom;
                        dateFrom = dateTo;
                        dateTo = dateTmp;
                    } // Get start and end of dates
                    dateFrom = dateFrom.startOf(startOf);
                    dateTo = dateTo.endOf(startOf);
                    if (startOf == 'week') {
                        // Weekday in FR start on Sat?
                        dateFrom = dateFrom.add(1, 'd');
                        dateTo = dateTo.add(1, 'd');
                    } // Assign results
                    result.start.assign('year', dateFrom.year());
                    result.start.assign('month', dateFrom.month() + 1);
                    result.start.assign('day', dateFrom.date());
                    result.start.assign('minute', dateFrom.minute());
                    result.start.assign('second', dateFrom.second());
                    result.start.assign('hour', dateFrom.hour());
                    result.start.assign('millisecond', dateFrom.millisecond());
                    result.end = result.start.clone();
                    result.end.assign('year', dateTo.year());
                    result.end.assign('month', dateTo.month() + 1);
                    result.end.assign('day', dateTo.date());
                    result.end.assign('minute', dateTo.minute());
                    result.end.assign('second', dateTo.second());
                    result.end.assign('hour', dateTo.hour());
                    result.end.assign('millisecond', dateTo.millisecond());
                    return result;
                };
            };
        /***/ },
        /* 54 */ /***/ function(module1, exports, __webpack_require__) {
            !function(t, n) {
                module1.exports = n();
            }(this, function() {
                "use strict";
                var t = "month", n = "quarter";
                return function(r, i) {
                    var e = i.prototype;
                    e.quarter = function(t) {
                        return this.$utils().u(t) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t - 1));
                    };
                    var u = e.add;
                    e.add = function(r, i) {
                        return r = Number(r), this.$utils().p(i) === n ? this.add(3 * r, t) : u.bind(this)(r, i);
                    };
                    var s = e.startOf;
                    e.startOf = function(r, i) {
                        var e = this.$utils(), u = !!e.u(i) || i;
                        if (e.p(r) === n) {
                            var a = this.quarter() - 1;
                            return u ? this.month(3 * a).startOf(t).startOf("day") : this.month(3 * a + 2).endOf(t).endOf("day");
                        }
                        return s.bind(this)(r, i);
                    };
                };
            });
        /***/ },
        /* 55 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(7);
            var PATTERN = new RegExp('(\\d{2,4}|[' + Object.keys(util.NUMBER).join('') + ']{2,4})?' + '(?:\\s*)' + "(?:\u5E74)?" + "(?:[\\s|,|\uFF0C]*)" + '(\\d{1,2}|[' + Object.keys(util.NUMBER).join('') + ']{1,2})' + '(?:\\s*)' + "(?:\u6708)" + '(?:\\s*)' + '(\\d{1,2}|[' + Object.keys(util.NUMBER).join('') + ']{1,2})?' + '(?:\\s*)' + "(?:\u65E5|\u865F)?");
            var YEAR_GROUP = 1;
            var MONTH_GROUP = 2;
            var DAY_GROUP = 3;
            exports.Parser = function ZHHantDateParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var startMoment = dayjs(ref);
                    var result = new ParsedResult({
                        text: match[0],
                        index: match.index,
                        ref: ref
                    }); //Month
                    var month = parseInt(match[MONTH_GROUP]);
                    if (isNaN(month)) month = util.zhStringToNumber(match[MONTH_GROUP]);
                    result.start.assign('month', month); //Day
                    if (match[DAY_GROUP]) {
                        var day = parseInt(match[DAY_GROUP]);
                        if (isNaN(day)) day = util.zhStringToNumber(match[DAY_GROUP]);
                        result.start.assign('day', day);
                    } else result.start.imply('day', startMoment.date());
                     //Year
                    if (match[YEAR_GROUP]) {
                        var year = parseInt(match[YEAR_GROUP]);
                        if (isNaN(year)) year = util.zhStringToYear(match[YEAR_GROUP]);
                        result.start.assign('year', year);
                    } else result.start.imply('year', startMoment.year());
                    result.tags.ZHHantDateParser = true;
                    return result;
                };
            };
        /***/ },
        /* 56 */ /***/ function(module1, exports, __webpack_require__) {
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var updateParsedComponent = __webpack_require__(5).updateParsedComponent;
            var util = __webpack_require__(7);
            var PATTERN = new RegExp("(\u4E0A|\u4ECA|\u4E0B|\u9019|\u5462)?(?:\u500B)?(?:\u661F\u671F|\u79AE\u62DC)(" + Object.keys(util.WEEKDAY_OFFSET).join('|') + ')');
            var PREFIX_GROUP = 1;
            var WEEKDAY_GROUP = 2;
            exports.Parser = function ZHHantWeekdayParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index;
                    text = match[0];
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var dayOfWeek = match[WEEKDAY_GROUP];
                    var offset = util.WEEKDAY_OFFSET[dayOfWeek];
                    if (offset === undefined) return null;
                    var modifier = null;
                    var prefix = match[PREFIX_GROUP];
                    if (prefix == "\u4E0A") modifier = 'last';
                    else if (prefix == "\u4E0B") modifier = 'next';
                    else if (prefix == "\u4ECA" || prefix == "\u9019" || prefix == "\u5462") modifier = 'this';
                    updateParsedComponent(result, ref, offset, modifier);
                    result.tags['ZHHantWeekdayParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 57 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var util = __webpack_require__(7);
            var patternString1 = "(?:\u7531|\u5F9E|\u81EA)?(?:(\u4ECA|\u660E|\u524D|\u5927\u524D|\u5F8C|\u5927\u5F8C|\u807D|\u6628|\u5C0B|\u7434)(\u65E9|\u671D|\u665A)|(\u4E0A(?:\u5348|\u665D)|\u671D(?:\u65E9)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348|\u665D)|\u664F(?:\u665D)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668))|(\u4ECA|\u660E|\u524D|\u5927\u524D|\u5F8C|\u5927\u5F8C|\u807D|\u6628|\u5C0B|\u7434)(?:\u65E5|\u5929)(?:[\\s,\uFF0C]*)(?:(\u4E0A(?:\u5348|\u665D)|\u671D(?:\u65E9)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348|\u665D)|\u664F(?:\u665D)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668)))?)?(?:[\\s,\uFF0C]*)(?:(\\d+|[" + Object.keys(util.NUMBER).join('') + "]+)(?:\\s*)(?:\u9EDE|\u6642|:|\uFF1A)" + '(?:\\s*)' + "(\\d+|\u534A|\u6B63|\u6574|[" + Object.keys(util.NUMBER).join('') + "]+)?(?:\\s*)(?:\u5206|:|\uFF1A)?" + '(?:\\s*)' + '(\\d+|[' + Object.keys(util.NUMBER).join('') + "]+)?(?:\\s*)(?:\u79D2)?)" + '(?:\\s*(A\.M\.|P\.M\.|AM?|PM?))?';
            var patternString2 = "(?:\\s*(?:\u5230|\u81F3|\\-|\\\u2013|\\~|\\\u301C)\\s*)(?:(\u4ECA|\u660E|\u524D|\u5927\u524D|\u5F8C|\u5927\u5F8C|\u807D|\u6628|\u5C0B|\u7434)(\u65E9|\u671D|\u665A)|(\u4E0A(?:\u5348|\u665D)|\u671D(?:\u65E9)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348|\u665D)|\u664F(?:\u665D)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668))|(\u4ECA|\u660E|\u524D|\u5927\u524D|\u5F8C|\u5927\u5F8C|\u807D|\u6628|\u5C0B|\u7434)(?:\u65E5|\u5929)(?:[\\s,\uFF0C]*)(?:(\u4E0A(?:\u5348|\u665D)|\u671D(?:\u65E9)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348|\u665D)|\u664F(?:\u665D)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668)))?)?(?:[\\s,\uFF0C]*)(?:(\\d+|[" + Object.keys(util.NUMBER).join('') + "]+)(?:\\s*)(?:\u9EDE|\u6642|:|\uFF1A)" + '(?:\\s*)' + "(\\d+|\u534A|\u6B63|\u6574|[" + Object.keys(util.NUMBER).join('') + "]+)?(?:\\s*)(?:\u5206|:|\uFF1A)?" + '(?:\\s*)' + '(\\d+|[' + Object.keys(util.NUMBER).join('') + "]+)?(?:\\s*)(?:\u79D2)?)" + '(?:\\s*(A\.M\.|P\.M\.|AM?|PM?))?';
            var FIRST_REG_PATTERN = new RegExp(patternString1, 'i');
            var SECOND_REG_PATTERN = new RegExp(patternString2, 'i');
            var DAY_GROUP_1 = 1;
            var ZH_AM_PM_HOUR_GROUP_1 = 2;
            var ZH_AM_PM_HOUR_GROUP_2 = 3;
            var DAY_GROUP_3 = 4;
            var ZH_AM_PM_HOUR_GROUP_3 = 5;
            var HOUR_GROUP = 6;
            var MINUTE_GROUP = 7;
            var SECOND_GROUP = 8;
            var AM_PM_HOUR_GROUP = 9;
            exports.Parser = function ZHHantTimeExpressionParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return FIRST_REG_PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    // This pattern can be overlaped Ex. [12] AM, 1[2] AM
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var refMoment = dayjs(ref);
                    var result = new ParsedResult();
                    result.ref = ref;
                    result.index = match.index;
                    result.text = match[0];
                    result.tags.ZHTimeExpressionParser = true;
                    var startMoment = refMoment.clone(); // ----- Day
                    if (match[DAY_GROUP_1]) {
                        var day1 = match[DAY_GROUP_1];
                        if (day1 == "\u660E" || day1 == "\u807D") // Check not "Tomorrow" on late night
                        {
                            if (refMoment.hour() > 1) startMoment.add(1, 'day');
                        } else if (day1 == "\u6628" || day1 == "\u5C0B" || day1 == "\u7434") startMoment.add(-1, 'day');
                        else if (day1 == "\u524D") startMoment.add(-2, 'day');
                        else if (day1 == "\u5927\u524D") startMoment.add(-3, 'day');
                        else if (day1 == "\u5F8C") startMoment.add(2, 'day');
                        else if (day1 == "\u5927\u5F8C") startMoment.add(3, 'day');
                        result.start.assign('day', startMoment.date());
                        result.start.assign('month', startMoment.month() + 1);
                        result.start.assign('year', startMoment.year());
                    } else if (match[DAY_GROUP_3]) {
                        var day3 = match[DAY_GROUP_3];
                        if (day3 == "\u660E" || day3 == "\u807D") startMoment.add(1, 'day');
                        else if (day3 == "\u6628" || day3 == "\u5C0B" || day3 == "\u7434") startMoment.add(-1, 'day');
                        else if (day3 == "\u524D") startMoment.add(-2, 'day');
                        else if (day3 == "\u5927\u524D") startMoment.add(-3, 'day');
                        else if (day3 == "\u5F8C") startMoment.add(2, 'day');
                        else if (day3 == "\u5927\u5F8C") startMoment.add(3, 'day');
                        result.start.assign('day', startMoment.date());
                        result.start.assign('month', startMoment.month() + 1);
                        result.start.assign('year', startMoment.year());
                    } else {
                        result.start.imply('day', startMoment.date());
                        result.start.imply('month', startMoment.month() + 1);
                        result.start.imply('year', startMoment.year());
                    }
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP]) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (isNaN(second)) second = util.zhStringToNumber(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.start.assign('second', second);
                    }
                    hour = parseInt(match[HOUR_GROUP]);
                    if (isNaN(hour)) hour = util.zhStringToNumber(match[HOUR_GROUP]);
                     // ----- Minutes
                    if (match[MINUTE_GROUP]) {
                        if (match[MINUTE_GROUP] == "\u534A") minute = 30;
                        else if (match[MINUTE_GROUP] == "\u6B63" || match[MINUTE_GROUP] == "\u6574") minute = 0;
                        else {
                            minute = parseInt(match[MINUTE_GROUP]);
                            if (isNaN(minute)) minute = util.zhStringToNumber(match[MINUTE_GROUP]);
                        }
                    } else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM
                    if (match[AM_PM_HOUR_GROUP]) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm == "a") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        }
                        if (ampm == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    } else if (match[ZH_AM_PM_HOUR_GROUP_1]) {
                        var zhAMPMString1 = match[ZH_AM_PM_HOUR_GROUP_1];
                        var zhAMPM1 = zhAMPMString1[0];
                        if (zhAMPM1 == "\u671D" || zhAMPM1 == "\u65E9") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        } else if (zhAMPM1 == "\u665A") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    } else if (match[ZH_AM_PM_HOUR_GROUP_2]) {
                        var zhAMPMString2 = match[ZH_AM_PM_HOUR_GROUP_2];
                        var zhAMPM2 = zhAMPMString2[0];
                        if (zhAMPM2 == "\u4E0A" || zhAMPM2 == "\u671D" || zhAMPM2 == "\u65E9" || zhAMPM2 == "\u51CC") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        } else if (zhAMPM2 == "\u4E0B" || zhAMPM2 == "\u664F" || zhAMPM2 == "\u665A") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    } else if (match[ZH_AM_PM_HOUR_GROUP_3]) {
                        var zhAMPMString3 = match[ZH_AM_PM_HOUR_GROUP_3];
                        var zhAMPM3 = zhAMPMString3[0];
                        if (zhAMPM3 == "\u4E0A" || zhAMPM3 == "\u671D" || zhAMPM3 == "\u65E9" || zhAMPM3 == "\u51CC") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        } else if (zhAMPM3 == "\u4E0B" || zhAMPM3 == "\u664F" || zhAMPM3 == "\u665A") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    }
                    result.start.assign('hour', hour);
                    result.start.assign('minute', minute);
                    if (meridiem >= 0) result.start.assign('meridiem', meridiem);
                    else if (hour < 12) result.start.imply('meridiem', 0);
                    else result.start.imply('meridiem', 1);
                     // ==============================================================
                    //                  Extracting the 'to' chunk
                    // ==============================================================
                    match = SECOND_REG_PATTERN.exec(text.substring(result.index + result.text.length));
                    if (!match) {
                        // Not accept number only result
                        if (result.text.match(/^\d+$/)) return null;
                        return result;
                    }
                    var endMoment = startMoment.clone();
                    result.end = new ParsedComponents(null, null); // ----- Day
                    if (match[DAY_GROUP_1]) {
                        var day1 = match[DAY_GROUP_1];
                        if (day1 == "\u660E" || day1 == "\u807D") // Check not "Tomorrow" on late night
                        {
                            if (refMoment.hour() > 1) endMoment.add(1, 'day');
                        } else if (day1 == "\u6628" || day1 == "\u5C0B" || day1 == "\u7434") endMoment.add(-1, 'day');
                        else if (day1 == "\u524D") endMoment.add(-2, 'day');
                        else if (day1 == "\u5927\u524D") endMoment.add(-3, 'day');
                        else if (day1 == "\u5F8C") endMoment.add(2, 'day');
                        else if (day1 == "\u5927\u5F8C") endMoment.add(3, 'day');
                        result.end.assign('day', endMoment.date());
                        result.end.assign('month', endMoment.month() + 1);
                        result.end.assign('year', endMoment.year());
                    } else if (match[DAY_GROUP_3]) {
                        var day3 = match[DAY_GROUP_3];
                        if (day3 == "\u660E" || day3 == "\u807D") endMoment.add(1, 'day');
                        else if (day3 == "\u6628" || day3 == "\u5C0B" || day3 == "\u7434") endMoment.add(-1, 'day');
                        else if (day3 == "\u524D") endMoment.add(-2, 'day');
                        else if (day3 == "\u5927\u524D") endMoment.add(-3, 'day');
                        else if (day3 == "\u5F8C") endMoment.add(2, 'day');
                        else if (day3 == "\u5927\u5F8C") endMoment.add(3, 'day');
                        result.end.assign('day', endMoment.date());
                        result.end.assign('month', endMoment.month() + 1);
                        result.end.assign('year', endMoment.year());
                    } else {
                        result.end.imply('day', endMoment.date());
                        result.end.imply('month', endMoment.month() + 1);
                        result.end.imply('year', endMoment.year());
                    }
                    hour = 0;
                    minute = 0;
                    meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP]) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (isNaN(second)) second = util.zhStringToNumber(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.end.assign('second', second);
                    }
                    hour = parseInt(match[HOUR_GROUP]);
                    if (isNaN(hour)) hour = util.zhStringToNumber(match[HOUR_GROUP]);
                     // ----- Minutes
                    if (match[MINUTE_GROUP]) {
                        if (match[MINUTE_GROUP] == "\u534A") minute = 30;
                        else if (match[MINUTE_GROUP] == "\u6B63" || match[MINUTE_GROUP] == "\u6574") minute = 0;
                        else {
                            minute = parseInt(match[MINUTE_GROUP]);
                            if (isNaN(minute)) minute = util.zhStringToNumber(match[MINUTE_GROUP]);
                        }
                    } else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM
                    if (match[AM_PM_HOUR_GROUP]) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm == "a") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        }
                        if (ampm == "p") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                        if (!result.start.isCertain('meridiem')) {
                            if (meridiem == 0) {
                                result.start.imply('meridiem', 0);
                                if (result.start.get('hour') == 12) result.start.assign('hour', 0);
                            } else {
                                result.start.imply('meridiem', 1);
                                if (result.start.get('hour') != 12) result.start.assign('hour', result.start.get('hour') + 12);
                            }
                        }
                    } else if (match[ZH_AM_PM_HOUR_GROUP_1]) {
                        var zhAMPMString1 = match[ZH_AM_PM_HOUR_GROUP_1];
                        var zhAMPM1 = zhAMPMString1[0];
                        if (zhAMPM1 == "\u671D" || zhAMPM1 == "\u65E9") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        } else if (zhAMPM1 == "\u665A") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    } else if (match[ZH_AM_PM_HOUR_GROUP_2]) {
                        var zhAMPMString2 = match[ZH_AM_PM_HOUR_GROUP_2];
                        var zhAMPM2 = zhAMPMString2[0];
                        if (zhAMPM2 == "\u4E0A" || zhAMPM2 == "\u671D" || zhAMPM2 == "\u65E9" || zhAMPM2 == "\u51CC") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        } else if (zhAMPM2 == "\u4E0B" || zhAMPM2 == "\u664F" || zhAMPM2 == "\u665A") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    } else if (match[ZH_AM_PM_HOUR_GROUP_3]) {
                        var zhAMPMString3 = match[ZH_AM_PM_HOUR_GROUP_3];
                        var zhAMPM3 = zhAMPMString3[0];
                        if (zhAMPM3 == "\u4E0A" || zhAMPM3 == "\u671D" || zhAMPM3 == "\u65E9" || zhAMPM3 == "\u51CC") {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        } else if (zhAMPM3 == "\u4E0B" || zhAMPM3 == "\u664F" || zhAMPM3 == "\u665A") {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    }
                    result.text = result.text + match[0];
                    result.end.assign('hour', hour);
                    result.end.assign('minute', minute);
                    if (meridiem >= 0) result.end.assign('meridiem', meridiem);
                    else {
                        var startAtPM = result.start.isCertain('meridiem') && result.start.get('meridiem') == 1;
                        if (startAtPM && result.start.get('hour') > hour) // 10pm - 1 (am)
                        result.end.imply('meridiem', 0);
                        else if (hour > 12) result.end.imply('meridiem', 1);
                    }
                    if (result.end.date().getTime() < result.start.date().getTime()) result.end.imply('day', result.end.get('day') + 1);
                    return result;
                };
            };
        /***/ },
        /* 58 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = new RegExp("(\u800C\u5BB6|\u7ACB(?:\u523B|\u5373)|\u5373\u523B)|(\u4ECA|\u660E|\u524D|\u5927\u524D|\u5F8C|\u5927\u5F8C|\u807D|\u6628|\u5C0B|\u7434)(\u65E9|\u671D|\u665A)|(\u4E0A(?:\u5348|\u665D)|\u671D(?:\u65E9)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348|\u665D)|\u664F(?:\u665D)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668))|(\u4ECA|\u660E|\u524D|\u5927\u524D|\u5F8C|\u5927\u5F8C|\u807D|\u6628|\u5C0B|\u7434)(?:\u65E5|\u5929)(?:[\\s|,|\uFF0C]*)(?:(\u4E0A(?:\u5348|\u665D)|\u671D(?:\u65E9)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348|\u665D)|\u664F(?:\u665D)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668)))?", 'i');
            var NOW_GROUP = 1;
            var DAY_GROUP_1 = 2;
            var TIME_GROUP_1 = 3;
            var TIME_GROUP_2 = 4;
            var DAY_GROUP_3 = 5;
            var TIME_GROUP_3 = 6;
            exports.Parser = function ZHHantCasualDateParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    text = match[0];
                    var index = match.index;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var refMoment = dayjs(ref);
                    var startMoment = refMoment;
                    if (match[NOW_GROUP]) {
                        result.start.imply('hour', refMoment.hour());
                        result.start.imply('minute', refMoment.minute());
                        result.start.imply('second', refMoment.second());
                        result.start.imply('millisecond', refMoment.millisecond());
                    } else if (match[DAY_GROUP_1]) {
                        var day1 = match[DAY_GROUP_1];
                        var time1 = match[TIME_GROUP_1];
                        if (day1 == "\u660E" || day1 == "\u807D") // Check not "Tomorrow" on late night
                        {
                            if (refMoment.hour() > 1) startMoment = startMoment.add(1, 'day');
                        } else if (day1 == "\u6628" || day1 == "\u5C0B" || day1 == "\u7434") startMoment = startMoment.add(-1, 'day');
                        else if (day1 == "\u524D") startMoment = startMoment.add(-2, 'day');
                        else if (day1 == "\u5927\u524D") startMoment = startMoment.add(-3, 'day');
                        else if (day1 == "\u5F8C") startMoment = startMoment.add(2, 'day');
                        else if (day1 == "\u5927\u5F8C") startMoment = startMoment.add(3, 'day');
                        if (time1 == "\u65E9" || time1 == "\u671D") result.start.imply('hour', 6);
                        else if (time1 == "\u665A") {
                            result.start.imply('hour', 22);
                            result.start.imply('meridiem', 1);
                        }
                    } else if (match[TIME_GROUP_2]) {
                        var timeString2 = match[TIME_GROUP_2];
                        var time2 = timeString2[0];
                        if (time2 == "\u65E9" || time2 == "\u671D" || time2 == "\u4E0A") result.start.imply('hour', 6);
                        else if (time2 == "\u4E0B" || time2 == "\u664F") {
                            result.start.imply('hour', 15);
                            result.start.imply('meridiem', 1);
                        } else if (time2 == "\u4E2D") {
                            result.start.imply('hour', 12);
                            result.start.imply('meridiem', 1);
                        } else if (time2 == "\u591C" || time2 == "\u665A") {
                            result.start.imply('hour', 22);
                            result.start.imply('meridiem', 1);
                        } else if (time2 == "\u51CC") result.start.imply('hour', 0);
                    } else if (match[DAY_GROUP_3]) {
                        var day3 = match[DAY_GROUP_3];
                        if (day3 == "\u660E" || day3 == "\u807D") // Check not "Tomorrow" on late night
                        {
                            if (refMoment.hour() > 1) startMoment = startMoment.add(1, 'day');
                        } else if (day3 == "\u6628" || day3 == "\u5C0B" || day3 == "\u7434") startMoment = startMoment.add(-1, 'day');
                        else if (day3 == "\u524D") startMoment = startMoment.add(-2, 'day');
                        else if (day3 == "\u5927\u524D") startMoment = startMoment.add(-3, 'day');
                        else if (day3 == "\u5F8C") startMoment = startMoment.add(2, 'day');
                        else if (day3 == "\u5927\u5F8C") startMoment = startMoment.add(3, 'day');
                        var timeString3 = match[TIME_GROUP_3];
                        if (timeString3) {
                            var time3 = timeString3[0];
                            if (time3 == "\u65E9" || time3 == "\u671D" || time3 == "\u4E0A") result.start.imply('hour', 6);
                            else if (time3 == "\u4E0B" || time3 == "\u664F") {
                                result.start.imply('hour', 15);
                                result.start.imply('meridiem', 1);
                            } else if (time3 == "\u4E2D") {
                                result.start.imply('hour', 12);
                                result.start.imply('meridiem', 1);
                            } else if (time3 == "\u591C" || time3 == "\u665A") {
                                result.start.imply('hour', 22);
                                result.start.imply('meridiem', 1);
                            } else if (time3 == "\u51CC") result.start.imply('hour', 0);
                        }
                    }
                    result.start.assign('day', startMoment.date());
                    result.start.assign('month', startMoment.month() + 1);
                    result.start.assign('year', startMoment.year());
                    result.tags.ZHHantCasualDateParser = true;
                    return result;
                };
            };
        /***/ },
        /* 59 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(7);
            var PATTERN = new RegExp('(\\d+|[' + Object.keys(util.NUMBER).join('') + "]+|\u534A|\u5E7E)(?:\\s*)" + "(?:\u500B)?" + "(\u79D2(?:\u9418)?|\u5206\u9418|\u5C0F\u6642|\u9418|\u65E5|\u5929|\u661F\u671F|\u79AE\u62DC|\u6708|\u5E74)" + "(?:(?:\u4E4B|\u904E)?\u5F8C|(?:\u4E4B)?\u5167)", 'i');
            var NUMBER_GROUP = 1;
            var UNIT_GROUP = 2;
            exports.Parser = function ZHHantCasualDateParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index;
                    text = match[0];
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var number = parseInt(match[NUMBER_GROUP]);
                    if (isNaN(number)) number = util.zhStringToNumber(match[NUMBER_GROUP]);
                    if (isNaN(number)) {
                        var string = match[NUMBER_GROUP];
                        if (string === "\u5E7E") number = 3;
                        else if (string === "\u534A") number = 0.5;
                        else //just in case
                        return null;
                    }
                    var date = dayjs(ref);
                    var unit = match[UNIT_GROUP];
                    var unitAbbr = unit[0];
                    if (unitAbbr.match(/[日天星禮月年]/)) {
                        if (unitAbbr == "\u65E5" || unitAbbr == "\u5929") date = date.add(number, 'd');
                        else if (unitAbbr == "\u661F" || unitAbbr == "\u79AE") date = date.add(number * 7, 'd');
                        else if (unitAbbr == "\u6708") date = date.add(number, 'month');
                        else if (unitAbbr == "\u5E74") date = date.add(number, 'year');
                        result.start.assign('year', date.year());
                        result.start.assign('month', date.month() + 1);
                        result.start.assign('day', date.date());
                        return result;
                    }
                    if (unitAbbr == "\u79D2") date = date.add(number, 'second');
                    else if (unitAbbr == "\u5206") date = date.add(number, 'minute');
                    else if (unitAbbr == "\u5C0F" || unitAbbr == "\u9418") date = date.add(number, 'hour');
                    result.start.imply('year', date.year());
                    result.start.imply('month', date.month() + 1);
                    result.start.imply('day', date.date());
                    result.start.assign('hour', date.hour());
                    result.start.assign('minute', date.minute());
                    result.start.assign('second', date.second());
                    result.tags.ZHHantDeadlineFormatParser = true;
                    return result;
                };
            };
        /***/ },
        /* 60 */ /***/ function(module1, exports, __webpack_require__) {
            /*


*/ var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(8);
            var PATTERN = new RegExp("(\\W|^)(in|nach)\\s*(" + util.INTEGER_WORDS_PATTERN + '|[0-9]+|einigen|eine[rm]\\s*halben|eine[rm])\\s*' + '(sekunden?|min(?:ute)?n?|stunden?|tag(?:en)?|wochen?|monat(?:en)?|jahr(?:en)?)\\s*' + '(?=\\W|$)', 'i');
            var STRICT_PATTERN = new RegExp("(\\W|^)(in|nach)\\s*(" + util.INTEGER_WORDS_PATTERN + '|[0-9]+|eine(?:r|m)?)\\s*' + '(sekunden?|minuten?|stunden?|tag(?:en)?)\\s*' + '(?=\\W|$)', 'i');
            exports.Parser = function DEDeadlineFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return this.isStrictMode() ? STRICT_PATTERN : PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var num = match[3].toLowerCase();
                    if (util.INTEGER_WORDS[num] !== undefined) num = util.INTEGER_WORDS[num];
                    else if (num === 'einer' || num === 'einem') num = 1;
                    else if (num === 'einigen') num = 3;
                    else if (/halben/.test(num)) num = 0.5;
                    else num = parseInt(num);
                    var date = dayjs(ref);
                    if (/tag|woche|monat|jahr/i.test(match[4])) {
                        if (/tag/i.test(match[4])) date = date.add(num, 'd');
                        else if (/woche/i.test(match[4])) date = date.add(num * 7, 'd');
                        else if (/monat/i.test(match[4])) date = date.add(num, 'month');
                        else if (/jahr/i.test(match[4])) date = date.add(num, 'year');
                        result.start.assign('year', date.year());
                        result.start.assign('month', date.month() + 1);
                        result.start.assign('day', date.date());
                        return result;
                    }
                    if (/stunde/i.test(match[4])) date = date.add(num, 'hour');
                    else if (/min/i.test(match[4])) date = date.add(num, 'minute');
                    else if (/sekunde/i.test(match[4])) date = date.add(num, 'second');
                    result.start.imply('year', date.year());
                    result.start.imply('month', date.month() + 1);
                    result.start.imply('day', date.date());
                    result.start.assign('hour', date.hour());
                    result.start.assign('minute', date.minute());
                    result.start.assign('second', date.second());
                    result.tags['DEDeadlineFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 61 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(8);
            var PATTERN = new RegExp("(\\W|^)(?:am\\s*?)?(?:(Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag|So|Mo|Di|Mi|Do|Fr|Sa)\\s*,?\\s*)?(?:den\\s*)?([0-9]{1,2})\\.(?:\\s*(?:bis(?:\\s*(?:am|zum))?|\\-|\\\u2013|\\s)\\s*([0-9]{1,2})\\.)?\\s*(Jan(?:uar|\\.)?|Feb(?:ruar|\\.)?|M\xe4r(?:z|\\.)?|Maerz|Mrz\\.?|Apr(?:il|\\.)?|Mai|Jun(?:i|\\.)?|Jul(?:i|\\.)?|Aug(?:ust|\\.)?|Sep(?:t|t\\.|tember|\\.)?|Okt(?:ober|\\.)?|Nov(?:ember|\\.)?|Dez(?:ember|\\.)?)(?:,?\\s*([0-9]{1,4}(?![^\\s]\\d))(\\s*[vn]\\.?\\s*C(?:hr)?\\.?)?)?(?=\\W|$)", 'i');
            var WEEKDAY_GROUP = 2;
            var DATE_GROUP = 3;
            var DATE_TO_GROUP = 4;
            var MONTH_NAME_GROUP = 5;
            var YEAR_GROUP = 6;
            var YEAR_BE_GROUP = 7;
            exports.Parser = function DEMonthNameLittleEndianParser() {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var result = new ParsedResult({
                        text: match[0].substr(match[1].length, match[0].length - match[1].length),
                        index: match.index + match[1].length,
                        ref: ref
                    });
                    var month = match[MONTH_NAME_GROUP];
                    month = util.MONTH_OFFSET[month.toLowerCase()];
                    var day = match[DATE_GROUP];
                    day = parseInt(day);
                    var year = null;
                    if (match[YEAR_GROUP]) {
                        year = match[YEAR_GROUP];
                        year = parseInt(year);
                        if (match[YEAR_BE_GROUP]) {
                            if (/v/i.test(match[YEAR_BE_GROUP])) // v.Chr.
                            year = -year;
                        } else if (year < 100) year = year + 2000;
                    }
                    if (year) {
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.assign('year', year);
                    } else {
                        year = parser.findYearClosestToRef(ref, day, month);
                        result.start.assign('day', day);
                        result.start.assign('month', month);
                        result.start.imply('year', year);
                    } // Weekday component
                    if (match[WEEKDAY_GROUP]) {
                        var weekday = match[WEEKDAY_GROUP];
                        weekday = util.WEEKDAY_OFFSET[weekday.toLowerCase()];
                        result.start.assign('weekday', weekday);
                    } // Text can be 'range' value. Such as '12 - 13 January 2012'
                    if (match[DATE_TO_GROUP]) {
                        result.end = result.start.clone();
                        result.end.assign('day', parseInt(match[DATE_TO_GROUP]));
                    }
                    result.tags['DEMonthNameLittleEndianParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 62 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    
    The parser for parsing month name and year.
    
    EX. 
        - Januar
        - Januar 2012
*/ var parser = __webpack_require__(1);
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(8);
            var PATTERN = new RegExp("(^|\\D\\s+|[^\\w\\s])(Jan\\.?|Januar|Feb\\.?|Februar|M\xe4r\\.?|M(?:\xe4|ae)rz|Mrz\\.?|Apr\\.?|April|Mai\\.?|Jun\\.?|Juni|Jul\\.?|Juli|Aug\\.?|August|Sep\\.?|Sept\\.?|September|Okt\\.?|Oktober|Nov\\.?|November|Dez\\.?|Dezember)\\s*(?:,?\\s*(?:([0-9]{4})(\\s*[vn]\\.?\\s*C(?:hr)?\\.?)?|([0-9]{1,4})\\s*([vn]\\.?\\s*C(?:hr)?\\.?)))?(?=[^\\s\\w]|$)", 'i');
            var MONTH_NAME_GROUP = 2;
            var YEAR_GROUP = 3;
            var YEAR_BE_GROUP = 4;
            var YEAR_GROUP2 = 5;
            var YEAR_BE_GROUP2 = 6;
            exports.Parser = function ENMonthNameParser() {
                parser.Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var result = new ParsedResult({
                        text: match[0].substr(match[1].length, match[0].length - match[1].length),
                        index: match.index + match[1].length,
                        ref: ref
                    });
                    var month = match[MONTH_NAME_GROUP];
                    month = util.MONTH_OFFSET[month.toLowerCase()];
                    var day = 1;
                    var year = null;
                    if (match[YEAR_GROUP] || match[YEAR_GROUP2]) {
                        year = match[YEAR_GROUP] || match[YEAR_GROUP2];
                        year = parseInt(year);
                        if (match[YEAR_BE_GROUP] || match[YEAR_BE_GROUP2]) {
                            if (/v/i.test(match[YEAR_BE_GROUP] || match[YEAR_BE_GROUP2])) // v.Chr.
                            year = -year;
                        } else if (year < 100) year = year + 2000;
                    }
                    if (year) {
                        result.start.imply('day', day);
                        result.start.assign('month', month);
                        result.start.assign('year', year);
                    } else {
                        year = parser.findYearClosestToRef(ref, day, month);
                        result.start.imply('day', day);
                        result.start.assign('month', month);
                        result.start.imply('year', year);
                    }
                    if (this.isStrictMode() && result.text.match(/^\w+$/)) return false;
                    result.tags['DEMonthNameParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 63 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    Date format with slash "/" (also "-" and ".") between numbers
    - Tuesday 11/3/2015
    - 11/3/2015
    - 11/3
*/ var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = new RegExp("(\\W|^)(?:(?:am\\s*?)?((?:sonntag|so|montag|mo|dienstag|di|mittwoch|mi|donnerstag|do|freitag|fr|samstag|sa))\\s*\\,?\\s*(?:den\\s*)?)?([0-3]{0,1}[0-9]{1})[\\/\\.\\-]([0-3]{0,1}[0-9]{1})(?:[\\/\\.\\-]([0-9]{4}s*,?s*|[0-9]{2}s*,?s*))?(\\W|$)", 'i');
            var DAYS_OFFSET = {
                'sonntag': 0,
                'so': 0,
                'montag': 1,
                'mo': 1,
                'dienstag': 2,
                'di': 2,
                'mittwoch': 3,
                'mi': 3,
                'donnerstag': 4,
                'do': 4,
                'freitag': 5,
                'fr': 5,
                'samstag': 6,
                'sa': 6
            };
            var OPENNING_GROUP = 1;
            var ENDING_GROUP = 6;
            var WEEKDAY_GROUP = 2;
            var DAY_GROUP = 3;
            var MONTH_GROUP = 4;
            var YEAR_GROUP = 5;
            exports.Parser = function DESlashDateFormatParser(argument) {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match[OPENNING_GROUP] == '/' || match[ENDING_GROUP] == '/') {
                        // Long skip, if there is some overlapping like:
                        // XX[/YY/ZZ]
                        // [XX/YY/]ZZ
                        match.index += match[0].length;
                        return;
                    }
                    var index = match.index + match[OPENNING_GROUP].length;
                    var text = match[0].substr(match[OPENNING_GROUP].length, match[0].length - match[ENDING_GROUP].length);
                    var result = new ParsedResult({
                        text: text,
                        index: index,
                        ref: ref
                    });
                    if (text.match(/^\d\.\d$/)) return;
                    if (text.match(/^\d\.\d{1,2}\.\d{1,2}$/)) return; // MM/dd -> OK
                    // MM.dd -> NG
                    if (!match[YEAR_GROUP] && match[0].indexOf('/') < 0) return;
                    var year = match[YEAR_GROUP] || dayjs(ref).year() + '';
                    var month = match[MONTH_GROUP];
                    var day = match[DAY_GROUP];
                    month = parseInt(month);
                    day = parseInt(day);
                    year = parseInt(year);
                    if (month < 1 || month > 12) return null;
                    if (day < 1 || day > 31) return null;
                    if (year < 100) {
                        if (year > 50) year = year + 1900;
                        else year = year + 2000;
                    }
                    result.start.assign('day', day);
                    result.start.assign('month', month);
                    result.start.assign('year', year); //Day of week
                    if (match[WEEKDAY_GROUP]) result.start.assign('weekday', DAYS_OFFSET[match[WEEKDAY_GROUP].toLowerCase()]);
                    result.tags['DESlashDateFormatParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 64 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var util = __webpack_require__(8);
            var PATTERN = new RegExp("(\\W|^)vor\\s*(" + util.INTEGER_WORDS_PATTERN + '|[0-9]+|einigen|eine[rm]\\s*halben|eine[rm])\\s*' + '(sekunden?|min(?:ute)?n?|stunden?|wochen?|tag(?:en)?|monat(?:en)?|jahr(?:en)?)\\s*' + '(?=(?:\\W|$))', 'i');
            var STRICT_PATTERN = new RegExp("(\\W|^)vor\\s*([0-9]+|eine(?:r|m))\\s*(sekunden?|minuten?|stunden?|tag(?:en)?)(?=(?:\\W|$))", 'i');
            exports.Parser = function DETimeAgoFormatParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return this.isStrictMode() ? STRICT_PATTERN : PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var text = match[0];
                    text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var num = match[2].toLowerCase();
                    if (util.INTEGER_WORDS[num] !== undefined) num = util.INTEGER_WORDS[num];
                    else if (num === 'einer' || num === 'einem') num = 1;
                    else if (num === 'einigen') num = 3;
                    else if (/halben/.test(num)) num = 0.5;
                    else num = parseInt(num);
                    var date = dayjs(ref);
                    if (/stunde|min|sekunde/i.test(match[3])) {
                        if (/stunde/i.test(match[3])) date = date.add(-num, 'hour');
                        else if (/min/i.test(match[3])) date = date.add(-num, 'minute');
                        else if (/sekunde/i.test(match[3])) date = date.add(-num, 'second');
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                        result.start.assign('hour', date.hour());
                        result.start.assign('minute', date.minute());
                        result.start.assign('second', date.second());
                        result.tags['DETimeAgoFormatParser'] = true;
                        return result;
                    }
                    if (/woche/i.test(match[3])) {
                        date = date.add(-num, 'week');
                        result.start.imply('day', date.date());
                        result.start.imply('month', date.month() + 1);
                        result.start.imply('year', date.year());
                        result.start.imply('weekday', date.day());
                        return result;
                    }
                    if (/tag/i.test(match[3])) date = date.add(-num, 'd');
                    if (/monat/i.test(match[3])) date = date.add(-num, 'month');
                    if (/jahr/i.test(match[3])) date = date.add(-num, 'year');
                    result.start.assign('day', date.date());
                    result.start.assign('month', date.month() + 1);
                    result.start.assign('year', date.year());
                    return result;
                };
            };
        /***/ },
        /* 65 */ /***/ function(module1, exports, __webpack_require__) {
            /*


*/ var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var FIRST_REG_PATTERN = new RegExp("(^|\\s|T)(?:(?:um|von)\\s*)?(\\d{1,4}|mittags?|mitternachts?)(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2})(?:(?:\\:|\\\uFF1A)(\\d{2}))?)?(?:\\s*uhr)?(?:\\s*(morgens|vormittags|mittags|nachmittags|abends|nachts))?(?=\\W|$)", 'i');
            var SECOND_REG_PATTERN = new RegExp("^\\s*(\\-|\\\u2013|\\~|\\\u301C|bis|\\?)\\s*(\\d{1,4})(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2})(?:(?:\\.|\\:|\\\uFF1A)(\\d{1,2}))?)?(?:\\s*(morgens|vormittags|mittags|nachmittags|abends|nachts))?(?=\\W|$)", 'i');
            var HOUR_GROUP = 2;
            var MINUTE_GROUP = 3;
            var SECOND_GROUP = 4;
            var AM_PM_HOUR_GROUP = 5;
            exports.Parser = function DETimeExpressionParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return FIRST_REG_PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    // This pattern can be overlaped Ex. [12] AM, 1[2] AM
                    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
                    var refMoment = dayjs(ref);
                    var result = new ParsedResult();
                    result.ref = ref;
                    result.index = match.index + match[1].length;
                    result.text = match[0].substring(match[1].length);
                    result.tags['DETimeExpressionParser'] = true;
                    result.start.imply('day', refMoment.date());
                    result.start.imply('month', refMoment.month() + 1);
                    result.start.imply('year', refMoment.year());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.start.assign('second', second);
                    } // ----- Hours
                    if (/mittags?/i.test(match[HOUR_GROUP])) {
                        meridiem = 1;
                        hour = 12;
                    } else if (/mitternachts?/i.test(match[HOUR_GROUP])) {
                        meridiem = 0;
                        hour = 0;
                    } else hour = parseInt(match[HOUR_GROUP]);
                     // ----- Minutes
                    if (match[MINUTE_GROUP] != null) minute = parseInt(match[MINUTE_GROUP]);
                    else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM  
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm === 'morgens' || ampm === 'vormittags') {
                            meridiem = 0;
                            if (hour == 12) hour = 0;
                        } else {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                    }
                    result.start.assign('hour', hour);
                    result.start.assign('minute', minute);
                    if (meridiem >= 0) result.start.assign('meridiem', meridiem);
                    else if (hour < 12) result.start.imply('meridiem', 0);
                    else result.start.imply('meridiem', 1);
                     // ==============================================================
                    //                  Extracting the 'to' chunk
                    // ==============================================================
                    match = SECOND_REG_PATTERN.exec(text.substring(result.index + result.text.length));
                    if (!match) {
                        // Not accept number only result
                        if (result.text.match(/^\d+$/)) return null;
                        return result;
                    } // Pattern "YY.YY -XXXX" is more like timezone offset
                    if (match[0].match(/^\s*(\+|\-)\s*\d{3,4}$/)) return result;
                    if (result.end == null) result.end = new ParsedComponents(null, result.start.date());
                    var hour = 0;
                    var minute = 0;
                    var meridiem = -1; // ----- Second
                    if (match[SECOND_GROUP] != null) {
                        var second = parseInt(match[SECOND_GROUP]);
                        if (second >= 60) return null;
                        result.end.assign('second', second);
                    }
                    hour = parseInt(match[2]); // ----- Minute
                    if (match[MINUTE_GROUP] != null) {
                        minute = parseInt(match[MINUTE_GROUP]);
                        if (minute >= 60) return result;
                    } else if (hour > 100) {
                        minute = hour % 100;
                        hour = parseInt(hour / 100);
                    }
                    if (minute >= 60) return null;
                    if (hour > 24) return null;
                    if (hour >= 12) meridiem = 1;
                     // ----- AM & PM 
                    if (match[AM_PM_HOUR_GROUP] != null) {
                        if (hour > 12) return null;
                        var ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
                        if (ampm === 'morgens' || ampm === 'vormittags') {
                            meridiem = 0;
                            if (hour == 12) {
                                hour = 0;
                                if (!result.end.isCertain('day')) result.end.imply('day', result.end.get('day') + 1);
                            }
                        } else {
                            meridiem = 1;
                            if (hour != 12) hour += 12;
                        }
                        if (!result.start.isCertain('meridiem')) {
                            if (meridiem == 0) {
                                result.start.imply('meridiem', 0);
                                if (result.start.get('hour') == 12) result.start.assign('hour', 0);
                            } else {
                                result.start.imply('meridiem', 1);
                                if (result.start.get('hour') != 12) result.start.assign('hour', result.start.get('hour') + 12);
                            }
                        }
                    }
                    result.text = result.text + match[0];
                    result.end.assign('hour', hour);
                    result.end.assign('minute', minute);
                    if (meridiem >= 0) result.end.assign('meridiem', meridiem);
                    else {
                        var startAtPM = result.start.isCertain('meridiem') && result.start.get('meridiem') == 1;
                        if (startAtPM && result.start.get('hour') > hour) // 10pm - 1 (am)
                        result.end.imply('meridiem', 0);
                        else if (hour > 12) result.end.imply('meridiem', 1);
                    }
                    if (result.end.date().getTime() < result.start.date().getTime()) result.end.imply('day', result.end.get('day') + 1);
                    return result;
                };
            };
        /***/ },
        /* 66 */ /***/ function(module1, exports, __webpack_require__) {
            /*


*/ var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var DAYS_OFFSET = {
                'sonntag': 0,
                'so': 0,
                'montag': 1,
                'mo': 1,
                'dienstag': 2,
                'di': 2,
                'mittwoch': 3,
                'mi': 3,
                'donnerstag': 4,
                'do': 4,
                'freitag': 5,
                'fr': 5,
                'samstag': 6,
                'sa': 6
            };
            var PATTERN = new RegExp("(\\W|^)(?:(?:\\,|\\(|\\\uFF08)\\s*)?(?:a[mn]\\s*?)?(?:(diese[mn]|letzte[mn]|n(?:\xe4|ae)chste[mn])\\s*)?(" + Object.keys(DAYS_OFFSET).join('|') + ')' + "(?:\\s*(?:\\,|\\)|\\\uFF09))?" + "(?:\\s*(diese|letzte|n(?:\xe4|ae)chste)\\s*woche)?" + '(?=\\W|$)', 'i');
            var PREFIX_GROUP = 2;
            var WEEKDAY_GROUP = 3;
            var POSTFIX_GROUP = 4;
            exports.Parser = function DEWeekdayParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    var index = match.index + match[1].length;
                    var text = match[0].substr(match[1].length, match[0].length - match[1].length);
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
                    var offset = DAYS_OFFSET[dayOfWeek];
                    if (offset === undefined) return null;
                    var startMoment = dayjs(ref);
                    var prefix = match[PREFIX_GROUP];
                    var postfix = match[POSTFIX_GROUP];
                    var refOffset = startMoment.day();
                    var norm = prefix || postfix;
                    norm = norm || '';
                    norm = norm.toLowerCase();
                    if (/letzte/.test(norm)) startMoment = startMoment.day(offset - 7);
                    else if (/n(?:ä|ae)chste/.test(norm)) startMoment = startMoment.day(offset + 7);
                    else if (/diese/.test(norm)) {
                        if (opt.forwardDate && refOffset > offset) startMoment = startMoment.day(offset + 7);
                        else startMoment = startMoment.day(offset);
                    } else {
                        if (opt.forwardDate && refOffset > offset) startMoment = startMoment.day(offset + 7);
                        else if (!opt.forwardDate && Math.abs(offset - 7 - refOffset) < Math.abs(offset - refOffset)) startMoment = startMoment.day(offset - 7);
                        else if (!opt.forwardDate && Math.abs(offset + 7 - refOffset) < Math.abs(offset - refOffset)) startMoment = startMoment.day(offset + 7);
                        else startMoment = startMoment.day(offset);
                    }
                    result.start.assign('weekday', offset);
                    result.start.imply('day', startMoment.date());
                    result.start.imply('month', startMoment.month() + 1);
                    result.start.imply('year', startMoment.year());
                    return result;
                };
            };
        /***/ },
        /* 67 */ /***/ function(module1, exports, __webpack_require__) {
            var dayjs = __webpack_require__(2);
            var Parser = __webpack_require__(1).Parser;
            var ParsedResult = __webpack_require__(0).ParsedResult;
            var PATTERN = new RegExp("(\\W|^)(jetzt|(?:heute|diesen)\\s*(morgen|vormittag|mittag|nachmittag|abend)|(?:heute|diese)\\s*nacht|heute|(?:(?:\xfc|ue)ber)?morgen(?:\\s*(morgen|vormittag|mittag|nachmittag|abend|nacht))?|(?:vor)?gestern(?:\\s*(morgen|vormittag|mittag|nachmittag|abend|nacht))?|letzte\\s*nacht)(?=\\W|$)", 'i');
            exports.Parser = function DECasualDateParser() {
                Parser.apply(this, arguments);
                this.pattern = function() {
                    return PATTERN;
                };
                this.extract = function(text, ref, match, opt) {
                    text = match[0].substr(match[1].length);
                    var index = match.index + match[1].length;
                    var result = new ParsedResult({
                        index: index,
                        text: text,
                        ref: ref
                    });
                    var refMoment = dayjs(ref);
                    var lowerText = text.toLowerCase();
                    var startMoment = refMoment;
                    if (/(?:heute|diese)\s*nacht/.test(lowerText)) {
                        // Normally means this coming midnight
                        result.start.imply('hour', 22);
                        result.start.imply('meridiem', 1);
                    } else if (/^(?:ü|ue)bermorgen/.test(lowerText)) startMoment = startMoment.add(refMoment.hour() > 1 ? 2 : 1, 'day');
                    else if (/^morgen/.test(lowerText)) // Check not "Tomorrow" on late night
                    {
                        if (refMoment.hour() > 1) startMoment = startMoment.add(1, 'day');
                    } else if (/^gestern/.test(lowerText)) startMoment = startMoment.add(-1, 'day');
                    else if (/^vorgestern/.test(lowerText)) startMoment = startMoment.add(-2, 'day');
                    else if (/letzte\s*nacht/.test(lowerText)) {
                        result.start.imply('hour', 0);
                        if (refMoment.hour() > 6) startMoment = startMoment.add(-1, 'day');
                    } else if (lowerText === 'jetzt') {
                        result.start.imply('hour', refMoment.hour());
                        result.start.imply('minute', refMoment.minute());
                        result.start.imply('second', refMoment.second());
                        result.start.imply('millisecond', refMoment.millisecond());
                    }
                    var secondMatch = match[3] || match[4] || match[5];
                    if (secondMatch) switch(secondMatch.toLowerCase()){
                        case 'morgen':
                            result.start.imply('hour', 6);
                            break;
                        case 'vormittag':
                            result.start.imply('hour', 9);
                            break;
                        case 'mittag':
                            result.start.imply('hour', 12);
                            break;
                        case 'nachmittag':
                            result.start.imply('hour', 15);
                            result.start.imply('meridiem', 1);
                            break;
                        case 'abend':
                            result.start.imply('hour', 18);
                            result.start.imply('meridiem', 1);
                            break;
                        case 'nacht':
                            result.start.imply('hour', 0);
                            break;
                    }
                    result.start.assign('day', startMoment.date());
                    result.start.assign('month', startMoment.month() + 1);
                    result.start.assign('year', startMoment.year());
                    result.tags['DECasualDateParser'] = true;
                    return result;
                };
            };
        /***/ },
        /* 68 */ /***/ function(module1, exports, __webpack_require__) {
            /*
  
*/ var Refiner = __webpack_require__(3).Refiner;
            exports.Refiner = function OverlapRemovalRefiner() {
                Refiner.call(this);
                this.refine = function(text, results, opt) {
                    if (results.length < 2) return results;
                    var filteredResults = [];
                    var prevResult = results[0];
                    for(var i = 1; i < results.length; i++){
                        var result = results[i]; // If overlap, compare the length and discard the shorter one
                        if (result.index < prevResult.index + prevResult.text.length) {
                            if (result.text.length > prevResult.text.length) prevResult = result;
                        } else {
                            filteredResults.push(prevResult);
                            prevResult = result;
                        }
                    } // The last one
                    if (prevResult != null) filteredResults.push(prevResult);
                    return filteredResults;
                };
            };
        /***/ },
        /* 69 */ /***/ function(module1, exports, __webpack_require__) {
            /*
  
*/ var Refiner = __webpack_require__(3).Refiner;
            var TIMEZONE_OFFSET_PATTERN = new RegExp("^\\s*(GMT|UTC)?(\\+|\\-)(\\d{1,2}):?(\\d{2})", 'i');
            var TIMEZONE_OFFSET_SIGN_GROUP = 2;
            var TIMEZONE_OFFSET_HOUR_OFFSET_GROUP = 3;
            var TIMEZONE_OFFSET_MINUTE_OFFSET_GROUP = 4;
            exports.Refiner = function ExtractTimezoneOffsetRefiner() {
                Refiner.call(this);
                this.refine = function(text, results, opt) {
                    results.forEach(function(result) {
                        if (result.start.isCertain('timezoneOffset')) return;
                        var match = TIMEZONE_OFFSET_PATTERN.exec(text.substring(result.index + result.text.length));
                        if (!match) return;
                        var hourOffset = parseInt(match[TIMEZONE_OFFSET_HOUR_OFFSET_GROUP]);
                        var minuteOffset = parseInt(match[TIMEZONE_OFFSET_MINUTE_OFFSET_GROUP]);
                        var timezoneOffset = hourOffset * 60 + minuteOffset;
                        if (match[TIMEZONE_OFFSET_SIGN_GROUP] === '-') timezoneOffset = -timezoneOffset;
                        if (result.end != null) result.end.assign('timezoneOffset', timezoneOffset);
                        result.start.assign('timezoneOffset', timezoneOffset);
                        result.text += match[0];
                        result.tags['ExtractTimezoneOffsetRefiner'] = true;
                    });
                    return results;
                };
            };
        /***/ },
        /* 70 */ /***/ function(module1, exports, __webpack_require__) {
            /*

*/ var Refiner = __webpack_require__(3).Refiner; // Map ABBR -> Offset in minute
            var TIMEZONE_NAME_PATTERN = new RegExp("^\\s*\\(?([A-Z]{2,4})\\)?(?=\\W|$)", 'i');
            var DEFAULT_TIMEZONE_ABBR_MAP = {
                "ACDT": 630,
                "ACST": 570,
                "ADT": -180,
                "AEDT": 660,
                "AEST": 600,
                "AFT": 270,
                "AKDT": -480,
                "AKST": -540,
                "ALMT": 360,
                "AMST": -180,
                "AMT": -240,
                "ANAST": 720,
                "ANAT": 720,
                "AQTT": 300,
                "ART": -180,
                "AST": -240,
                "AWDT": 540,
                "AWST": 480,
                "AZOST": 0,
                "AZOT": -60,
                "AZST": 300,
                "AZT": 240,
                "BNT": 480,
                "BOT": -240,
                "BRST": -120,
                "BRT": -180,
                "BST": 60,
                "BTT": 360,
                "CAST": 480,
                "CAT": 120,
                "CCT": 390,
                "CDT": -300,
                "CEST": 120,
                "CET": 60,
                "CHADT": 825,
                "CHAST": 765,
                "CKT": -600,
                "CLST": -180,
                "CLT": -240,
                "COT": -300,
                "CST": -360,
                "CVT": -60,
                "CXT": 420,
                "ChST": 600,
                "DAVT": 420,
                "EASST": -300,
                "EAST": -360,
                "EAT": 180,
                "ECT": -300,
                "EDT": -240,
                "EEST": 180,
                "EET": 120,
                "EGST": 0,
                "EGT": -60,
                "EST": -300,
                "ET": -300,
                "FJST": 780,
                "FJT": 720,
                "FKST": -180,
                "FKT": -240,
                "FNT": -120,
                "GALT": -360,
                "GAMT": -540,
                "GET": 240,
                "GFT": -180,
                "GILT": 720,
                "GMT": 0,
                "GST": 240,
                "GYT": -240,
                "HAA": -180,
                "HAC": -300,
                "HADT": -540,
                "HAE": -240,
                "HAP": -420,
                "HAR": -360,
                "HAST": -600,
                "HAT": -90,
                "HAY": -480,
                "HKT": 480,
                "HLV": -210,
                "HNA": -240,
                "HNC": -360,
                "HNE": -300,
                "HNP": -480,
                "HNR": -420,
                "HNT": -150,
                "HNY": -540,
                "HOVT": 420,
                "ICT": 420,
                "IDT": 180,
                "IOT": 360,
                "IRDT": 270,
                "IRKST": 540,
                "IRKT": 540,
                "IRST": 210,
                "IST": 330,
                "JST": 540,
                "KGT": 360,
                "KRAST": 480,
                "KRAT": 480,
                "KST": 540,
                "KUYT": 240,
                "LHDT": 660,
                "LHST": 630,
                "LINT": 840,
                "MAGST": 720,
                "MAGT": 720,
                "MART": -510,
                "MAWT": 300,
                "MDT": -360,
                "MESZ": 120,
                "MEZ": 60,
                "MHT": 720,
                "MMT": 390,
                "MSD": 240,
                "MSK": 240,
                "MST": -420,
                "MUT": 240,
                "MVT": 300,
                "MYT": 480,
                "NCT": 660,
                "NDT": -90,
                "NFT": 690,
                "NOVST": 420,
                "NOVT": 360,
                "NPT": 345,
                "NST": -150,
                "NUT": -660,
                "NZDT": 780,
                "NZST": 720,
                "OMSST": 420,
                "OMST": 420,
                "PDT": -420,
                "PET": -300,
                "PETST": 720,
                "PETT": 720,
                "PGT": 600,
                "PHOT": 780,
                "PHT": 480,
                "PKT": 300,
                "PMDT": -120,
                "PMST": -180,
                "PONT": 660,
                "PST": -480,
                "PT": -480,
                "PWT": 540,
                "PYST": -180,
                "PYT": -240,
                "RET": 240,
                "SAMT": 240,
                "SAST": 120,
                "SBT": 660,
                "SCT": 240,
                "SGT": 480,
                "SRT": -180,
                "SST": -660,
                "TAHT": -600,
                "TFT": 300,
                "TJT": 300,
                "TKT": 780,
                "TLT": 540,
                "TMT": 300,
                "TVT": 720,
                "ULAT": 480,
                "UTC": 0,
                "UYST": -120,
                "UYT": -180,
                "UZT": 300,
                "VET": -210,
                "VLAST": 660,
                "VLAT": 660,
                "VUT": 660,
                "WAST": 120,
                "WAT": 60,
                "WEST": 60,
                "WESZ": 60,
                "WET": 0,
                "WEZ": 0,
                "WFT": 720,
                "WGST": -120,
                "WGT": -180,
                "WIB": 420,
                "WIT": 540,
                "WITA": 480,
                "WST": 780,
                "WT": 0,
                "YAKST": 600,
                "YAKT": 600,
                "YAPT": 600,
                "YEKST": 360,
                "YEKT": 360
            };
            exports.Refiner = function ExtractTimezoneAbbrRefiner(config) {
                Refiner.call(this, arguments);
                this.refine = function(text, results, opt) {
                    var timezones = new Object(DEFAULT_TIMEZONE_ABBR_MAP);
                    if (opt.timezones) for(var name in opt.timezones)timezones[name] = opt.timezones[name];
                    results.forEach(function(result) {
                        if (!result.tags['ENTimeExpressionParser'] && !result.tags['ZHTimeExpressionParser'] && !result.tags['FRTimeExpressionParser'] && !result.tags['DETimeExpressionParser']) return;
                        var match = TIMEZONE_NAME_PATTERN.exec(text.substring(result.index + result.text.length));
                        if (match) {
                            var timezoneAbbr = match[1].toUpperCase();
                            if (timezones[timezoneAbbr] === undefined) return;
                            var timezoneOffset = timezones[timezoneAbbr];
                            if (!result.start.isCertain('timezoneOffset')) result.start.assign('timezoneOffset', timezoneOffset);
                            if (result.end != null && !result.end.isCertain('timezoneOffset')) result.end.assign('timezoneOffset', timezoneOffset);
                            result.text += match[0];
                            result.tags['ExtractTimezoneAbbrRefiner'] = true;
                        }
                    });
                    return results;
                };
            };
        /***/ },
        /* 71 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    Enforce 'forwardDate' option to on the results. When there are missing component,
    e.g. "March 12-13 (without year)" or "Thursday", the refiner will try to adjust the result
    into the future instead of the past.
*/ var dayjs = __webpack_require__(2);
            var Refiner = __webpack_require__(3).Refiner;
            var TIMEZONE_NAME_PATTERN = new RegExp("^\\s*\\(?([A-Z]{2,4})\\)?(?=\\W|$)", "i");
            var DEFAULT_TIMEZONE_ABBR_MAP = {
                ACDT: 630,
                ACST: 570,
                ADT: -180,
                AEDT: 660,
                AEST: 600,
                AFT: 270,
                AKDT: -480,
                AKST: -540,
                ALMT: 360,
                AMST: -180,
                AMT: -240,
                ANAST: 720,
                ANAT: 720,
                AQTT: 300,
                ART: -180,
                AST: -240,
                AWDT: 540,
                AWST: 480,
                AZOST: 0,
                AZOT: -60,
                AZST: 300,
                AZT: 240,
                BNT: 480,
                BOT: -240,
                BRST: -120,
                BRT: -180,
                BST: 60,
                BTT: 360,
                CAST: 480,
                CAT: 120,
                CCT: 390,
                CDT: -300,
                CEST: 120,
                CET: 60,
                CHADT: 825,
                CHAST: 765,
                CKT: -600,
                CLST: -180,
                CLT: -240,
                COT: -300,
                CST: -360,
                CVT: -60,
                CXT: 420,
                ChST: 600,
                DAVT: 420,
                EASST: -300,
                EAST: -360,
                EAT: 180,
                ECT: -300,
                EDT: -240,
                EEST: 180,
                EET: 120,
                EGST: 0,
                EGT: -60,
                EST: -300,
                ET: -300,
                FJST: 780,
                FJT: 720,
                FKST: -180,
                FKT: -240,
                FNT: -120,
                GALT: -360,
                GAMT: -540,
                GET: 240,
                GFT: -180,
                GILT: 720,
                GMT: 0,
                GST: 240,
                GYT: -240,
                HAA: -180,
                HAC: -300,
                HADT: -540,
                HAE: -240,
                HAP: -420,
                HAR: -360,
                HAST: -600,
                HAT: -90,
                HAY: -480,
                HKT: 480,
                HLV: -210,
                HNA: -240,
                HNC: -360,
                HNE: -300,
                HNP: -480,
                HNR: -420,
                HNT: -150,
                HNY: -540,
                HOVT: 420,
                ICT: 420,
                IDT: 180,
                IOT: 360,
                IRDT: 270,
                IRKST: 540,
                IRKT: 540,
                IRST: 210,
                IST: 330,
                JST: 540,
                KGT: 360,
                KRAST: 480,
                KRAT: 480,
                KST: 540,
                KUYT: 240,
                LHDT: 660,
                LHST: 630,
                LINT: 840,
                MAGST: 720,
                MAGT: 720,
                MART: -510,
                MAWT: 300,
                MDT: -360,
                MESZ: 120,
                MEZ: 60,
                MHT: 720,
                MMT: 390,
                MSD: 240,
                MSK: 240,
                MST: -420,
                MUT: 240,
                MVT: 300,
                MYT: 480,
                NCT: 660,
                NDT: -90,
                NFT: 690,
                NOVST: 420,
                NOVT: 360,
                NPT: 345,
                NST: -150,
                NUT: -660,
                NZDT: 780,
                NZST: 720,
                OMSST: 420,
                OMST: 420,
                PDT: -420,
                PET: -300,
                PETST: 720,
                PETT: 720,
                PGT: 600,
                PHOT: 780,
                PHT: 480,
                PKT: 300,
                PMDT: -120,
                PMST: -180,
                PONT: 660,
                PST: -480,
                PT: -480,
                PWT: 540,
                PYST: -180,
                PYT: -240,
                RET: 240,
                SAMT: 240,
                SAST: 120,
                SBT: 660,
                SCT: 240,
                SGT: 480,
                SRT: -180,
                SST: -660,
                TAHT: -600,
                TFT: 300,
                TJT: 300,
                TKT: 780,
                TLT: 540,
                TMT: 300,
                TVT: 720,
                ULAT: 480,
                UTC: 0,
                UYST: -120,
                UYT: -180,
                UZT: 300,
                VET: -210,
                VLAST: 660,
                VLAT: 660,
                VUT: 660,
                WAST: 120,
                WAT: 60,
                WEST: 60,
                WESZ: 60,
                WET: 0,
                WEZ: 0,
                WFT: 720,
                WGST: -120,
                WGT: -180,
                WIB: 420,
                WIT: 540,
                WITA: 480,
                WST: 780,
                WT: 0,
                YAKST: 600,
                YAKT: 600,
                YAPT: 600,
                YEKST: 360,
                YEKT: 360
            };
            exports.Refiner = function ForwardDateRefiner() {
                Refiner.call(this);
                this.refine = function(text, results, opt) {
                    if (!opt["forwardDate"]) return results;
                    results.forEach(function(result) {
                        var refMoment = dayjs(result.ref);
                        if (result.start.isOnlyDayMonthComponent() && refMoment.isAfter(result.start.dayjs())) {
                            // Adjust year into the future
                            for(var i = 0; i < 3 && refMoment.isAfter(result.start.dayjs()); i++){
                                result.start.imply("year", result.start.get("year") + 1);
                                if (result.end && !result.end.isCertain("year")) result.end.imply("year", result.end.get("year") + 1);
                            }
                            result.tags["ForwardDateRefiner"] = true;
                        }
                        if (result.start.isOnlyWeekdayComponent() && refMoment.isAfter(result.start.dayjs())) {
                            // Adjust date to the coming week
                            if (refMoment.day() > result.start.get("weekday")) refMoment = refMoment.day(result.start.get("weekday") + 7);
                            else refMoment = refMoment.day(result.start.get("weekday"));
                            result.start.imply("day", refMoment.date());
                            result.start.imply("month", refMoment.month() + 1);
                            result.start.imply("year", refMoment.year());
                            result.tags["ForwardDateRefiner"] = true;
                        }
                        if (result.tags["ENTimeExpressionParser"] || result.tags["ZHTimeExpressionParser"] || result.tags["FRTimeExpressionParser"] || result.tags["DETimeExpressionParser"]) {
                            var contains_tz_abbr = false;
                            var match = TIMEZONE_NAME_PATTERN.exec(text.substring(result.index + result.text.length));
                            if (match) {
                                var timezoneAbbr = match[1].toUpperCase();
                                if (DEFAULT_TIMEZONE_ABBR_MAP[timezoneAbbr]) contains_tz_abbr = true;
                            }
                            if (!contains_tz_abbr && !result.start.isCertain("day") && result.start.isCertain("hour") && result.start.isCertain("minute") && refMoment.isAfter(result.start.dayjs())) {
                                var did_shift_by_meridiem = false;
                                if (!result.start.isCertain("meridiem")) {
                                    var result_plus_12_hours = result.start.clone();
                                    result_plus_12_hours.imply("meridiem", 1);
                                    result_plus_12_hours.assign("hour", result_plus_12_hours.get("hour") + 12);
                                    if (!refMoment.isAfter(result_plus_12_hours.dayjs())) {
                                        // Shift by meridiem
                                        result.start.imply("meridiem", 1);
                                        result.start.assign("hour", result.start.get("hour") + 12);
                                        did_shift_by_meridiem = true;
                                        if (result.end && !result.end.isCertain("day")) {
                                            result.end.assign("hour", result.end.get("hour") + 12);
                                            if (result.end.get("hour") >= 12) result.end.imply("meridiem", 1);
                                        }
                                    }
                                }
                                if (!did_shift_by_meridiem) {
                                    // Adjust day into future
                                    result.start.imply("day", result.start.get("day") + 1);
                                    if (result.end && !result.end.isCertain("day")) result.end.imply("day", result.end.get("day") + 1);
                                }
                                result.tags["ForwardDateCustomRefiner"] = true;
                            }
                        }
                    });
                    return results;
                };
            };
        /***/ },
        /* 72 */ /***/ function(module1, exports, __webpack_require__) {
            /*
  
*/ var Filter = __webpack_require__(3).Filter;
            exports.Refiner = function UnlikelyFormatFilter() {
                Filter.call(this);
                this.isValid = function(text, result, opt) {
                    if (result.text.replace(' ', '').match(/^\d*(\.\d*)?$/)) return false;
                    return true;
                };
            };
        /***/ },
        /* 73 */ /***/ function(module1, exports, __webpack_require__) {
            /*

*/ var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var Refiner = __webpack_require__(3).Refiner;
            var PATTERN = new RegExp("^\\s*(at|after|before|on|,|-|\\(|\\))?\\s*$");
            function isMoreSpecific(prevResult, currResult) {
                var moreSpecific = false;
                if (prevResult.start.isCertain('year')) {
                    if (!currResult.start.isCertain('year')) moreSpecific = true;
                    else if (prevResult.start.isCertain('month')) {
                        if (!currResult.start.isCertain('month')) moreSpecific = true;
                        else if (prevResult.start.isCertain('day') && !currResult.start.isCertain('day')) moreSpecific = true;
                    }
                }
                return moreSpecific;
            }
            function isAbleToMerge(text, prevResult, currResult) {
                var textBetween = text.substring(prevResult.index + prevResult.text.length, currResult.index); // Only accepts merge if one of them comes from casual relative date
                var includesRelativeResult = prevResult.tags['ENRelativeDateFormatParser'] || currResult.tags['ENRelativeDateFormatParser']; // We assume they refer to the same date if all date fields are implied
                var referToSameDate = !prevResult.start.isCertain('day') && !prevResult.start.isCertain('month') && !prevResult.start.isCertain('year'); // If both years are certain, that determines if they refer to the same date
                // but with one more specific than the other
                if (prevResult.start.isCertain('year') && currResult.start.isCertain('year')) referToSameDate = prevResult.start.get('year') === currResult.start.get('year'); // We now test with the next level (month) if they refer to the same date
                if (prevResult.start.isCertain('month') && currResult.start.isCertain('month')) referToSameDate = prevResult.start.get('month') === currResult.start.get('month') && referToSameDate;
                return includesRelativeResult && textBetween.match(PATTERN) && referToSameDate;
            }
            function mergeResult(text, specificResult, nonSpecificResult) {
                var specificDate = specificResult.start;
                var nonSpecificDate = nonSpecificResult.start;
                var startIndex = Math.min(specificResult.index, nonSpecificResult.index);
                var endIndex = Math.max(specificResult.index + specificResult.text.length, nonSpecificResult.index + nonSpecificResult.text.length);
                specificResult.index = startIndex;
                specificResult.text = text.substring(startIndex, endIndex);
                for(var tag in nonSpecificResult.tags)specificResult.tags[tag] = true;
                specificResult.tags['ENPrioritizeSpecificDateRefiner'] = true;
                return specificResult;
            }
            exports.Refiner = function ENPrioritizeSpecificDateRefiner() {
                Refiner.call(this);
                this.refine = function(text, results, opt) {
                    if (results.length < 2) return results;
                    var mergedResult = [];
                    var currResult = null;
                    var prevResult = null;
                    for(var i = 1; i < results.length; i++){
                        currResult = results[i];
                        prevResult = results[i - 1];
                        if (isMoreSpecific(prevResult, currResult) && isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = mergeResult(text, prevResult, currResult);
                            currResult = null;
                            i += 1;
                        } else if (isMoreSpecific(currResult, prevResult) && isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = mergeResult(text, currResult, prevResult);
                            currResult = null;
                            i += 1;
                        }
                        mergedResult.push(prevResult);
                    }
                    if (currResult != null) mergedResult.push(currResult);
                    return mergedResult;
                };
            };
        /***/ },
        /* 74 */ /***/ function(module1, exports, __webpack_require__) {
            /*
  
*/ var ENMergeDateRangeRefiner = __webpack_require__(10).Refiner;
            exports.Refiner = function JPMergeDateRangeRefiner() {
                ENMergeDateRangeRefiner.call(this);
                this.pattern = function() {
                    return /^\s*(から|ー)\s*$/i;
                };
            };
        /***/ },
        /* 75 */ /***/ function(module1, exports, __webpack_require__) {
            /*
  
*/ var Refiner = __webpack_require__(3).Refiner;
            exports.Refiner = function FRMergeDateRangeRefiner() {
                Refiner.call(this);
                this.pattern = function() {
                    return /^\s*(à|a|\-)\s*$/i;
                };
                this.refine = function(text, results, opt) {
                    if (results.length < 2) return results;
                    var mergedResult = [];
                    var currResult = null;
                    var prevResult = null;
                    for(var i = 1; i < results.length; i++){
                        currResult = results[i];
                        prevResult = results[i - 1];
                        if (!prevResult.end && !currResult.end && this.isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = this.mergeResult(text, prevResult, currResult);
                            currResult = null;
                            i += 1;
                        }
                        mergedResult.push(prevResult);
                    }
                    if (currResult != null) mergedResult.push(currResult);
                    return mergedResult;
                };
                this.isAbleToMerge = function(text, result1, result2) {
                    var begin = result1.index + result1.text.length;
                    var end = result2.index;
                    var textBetween = text.substring(begin, end);
                    return textBetween.match(this.pattern());
                };
                this.isWeekdayResult = function(result) {
                    return result.start.isCertain('weekday') && !result.start.isCertain('day');
                };
                this.mergeResult = function(text, fromResult, toResult) {
                    if (!this.isWeekdayResult(fromResult) && !this.isWeekdayResult(toResult)) {
                        for(var key in toResult.start.knownValues)if (!fromResult.start.isCertain(key)) fromResult.start.assign(key, toResult.start.get(key));
                        for(var key in fromResult.start.knownValues)if (!toResult.start.isCertain(key)) toResult.start.assign(key, fromResult.start.get(key));
                    }
                    if (fromResult.start.date().getTime() > toResult.start.date()) {
                        var tmp = toResult;
                        toResult = fromResult;
                        fromResult = tmp;
                    }
                    fromResult.end = toResult.start;
                    for(var tag in toResult.tags)fromResult.tags[tag] = true;
                    var startIndex = Math.min(fromResult.index, toResult.index);
                    var endIndex = Math.max(fromResult.index + fromResult.text.length, toResult.index + toResult.text.length);
                    fromResult.index = startIndex;
                    fromResult.text = text.substring(startIndex, endIndex);
                    fromResult.tags[this.constructor.name] = true;
                    return fromResult;
                };
            };
        /***/ },
        /* 76 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    
*/ var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var Refiner = __webpack_require__(3).Refiner;
            var mergeDateTimeComponent = __webpack_require__(6).mergeDateTimeComponent;
            var PATTERN = new RegExp("^\\s*(T|\xe0|a|vers|de|,|-)?\\s*$");
            function isDateOnly(result) {
                return !result.start.isCertain('hour') || result.tags['FRCasualDateParser'];
            }
            function isTimeOnly(result) {
                return !result.start.isCertain('month') && !result.start.isCertain('weekday');
            }
            function isAbleToMerge(text, prevResult, curResult) {
                var textBetween = text.substring(prevResult.index + prevResult.text.length, curResult.index);
                return textBetween.match(PATTERN);
            }
            function mergeResult(text, dateResult, timeResult) {
                var beginDate = dateResult.start;
                var beginTime = timeResult.start;
                var beginDateTime = mergeDateTimeComponent(beginDate, beginTime);
                if (dateResult.end != null || timeResult.end != null) {
                    var endDate = dateResult.end == null ? dateResult.start : dateResult.end;
                    var endTime = timeResult.end == null ? timeResult.start : timeResult.end;
                    var endDateTime = mergeDateTimeComponent(endDate, endTime);
                    if (dateResult.end == null && endDateTime.date().getTime() < beginDateTime.date().getTime()) {
                        // Ex. 9pm - 1am
                        if (endDateTime.isCertain('day')) endDateTime.assign('day', endDateTime.get('day') + 1);
                        else endDateTime.imply('day', endDateTime.get('day') + 1);
                    }
                    dateResult.end = endDateTime;
                }
                dateResult.start = beginDateTime;
                var startIndex = Math.min(dateResult.index, timeResult.index);
                var endIndex = Math.max(dateResult.index + dateResult.text.length, timeResult.index + timeResult.text.length);
                dateResult.index = startIndex;
                dateResult.text = text.substring(startIndex, endIndex);
                for(var tag in timeResult.tags)dateResult.tags[tag] = true;
                dateResult.tags['FRMergeDateAndTimeRefiner'] = true;
                return dateResult;
            }
            exports.Refiner = function FRMergeDateTimeRefiner() {
                Refiner.call(this);
                this.refine = function(text, results, opt) {
                    if (results.length < 2) return results;
                    var mergedResult = [];
                    var currResult = null;
                    var prevResult = null;
                    for(var i = 1; i < results.length; i++){
                        currResult = results[i];
                        prevResult = results[i - 1];
                        if (isDateOnly(prevResult) && isTimeOnly(currResult) && isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = mergeResult(text, prevResult, currResult);
                            currResult = null;
                            i += 1;
                        } else if (isDateOnly(currResult) && isTimeOnly(prevResult) && isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = mergeResult(text, currResult, prevResult);
                            currResult = null;
                            i += 1;
                        }
                        mergedResult.push(prevResult);
                    }
                    if (currResult != null) mergedResult.push(currResult);
                    return mergedResult;
                };
            };
        /***/ },
        /* 77 */ /***/ function(module1, exports, __webpack_require__) {
            /*
  
*/ var ENMergeDateRangeRefiner = __webpack_require__(10).Refiner;
            exports.Refiner = function DEMergeDateRangeRefiner() {
                ENMergeDateRangeRefiner.call(this);
                this.pattern = function() {
                    return /^\s*(bis(?:\s*(?:am|zum))?|\-)\s*$/i;
                };
            };
        /***/ },
        /* 78 */ /***/ function(module1, exports, __webpack_require__) {
            /*
    
*/ var ParsedComponents = __webpack_require__(0).ParsedComponents;
            var Refiner = __webpack_require__(3).Refiner;
            var mergeDateTimeComponent = __webpack_require__(6).mergeDateTimeComponent;
            var isDateOnly = __webpack_require__(6).isDateOnly;
            var isTimeOnly = __webpack_require__(6).isTimeOnly;
            var PATTERN = new RegExp("^\\s*(T|um|am|,|-)?\\s*$");
            function isAbleToMerge(text, prevResult, curResult) {
                var textBetween = text.substring(prevResult.index + prevResult.text.length, curResult.index);
                return textBetween.match(PATTERN);
            }
            function mergeResult(text, dateResult, timeResult) {
                var beginDate = dateResult.start;
                var beginTime = timeResult.start;
                var beginDateTime = mergeDateTimeComponent(beginDate, beginTime);
                if (dateResult.end != null || timeResult.end != null) {
                    var endDate = dateResult.end == null ? dateResult.start : dateResult.end;
                    var endTime = timeResult.end == null ? timeResult.start : timeResult.end;
                    var endDateTime = mergeDateTimeComponent(endDate, endTime);
                    if (dateResult.end == null && endDateTime.date().getTime() < beginDateTime.date().getTime()) {
                        // Ex. 9pm - 1am
                        if (endDateTime.isCertain('day')) endDateTime.assign('day', endDateTime.get('day') + 1);
                        else endDateTime.imply('day', endDateTime.get('day') + 1);
                    }
                    dateResult.end = endDateTime;
                }
                dateResult.start = beginDateTime;
                var startIndex = Math.min(dateResult.index, timeResult.index);
                var endIndex = Math.max(dateResult.index + dateResult.text.length, timeResult.index + timeResult.text.length);
                dateResult.index = startIndex;
                dateResult.text = text.substring(startIndex, endIndex);
                for(var tag in timeResult.tags)dateResult.tags[tag] = true;
                dateResult.tags['DEMergeDateAndTimeRefiner'] = true;
                return dateResult;
            }
            exports.Refiner = function DEMergeDateTimeRefiner() {
                Refiner.call(this);
                this.refine = function(text, results, opt) {
                    if (results.length < 2) return results;
                    var mergedResult = [];
                    var currResult = null;
                    var prevResult = null;
                    for(var i = 1; i < results.length; i++){
                        currResult = results[i];
                        prevResult = results[i - 1];
                        if (isDateOnly(prevResult) && isTimeOnly(currResult) && isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = mergeResult(text, prevResult, currResult);
                            currResult = null;
                            i += 1;
                        } else if (isDateOnly(currResult) && isTimeOnly(prevResult) && isAbleToMerge(text, prevResult, currResult)) {
                            prevResult = mergeResult(text, currResult, prevResult);
                            currResult = null;
                            i += 1;
                        }
                        mergedResult.push(prevResult);
                    }
                    if (currResult != null) mergedResult.push(currResult);
                    return mergedResult;
                };
            };
        /***/ }
    ]);
});

},{}],"c4mcO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "DateTimePicker", ()=>DateTimePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _reactDayPicker = require("react-day-picker");
var _styleCss = require("react-day-picker/src/style.css");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _luxon = require("luxon");
var _timePicker = require("./time_picker");
var _dashboardUtils = require("../dashboard_utils");
function formatDate(date) {
    const luxon_date = _luxon.DateTime.fromJSDate(date);
    return luxon_date.toLocaleString({
        month: "short",
        day: "numeric",
        year: "numeric"
    });
}
function getDayAndTimeMs(date) {
    if (!date) return {
        selected_day: new Date(),
        selected_time_ms: 0
    };
    const selected_day = date;
    const luxon_initial_value = _luxon.DateTime.fromJSDate(date);
    const initial_value_at_midnight_ms = luxon_initial_value.set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
    }).toMillis();
    const selected_time_ms = selected_day.getTime() - initial_value_at_midnight_ms;
    return {
        selected_day,
        selected_time_ms
    };
}
function CustomDayPickerInput({ value, onDayChange, formatDate: formatDateProp, placeholder, inputProps = {}, dayPickerProps = {}, wrapperClassName = "", children }) {
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const [selected, setSelected] = (0, _react.useState)(value);
    const wrapperRef = (0, _react.useRef)(null);
    // Update selected when value prop changes
    (0, _react.useEffect)(()=>{
        setSelected(value);
    }, [
        value
    ]);
    // Close dropdown when clicking outside
    (0, _react.useEffect)(()=>{
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) setIsOpen(false);
        }
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [
        isOpen
    ]);
    const handleSelect = (day)=>{
        if (day) {
            setSelected(day);
            onDayChange(day);
            setIsOpen(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: wrapperRef,
        className: `date-picker-input-wrapper ${wrapperClassName}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "input",
                type: "text",
                value: formatDateProp(selected),
                onClick: ()=>!inputProps.disabled && setIsOpen(!isOpen),
                readOnly: inputProps.readOnly ?? true,
                disabled: inputProps.disabled,
                placeholder: placeholder,
                style: {
                    cursor: inputProps.disabled ? "not-allowed" : "pointer"
                }
            }),
            children,
            isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "date-picker-dropdown",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDayPicker.DayPicker), {
                    mode: "single",
                    selected: selected,
                    onSelect: handleSelect,
                    disabled: dayPickerProps.disabled
                })
            })
        ]
    });
}
class DateTimePicker extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        const { selected_day, selected_time_ms } = getDayAndTimeMs(this.props.initial_value);
        this.state = {
            selected_day,
            selected_time_ms
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(date, ms) {
        this.setState({
            selected_day: date,
            selected_time_ms: ms
        });
        const ms_in_minutes = Math.floor(ms / 1000 / 60);
        const hours = Math.floor(ms_in_minutes / 60);
        const minutes = ms_in_minutes - hours * 60;
        date.setMinutes(minutes);
        date.setHours(hours);
        this.props.updateFunc(date);
    }
    handleKeyDown(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    renderDatePicker(selected_day) {
        const disabled_class_name = this.props.disabled ? "input-disabled" : "";
        if ((0, _dashboardUtils.DashboardUtils).IsMobileOS() && !(0, _dashboardUtils.DashboardUtils).IsAndroid()) {
            const day = _luxon.DateTime.fromJSDate(selected_day).toLocal();
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: disabled_class_name,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    className: `mobile-date-picker`,
                    type: "date",
                    value: day.toISODate(),
                    readOnly: false,
                    disabled: this.props.disabled,
                    onChange: (e)=>{
                        const date = _luxon.DateTime.fromJSDate(e.target.valueAsDate).toUTC();
                        const local_zone = _luxon.DateTime.local().zone;
                        const converted_date = date.setZone(local_zone, {
                            keepLocalTime: true
                        });
                        this.handleChange(converted_date.toJSDate(), this.state.selected_time_ms);
                    }
                })
            });
        } else return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomDayPickerInput, {
            wrapperClassName: `control has-icons-right ${disabled_class_name}`,
            onDayChange: (day)=>this.handleChange(day, this.state.selected_time_ms),
            formatDate: formatDate,
            value: selected_day,
            inputProps: {
                readOnly: true,
                disabled: this.props.disabled
            },
            dayPickerProps: {
                selected: selected_day,
                disabled: (day)=>{
                    if (!this.props.disable_past_days) return false;
                    const now = new Date().setHours(0, 0, 0, 0);
                    return day < new Date(now);
                }
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "icon is-small is-right",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "far fa-calendar"
                })
            })
        });
    }
    render() {
        const { selected_day, selected_time_ms } = this.state;
        //TimePicker
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            onKeyDown: this.handleKeyDown,
            className: "sesh-date-picker",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "columns is-mobile is-variable is-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-half-tablet is-7-mobile",
                        children: this.renderDatePicker(selected_day)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-half-tablet is-5-mobile",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timePicker.TimePicker), {
                            initial_value_ms: selected_time_ms,
                            updateFunc: (val)=>this.handleChange(this.state.selected_day, val),
                            disabled: this.props.disabled
                        })
                    })
                ]
            })
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react-day-picker":"3kO7p","react-day-picker/src/style.css":"iHziy","react":"IMRgT","luxon":"fLWpi","./time_picker":"bT1Cg","../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3kO7p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Renders the DayPicker calendar component.
 *
 * @param initialProps - The props for the DayPicker component.
 * @returns The rendered DayPicker component.
 * @group DayPicker
 * @see https://daypicker.dev
 */ parcelHelpers.export(exports, "DayPicker", ()=>DayPicker);
var _tz = require("@date-fns/tz");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateLibJs = require("./classes/DateLib.js");
var _createGetModifiersJs = require("./helpers/createGetModifiers.js");
var _getClassNamesForModifiersJs = require("./helpers/getClassNamesForModifiers.js");
var _getComponentsJs = require("./helpers/getComponents.js");
var _getDataAttributesJs = require("./helpers/getDataAttributes.js");
var _getDefaultClassNamesJs = require("./helpers/getDefaultClassNames.js");
var _getFormattersJs = require("./helpers/getFormatters.js");
var _getMonthOptionsJs = require("./helpers/getMonthOptions.js");
var _getStyleForModifiersJs = require("./helpers/getStyleForModifiers.js");
var _getWeekdaysJs = require("./helpers/getWeekdays.js");
var _getYearOptionsJs = require("./helpers/getYearOptions.js");
var _indexJs = require("./labels/index.js");
var _uiJs = require("./UI.js");
var _useAnimationJs = require("./useAnimation.js");
var _useCalendarJs = require("./useCalendar.js");
var _useDayPickerJs = require("./useDayPicker.js");
var _useFocusJs = require("./useFocus.js");
var _useSelectionJs = require("./useSelection.js");
var _rangeIncludesDateJs = require("./utils/rangeIncludesDate.js");
var _typeguardsJs = require("./utils/typeguards.js");
function DayPicker(initialProps) {
    let props = initialProps;
    if (props.timeZone) {
        props = {
            ...initialProps
        };
        if (props.today) props.today = new (0, _tz.TZDate)(props.today, props.timeZone);
        if (props.month) props.month = new (0, _tz.TZDate)(props.month, props.timeZone);
        if (props.defaultMonth) props.defaultMonth = new (0, _tz.TZDate)(props.defaultMonth, props.timeZone);
        if (props.startMonth) props.startMonth = new (0, _tz.TZDate)(props.startMonth, props.timeZone);
        if (props.endMonth) props.endMonth = new (0, _tz.TZDate)(props.endMonth, props.timeZone);
        if (props.mode === "single" && props.selected) props.selected = new (0, _tz.TZDate)(props.selected, props.timeZone);
        else if (props.mode === "multiple" && props.selected) props.selected = props.selected?.map((date)=>new (0, _tz.TZDate)(date, props.timeZone));
        else if (props.mode === "range" && props.selected) props.selected = {
            from: props.selected.from ? new (0, _tz.TZDate)(props.selected.from, props.timeZone) : undefined,
            to: props.selected.to ? new (0, _tz.TZDate)(props.selected.to, props.timeZone) : undefined
        };
    }
    const { components, formatters, labels, dateLib, locale, classNames } = (0, _react.useMemo)(()=>{
        const locale = {
            ...(0, _dateLibJs.defaultLocale),
            ...props.locale
        };
        const dateLib = new (0, _dateLibJs.DateLib)({
            locale,
            weekStartsOn: props.broadcastCalendar ? 1 : props.weekStartsOn,
            firstWeekContainsDate: props.firstWeekContainsDate,
            useAdditionalWeekYearTokens: props.useAdditionalWeekYearTokens,
            useAdditionalDayOfYearTokens: props.useAdditionalDayOfYearTokens,
            timeZone: props.timeZone,
            numerals: props.numerals
        }, props.dateLib);
        return {
            dateLib,
            components: (0, _getComponentsJs.getComponents)(props.components),
            formatters: (0, _getFormattersJs.getFormatters)(props.formatters),
            labels: {
                ..._indexJs,
                ...props.labels
            },
            locale,
            classNames: {
                ...(0, _getDefaultClassNamesJs.getDefaultClassNames)(),
                ...props.classNames
            }
        };
    }, [
        props.locale,
        props.broadcastCalendar,
        props.weekStartsOn,
        props.firstWeekContainsDate,
        props.useAdditionalWeekYearTokens,
        props.useAdditionalDayOfYearTokens,
        props.timeZone,
        props.numerals,
        props.dateLib,
        props.components,
        props.formatters,
        props.labels,
        props.classNames
    ]);
    const { captionLayout, mode, navLayout, numberOfMonths = 1, onDayBlur, onDayClick, onDayFocus, onDayKeyDown, onDayMouseEnter, onDayMouseLeave, onNextClick, onPrevClick, showWeekNumber, styles } = props;
    const { formatCaption, formatDay, formatMonthDropdown, formatWeekNumber, formatWeekNumberHeader, formatWeekdayName, formatYearDropdown } = formatters;
    const calendar = (0, _useCalendarJs.useCalendar)(props, dateLib);
    const { days, months, navStart, navEnd, previousMonth, nextMonth, goToMonth } = calendar;
    const getModifiers = (0, _createGetModifiersJs.createGetModifiers)(days, props, navStart, navEnd, dateLib);
    const { isSelected, select, selected: selectedValue } = (0, _useSelectionJs.useSelection)(props, dateLib) ?? {};
    const { blur, focused, isFocusTarget, moveFocus, setFocused } = (0, _useFocusJs.useFocus)(props, calendar, getModifiers, isSelected ?? (()=>false), dateLib);
    const { labelDayButton, labelGridcell, labelGrid, labelMonthDropdown, labelNav, labelPrevious, labelNext, labelWeekday, labelWeekNumber, labelWeekNumberHeader, labelYearDropdown } = labels;
    const weekdays = (0, _react.useMemo)(()=>(0, _getWeekdaysJs.getWeekdays)(dateLib, props.ISOWeek), [
        dateLib,
        props.ISOWeek
    ]);
    const isInteractive = mode !== undefined || onDayClick !== undefined;
    const handlePreviousClick = (0, _react.useCallback)(()=>{
        if (!previousMonth) return;
        goToMonth(previousMonth);
        onPrevClick?.(previousMonth);
    }, [
        previousMonth,
        goToMonth,
        onPrevClick
    ]);
    const handleNextClick = (0, _react.useCallback)(()=>{
        if (!nextMonth) return;
        goToMonth(nextMonth);
        onNextClick?.(nextMonth);
    }, [
        goToMonth,
        nextMonth,
        onNextClick
    ]);
    const handleDayClick = (0, _react.useCallback)((day, m)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            setFocused(day);
            select?.(day.date, m, e);
            onDayClick?.(day.date, m, e);
        }, [
        select,
        onDayClick,
        setFocused
    ]);
    const handleDayFocus = (0, _react.useCallback)((day, m)=>(e)=>{
            setFocused(day);
            onDayFocus?.(day.date, m, e);
        }, [
        onDayFocus,
        setFocused
    ]);
    const handleDayBlur = (0, _react.useCallback)((day, m)=>(e)=>{
            blur();
            onDayBlur?.(day.date, m, e);
        }, [
        blur,
        onDayBlur
    ]);
    const handleDayKeyDown = (0, _react.useCallback)((day, modifiers)=>(e)=>{
            const keyMap = {
                ArrowLeft: [
                    e.shiftKey ? "month" : "day",
                    props.dir === "rtl" ? "after" : "before"
                ],
                ArrowRight: [
                    e.shiftKey ? "month" : "day",
                    props.dir === "rtl" ? "before" : "after"
                ],
                ArrowDown: [
                    e.shiftKey ? "year" : "week",
                    "after"
                ],
                ArrowUp: [
                    e.shiftKey ? "year" : "week",
                    "before"
                ],
                PageUp: [
                    e.shiftKey ? "year" : "month",
                    "before"
                ],
                PageDown: [
                    e.shiftKey ? "year" : "month",
                    "after"
                ],
                Home: [
                    "startOfWeek",
                    "before"
                ],
                End: [
                    "endOfWeek",
                    "after"
                ]
            };
            if (keyMap[e.key]) {
                e.preventDefault();
                e.stopPropagation();
                const [moveBy, moveDir] = keyMap[e.key];
                moveFocus(moveBy, moveDir);
            }
            onDayKeyDown?.(day.date, modifiers, e);
        }, [
        moveFocus,
        onDayKeyDown,
        props.dir
    ]);
    const handleDayMouseEnter = (0, _react.useCallback)((day, modifiers)=>(e)=>{
            onDayMouseEnter?.(day.date, modifiers, e);
        }, [
        onDayMouseEnter
    ]);
    const handleDayMouseLeave = (0, _react.useCallback)((day, modifiers)=>(e)=>{
            onDayMouseLeave?.(day.date, modifiers, e);
        }, [
        onDayMouseLeave
    ]);
    const handleMonthChange = (0, _react.useCallback)((date)=>(e)=>{
            const selectedMonth = Number(e.target.value);
            const month = dateLib.setMonth(dateLib.startOfMonth(date), selectedMonth);
            goToMonth(month);
        }, [
        dateLib,
        goToMonth
    ]);
    const handleYearChange = (0, _react.useCallback)((date)=>(e)=>{
            const selectedYear = Number(e.target.value);
            const month = dateLib.setYear(dateLib.startOfMonth(date), selectedYear);
            goToMonth(month);
        }, [
        dateLib,
        goToMonth
    ]);
    const { className, style } = (0, _react.useMemo)(()=>({
            className: [
                classNames[(0, _uiJs.UI).Root],
                props.className
            ].filter(Boolean).join(" "),
            style: {
                ...styles?.[(0, _uiJs.UI).Root],
                ...props.style
            }
        }), [
        classNames,
        props.className,
        props.style,
        styles
    ]);
    const dataAttributes = (0, _getDataAttributesJs.getDataAttributes)(props);
    const rootElRef = (0, _react.useRef)(null);
    (0, _useAnimationJs.useAnimation)(rootElRef, Boolean(props.animate), {
        classNames,
        months,
        focused,
        dateLib
    });
    const contextValue = {
        dayPickerProps: props,
        selected: selectedValue,
        select: select,
        isSelected,
        months,
        nextMonth,
        previousMonth,
        goToMonth,
        getModifiers,
        components,
        classNames,
        styles,
        labels,
        formatters
    };
    return (0, _reactDefault.default).createElement((0, _useDayPickerJs.dayPickerContext).Provider, {
        value: contextValue
    }, (0, _reactDefault.default).createElement(components.Root, {
        rootRef: props.animate ? rootElRef : undefined,
        className: className,
        style: style,
        dir: props.dir,
        id: props.id,
        lang: props.lang,
        nonce: props.nonce,
        title: props.title,
        role: props.role,
        "aria-label": props["aria-label"],
        "aria-labelledby": props["aria-labelledby"],
        ...dataAttributes
    }, (0, _reactDefault.default).createElement(components.Months, {
        className: classNames[(0, _uiJs.UI).Months],
        style: styles?.[(0, _uiJs.UI).Months]
    }, !props.hideNavigation && !navLayout && (0, _reactDefault.default).createElement(components.Nav, {
        "data-animated-nav": props.animate ? "true" : undefined,
        className: classNames[(0, _uiJs.UI).Nav],
        style: styles?.[(0, _uiJs.UI).Nav],
        "aria-label": labelNav(),
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick,
        previousMonth: previousMonth,
        nextMonth: nextMonth
    }), months.map((calendarMonth, displayIndex)=>{
        return (0, _reactDefault.default).createElement(components.Month, {
            "data-animated-month": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).Month],
            style: styles?.[(0, _uiJs.UI).Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: displayIndex,
            displayIndex: displayIndex,
            calendarMonth: calendarMonth
        }, navLayout === "around" && !props.hideNavigation && displayIndex === 0 && (0, _reactDefault.default).createElement(components.PreviousMonthButton, {
            type: "button",
            className: classNames[(0, _uiJs.UI).PreviousMonthButton],
            tabIndex: previousMonth ? undefined : -1,
            "aria-disabled": previousMonth ? undefined : true,
            "aria-label": labelPrevious(previousMonth),
            onClick: handlePreviousClick,
            "data-animated-button": props.animate ? "true" : undefined
        }, (0, _reactDefault.default).createElement(components.Chevron, {
            disabled: previousMonth ? undefined : true,
            className: classNames[(0, _uiJs.UI).Chevron],
            orientation: props.dir === "rtl" ? "right" : "left"
        })), (0, _reactDefault.default).createElement(components.MonthCaption, {
            "data-animated-caption": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).MonthCaption],
            style: styles?.[(0, _uiJs.UI).MonthCaption],
            calendarMonth: calendarMonth,
            displayIndex: displayIndex
        }, captionLayout?.startsWith("dropdown") ? (0, _reactDefault.default).createElement(components.DropdownNav, {
            className: classNames[(0, _uiJs.UI).Dropdowns],
            style: styles?.[(0, _uiJs.UI).Dropdowns]
        }, (()=>{
            const monthControl = captionLayout === "dropdown" || captionLayout === "dropdown-months" ? (0, _reactDefault.default).createElement(components.MonthsDropdown, {
                key: "month",
                className: classNames[(0, _uiJs.UI).MonthsDropdown],
                "aria-label": labelMonthDropdown(),
                classNames: classNames,
                components: components,
                disabled: Boolean(props.disableNavigation),
                onChange: handleMonthChange(calendarMonth.date),
                options: (0, _getMonthOptionsJs.getMonthOptions)(calendarMonth.date, navStart, navEnd, formatters, dateLib),
                style: styles?.[(0, _uiJs.UI).Dropdown],
                value: dateLib.getMonth(calendarMonth.date)
            }) : (0, _reactDefault.default).createElement("span", {
                key: "month"
            }, formatMonthDropdown(calendarMonth.date, dateLib));
            const yearControl = captionLayout === "dropdown" || captionLayout === "dropdown-years" ? (0, _reactDefault.default).createElement(components.YearsDropdown, {
                key: "year",
                className: classNames[(0, _uiJs.UI).YearsDropdown],
                "aria-label": labelYearDropdown(dateLib.options),
                classNames: classNames,
                components: components,
                disabled: Boolean(props.disableNavigation),
                onChange: handleYearChange(calendarMonth.date),
                options: (0, _getYearOptionsJs.getYearOptions)(navStart, navEnd, formatters, dateLib, Boolean(props.reverseYears)),
                style: styles?.[(0, _uiJs.UI).Dropdown],
                value: dateLib.getYear(calendarMonth.date)
            }) : (0, _reactDefault.default).createElement("span", {
                key: "year"
            }, formatYearDropdown(calendarMonth.date, dateLib));
            const controls = dateLib.getMonthYearOrder() === "year-first" ? [
                yearControl,
                monthControl
            ] : [
                monthControl,
                yearControl
            ];
            return controls;
        })(), (0, _reactDefault.default).createElement("span", {
            role: "status",
            "aria-live": "polite",
            style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
            }
        }, formatCaption(calendarMonth.date, dateLib.options, dateLib))) : // biome-ignore lint/a11y/useSemanticElements: breaking change
        (0, _reactDefault.default).createElement(components.CaptionLabel, {
            className: classNames[(0, _uiJs.UI).CaptionLabel],
            role: "status",
            "aria-live": "polite"
        }, formatCaption(calendarMonth.date, dateLib.options, dateLib))), navLayout === "around" && !props.hideNavigation && displayIndex === numberOfMonths - 1 && (0, _reactDefault.default).createElement(components.NextMonthButton, {
            type: "button",
            className: classNames[(0, _uiJs.UI).NextMonthButton],
            tabIndex: nextMonth ? undefined : -1,
            "aria-disabled": nextMonth ? undefined : true,
            "aria-label": labelNext(nextMonth),
            onClick: handleNextClick,
            "data-animated-button": props.animate ? "true" : undefined
        }, (0, _reactDefault.default).createElement(components.Chevron, {
            disabled: nextMonth ? undefined : true,
            className: classNames[(0, _uiJs.UI).Chevron],
            orientation: props.dir === "rtl" ? "left" : "right"
        })), displayIndex === numberOfMonths - 1 && navLayout === "after" && !props.hideNavigation && (0, _reactDefault.default).createElement(components.Nav, {
            "data-animated-nav": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).Nav],
            style: styles?.[(0, _uiJs.UI).Nav],
            "aria-label": labelNav(),
            onPreviousClick: handlePreviousClick,
            onNextClick: handleNextClick,
            previousMonth: previousMonth,
            nextMonth: nextMonth
        }), (0, _reactDefault.default).createElement(components.MonthGrid, {
            role: "grid",
            "aria-multiselectable": mode === "multiple" || mode === "range",
            "aria-label": labelGrid(calendarMonth.date, dateLib.options, dateLib) || undefined,
            className: classNames[(0, _uiJs.UI).MonthGrid],
            style: styles?.[(0, _uiJs.UI).MonthGrid]
        }, !props.hideWeekdays && (0, _reactDefault.default).createElement(components.Weekdays, {
            "data-animated-weekdays": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).Weekdays],
            style: styles?.[(0, _uiJs.UI).Weekdays]
        }, showWeekNumber && (0, _reactDefault.default).createElement(components.WeekNumberHeader, {
            "aria-label": labelWeekNumberHeader(dateLib.options),
            className: classNames[(0, _uiJs.UI).WeekNumberHeader],
            style: styles?.[(0, _uiJs.UI).WeekNumberHeader],
            scope: "col"
        }, formatWeekNumberHeader()), weekdays.map((weekday)=>(0, _reactDefault.default).createElement(components.Weekday, {
                "aria-label": labelWeekday(weekday, dateLib.options, dateLib),
                className: classNames[(0, _uiJs.UI).Weekday],
                key: String(weekday),
                style: styles?.[(0, _uiJs.UI).Weekday],
                scope: "col"
            }, formatWeekdayName(weekday, dateLib.options, dateLib)))), (0, _reactDefault.default).createElement(components.Weeks, {
            "data-animated-weeks": props.animate ? "true" : undefined,
            className: classNames[(0, _uiJs.UI).Weeks],
            style: styles?.[(0, _uiJs.UI).Weeks]
        }, calendarMonth.weeks.map((week)=>{
            return (0, _reactDefault.default).createElement(components.Week, {
                className: classNames[(0, _uiJs.UI).Week],
                key: week.weekNumber,
                style: styles?.[(0, _uiJs.UI).Week],
                week: week
            }, showWeekNumber && // biome-ignore lint/a11y/useSemanticElements: react component
            (0, _reactDefault.default).createElement(components.WeekNumber, {
                week: week,
                style: styles?.[(0, _uiJs.UI).WeekNumber],
                "aria-label": labelWeekNumber(week.weekNumber, {
                    locale
                }),
                className: classNames[(0, _uiJs.UI).WeekNumber],
                scope: "row",
                role: "rowheader"
            }, formatWeekNumber(week.weekNumber, dateLib)), week.days.map((day)=>{
                const { date } = day;
                const modifiers = getModifiers(day);
                modifiers[(0, _uiJs.DayFlag).focused] = !modifiers.hidden && Boolean(focused?.isEqualTo(day));
                modifiers[(0, _uiJs.SelectionState).selected] = isSelected?.(date) || modifiers.selected;
                if ((0, _typeguardsJs.isDateRange)(selectedValue)) {
                    // add range modifiers
                    const { from, to } = selectedValue;
                    modifiers[(0, _uiJs.SelectionState).range_start] = Boolean(from && to && dateLib.isSameDay(date, from));
                    modifiers[(0, _uiJs.SelectionState).range_end] = Boolean(from && to && dateLib.isSameDay(date, to));
                    modifiers[(0, _uiJs.SelectionState).range_middle] = (0, _rangeIncludesDateJs.rangeIncludesDate)(selectedValue, date, true, dateLib);
                }
                const style = (0, _getStyleForModifiersJs.getStyleForModifiers)(modifiers, styles, props.modifiersStyles);
                const className = (0, _getClassNamesForModifiersJs.getClassNamesForModifiers)(modifiers, classNames, props.modifiersClassNames);
                const ariaLabel = !isInteractive && !modifiers.hidden ? labelGridcell(date, modifiers, dateLib.options, dateLib) : undefined;
                return(// biome-ignore lint/a11y/useSemanticElements: react component
                (0, _reactDefault.default).createElement(components.Day, {
                    key: `${dateLib.format(date, "yyyy-MM-dd")}_${dateLib.format(day.displayMonth, "yyyy-MM")}`,
                    day: day,
                    modifiers: modifiers,
                    className: className.join(" "),
                    style: style,
                    role: "gridcell",
                    "aria-selected": modifiers.selected || undefined,
                    "aria-label": ariaLabel,
                    "data-day": dateLib.format(date, "yyyy-MM-dd"),
                    "data-month": day.outside ? dateLib.format(date, "yyyy-MM") : undefined,
                    "data-selected": modifiers.selected || undefined,
                    "data-disabled": modifiers.disabled || undefined,
                    "data-hidden": modifiers.hidden || undefined,
                    "data-outside": day.outside || undefined,
                    "data-focused": modifiers.focused || undefined,
                    "data-today": modifiers.today || undefined
                }, !modifiers.hidden && isInteractive ? (0, _reactDefault.default).createElement(components.DayButton, {
                    className: classNames[(0, _uiJs.UI).DayButton],
                    style: styles?.[(0, _uiJs.UI).DayButton],
                    type: "button",
                    day: day,
                    modifiers: modifiers,
                    disabled: modifiers.disabled || undefined,
                    tabIndex: isFocusTarget(day) ? 0 : -1,
                    "aria-label": labelDayButton(date, modifiers, dateLib.options, dateLib),
                    onClick: handleDayClick(day, modifiers),
                    onBlur: handleDayBlur(day, modifiers),
                    onFocus: handleDayFocus(day, modifiers),
                    onKeyDown: handleDayKeyDown(day, modifiers),
                    onMouseEnter: handleDayMouseEnter(day, modifiers),
                    onMouseLeave: handleDayMouseLeave(day, modifiers)
                }, formatDay(date, dateLib.options, dateLib)) : !modifiers.hidden && formatDay(day.date, dateLib.options, dateLib)));
            }));
        }))));
    })), props.footer && // biome-ignore lint/a11y/useSemanticElements: react component
    (0, _reactDefault.default).createElement(components.Footer, {
        className: classNames[(0, _uiJs.UI).Footer],
        style: styles?.[(0, _uiJs.UI).Footer],
        role: "status",
        "aria-live": "polite"
    }, props.footer)));
}

},{"@date-fns/tz":"hGxfM","react":"IMRgT","./classes/DateLib.js":"l7QE0","./helpers/createGetModifiers.js":"32SpU","./helpers/getClassNamesForModifiers.js":"gBcHI","./helpers/getComponents.js":"8PTFF","./helpers/getDataAttributes.js":"laIPo","./helpers/getDefaultClassNames.js":"abzSU","./helpers/getFormatters.js":"dgyb1","./helpers/getMonthOptions.js":"1yqQn","./helpers/getStyleForModifiers.js":"gZcYW","./helpers/getWeekdays.js":"cbCV5","./helpers/getYearOptions.js":"iF2zD","./labels/index.js":"6y6xk","./UI.js":"7f59g","./useAnimation.js":"8Jv6n","./useCalendar.js":"6fZSL","./useDayPicker.js":"9p9gP","./useFocus.js":"78xEB","./useSelection.js":"bim9M","./utils/rangeIncludesDate.js":"aWwuo","./utils/typeguards.js":"4HpfU","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hGxfM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./constants/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _indexJs1 = require("./date/index.js");
parcelHelpers.exportAll(_indexJs1, exports);
var _miniJs = require("./date/mini.js");
parcelHelpers.exportAll(_miniJs, exports);
var _indexJs2 = require("./tz/index.js");
parcelHelpers.exportAll(_indexJs2, exports);
var _indexJs3 = require("./tzOffset/index.js");
parcelHelpers.exportAll(_indexJs3, exports);
var _indexJs4 = require("./tzScan/index.js");
parcelHelpers.exportAll(_indexJs4, exports);
var _indexJs5 = require("./tzName/index.js");
parcelHelpers.exportAll(_indexJs5, exports);

},{"./constants/index.js":"1dBSx","./date/index.js":"3FuH0","./date/mini.js":"5cbp3","./tz/index.js":"2OFBZ","./tzOffset/index.js":"eQLpF","./tzScan/index.js":"gtOeU","./tzName/index.js":"fCS57","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1dBSx":[function(require,module,exports,__globalThis) {
/**
 * The symbol to access the `TZDate`'s function to construct a new instance from
 * the provided value. It helps date-fns to inherit the time zone.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructFromSymbol", ()=>constructFromSymbol);
const constructFromSymbol = Symbol.for("constructDateFrom");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3FuH0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TZDate", ()=>TZDate);
var _indexJs = require("../tzName/index.js");
var _miniJs = require("./mini.js");
class TZDate extends (0, _miniJs.TZDateMini) {
    //#region static
    static tz(tz, ...args) {
        return args.length ? new TZDate(...args, tz) : new TZDate(Date.now(), tz);
    }
    //#endregion
    //#region representation
    toISOString() {
        const [sign, hours, minutes] = this.tzComponents();
        const tz = `${sign}${hours}:${minutes}`;
        return this.internal.toISOString().slice(0, -1) + tz;
    }
    toString() {
        // "Tue Aug 13 2024 07:50:19 GMT+0800 (Singapore Standard Time)";
        return `${this.toDateString()} ${this.toTimeString()}`;
    }
    toDateString() {
        // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
        const [day, date, month, year] = this.internal.toUTCString().split(" ");
        // "Tue Aug 13 2024"
        return `${day?.slice(0, -1)} ${month} ${date} ${year}`;
    }
    toTimeString() {
        // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
        const time = this.internal.toUTCString().split(" ")[4];
        const [sign, hours, minutes] = this.tzComponents();
        // "07:42:23 GMT+0800 (Singapore Standard Time)"
        return `${time} GMT${sign}${hours}${minutes} (${(0, _indexJs.tzName)(this.timeZone, this)})`;
    }
    toLocaleString(locales, options) {
        return Date.prototype.toLocaleString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    toLocaleDateString(locales, options) {
        return Date.prototype.toLocaleDateString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    toLocaleTimeString(locales, options) {
        return Date.prototype.toLocaleTimeString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    //#endregion
    //#region private
    tzComponents() {
        const offset = this.getTimezoneOffset();
        const sign = offset > 0 ? "-" : "+";
        const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
        const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
        return [
            sign,
            hours,
            minutes
        ];
    }
    //#endregion
    withTimeZone(timeZone) {
        return new TZDate(+this, timeZone);
    }
    //#region date-fns integration
    [Symbol.for("constructDateFrom")](date) {
        return new TZDate(+new Date(date), this.timeZone);
    }
}

},{"../tzName/index.js":"fCS57","./mini.js":"5cbp3","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fCS57":[function(require,module,exports,__globalThis) {
/**
 * Time zone name format.
 */ /**
 * The function returns the time zone name for the given date in the specified
 * time zone.
 *
 * It uses the `Intl.DateTimeFormat` API and by default outputs the time zone
 * name in a long format, e.g. "Pacific Standard Time" or
 * "Singapore Standard Time".
 *
 * It is possible to specify the format as the third argument using one of the following options
 *
 * - "short": e.g. "EDT" or "GMT+8".
 * - "long": e.g. "Eastern Daylight Time".
 * - "shortGeneric": e.g. "ET" or "Singapore Time".
 * - "longGeneric": e.g. "Eastern Time" or "Singapore Standard Time".
 *
 * These options correspond to TR35 tokens `z..zzz`, `zzzz`, `v`, and `vvvv` respectively: https://www.unicode.org/reports/tr35/tr35-dates.html#dfst-zone
 *
 * @param timeZone - Time zone name (IANA or UTC offset)
 * @param date - Date object to get the time zone name for
 * @param format - Optional format of the time zone name. Defaults to "long". Can be "short", "long", "shortGeneric", or "longGeneric".
 *
 * @returns Time zone name (e.g. "Singapore Standard Time")
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tzName", ()=>tzName);
function tzName(timeZone, date, format = "long") {
    return new Intl.DateTimeFormat("en-US", {
        // Enforces engine to render the time. Without the option JavaScriptCore omits it.
        hour: "numeric",
        timeZone: timeZone,
        timeZoneName: format
    }).format(date).split(/\s/g) // Format.JS uses non-breaking spaces
    .slice(2) // Skip the hour and AM/PM parts
    .join(" ");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5cbp3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TZDateMini", ()=>TZDateMini);
var _indexJs = require("../tzOffset/index.js");
class TZDateMini extends Date {
    //#region static
    constructor(...args){
        super();
        if (args.length > 1 && typeof args[args.length - 1] === "string") this.timeZone = args.pop();
        this.internal = new Date();
        if (isNaN((0, _indexJs.tzOffset)(this.timeZone, this))) this.setTime(NaN);
        else {
            if (!args.length) this.setTime(Date.now());
            else if (typeof args[0] === "number" && (args.length === 1 || args.length === 2 && typeof args[1] !== "number")) this.setTime(args[0]);
            else if (typeof args[0] === "string") this.setTime(+new Date(args[0]));
            else if (args[0] instanceof Date) this.setTime(+args[0]);
            else {
                this.setTime(+new Date(...args));
                adjustToSystemTZ(this, NaN);
                syncToInternal(this);
            }
        }
    }
    static tz(tz, ...args) {
        return args.length ? new TZDateMini(...args, tz) : new TZDateMini(Date.now(), tz);
    }
    //#endregion
    //#region time zone
    withTimeZone(timeZone) {
        return new TZDateMini(+this, timeZone);
    }
    getTimezoneOffset() {
        const offset = -(0, _indexJs.tzOffset)(this.timeZone, this);
        // Remove the seconds offset
        // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
        return offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    }
    //#endregion
    //#region time
    setTime(time) {
        Date.prototype.setTime.apply(this, arguments);
        syncToInternal(this);
        return +this;
    }
    //#endregion
    //#region date-fns integration
    [Symbol.for("constructDateFrom")](date) {
        return new TZDateMini(+new Date(date), this.timeZone);
    }
}
// Assign getters and setters
const re = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((method)=>{
    if (!re.test(method)) return;
    const utcMethod = method.replace(re, "$1UTC");
    // Filter out methods without UTC counterparts
    if (!TZDateMini.prototype[utcMethod]) return;
    if (method.startsWith("get")) // Delegate to internal date's UTC method
    TZDateMini.prototype[method] = function() {
        return this.internal[utcMethod]();
    };
    else {
        // Assign regular setter
        TZDateMini.prototype[method] = function() {
            Date.prototype[utcMethod].apply(this.internal, arguments);
            syncFromInternal(this);
            return +this;
        };
        // Assign UTC setter
        TZDateMini.prototype[utcMethod] = function() {
            Date.prototype[utcMethod].apply(this, arguments);
            syncToInternal(this);
            return +this;
        };
    }
});
/**
 * Function syncs time to internal date, applying the time zone offset.
 *
 * @param {Date} date - Date to sync
 */ function syncToInternal(date) {
    date.internal.setTime(+date);
    date.internal.setUTCSeconds(date.internal.getUTCSeconds() - Math.round(-(0, _indexJs.tzOffset)(date.timeZone, date) * 60));
}
/**
 * Function syncs the internal date UTC values to the date. It allows to get
 * accurate timestamp value.
 *
 * @param {Date} date - The date to sync
 */ function syncFromInternal(date) {
    // First we transpose the internal values
    Date.prototype.setFullYear.call(date, date.internal.getUTCFullYear(), date.internal.getUTCMonth(), date.internal.getUTCDate());
    Date.prototype.setHours.call(date, date.internal.getUTCHours(), date.internal.getUTCMinutes(), date.internal.getUTCSeconds(), date.internal.getUTCMilliseconds());
    // Now we have to adjust the date to the system time zone
    adjustToSystemTZ(date);
}
/**
 * Function adjusts the date to the system time zone. It uses the time zone
 * differences to calculate the offset and adjust the date.
 *
 * @param {Date} date - Date to adjust
 */ function adjustToSystemTZ(date) {
    // Save the time zone offset before all the adjustments
    const baseOffset = (0, _indexJs.tzOffset)(date.timeZone, date);
    // Remove the seconds offset
    // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
    const offset = baseOffset > 0 ? Math.floor(baseOffset) : Math.ceil(baseOffset);
    //#region System DST adjustment
    // The biggest problem with using the system time zone is that when we create
    // a date from internal values stored in UTC, the system time zone might end
    // up on the DST hour:
    //
    //   $ TZ=America/New_York node
    //   > new Date(2020, 2, 8, 1).toString()
    //   'Sun Mar 08 2020 01:00:00 GMT-0500 (Eastern Standard Time)'
    //   > new Date(2020, 2, 8, 2).toString()
    //   'Sun Mar 08 2020 03:00:00 GMT-0400 (Eastern Daylight Time)'
    //   > new Date(2020, 2, 8, 3).toString()
    //   'Sun Mar 08 2020 03:00:00 GMT-0400 (Eastern Daylight Time)'
    //   > new Date(2020, 2, 8, 4).toString()
    //   'Sun Mar 08 2020 04:00:00 GMT-0400 (Eastern Daylight Time)'
    //
    // Here we get the same hour for both 2 and 3, because the system time zone
    // has DST beginning at 8 March 2020, 2 a.m. and jumps to 3 a.m. So we have
    // to adjust the internal date to reflect that.
    //
    // However we want to adjust only if that's the DST hour the change happenes,
    // not the hour where DST moves to.
    // We calculate the previous hour to see if the time zone offset has changed
    // and we have landed on the DST hour.
    const prevHour = new Date(+date);
    // We use UTC methods here as we don't want to land on the same hour again
    // in case of DST.
    prevHour.setUTCHours(prevHour.getUTCHours() - 1);
    // Calculate if we are on the system DST hour.
    const systemOffset = -new Date(+date).getTimezoneOffset();
    const prevHourSystemOffset = -new Date(+prevHour).getTimezoneOffset();
    const systemDSTChange = systemOffset - prevHourSystemOffset;
    // Detect the DST shift. System DST change will occur both on
    const dstShift = Date.prototype.getHours.apply(date) !== date.internal.getUTCHours();
    // Move the internal date when we are on the system DST hour.
    if (systemDSTChange && dstShift) date.internal.setUTCMinutes(date.internal.getUTCMinutes() + systemDSTChange);
    //#endregion
    //#region System diff adjustment
    // Now we need to adjust the date, since we just applied internal values.
    // We need to calculate the difference between the system and date time zones
    // and apply it to the date.
    const offsetDiff = systemOffset - offset;
    if (offsetDiff) Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetDiff);
    //#endregion
    //#region Seconds System diff adjustment
    const systemDate = new Date(+date);
    // Set the UTC seconds to 0 to isolate the timezone offset in seconds.
    systemDate.setUTCSeconds(0);
    // For negative systemOffset, invert the seconds.
    const systemSecondsOffset = systemOffset > 0 ? systemDate.getSeconds() : (systemDate.getSeconds() - 60) % 60;
    // Calculate the seconds offset based on the timezone offset.
    const secondsOffset = Math.round(-((0, _indexJs.tzOffset)(date.timeZone, date) * 60)) % 60;
    if (secondsOffset || systemSecondsOffset) {
        date.internal.setUTCSeconds(date.internal.getUTCSeconds() + secondsOffset);
        Date.prototype.setUTCSeconds.call(date, Date.prototype.getUTCSeconds.call(date) + secondsOffset + systemSecondsOffset);
    }
    //#endregion
    //#region Post-adjustment DST fix
    const postBaseOffset = (0, _indexJs.tzOffset)(date.timeZone, date);
    // Remove the seconds offset
    // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
    const postOffset = postBaseOffset > 0 ? Math.floor(postBaseOffset) : Math.ceil(postBaseOffset);
    const postSystemOffset = -new Date(+date).getTimezoneOffset();
    const postOffsetDiff = postSystemOffset - postOffset;
    const offsetChanged = postOffset !== offset;
    const postDiff = postOffsetDiff - offsetDiff;
    if (offsetChanged && postDiff) {
        Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + postDiff);
        // Now we need to check if got offset change during the post-adjustment.
        // If so, we also need both dates to reflect that.
        const newBaseOffset = (0, _indexJs.tzOffset)(date.timeZone, date);
        // Remove the seconds offset
        // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
        const newOffset = newBaseOffset > 0 ? Math.floor(newBaseOffset) : Math.ceil(newBaseOffset);
        const offsetChange = postOffset - newOffset;
        if (offsetChange) {
            date.internal.setUTCMinutes(date.internal.getUTCMinutes() + offsetChange);
            Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetChange);
        }
    }
//#endregion
}

},{"../tzOffset/index.js":"eQLpF","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eQLpF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The function extracts UTC offset in minutes from the given date in specified
 * time zone.
 *
 * Unlike `Date.prototype.getTimezoneOffset`, this function returns the value
 * mirrored to the sign of the offset in the time zone. For Asia/Singapore
 * (UTC+8), `tzOffset` returns 480, while `getTimezoneOffset` returns -480.
 *
 * @param timeZone - Time zone name (IANA or UTC offset)
 * @param date - Date to check the offset for
 *
 * @returns UTC offset in minutes
 */ parcelHelpers.export(exports, "tzOffset", ()=>tzOffset);
const offsetFormatCache = {};
const offsetCache = {};
function tzOffset(timeZone, date) {
    try {
        const format = offsetFormatCache[timeZone] ||= new Intl.DateTimeFormat("en-US", {
            timeZone,
            timeZoneName: "longOffset"
        }).format;
        const offsetStr = format(date).split("GMT")[1];
        if (offsetStr in offsetCache) return offsetCache[offsetStr];
        return calcOffset(offsetStr, offsetStr.split(":"));
    } catch  {
        // Fallback to manual parsing if the runtime doesn't support ±HH:MM/±HHMM/±HH
        // See: https://github.com/nodejs/node/issues/53419
        if (timeZone in offsetCache) return offsetCache[timeZone];
        const captures = timeZone?.match(offsetRe);
        if (captures) return calcOffset(timeZone, captures.slice(1));
        return NaN;
    }
}
const offsetRe = /([+-]\d\d):?(\d\d)?/;
function calcOffset(cacheStr, values) {
    const hours = +(values[0] || 0);
    const minutes = +(values[1] || 0);
    // Convert seconds to minutes by dividing by 60 to keep the function return in minutes.
    const seconds = +(values[2] || 0) / 60;
    return offsetCache[cacheStr] = hours * 60 + minutes > 0 ? hours * 60 + minutes + seconds : hours * 60 - minutes - seconds;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2OFBZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tz", ()=>tz);
var _indexJs = require("../date/index.js");
const tz = (timeZone)=>(value)=>(0, _indexJs.TZDate).tz(timeZone, +new Date(value));

},{"../date/index.js":"3FuH0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gtOeU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Time interval.
 */ /**
 * Time zone change record.
 */ /**
 * The function scans the time zone for changes in the given interval.
 *
 * @param timeZone - Time zone name (IANA or UTC offset)
 * @param interval - Time interval to scan for changes
 *
 * @returns Array of time zone changes
 */ parcelHelpers.export(exports, "tzScan", ()=>tzScan);
var _indexJs = require("../tzOffset/index.js");
function tzScan(timeZone, interval) {
    const changes = [];
    const monthDate = new Date(interval.start);
    monthDate.setUTCSeconds(0, 0);
    const endDate = new Date(interval.end);
    endDate.setUTCSeconds(0, 0);
    const endMonthTime = +endDate;
    let lastOffset = (0, _indexJs.tzOffset)(timeZone, monthDate);
    while(+monthDate < endMonthTime){
        // Month forward
        monthDate.setUTCMonth(monthDate.getUTCMonth() + 1);
        // Find the month where the offset changes
        const offset = (0, _indexJs.tzOffset)(timeZone, monthDate);
        if (offset != lastOffset) {
            // Rewind a month back to find the day where the offset changes
            const dayDate = new Date(monthDate);
            dayDate.setUTCMonth(dayDate.getUTCMonth() - 1);
            const endDayTime = +monthDate;
            lastOffset = (0, _indexJs.tzOffset)(timeZone, dayDate);
            while(+dayDate < endDayTime){
                // Day forward
                dayDate.setUTCDate(dayDate.getUTCDate() + 1);
                // Find the day where the offset changes
                const offset = (0, _indexJs.tzOffset)(timeZone, dayDate);
                if (offset != lastOffset) {
                    // Rewind a day back to find the time where the offset changes
                    const hourDate = new Date(dayDate);
                    hourDate.setUTCDate(hourDate.getUTCDate() - 1);
                    const endHourTime = +dayDate;
                    lastOffset = (0, _indexJs.tzOffset)(timeZone, hourDate);
                    while(+hourDate < endHourTime){
                        // Hour forward
                        hourDate.setUTCHours(hourDate.getUTCHours() + 1);
                        // Find the hour where the offset changes
                        const hourOffset = (0, _indexJs.tzOffset)(timeZone, hourDate);
                        if (hourOffset !== lastOffset) changes.push({
                            date: new Date(hourDate),
                            change: hourOffset - lastOffset,
                            offset: hourOffset
                        });
                        lastOffset = hourOffset;
                    }
                }
                lastOffset = offset;
            }
        }
        lastOffset = offset;
    }
    return changes;
}

},{"../tzOffset/index.js":"eQLpF","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"l7QE0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** The default locale (English). */ parcelHelpers.export(exports, "defaultLocale", ()=>(0, _enUS.enUS));
/**
 * A wrapper class around [date-fns](http://date-fns.org) that provides utility
 * methods for date manipulation and formatting.
 *
 * @since 9.2.0
 * @example
 *   const dateLib = new DateLib({ locale: es });
 *   const newDate = dateLib.addDays(new Date(), 5);
 */ parcelHelpers.export(exports, "DateLib", ()=>DateLib);
parcelHelpers.export(exports, "defaultDateLib", ()=>defaultDateLib);
parcelHelpers.export(exports, "dateLib", ()=>dateLib);
var _tz = require("@date-fns/tz");
var _dateFns = require("date-fns");
var _enUS = require("date-fns/locale/en-US");
var _endOfBroadcastWeekJs = require("../helpers/endOfBroadcastWeek.js");
var _startOfBroadcastWeekJs = require("../helpers/startOfBroadcastWeek.js");
class DateLib {
    /**
     * Creates an instance of `DateLib`.
     *
     * @param options Configuration options for the date library.
     * @param overrides Custom overrides for the date library functions.
     */ constructor(options, overrides){
        /**
         * Reference to the built-in Date constructor.
         *
         * @deprecated Use `newDate()` or `today()`.
         */ this.Date = Date;
        /**
         * Creates a new `Date` object representing today's date.
         *
         * @since 9.5.0
         * @returns A `Date` object for today's date.
         */ this.today = ()=>{
            if (this.overrides?.today) return this.overrides.today();
            if (this.options.timeZone) return (0, _tz.TZDate).tz(this.options.timeZone);
            return new this.Date();
        };
        /**
         * Creates a new `Date` object with the specified year, month, and day.
         *
         * @since 9.5.0
         * @param year The year.
         * @param monthIndex The month (0-11).
         * @param date The day of the month.
         * @returns A new `Date` object.
         */ this.newDate = (year, monthIndex, date)=>{
            if (this.overrides?.newDate) return this.overrides.newDate(year, monthIndex, date);
            if (this.options.timeZone) return new (0, _tz.TZDate)(year, monthIndex, date, this.options.timeZone);
            return new Date(year, monthIndex, date);
        };
        /**
         * Adds the specified number of days to the given date.
         *
         * @param date The date to add days to.
         * @param amount The number of days to add.
         * @returns The new date with the days added.
         */ this.addDays = (date, amount)=>{
            return this.overrides?.addDays ? this.overrides.addDays(date, amount) : (0, _dateFns.addDays)(date, amount);
        };
        /**
         * Adds the specified number of months to the given date.
         *
         * @param date The date to add months to.
         * @param amount The number of months to add.
         * @returns The new date with the months added.
         */ this.addMonths = (date, amount)=>{
            return this.overrides?.addMonths ? this.overrides.addMonths(date, amount) : (0, _dateFns.addMonths)(date, amount);
        };
        /**
         * Adds the specified number of weeks to the given date.
         *
         * @param date The date to add weeks to.
         * @param amount The number of weeks to add.
         * @returns The new date with the weeks added.
         */ this.addWeeks = (date, amount)=>{
            return this.overrides?.addWeeks ? this.overrides.addWeeks(date, amount) : (0, _dateFns.addWeeks)(date, amount);
        };
        /**
         * Adds the specified number of years to the given date.
         *
         * @param date The date to add years to.
         * @param amount The number of years to add.
         * @returns The new date with the years added.
         */ this.addYears = (date, amount)=>{
            return this.overrides?.addYears ? this.overrides.addYears(date, amount) : (0, _dateFns.addYears)(date, amount);
        };
        /**
         * Returns the number of calendar days between the given dates.
         *
         * @param dateLeft The later date.
         * @param dateRight The earlier date.
         * @returns The number of calendar days between the dates.
         */ this.differenceInCalendarDays = (dateLeft, dateRight)=>{
            return this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(dateLeft, dateRight) : (0, _dateFns.differenceInCalendarDays)(dateLeft, dateRight);
        };
        /**
         * Returns the number of calendar months between the given dates.
         *
         * @param dateLeft The later date.
         * @param dateRight The earlier date.
         * @returns The number of calendar months between the dates.
         */ this.differenceInCalendarMonths = (dateLeft, dateRight)=>{
            return this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(dateLeft, dateRight) : (0, _dateFns.differenceInCalendarMonths)(dateLeft, dateRight);
        };
        /**
         * Returns the months between the given dates.
         *
         * @param interval The interval to get the months for.
         */ this.eachMonthOfInterval = (interval)=>{
            return this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(interval) : (0, _dateFns.eachMonthOfInterval)(interval);
        };
        /**
         * Returns the years between the given dates.
         *
         * @since 9.11.1
         * @param interval The interval to get the years for.
         * @returns The array of years in the interval.
         */ this.eachYearOfInterval = (interval)=>{
            const years = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(interval) : (0, _dateFns.eachYearOfInterval)(interval);
            // Remove duplicates that may happen across DST transitions (e.g., "America/Sao_Paulo")
            // See https://github.com/date-fns/tz/issues/72
            const uniqueYears = new Set(years.map((d)=>this.getYear(d)));
            if (uniqueYears.size === years.length) // No duplicates, return as is
            return years;
            // Rebuild the array to ensure one date per year
            const yearsArray = [];
            uniqueYears.forEach((y)=>{
                yearsArray.push(new Date(y, 0, 1));
            });
            return yearsArray;
        };
        /**
         * Returns the end of the broadcast week for the given date.
         *
         * @param date The original date.
         * @returns The end of the broadcast week.
         */ this.endOfBroadcastWeek = (date)=>{
            return this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(date) : (0, _endOfBroadcastWeekJs.endOfBroadcastWeek)(date, this);
        };
        /**
         * Returns the end of the ISO week for the given date.
         *
         * @param date The original date.
         * @returns The end of the ISO week.
         */ this.endOfISOWeek = (date)=>{
            return this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(date) : (0, _dateFns.endOfISOWeek)(date);
        };
        /**
         * Returns the end of the month for the given date.
         *
         * @param date The original date.
         * @returns The end of the month.
         */ this.endOfMonth = (date)=>{
            return this.overrides?.endOfMonth ? this.overrides.endOfMonth(date) : (0, _dateFns.endOfMonth)(date);
        };
        /**
         * Returns the end of the week for the given date.
         *
         * @param date The original date.
         * @returns The end of the week.
         */ this.endOfWeek = (date, options)=>{
            return this.overrides?.endOfWeek ? this.overrides.endOfWeek(date, options) : (0, _dateFns.endOfWeek)(date, this.options);
        };
        /**
         * Returns the end of the year for the given date.
         *
         * @param date The original date.
         * @returns The end of the year.
         */ this.endOfYear = (date)=>{
            return this.overrides?.endOfYear ? this.overrides.endOfYear(date) : (0, _dateFns.endOfYear)(date);
        };
        /**
         * Formats the given date using the specified format string.
         *
         * @param date The date to format.
         * @param formatStr The format string.
         * @returns The formatted date string.
         */ this.format = (date, formatStr, _options)=>{
            const formatted = this.overrides?.format ? this.overrides.format(date, formatStr, this.options) : (0, _dateFns.format)(date, formatStr, this.options);
            if (this.options.numerals && this.options.numerals !== "latn") return this.replaceDigits(formatted);
            return formatted;
        };
        /**
         * Returns the ISO week number for the given date.
         *
         * @param date The date to get the ISO week number for.
         * @returns The ISO week number.
         */ this.getISOWeek = (date)=>{
            return this.overrides?.getISOWeek ? this.overrides.getISOWeek(date) : (0, _dateFns.getISOWeek)(date);
        };
        /**
         * Returns the month of the given date.
         *
         * @param date The date to get the month for.
         * @returns The month.
         */ this.getMonth = (date, _options)=>{
            return this.overrides?.getMonth ? this.overrides.getMonth(date, this.options) : (0, _dateFns.getMonth)(date, this.options);
        };
        /**
         * Returns the year of the given date.
         *
         * @param date The date to get the year for.
         * @returns The year.
         */ this.getYear = (date, _options)=>{
            return this.overrides?.getYear ? this.overrides.getYear(date, this.options) : (0, _dateFns.getYear)(date, this.options);
        };
        /**
         * Returns the local week number for the given date.
         *
         * @param date The date to get the week number for.
         * @returns The week number.
         */ this.getWeek = (date, _options)=>{
            return this.overrides?.getWeek ? this.overrides.getWeek(date, this.options) : (0, _dateFns.getWeek)(date, this.options);
        };
        /**
         * Checks if the first date is after the second date.
         *
         * @param date The date to compare.
         * @param dateToCompare The date to compare with.
         * @returns True if the first date is after the second date.
         */ this.isAfter = (date, dateToCompare)=>{
            return this.overrides?.isAfter ? this.overrides.isAfter(date, dateToCompare) : (0, _dateFns.isAfter)(date, dateToCompare);
        };
        /**
         * Checks if the first date is before the second date.
         *
         * @param date The date to compare.
         * @param dateToCompare The date to compare with.
         * @returns True if the first date is before the second date.
         */ this.isBefore = (date, dateToCompare)=>{
            return this.overrides?.isBefore ? this.overrides.isBefore(date, dateToCompare) : (0, _dateFns.isBefore)(date, dateToCompare);
        };
        /**
         * Checks if the given value is a Date object.
         *
         * @param value The value to check.
         * @returns True if the value is a Date object.
         */ this.isDate = (value)=>{
            return this.overrides?.isDate ? this.overrides.isDate(value) : (0, _dateFns.isDate)(value);
        };
        /**
         * Checks if the given dates are on the same day.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are on the same day.
         */ this.isSameDay = (dateLeft, dateRight)=>{
            return this.overrides?.isSameDay ? this.overrides.isSameDay(dateLeft, dateRight) : (0, _dateFns.isSameDay)(dateLeft, dateRight);
        };
        /**
         * Checks if the given dates are in the same month.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are in the same month.
         */ this.isSameMonth = (dateLeft, dateRight)=>{
            return this.overrides?.isSameMonth ? this.overrides.isSameMonth(dateLeft, dateRight) : (0, _dateFns.isSameMonth)(dateLeft, dateRight);
        };
        /**
         * Checks if the given dates are in the same year.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are in the same year.
         */ this.isSameYear = (dateLeft, dateRight)=>{
            return this.overrides?.isSameYear ? this.overrides.isSameYear(dateLeft, dateRight) : (0, _dateFns.isSameYear)(dateLeft, dateRight);
        };
        /**
         * Returns the latest date in the given array of dates.
         *
         * @param dates The array of dates to compare.
         * @returns The latest date.
         */ this.max = (dates)=>{
            return this.overrides?.max ? this.overrides.max(dates) : (0, _dateFns.max)(dates);
        };
        /**
         * Returns the earliest date in the given array of dates.
         *
         * @param dates The array of dates to compare.
         * @returns The earliest date.
         */ this.min = (dates)=>{
            return this.overrides?.min ? this.overrides.min(dates) : (0, _dateFns.min)(dates);
        };
        /**
         * Sets the month of the given date.
         *
         * @param date The date to set the month on.
         * @param month The month to set (0-11).
         * @returns The new date with the month set.
         */ this.setMonth = (date, month)=>{
            return this.overrides?.setMonth ? this.overrides.setMonth(date, month) : (0, _dateFns.setMonth)(date, month);
        };
        /**
         * Sets the year of the given date.
         *
         * @param date The date to set the year on.
         * @param year The year to set.
         * @returns The new date with the year set.
         */ this.setYear = (date, year)=>{
            return this.overrides?.setYear ? this.overrides.setYear(date, year) : (0, _dateFns.setYear)(date, year);
        };
        /**
         * Returns the start of the broadcast week for the given date.
         *
         * @param date The original date.
         * @returns The start of the broadcast week.
         */ this.startOfBroadcastWeek = (date, _dateLib)=>{
            return this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(date, this) : (0, _startOfBroadcastWeekJs.startOfBroadcastWeek)(date, this);
        };
        /**
         * Returns the start of the day for the given date.
         *
         * @param date The original date.
         * @returns The start of the day.
         */ this.startOfDay = (date)=>{
            return this.overrides?.startOfDay ? this.overrides.startOfDay(date) : (0, _dateFns.startOfDay)(date);
        };
        /**
         * Returns the start of the ISO week for the given date.
         *
         * @param date The original date.
         * @returns The start of the ISO week.
         */ this.startOfISOWeek = (date)=>{
            return this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(date) : (0, _dateFns.startOfISOWeek)(date);
        };
        /**
         * Returns the start of the month for the given date.
         *
         * @param date The original date.
         * @returns The start of the month.
         */ this.startOfMonth = (date)=>{
            return this.overrides?.startOfMonth ? this.overrides.startOfMonth(date) : (0, _dateFns.startOfMonth)(date);
        };
        /**
         * Returns the start of the week for the given date.
         *
         * @param date The original date.
         * @returns The start of the week.
         */ this.startOfWeek = (date, _options)=>{
            return this.overrides?.startOfWeek ? this.overrides.startOfWeek(date, this.options) : (0, _dateFns.startOfWeek)(date, this.options);
        };
        /**
         * Returns the start of the year for the given date.
         *
         * @param date The original date.
         * @returns The start of the year.
         */ this.startOfYear = (date)=>{
            return this.overrides?.startOfYear ? this.overrides.startOfYear(date) : (0, _dateFns.startOfYear)(date);
        };
        this.options = {
            locale: (0, _enUS.enUS),
            ...options
        };
        this.overrides = overrides;
    }
    /**
     * Generates a mapping of Arabic digits (0-9) to the target numbering system
     * digits.
     *
     * @since 9.5.0
     * @returns A record mapping Arabic digits to the target numerals.
     */ getDigitMap() {
        const { numerals = "latn" } = this.options;
        // Use Intl.NumberFormat to create a formatter with the specified numbering system
        const formatter = new Intl.NumberFormat("en-US", {
            numberingSystem: numerals
        });
        // Map Arabic digits (0-9) to the target numerals
        const digitMap = {};
        for(let i = 0; i < 10; i++)digitMap[i.toString()] = formatter.format(i);
        return digitMap;
    }
    /**
     * Replaces Arabic digits in a string with the target numbering system digits.
     *
     * @since 9.5.0
     * @param input The string containing Arabic digits.
     * @returns The string with digits replaced.
     */ replaceDigits(input) {
        const digitMap = this.getDigitMap();
        return input.replace(/\d/g, (digit)=>digitMap[digit] || digit);
    }
    /**
     * Formats a number using the configured numbering system.
     *
     * @since 9.5.0
     * @param value The number to format.
     * @returns The formatted number as a string.
     */ formatNumber(value) {
        return this.replaceDigits(value.toString());
    }
    /**
     * Returns the preferred ordering for month and year labels for the current
     * locale.
     */ getMonthYearOrder() {
        const code = this.options.locale?.code;
        if (!code) return "month-first";
        return DateLib.yearFirstLocales.has(code) ? "year-first" : "month-first";
    }
    /**
     * Formats the month/year pair respecting locale conventions.
     *
     * @since 9.11.0
     */ formatMonthYear(date) {
        const { locale, timeZone, numerals } = this.options;
        const localeCode = locale?.code;
        if (localeCode && DateLib.yearFirstLocales.has(localeCode)) try {
            const intl = new Intl.DateTimeFormat(localeCode, {
                month: "long",
                year: "numeric",
                timeZone,
                numberingSystem: numerals
            });
            const formatted = intl.format(date);
            return formatted;
        } catch  {
        // Fallback to date-fns formatting below.
        }
        const pattern = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
        return this.format(date, pattern);
    }
}
DateLib.yearFirstLocales = new Set([
    "eu",
    "hu",
    "ja",
    "ja-Hira",
    "ja-JP",
    "ko",
    "ko-KR",
    "lt",
    "lt-LT",
    "lv",
    "lv-LV",
    "mn",
    "mn-MN",
    "zh",
    "zh-CN",
    "zh-HK",
    "zh-TW"
]);
const defaultDateLib = new DateLib();
const dateLib = defaultDateLib;

},{"@date-fns/tz":"hGxfM","date-fns":[["addDays","5eou6"],["addMonths","6ugX4"],["addWeeks","dpQcu"],["addYears","ftzMU"],["differenceInCalendarDays","kvKSg"],["differenceInCalendarMonths","fvKUm"],["eachMonthOfInterval","dW2Mn"],["eachYearOfInterval","aacpJ"],["endOfISOWeek","gkBrR"],["endOfMonth","Bk522"],["endOfWeek","aBpZx"],["endOfYear","eR97n"],["format","2MzTw"],["getISOWeek","i068P"],["getMonth","aoCYd"],["getWeek","2KaII"],["getYear","gvafp"],["isAfter","8BGQ7"],["isBefore","gB3xu"],["isDate","c8LTj"],["isSameDay","bLzay"],["isSameMonth","6V9pY"],["isSameYear","BE3zW"],["max","dsO33"],["min","lUCj0"],["setMonth","joaKY"],["setYear","66Ggt"],["startOfDay","4Spem"],["startOfISOWeek","3ealL"],["startOfMonth","1r2ij"],["startOfWeek","jc22x"],["startOfYear","eXhIs"]],"date-fns/locale/en-US":"2OeRi","../helpers/endOfBroadcastWeek.js":"3HpID","../helpers/startOfBroadcastWeek.js":"hjq2z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5eou6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addDays} function options.
 */ /**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 * @param options - An object with options
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ parcelHelpers.export(exports, "addDays", ()=>addDays);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function addDays(date, amount, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    if (isNaN(amount)) return (0, _constructFromJs.constructFrom)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
// Fallback for modularized imports:
exports.default = addDays;

},{"./constructFrom.js":"9NM7w","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9NM7w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * Starting from v3.7.0, it allows to construct a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from "./constructFrom/date-fns";
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date>(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use constructor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   );
 * }
 */ parcelHelpers.export(exports, "constructFrom", ()=>constructFrom);
var _constantsJs = require("./constants.js");
function constructFrom(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, _constantsJs.constructFromSymbol) in date) return date[0, _constantsJs.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
// Fallback for modularized imports:
exports.default = constructFrom;

},{"./constants.js":"8PGN2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8PGN2":[function(require,module,exports,__globalThis) {
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "millisecondsInWeek", ()=>millisecondsInWeek);
parcelHelpers.export(exports, "millisecondsInDay", ()=>millisecondsInDay);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minutesInYear", ()=>minutesInYear);
parcelHelpers.export(exports, "minutesInMonth", ()=>minutesInMonth);
parcelHelpers.export(exports, "minutesInDay", ()=>minutesInDay);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
parcelHelpers.export(exports, "constructFromSymbol", ()=>constructFromSymbol);
const daysInWeek = 7;
const daysInYear = 365.2425;
const maxTime = Math.pow(10, 8) * 86400000;
const minTime = -maxTime;
const millisecondsInWeek = 604800000;
const millisecondsInDay = 86400000;
const millisecondsInMinute = 60000;
const millisecondsInHour = 3600000;
const millisecondsInSecond = 1000;
const minutesInYear = 525600;
const minutesInMonth = 43200;
const minutesInDay = 1440;
const minutesInHour = 60;
const monthsInQuarter = 3;
const monthsInYear = 12;
const quartersInYear = 4;
const secondsInHour = 3600;
const secondsInMinute = 60;
const secondsInDay = secondsInHour * 24;
const secondsInWeek = secondsInDay * 7;
const secondsInYear = secondsInDay * daysInYear;
const secondsInMonth = secondsInYear / 12;
const secondsInQuarter = secondsInMonth * 3;
const constructFromSymbol = Symbol.for("constructDateFrom");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"62U6l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * Starting from v3.7.0, it clones a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ parcelHelpers.export(exports, "toDate", ()=>toDate);
var _constructFromJs = require("./constructFrom.js");
function toDate(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, _constructFromJs.constructFrom)(context || argument, argument);
}
// Fallback for modularized imports:
exports.default = toDate;

},{"./constructFrom.js":"9NM7w","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6ugX4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addMonths} function options.
 */ /**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 * @param options - The options object
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ parcelHelpers.export(exports, "addMonths", ()=>addMonths);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function addMonths(date, amount, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    if (isNaN(amount)) return (0, _constructFromJs.constructFrom)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, _constructFromJs.constructFrom)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
// Fallback for modularized imports:
exports.default = addMonths;

},{"./constructFrom.js":"9NM7w","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dpQcu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addWeeks} function options.
 */ /**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of weeks to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 * @param options - An object with options
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ parcelHelpers.export(exports, "addWeeks", ()=>addWeeks);
var _addDaysJs = require("./addDays.js");
function addWeeks(date, amount, options) {
    return (0, _addDaysJs.addDays)(date, amount * 7, options);
}
// Fallback for modularized imports:
exports.default = addWeeks;

},{"./addDays.js":"5eou6","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ftzMU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addYears} function options.
 */ /**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 * @param options - The options
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ parcelHelpers.export(exports, "addYears", ()=>addYears);
var _addMonthsJs = require("./addMonths.js");
function addYears(date, amount, options) {
    return (0, _addMonthsJs.addMonths)(date, amount * 12, options);
}
// Fallback for modularized imports:
exports.default = addYears;

},{"./addMonths.js":"6ugX4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kvKSg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInCalendarDays} function options.
 */ /**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - The options object
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInCalendarDays", ()=>differenceInCalendarDays);
var _getTimezoneOffsetInMillisecondsJs = require("./_lib/getTimezoneOffsetInMilliseconds.js");
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _constantsJs = require("./constants.js");
var _startOfDayJs = require("./startOfDay.js");
function differenceInCalendarDays(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, _startOfDayJs.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, _startOfDayJs.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, _constantsJs.millisecondsInDay));
}
// Fallback for modularized imports:
exports.default = differenceInCalendarDays;

},{"./_lib/getTimezoneOffsetInMilliseconds.js":"gfAOj","./_lib/normalizeDates.js":"djADH","./constants.js":"8PGN2","./startOfDay.js":"4Spem","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gfAOj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ parcelHelpers.export(exports, "getTimezoneOffsetInMilliseconds", ()=>getTimezoneOffsetInMilliseconds);
var _toDateJs = require("../toDate.js");
function getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, _toDateJs.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

},{"../toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"djADH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeDates", ()=>normalizeDates);
var _constructFromJs = require("../constructFrom.js");
function normalizeDates(context, ...dates) {
    const normalize = (0, _constructFromJs.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

},{"../constructFrom.js":"9NM7w","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4Spem":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfDay} function options.
 */ /**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfDay", ()=>startOfDay);
var _toDateJs = require("./toDate.js");
function startOfDay(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfDay;

},{"./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fvKUm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInCalendarMonths} function options.
 */ /**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - An object with options
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ parcelHelpers.export(exports, "differenceInCalendarMonths", ()=>differenceInCalendarMonths);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
function differenceInCalendarMonths(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
// Fallback for modularized imports:
exports.default = differenceInCalendarMonths;

},{"./_lib/normalizeDates.js":"djADH","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dW2Mn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * The {@link eachMonthOfInterval} function result type. It resolves the proper data type.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam IntervalType - Interval type.
 * @typeParam Options - Options type.
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachMonthOfInterval", ()=>eachMonthOfInterval);
var _normalizeIntervalJs = require("./_lib/normalizeInterval.js");
var _constructFromJs = require("./constructFrom.js");
function eachMonthOfInterval(interval, options) {
    const { start, end } = (0, _normalizeIntervalJs.normalizeInterval)(options?.in, interval);
    let reversed = +start > +end;
    const endTime = reversed ? +start : +end;
    const date = reversed ? end : start;
    date.setHours(0, 0, 0, 0);
    date.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+date <= endTime){
        dates.push((0, _constructFromJs.constructFrom)(start, date));
        date.setMonth(date.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}
// Fallback for modularized imports:
exports.default = eachMonthOfInterval;

},{"./_lib/normalizeInterval.js":"3wVdS","./constructFrom.js":"9NM7w","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3wVdS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeInterval", ()=>normalizeInterval);
var _normalizeDatesJs = require("./normalizeDates.js");
function normalizeInterval(context, interval) {
    const [start, end] = (0, _normalizeDatesJs.normalizeDates)(context, interval.start, interval.end);
    return {
        start,
        end
    };
}

},{"./normalizeDates.js":"djADH","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aacpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * The {@link eachYearOfInterval} function result type. It resolves the proper data type.
 * It uses the first argument date object type, starting from the date argument,
 * then the start interval date, and finally the end interval date. If
 * a context function is passed, it uses the context function return type.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam IntervalType - Interval type.
 * @typeParam Options - Options type.
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "eachYearOfInterval", ()=>eachYearOfInterval);
var _normalizeIntervalJs = require("./_lib/normalizeInterval.js");
var _constructFromJs = require("./constructFrom.js");
function eachYearOfInterval(interval, options) {
    const { start, end } = (0, _normalizeIntervalJs.normalizeInterval)(options?.in, interval);
    let reversed = +start > +end;
    const endTime = reversed ? +start : +end;
    const date = reversed ? end : start;
    date.setHours(0, 0, 0, 0);
    date.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+date <= endTime){
        dates.push((0, _constructFromJs.constructFrom)(start, date));
        date.setFullYear(date.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}
// Fallback for modularized imports:
exports.default = eachYearOfInterval;

},{"./_lib/normalizeInterval.js":"3wVdS","./constructFrom.js":"9NM7w","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gkBrR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfISOWeek} function options.
 */ /**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfISOWeek", ()=>endOfISOWeek);
var _endOfWeekJs = require("./endOfWeek.js");
function endOfISOWeek(date, options) {
    return (0, _endOfWeekJs.endOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}
// Fallback for modularized imports:
exports.default = endOfISOWeek;

},{"./endOfWeek.js":"aBpZx","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aBpZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfWeek", ()=>endOfWeek);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _toDateJs = require("./toDate.js");
function endOfWeek(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfWeek;

},{"./_lib/defaultOptions.js":"8lxJb","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8lxJb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
let defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"Bk522":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfMonth} function options.
 */ /**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfMonth", ()=>endOfMonth);
var _toDateJs = require("./toDate.js");
function endOfMonth(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfMonth;

},{"./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eR97n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfYear} function options.
 */ /**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfYear", ()=>endOfYear);
var _toDateJs = require("./toDate.js");
function endOfYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfYear;

},{"./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2MzTw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
parcelHelpers.export(exports, "formatters", ()=>(0, _formattersJs.formatters));
parcelHelpers.export(exports, "longFormatters", ()=>(0, _longFormattersJs.longFormatters));
parcelHelpers.export(exports, "formatDate", ()=>format);
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ parcelHelpers.export(exports, "format", ()=>format);
var _defaultLocaleJs = require("./_lib/defaultLocale.js");
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _formattersJs = require("./_lib/format/formatters.js");
var _longFormattersJs = require("./_lib/format/longFormatters.js");
var _protectedTokensJs = require("./_lib/protectedTokens.js");
var _isValidJs = require("./isValid.js");
var _toDateJs = require("./toDate.js");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleJs.defaultLocale);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, _toDateJs.toDate)(date, options?.in);
    if (!(0, _isValidJs.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match(longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, _longFormattersJs.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: cleanEscapedString(substring)
        };
        if ((0, _formattersJs.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate,
        weekStartsOn,
        locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, _protectedTokensJs.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, _protectedTokensJs.isProtectedDayOfYearToken)(token)) (0, _protectedTokensJs.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, _formattersJs.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function cleanEscapedString(input) {
    const matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
// Fallback for modularized imports:
exports.default = format;

},{"./_lib/defaultLocale.js":[["defaultLocale","2OeRi","enUS"]],"./_lib/defaultOptions.js":"8lxJb","./_lib/format/formatters.js":"6qhCX","./_lib/format/longFormatters.js":"3unFD","./_lib/protectedTokens.js":"1L1x2","./isValid.js":"fi7t4","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2OeRi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enUS", ()=>enUS);
var _formatDistanceJs = require("./en-US/_lib/formatDistance.js");
var _formatLongJs = require("./en-US/_lib/formatLong.js");
var _formatRelativeJs = require("./en-US/_lib/formatRelative.js");
var _localizeJs = require("./en-US/_lib/localize.js");
var _matchJs = require("./en-US/_lib/match.js");
const enUS = {
    code: "en-US",
    formatDistance: (0, _formatDistanceJs.formatDistance),
    formatLong: (0, _formatLongJs.formatLong),
    formatRelative: (0, _formatRelativeJs.formatRelative),
    localize: (0, _localizeJs.localize),
    match: (0, _matchJs.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
// Fallback for modularized imports:
exports.default = enUS;

},{"./en-US/_lib/formatDistance.js":"dvART","./en-US/_lib/formatLong.js":"wRo5W","./en-US/_lib/formatRelative.js":"kpogG","./en-US/_lib/localize.js":"5KVsQ","./en-US/_lib/match.js":"9fwLB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dvART":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDistance", ()=>formatDistance);
const formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"wRo5W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatLong", ()=>formatLong);
var _buildFormatLongFnJs = require("../../_lib/buildFormatLongFn.js");
const dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const formatLong = {
    date: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};

},{"../../_lib/buildFormatLongFn.js":"1OPPA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1OPPA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildFormatLongFn", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kpogG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelative", ()=>formatRelative);
const formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const formatRelative = (token, _date, _baseDate, _options)=>formatRelativeLocale[token];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5KVsQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localize", ()=>localize);
var _buildLocalizeFnJs = require("../../_lib/buildLocalizeFn.js");
const eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const localize = {
    ordinalNumber,
    era: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

},{"../../_lib/buildLocalizeFn.js":"juzrt","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"juzrt":[function(require,module,exports,__globalThis) {
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildLocalizeFn", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9fwLB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", ()=>match);
var _buildMatchFnJs = require("../../_lib/buildMatchFn.js");
var _buildMatchPatternFnJs = require("../../_lib/buildMatchPatternFn.js");
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const match = {
    ordinalNumber: (0, _buildMatchPatternFnJs.buildMatchPatternFn)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

},{"../../_lib/buildMatchFn.js":"lYEOO","../../_lib/buildMatchPatternFn.js":"jPcDD","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lYEOO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchFn", ()=>buildMatchFn);
function buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}
function findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jPcDD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchPatternFn", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6qhCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatters", ()=>formatters);
var _getDayOfYearJs = require("../../getDayOfYear.js");
var _getISOWeekJs = require("../../getISOWeek.js");
var _getISOWeekYearJs = require("../../getISOWeekYear.js");
var _getWeekJs = require("../../getWeek.js");
var _getWeekYearJs = require("../../getWeekYear.js");
var _addLeadingZerosJs = require("../addLeadingZeros.js");
var _lightFormattersJs = require("./lightFormatters.js");
const dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const formatters = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _lightFormattersJs.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, _getWeekYearJs.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, _addLeadingZerosJs.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _addLeadingZerosJs.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, _getISOWeekYearJs.getISOWeekYear)(date);
        // Padding
        return (0, _addLeadingZerosJs.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, _addLeadingZerosJs.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _addLeadingZerosJs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _addLeadingZerosJs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _lightFormattersJs.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _addLeadingZerosJs.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, _getWeekJs.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, _getISOWeekJs.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, _lightFormattersJs.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, _getDayOfYearJs.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _addLeadingZerosJs.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _addLeadingZerosJs.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _addLeadingZerosJs.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _lightFormattersJs.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, _lightFormattersJs.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, _lightFormattersJs.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, _lightFormattersJs.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, _lightFormattersJs.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, _addLeadingZerosJs.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(+date, token.length);
    }
};
function formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, _addLeadingZerosJs.addLeadingZeros)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, _addLeadingZerosJs.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, _addLeadingZerosJs.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, _addLeadingZerosJs.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

},{"../../getDayOfYear.js":"hk7G0","../../getISOWeek.js":"i068P","../../getISOWeekYear.js":"4YqZb","../../getWeek.js":"2KaII","../../getWeekYear.js":"dn2xp","../addLeadingZeros.js":"evL9X","./lightFormatters.js":"jRuIx","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hk7G0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getDayOfYear} function options.
 */ /**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ parcelHelpers.export(exports, "getDayOfYear", ()=>getDayOfYear);
var _differenceInCalendarDaysJs = require("./differenceInCalendarDays.js");
var _startOfYearJs = require("./startOfYear.js");
var _toDateJs = require("./toDate.js");
function getDayOfYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = (0, _differenceInCalendarDaysJs.differenceInCalendarDays)(_date, (0, _startOfYearJs.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
// Fallback for modularized imports:
exports.default = getDayOfYear;

},{"./differenceInCalendarDays.js":"kvKSg","./startOfYear.js":"eXhIs","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eXhIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfYear} function options.
 */ /**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfYear", ()=>startOfYear);
var _toDateJs = require("./toDate.js");
function startOfYear(date, options) {
    const date_ = (0, _toDateJs.toDate)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
// Fallback for modularized imports:
exports.default = startOfYear;

},{"./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"i068P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getISOWeek} function options.
 */ /**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ parcelHelpers.export(exports, "getISOWeek", ()=>getISOWeek);
var _constantsJs = require("./constants.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
var _startOfISOWeekYearJs = require("./startOfISOWeekYear.js");
var _toDateJs = require("./toDate.js");
function getISOWeek(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = +(0, _startOfISOWeekJs.startOfISOWeek)(_date) - +(0, _startOfISOWeekYearJs.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsJs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getISOWeek;

},{"./constants.js":"8PGN2","./startOfISOWeek.js":"3ealL","./startOfISOWeekYear.js":"3alSG","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3ealL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfISOWeek} function options.
 */ /**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeek", ()=>startOfISOWeek);
var _startOfWeekJs = require("./startOfWeek.js");
function startOfISOWeek(date, options) {
    return (0, _startOfWeekJs.startOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}
// Fallback for modularized imports:
exports.default = startOfISOWeek;

},{"./startOfWeek.js":"jc22x","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jc22x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfWeek", ()=>startOfWeek);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _toDateJs = require("./toDate.js");
function startOfWeek(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeek;

},{"./_lib/defaultOptions.js":"8lxJb","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3alSG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfISOWeekYear} function options.
 */ /**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeekYear", ()=>startOfISOWeekYear);
var _constructFromJs = require("./constructFrom.js");
var _getISOWeekYearJs = require("./getISOWeekYear.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
function startOfISOWeekYear(date, options) {
    const year = (0, _getISOWeekYearJs.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuary);
}
// Fallback for modularized imports:
exports.default = startOfISOWeekYear;

},{"./constructFrom.js":"9NM7w","./getISOWeekYear.js":"4YqZb","./startOfISOWeek.js":"3ealL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4YqZb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getISOWeekYear} function options.
 */ /**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ parcelHelpers.export(exports, "getISOWeekYear", ()=>getISOWeekYear);
var _constructFromJs = require("./constructFrom.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
var _toDateJs = require("./toDate.js");
function getISOWeekYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, _constructFromJs.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, _constructFromJs.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getISOWeekYear;

},{"./constructFrom.js":"9NM7w","./startOfISOWeek.js":"3ealL","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2KaII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ parcelHelpers.export(exports, "getWeek", ()=>getWeek);
var _constantsJs = require("./constants.js");
var _startOfWeekJs = require("./startOfWeek.js");
var _startOfWeekYearJs = require("./startOfWeekYear.js");
var _toDateJs = require("./toDate.js");
function getWeek(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = +(0, _startOfWeekJs.startOfWeek)(_date, options) - +(0, _startOfWeekYearJs.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsJs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getWeek;

},{"./constants.js":"8PGN2","./startOfWeek.js":"jc22x","./startOfWeekYear.js":"9Jkzq","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9Jkzq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfWeekYear", ()=>startOfWeekYear);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _constructFromJs = require("./constructFrom.js");
var _getWeekYearJs = require("./getWeekYear.js");
var _startOfWeekJs = require("./startOfWeek.js");
function startOfWeekYear(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, _getWeekYearJs.getWeekYear)(date, options);
    const firstWeek = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, _startOfWeekJs.startOfWeek)(firstWeek, options);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeekYear;

},{"./_lib/defaultOptions.js":"8lxJb","./constructFrom.js":"9NM7w","./getWeekYear.js":"dn2xp","./startOfWeek.js":"jc22x","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dn2xp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ parcelHelpers.export(exports, "getWeekYear", ()=>getWeekYear);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _constructFromJs = require("./constructFrom.js");
var _startOfWeekJs = require("./startOfWeek.js");
var _toDateJs = require("./toDate.js");
function getWeekYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfWeekJs.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfWeekJs.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getWeekYear;

},{"./_lib/defaultOptions.js":"8lxJb","./constructFrom.js":"9NM7w","./startOfWeek.js":"jc22x","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"evL9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLeadingZeros", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jRuIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lightFormatters", ()=>lightFormatters);
var _addLeadingZerosJs = require("../addLeadingZeros.js");
const lightFormatters = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _addLeadingZerosJs.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, _addLeadingZerosJs.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _addLeadingZerosJs.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

},{"../addLeadingZeros.js":"evL9X","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3unFD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "longFormatters", ()=>longFormatters);
const dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
const longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1L1x2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "warnOrThrowProtectedError", ()=>warnOrThrowProtectedError);
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
    return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
    const _message = message(token, format, input);
    console.warn(_message);
    if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fi7t4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertible into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ parcelHelpers.export(exports, "isValid", ()=>isValid);
var _isDateJs = require("./isDate.js");
var _toDateJs = require("./toDate.js");
function isValid(date) {
    return !(!(0, _isDateJs.isDate)(date) && typeof date !== "number" || isNaN(+(0, _toDateJs.toDate)(date)));
}
// Fallback for modularized imports:
exports.default = isValid;

},{"./isDate.js":"c8LTj","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c8LTj":[function(require,module,exports,__globalThis) {
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", ()=>isDate);
function isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
// Fallback for modularized imports:
exports.default = isDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aoCYd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getMonth} function options.
 */ /**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ parcelHelpers.export(exports, "getMonth", ()=>getMonth);
var _toDateJs = require("./toDate.js");
function getMonth(date, options) {
    return (0, _toDateJs.toDate)(date, options?.in).getMonth();
}
// Fallback for modularized imports:
exports.default = getMonth;

},{"./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gvafp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getYear} function options.
 */ /**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ parcelHelpers.export(exports, "getYear", ()=>getYear);
var _toDateJs = require("./toDate.js");
function getYear(date, options) {
    return (0, _toDateJs.toDate)(date, options?.in).getFullYear();
}
// Fallback for modularized imports:
exports.default = getYear;

},{"./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8BGQ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ parcelHelpers.export(exports, "isAfter", ()=>isAfter);
var _toDateJs = require("./toDate.js");
function isAfter(date, dateToCompare) {
    return +(0, _toDateJs.toDate)(date) > +(0, _toDateJs.toDate)(dateToCompare);
}
// Fallback for modularized imports:
exports.default = isAfter;

},{"./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gB3xu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ parcelHelpers.export(exports, "isBefore", ()=>isBefore);
var _toDateJs = require("./toDate.js");
function isBefore(date, dateToCompare) {
    return +(0, _toDateJs.toDate)(date) < +(0, _toDateJs.toDate)(dateToCompare);
}
// Fallback for modularized imports:
exports.default = isBefore;

},{"./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bLzay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isSameDay} function options.
 */ /**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ parcelHelpers.export(exports, "isSameDay", ()=>isSameDay);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _startOfDayJs = require("./startOfDay.js");
function isSameDay(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    return +(0, _startOfDayJs.startOfDay)(dateLeft_) === +(0, _startOfDayJs.startOfDay)(dateRight_);
}
// Fallback for modularized imports:
exports.default = isSameDay;

},{"./_lib/normalizeDates.js":"djADH","./startOfDay.js":"4Spem","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6V9pY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isSameMonth} function options.
 */ /**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ parcelHelpers.export(exports, "isSameMonth", ()=>isSameMonth);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
function isSameMonth(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
// Fallback for modularized imports:
exports.default = isSameMonth;

},{"./_lib/normalizeDates.js":"djADH","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"BE3zW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isSameYear} function options.
 */ /**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ parcelHelpers.export(exports, "isSameYear", ()=>isSameYear);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
function isSameYear(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
// Fallback for modularized imports:
exports.default = isSameYear;

},{"./_lib/normalizeDates.js":"djADH","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dsO33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link max} function options.
 */ /**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ parcelHelpers.export(exports, "max", ()=>max);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function max(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, _constructFromJs.constructFrom).bind(null, date);
        const date_ = (0, _toDateJs.toDate)(date, context);
        if (!result || result < date_ || isNaN(+date_)) result = date_;
    });
    return (0, _constructFromJs.constructFrom)(context, result || NaN);
}
// Fallback for modularized imports:
exports.default = max;

},{"./constructFrom.js":"9NM7w","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lUCj0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link min} function options.
 */ /**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ parcelHelpers.export(exports, "min", ()=>min);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function min(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, _constructFromJs.constructFrom).bind(null, date);
        const date_ = (0, _toDateJs.toDate)(date, context);
        if (!result || result > date_ || isNaN(+date_)) result = date_;
    });
    return (0, _constructFromJs.constructFrom)(context, result || NaN);
}
// Fallback for modularized imports:
exports.default = min;

},{"./constructFrom.js":"9NM7w","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"joaKY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setMonth} function options.
 */ /**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 * @param options - The options
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ parcelHelpers.export(exports, "setMonth", ()=>setMonth);
var _constructFromJs = require("./constructFrom.js");
var _getDaysInMonthJs = require("./getDaysInMonth.js");
var _toDateJs = require("./toDate.js");
function setMonth(date, month, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const midMonth = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, _getDaysInMonthJs.getDaysInMonth)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
// Fallback for modularized imports:
exports.default = setMonth;

},{"./constructFrom.js":"9NM7w","./getDaysInMonth.js":"bvY7L","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bvY7L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getDaysInMonth} function options.
 */ /**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date, considering the context if provided.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ parcelHelpers.export(exports, "getDaysInMonth", ()=>getDaysInMonth);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function getDaysInMonth(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, _constructFromJs.constructFrom)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
// Fallback for modularized imports:
exports.default = getDaysInMonth;

},{"./constructFrom.js":"9NM7w","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"66Ggt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setYear} function options.
 */ /**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ parcelHelpers.export(exports, "setYear", ()=>setYear);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function setYear(date, year, options) {
    const date_ = (0, _toDateJs.toDate)(date, options?.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, _constructFromJs.constructFrom)(options?.in || date, NaN);
    date_.setFullYear(year);
    return date_;
}
// Fallback for modularized imports:
exports.default = setYear;

},{"./constructFrom.js":"9NM7w","./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1r2ij":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfMonth} function options.
 */ /**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date. The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments.
 * Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed,
 * or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfMonth", ()=>startOfMonth);
var _toDateJs = require("./toDate.js");
function startOfMonth(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfMonth;

},{"./toDate.js":"62U6l","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3HpID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the end date of the week in the broadcast calendar.
 *
 * The broadcast week ends on the last day of the last broadcast week for the
 * given date.
 *
 * @since 9.4.0
 * @param date The date for which to calculate the end of the broadcast week.
 * @param dateLib The date library to use for date manipulation.
 * @returns The end date of the broadcast week.
 */ parcelHelpers.export(exports, "endOfBroadcastWeek", ()=>endOfBroadcastWeek);
var _getBroadcastWeeksInMonthJs = require("./getBroadcastWeeksInMonth.js");
var _startOfBroadcastWeekJs = require("./startOfBroadcastWeek.js");
function endOfBroadcastWeek(date, dateLib) {
    const startDate = (0, _startOfBroadcastWeekJs.startOfBroadcastWeek)(date, dateLib);
    const numberOfWeeks = (0, _getBroadcastWeeksInMonthJs.getBroadcastWeeksInMonth)(date, dateLib);
    const endDate = dateLib.addDays(startDate, numberOfWeeks * 7 - 1);
    return endDate;
}

},{"./getBroadcastWeeksInMonth.js":"cnkt4","./startOfBroadcastWeek.js":"hjq2z","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cnkt4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the number of weeks to display in the broadcast calendar for a given
 * month.
 *
 * The broadcast calendar may have either 4 or 5 weeks in a month, depending on
 * the start and end dates of the broadcast weeks.
 *
 * @since 9.4.0
 * @param month The month for which to calculate the number of weeks.
 * @param dateLib The date library to use for date manipulation.
 * @returns The number of weeks in the broadcast calendar (4 or 5).
 */ parcelHelpers.export(exports, "getBroadcastWeeksInMonth", ()=>getBroadcastWeeksInMonth);
const FIVE_WEEKS = 5;
const FOUR_WEEKS = 4;
function getBroadcastWeeksInMonth(month, dateLib) {
    // Get the first day of the month
    const firstDayOfMonth = dateLib.startOfMonth(month);
    // Get the day of the week for the first day of the month (1-7, where 1 is Monday)
    const firstDayOfWeek = firstDayOfMonth.getDay() > 0 ? firstDayOfMonth.getDay() : 7;
    const broadcastStartDate = dateLib.addDays(month, -firstDayOfWeek + 1);
    const lastDateOfLastWeek = dateLib.addDays(broadcastStartDate, FIVE_WEEKS * 7 - 1);
    const numberOfWeeks = dateLib.getMonth(month) === dateLib.getMonth(lastDateOfLastWeek) ? FIVE_WEEKS : FOUR_WEEKS;
    return numberOfWeeks;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hjq2z":[function(require,module,exports,__globalThis) {
/**
 * Returns the start date of the week in the broadcast calendar.
 *
 * The broadcast week starts on Monday. If the first day of the month is not a
 * Monday, this function calculates the previous Monday as the start of the
 * broadcast week.
 *
 * @since 9.4.0
 * @param date The date for which to calculate the start of the broadcast week.
 * @param dateLib The date library to use for date manipulation.
 * @returns The start date of the broadcast week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startOfBroadcastWeek", ()=>startOfBroadcastWeek);
function startOfBroadcastWeek(date, dateLib) {
    const firstOfMonth = dateLib.startOfMonth(date);
    const dayOfWeek = firstOfMonth.getDay();
    if (dayOfWeek === 1) return firstOfMonth;
    else if (dayOfWeek === 0) return dateLib.addDays(firstOfMonth, -6);
    else return dateLib.addDays(firstOfMonth, -1 * (dayOfWeek - 1));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"32SpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a function to retrieve the modifiers for a given day.
 *
 * This function calculates both internal and custom modifiers for each day
 * based on the provided calendar days and DayPicker props.
 *
 * @private
 * @param days The array of `CalendarDay` objects to process.
 * @param props The DayPicker props, including modifiers and configuration
 *   options.
 * @param dateLib The date library to use for date manipulation.
 * @returns A function that retrieves the modifiers for a given `CalendarDay`.
 */ parcelHelpers.export(exports, "createGetModifiers", ()=>createGetModifiers);
var _uiJs = require("../UI.js");
var _dateMatchModifiersJs = require("../utils/dateMatchModifiers.js");
function createGetModifiers(days, props, navStart, navEnd, dateLib) {
    const { disabled, hidden, modifiers, showOutsideDays, broadcastCalendar, today } = props;
    const { isSameDay, isSameMonth, startOfMonth, isBefore, endOfMonth, isAfter } = dateLib;
    const computedNavStart = navStart && startOfMonth(navStart);
    const computedNavEnd = navEnd && endOfMonth(navEnd);
    const internalModifiersMap = {
        [(0, _uiJs.DayFlag).focused]: [],
        [(0, _uiJs.DayFlag).outside]: [],
        [(0, _uiJs.DayFlag).disabled]: [],
        [(0, _uiJs.DayFlag).hidden]: [],
        [(0, _uiJs.DayFlag).today]: []
    };
    const customModifiersMap = {};
    for (const day of days){
        const { date, displayMonth } = day;
        const isOutside = Boolean(displayMonth && !isSameMonth(date, displayMonth));
        const isBeforeNavStart = Boolean(computedNavStart && isBefore(date, computedNavStart));
        const isAfterNavEnd = Boolean(computedNavEnd && isAfter(date, computedNavEnd));
        const isDisabled = Boolean(disabled && (0, _dateMatchModifiersJs.dateMatchModifiers)(date, disabled, dateLib));
        const isHidden = Boolean(hidden && (0, _dateMatchModifiersJs.dateMatchModifiers)(date, hidden, dateLib)) || isBeforeNavStart || isAfterNavEnd || // Broadcast calendar will show outside days as default
        !broadcastCalendar && !showOutsideDays && isOutside || broadcastCalendar && showOutsideDays === false && isOutside;
        const isToday = isSameDay(date, today ?? dateLib.today());
        if (isOutside) internalModifiersMap.outside.push(day);
        if (isDisabled) internalModifiersMap.disabled.push(day);
        if (isHidden) internalModifiersMap.hidden.push(day);
        if (isToday) internalModifiersMap.today.push(day);
        // Add custom modifiers
        if (modifiers) Object.keys(modifiers).forEach((name)=>{
            const modifierValue = modifiers?.[name];
            const isMatch = modifierValue ? (0, _dateMatchModifiersJs.dateMatchModifiers)(date, modifierValue, dateLib) : false;
            if (!isMatch) return;
            if (customModifiersMap[name]) customModifiersMap[name].push(day);
            else customModifiersMap[name] = [
                day
            ];
        });
    }
    return (day)=>{
        // Initialize all the modifiers to false
        const dayFlags = {
            [(0, _uiJs.DayFlag).focused]: false,
            [(0, _uiJs.DayFlag).disabled]: false,
            [(0, _uiJs.DayFlag).hidden]: false,
            [(0, _uiJs.DayFlag).outside]: false,
            [(0, _uiJs.DayFlag).today]: false
        };
        const customModifiers = {};
        // Find the modifiers for the given day
        for(const name in internalModifiersMap){
            const days = internalModifiersMap[name];
            dayFlags[name] = days.some((d)=>d === day);
        }
        for(const name in customModifiersMap)customModifiers[name] = customModifiersMap[name].some((d)=>d === day);
        return {
            ...dayFlags,
            // custom modifiers should override all the previous ones
            ...customModifiers
        };
    };
}

},{"../UI.js":"7f59g","../utils/dateMatchModifiers.js":"6RjDL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7f59g":[function(require,module,exports,__globalThis) {
/**
 * Enum representing the UI elements composing DayPicker. These elements are
 * mapped to {@link CustomComponents}, {@link ClassNames}, and {@link Styles}.
 *
 * Some elements are extended by flags and modifiers.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UI", ()=>UI);
parcelHelpers.export(exports, "DayFlag", ()=>DayFlag);
parcelHelpers.export(exports, "SelectionState", ()=>SelectionState);
parcelHelpers.export(exports, "Animation", ()=>Animation);
var UI;
(function(UI) {
    /** The root component displaying the months and the navigation bar. */ UI["Root"] = "root";
    /** The Chevron SVG element used by navigation buttons and dropdowns. */ UI["Chevron"] = "chevron";
    /**
     * The grid cell with the day's date. Extended by {@link DayFlag} and
     * {@link SelectionState}.
     */ UI["Day"] = "day";
    /** The button containing the formatted day's date, inside the grid cell. */ UI["DayButton"] = "day_button";
    /** The caption label of the month (when not showing the dropdown navigation). */ UI["CaptionLabel"] = "caption_label";
    /** The container of the dropdown navigation (when enabled). */ UI["Dropdowns"] = "dropdowns";
    /** The dropdown element to select for years and months. */ UI["Dropdown"] = "dropdown";
    /** The container element of the dropdown. */ UI["DropdownRoot"] = "dropdown_root";
    /** The root element of the footer. */ UI["Footer"] = "footer";
    /** The month grid. */ UI["MonthGrid"] = "month_grid";
    /** Contains the dropdown navigation or the caption label. */ UI["MonthCaption"] = "month_caption";
    /** The dropdown with the months. */ UI["MonthsDropdown"] = "months_dropdown";
    /** Wrapper of the month grid. */ UI["Month"] = "month";
    /** The container of the displayed months. */ UI["Months"] = "months";
    /** The navigation bar with the previous and next buttons. */ UI["Nav"] = "nav";
    /**
     * The next month button in the navigation. *
     *
     * @since 9.1.0
     */ UI["NextMonthButton"] = "button_next";
    /**
     * The previous month button in the navigation.
     *
     * @since 9.1.0
     */ UI["PreviousMonthButton"] = "button_previous";
    /** The row containing the week. */ UI["Week"] = "week";
    /** The group of row weeks in a month (`tbody`). */ UI["Weeks"] = "weeks";
    /** The column header with the weekday. */ UI["Weekday"] = "weekday";
    /** The row grouping the weekdays in the column headers. */ UI["Weekdays"] = "weekdays";
    /** The cell containing the week number. */ UI["WeekNumber"] = "week_number";
    /** The cell header of the week numbers column. */ UI["WeekNumberHeader"] = "week_number_header";
    /** The dropdown with the years. */ UI["YearsDropdown"] = "years_dropdown";
})(UI || (UI = {}));
var DayFlag;
(function(DayFlag) {
    /** The day is disabled. */ DayFlag["disabled"] = "disabled";
    /** The day is hidden. */ DayFlag["hidden"] = "hidden";
    /** The day is outside the current month. */ DayFlag["outside"] = "outside";
    /** The day is focused. */ DayFlag["focused"] = "focused";
    /** The day is today. */ DayFlag["today"] = "today";
})(DayFlag || (DayFlag = {}));
var SelectionState;
(function(SelectionState) {
    /** The day is at the end of a selected range. */ SelectionState["range_end"] = "range_end";
    /** The day is at the middle of a selected range. */ SelectionState["range_middle"] = "range_middle";
    /** The day is at the start of a selected range. */ SelectionState["range_start"] = "range_start";
    /** The day is selected. */ SelectionState["selected"] = "selected";
})(SelectionState || (SelectionState = {}));
var Animation;
(function(Animation) {
    /** The entering weeks when they appear before the exiting month. */ Animation["weeks_before_enter"] = "weeks_before_enter";
    /** The exiting weeks when they disappear before the entering month. */ Animation["weeks_before_exit"] = "weeks_before_exit";
    /** The entering weeks when they appear after the exiting month. */ Animation["weeks_after_enter"] = "weeks_after_enter";
    /** The exiting weeks when they disappear after the entering month. */ Animation["weeks_after_exit"] = "weeks_after_exit";
    /** The entering caption when it appears after the exiting month. */ Animation["caption_after_enter"] = "caption_after_enter";
    /** The exiting caption when it disappears after the entering month. */ Animation["caption_after_exit"] = "caption_after_exit";
    /** The entering caption when it appears before the exiting month. */ Animation["caption_before_enter"] = "caption_before_enter";
    /** The exiting caption when it disappears before the entering month. */ Animation["caption_before_exit"] = "caption_before_exit";
})(Animation || (Animation = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6RjDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a given date matches at least one of the specified {@link Matcher}.
 *
 * @param date - The date to check.
 * @param matchers - The matchers to check against.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the date matches any of the matchers, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "dateMatchModifiers", ()=>dateMatchModifiers);
parcelHelpers.export(exports, "isMatch", ()=>isMatch);
var _dateLibJs = require("../classes/DateLib.js");
var _rangeIncludesDateJs = require("./rangeIncludesDate.js");
var _typeguardsJs = require("./typeguards.js");
function dateMatchModifiers(date, matchers, dateLib = (0, _dateLibJs.defaultDateLib)) {
    const matchersArr = !Array.isArray(matchers) ? [
        matchers
    ] : matchers;
    const { isSameDay, differenceInCalendarDays, isAfter } = dateLib;
    return matchersArr.some((matcher)=>{
        if (typeof matcher === "boolean") return matcher;
        if (dateLib.isDate(matcher)) return isSameDay(date, matcher);
        if ((0, _typeguardsJs.isDatesArray)(matcher, dateLib)) return matcher.includes(date);
        if ((0, _typeguardsJs.isDateRange)(matcher)) return (0, _rangeIncludesDateJs.rangeIncludesDate)(matcher, date, false, dateLib);
        if ((0, _typeguardsJs.isDayOfWeekType)(matcher)) {
            if (!Array.isArray(matcher.dayOfWeek)) return matcher.dayOfWeek === date.getDay();
            return matcher.dayOfWeek.includes(date.getDay());
        }
        if ((0, _typeguardsJs.isDateInterval)(matcher)) {
            const diffBefore = differenceInCalendarDays(matcher.before, date);
            const diffAfter = differenceInCalendarDays(matcher.after, date);
            const isDayBefore = diffBefore > 0;
            const isDayAfter = diffAfter < 0;
            const isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ((0, _typeguardsJs.isDateAfterType)(matcher)) return differenceInCalendarDays(date, matcher.after) > 0;
        if ((0, _typeguardsJs.isDateBeforeType)(matcher)) return differenceInCalendarDays(matcher.before, date) > 0;
        if (typeof matcher === "function") return matcher(date);
        return false;
    });
}
const isMatch = dateMatchModifiers;

},{"../classes/DateLib.js":"l7QE0","./rangeIncludesDate.js":"aWwuo","./typeguards.js":"4HpfU","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aWwuo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a given date is within a specified date range.
 *
 * @since 9.0.0
 * @param range - The date range to check against.
 * @param date - The date to check.
 * @param excludeEnds - If `true`, the range's start and end dates are excluded.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the date is within the range, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "rangeIncludesDate", ()=>rangeIncludesDate);
parcelHelpers.export(exports, "isDateInRange", ()=>isDateInRange);
var _indexJs = require("../classes/index.js");
function rangeIncludesDate(range, date, excludeEnds = false, dateLib = (0, _indexJs.defaultDateLib)) {
    let { from, to } = range;
    const { differenceInCalendarDays, isSameDay } = dateLib;
    if (from && to) {
        const isRangeInverted = differenceInCalendarDays(to, from) < 0;
        if (isRangeInverted) [from, to] = [
            to,
            from
        ];
        const isInRange = differenceInCalendarDays(date, from) >= (excludeEnds ? 1 : 0) && differenceInCalendarDays(to, date) >= (excludeEnds ? 1 : 0);
        return isInRange;
    }
    if (!excludeEnds && to) return isSameDay(to, date);
    if (!excludeEnds && from) return isSameDay(from, date);
    return false;
}
const isDateInRange = (range, date)=>rangeIncludesDate(range, date, false, (0, _indexJs.defaultDateLib));

},{"../classes/index.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4HpfU":[function(require,module,exports,__globalThis) {
/**
 * Checks if the given value is of type {@link DateInterval}.
 *
 * @param matcher - The value to check.
 * @returns `true` if the value is a {@link DateInterval}, otherwise `false`.
 * @group Utilities
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDateInterval", ()=>isDateInterval);
/**
 * Checks if the given value is of type {@link DateRange}.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a {@link DateRange}, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "isDateRange", ()=>isDateRange);
/**
 * Checks if the given value is of type {@link DateAfter}.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a {@link DateAfter}, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "isDateAfterType", ()=>isDateAfterType);
/**
 * Checks if the given value is of type {@link DateBefore}.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a {@link DateBefore}, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "isDateBeforeType", ()=>isDateBeforeType);
/**
 * Checks if the given value is of type {@link DayOfWeek}.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a {@link DayOfWeek}, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "isDayOfWeekType", ()=>isDayOfWeekType);
/**
 * Checks if the given value is an array of valid dates.
 *
 * @private
 * @param value - The value to check.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the value is an array of valid dates, otherwise `false`.
 */ parcelHelpers.export(exports, "isDatesArray", ()=>isDatesArray);
function isDateInterval(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
function isDateRange(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
function isDateAfterType(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
function isDateBeforeType(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
function isDatesArray(value, dateLib) {
    return Array.isArray(value) && value.every(dateLib.isDate);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gBcHI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the class names for a day based on its modifiers.
 *
 * This function combines the base class name for the day with any class names
 * associated with active modifiers.
 *
 * @param modifiers The modifiers applied to the day.
 * @param classNames The base class names for the calendar elements.
 * @param modifiersClassNames The class names associated with specific
 *   modifiers.
 * @returns An array of class names for the day.
 */ parcelHelpers.export(exports, "getClassNamesForModifiers", ()=>getClassNamesForModifiers);
var _uiJs = require("../UI.js");
function getClassNamesForModifiers(modifiers, classNames, modifiersClassNames = {}) {
    const modifierClassNames = Object.entries(modifiers).filter(([, active])=>active === true).reduce((previousValue, [key])=>{
        if (modifiersClassNames[key]) previousValue.push(modifiersClassNames[key]);
        else if (classNames[(0, _uiJs.DayFlag)[key]]) previousValue.push(classNames[(0, _uiJs.DayFlag)[key]]);
        else if (classNames[(0, _uiJs.SelectionState)[key]]) previousValue.push(classNames[(0, _uiJs.SelectionState)[key]]);
        return previousValue;
    }, [
        classNames[(0, _uiJs.UI).Day]
    ]);
    return modifierClassNames;
}

},{"../UI.js":"7f59g","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8PTFF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges custom components from the props with the default components.
 *
 * This function ensures that any custom components provided in the props
 * override the default components.
 *
 * @param customComponents The custom components provided in the DayPicker
 *   props.
 * @returns An object containing the merged components.
 */ parcelHelpers.export(exports, "getComponents", ()=>getComponents);
var _customComponentsJs = require("../components/custom-components.js");
function getComponents(customComponents) {
    return {
        ..._customComponentsJs,
        ...customComponents
    };
}

},{"../components/custom-components.js":"9ONr8","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9ONr8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buttonJs = require("./Button.js");
parcelHelpers.exportAll(_buttonJs, exports);
var _captionLabelJs = require("./CaptionLabel.js");
parcelHelpers.exportAll(_captionLabelJs, exports);
var _chevronJs = require("./Chevron.js");
parcelHelpers.exportAll(_chevronJs, exports);
var _dayJs = require("./Day.js");
parcelHelpers.exportAll(_dayJs, exports);
var _dayButtonJs = require("./DayButton.js");
parcelHelpers.exportAll(_dayButtonJs, exports);
var _dropdownJs = require("./Dropdown.js");
parcelHelpers.exportAll(_dropdownJs, exports);
var _dropdownNavJs = require("./DropdownNav.js");
parcelHelpers.exportAll(_dropdownNavJs, exports);
var _footerJs = require("./Footer.js");
parcelHelpers.exportAll(_footerJs, exports);
var _monthJs = require("./Month.js");
parcelHelpers.exportAll(_monthJs, exports);
var _monthCaptionJs = require("./MonthCaption.js");
parcelHelpers.exportAll(_monthCaptionJs, exports);
var _monthGridJs = require("./MonthGrid.js");
parcelHelpers.exportAll(_monthGridJs, exports);
var _monthsJs = require("./Months.js");
parcelHelpers.exportAll(_monthsJs, exports);
var _monthsDropdownJs = require("./MonthsDropdown.js");
parcelHelpers.exportAll(_monthsDropdownJs, exports);
var _navJs = require("./Nav.js");
parcelHelpers.exportAll(_navJs, exports);
var _nextMonthButtonJs = require("./NextMonthButton.js");
parcelHelpers.exportAll(_nextMonthButtonJs, exports);
var _optionJs = require("./Option.js");
parcelHelpers.exportAll(_optionJs, exports);
var _previousMonthButtonJs = require("./PreviousMonthButton.js");
parcelHelpers.exportAll(_previousMonthButtonJs, exports);
var _rootJs = require("./Root.js");
parcelHelpers.exportAll(_rootJs, exports);
var _selectJs = require("./Select.js");
parcelHelpers.exportAll(_selectJs, exports);
var _weekJs = require("./Week.js");
parcelHelpers.exportAll(_weekJs, exports);
var _weekdayJs = require("./Weekday.js");
parcelHelpers.exportAll(_weekdayJs, exports);
var _weekdaysJs = require("./Weekdays.js");
parcelHelpers.exportAll(_weekdaysJs, exports);
var _weekNumberJs = require("./WeekNumber.js");
parcelHelpers.exportAll(_weekNumberJs, exports);
var _weekNumberHeaderJs = require("./WeekNumberHeader.js");
parcelHelpers.exportAll(_weekNumberHeaderJs, exports);
var _weeksJs = require("./Weeks.js");
parcelHelpers.exportAll(_weeksJs, exports);
var _yearsDropdownJs = require("./YearsDropdown.js");
parcelHelpers.exportAll(_yearsDropdownJs, exports);

},{"./Button.js":"5gbM0","./CaptionLabel.js":"4IxbC","./Chevron.js":"hR5f1","./Day.js":"3xEpN","./DayButton.js":"3kpBP","./Dropdown.js":"cjE30","./DropdownNav.js":"4h2UB","./Footer.js":"wT5Tk","./Month.js":"abhMi","./MonthCaption.js":"iTuUo","./MonthGrid.js":"8cLzB","./Months.js":"4u6Tg","./MonthsDropdown.js":"iW332","./Nav.js":"10mmB","./NextMonthButton.js":"8K8u9","./Option.js":"jjCLG","./PreviousMonthButton.js":"12KsO","./Root.js":"il0Tx","./Select.js":"3nqFT","./Week.js":"1rkfG","./Weekday.js":"c4H2T","./Weekdays.js":"lscuI","./WeekNumber.js":"dB7kq","./WeekNumberHeader.js":"la6Al","./Weeks.js":"hfzB1","./YearsDropdown.js":"bl3tD","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5gbM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the button elements in the calendar.
 *
 * @private
 * @deprecated Use `PreviousMonthButton` or `@link NextMonthButton` instead.
 */ parcelHelpers.export(exports, "Button", ()=>Button);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Button(props) {
    return (0, _reactDefault.default).createElement("button", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4IxbC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the label in the month caption.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "CaptionLabel", ()=>CaptionLabel);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function CaptionLabel(props) {
    return (0, _reactDefault.default).createElement("span", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hR5f1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the chevron icon used in the navigation buttons and dropdowns.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Chevron", ()=>Chevron);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Chevron(props) {
    const { size = 24, orientation = "left", className } = props;
    return(// biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    (0, _reactDefault.default).createElement("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24"
    }, orientation === "up" && (0, _reactDefault.default).createElement("polygon", {
        points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28"
    }), orientation === "down" && (0, _reactDefault.default).createElement("polygon", {
        points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72"
    }), orientation === "left" && (0, _reactDefault.default).createElement("polygon", {
        points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20"
    }), orientation === "right" && (0, _reactDefault.default).createElement("polygon", {
        points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20"
    })));
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3xEpN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a grid cell for a specific day in the calendar.
 *
 * Handles interaction and focus for the day. If you only need to change the
 * content of the day cell, consider swapping the `DayButton` component
 * instead.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Day", ()=>Day);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Day(props) {
    const { day, modifiers, ...tdProps } = props;
    return (0, _reactDefault.default).createElement("td", {
        ...tdProps
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3kpBP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a button for a specific day in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "DayButton", ()=>DayButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function DayButton(props) {
    const { day, modifiers, ...buttonProps } = props;
    const ref = (0, _reactDefault.default).useRef(null);
    (0, _reactDefault.default).useEffect(()=>{
        if (modifiers.focused) ref.current?.focus();
    }, [
        modifiers.focused
    ]);
    return (0, _reactDefault.default).createElement("button", {
        ref: ref,
        ...buttonProps
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cjE30":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a dropdown component for navigation in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Dropdown", ()=>Dropdown);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uiJs = require("../UI.js");
function Dropdown(props) {
    const { options, className, components, classNames, ...selectProps } = props;
    const cssClassSelect = [
        classNames[(0, _uiJs.UI).Dropdown],
        className
    ].join(" ");
    const selectedOption = options?.find(({ value })=>value === selectProps.value);
    return (0, _reactDefault.default).createElement("span", {
        "data-disabled": selectProps.disabled,
        className: classNames[(0, _uiJs.UI).DropdownRoot]
    }, (0, _reactDefault.default).createElement(components.Select, {
        className: cssClassSelect,
        ...selectProps
    }, options?.map(({ value, label, disabled })=>(0, _reactDefault.default).createElement(components.Option, {
            key: value,
            value: value,
            disabled: disabled
        }, label))), (0, _reactDefault.default).createElement("span", {
        className: classNames[(0, _uiJs.UI).CaptionLabel],
        "aria-hidden": true
    }, selectedOption?.label, (0, _reactDefault.default).createElement(components.Chevron, {
        orientation: "down",
        size: 18,
        className: classNames[(0, _uiJs.UI).Chevron]
    })));
}

},{"react":"IMRgT","../UI.js":"7f59g","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4h2UB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the navigation dropdowns for the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "DropdownNav", ()=>DropdownNav);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function DropdownNav(props) {
    return (0, _reactDefault.default).createElement("div", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"wT5Tk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the footer of the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Footer", ()=>Footer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Footer(props) {
    return (0, _reactDefault.default).createElement("div", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"abhMi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the grid with the weekday header row and the weeks for a specific
 * month.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Month", ()=>Month);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Month(props) {
    const { calendarMonth, displayIndex, ...divProps } = props;
    return (0, _reactDefault.default).createElement("div", {
        ...divProps
    }, props.children);
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iTuUo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the caption for a month in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "MonthCaption", ()=>MonthCaption);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function MonthCaption(props) {
    const { calendarMonth, displayIndex, ...divProps } = props;
    return (0, _reactDefault.default).createElement("div", {
        ...divProps
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8cLzB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the grid of days for a specific month.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "MonthGrid", ()=>MonthGrid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function MonthGrid(props) {
    return (0, _reactDefault.default).createElement("table", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4u6Tg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a container wrapping the month grids.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Months", ()=>Months);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Months(props) {
    return (0, _reactDefault.default).createElement("div", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iW332":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a dropdown to navigate between months in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "MonthsDropdown", ()=>MonthsDropdown);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDayPickerJs = require("../useDayPicker.js");
function MonthsDropdown(props) {
    const { components } = (0, _useDayPickerJs.useDayPicker)();
    return (0, _reactDefault.default).createElement(components.Dropdown, {
        ...props
    });
}

},{"react":"IMRgT","../useDayPicker.js":"9p9gP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9p9gP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dayPickerContext", ()=>dayPickerContext);
/**
 * Provides access to the DayPicker context, which includes properties and
 * methods to interact with the DayPicker component. This hook must be used
 * within a custom component.
 *
 * @template T - Use this type to refine the returned context type with a
 *   specific selection mode.
 * @returns The context to work with DayPicker.
 * @throws {Error} If the hook is used outside of a DayPicker provider.
 * @group Hooks
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "useDayPicker", ()=>useDayPicker);
var _react = require("react");
const dayPickerContext = (0, _react.createContext)(undefined);
function useDayPicker() {
    const context = (0, _react.useContext)(dayPickerContext);
    if (context === undefined) throw new Error("useDayPicker() must be used within a custom component.");
    return context;
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"10mmB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the navigation toolbar with buttons to navigate between months.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Nav", ()=>Nav);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uiJs = require("../UI.js");
var _useDayPickerJs = require("../useDayPicker.js");
function Nav(props) {
    const { onPreviousClick, onNextClick, previousMonth, nextMonth, ...navProps } = props;
    const { components, classNames, labels: { labelPrevious, labelNext } } = (0, _useDayPickerJs.useDayPicker)();
    const handleNextClick = (0, _react.useCallback)((e)=>{
        if (nextMonth) onNextClick?.(e);
    }, [
        nextMonth,
        onNextClick
    ]);
    const handlePreviousClick = (0, _react.useCallback)((e)=>{
        if (previousMonth) onPreviousClick?.(e);
    }, [
        previousMonth,
        onPreviousClick
    ]);
    return (0, _reactDefault.default).createElement("nav", {
        ...navProps
    }, (0, _reactDefault.default).createElement(components.PreviousMonthButton, {
        type: "button",
        className: classNames[(0, _uiJs.UI).PreviousMonthButton],
        tabIndex: previousMonth ? undefined : -1,
        "aria-disabled": previousMonth ? undefined : true,
        "aria-label": labelPrevious(previousMonth),
        onClick: handlePreviousClick
    }, (0, _reactDefault.default).createElement(components.Chevron, {
        disabled: previousMonth ? undefined : true,
        className: classNames[(0, _uiJs.UI).Chevron],
        orientation: "left"
    })), (0, _reactDefault.default).createElement(components.NextMonthButton, {
        type: "button",
        className: classNames[(0, _uiJs.UI).NextMonthButton],
        tabIndex: nextMonth ? undefined : -1,
        "aria-disabled": nextMonth ? undefined : true,
        "aria-label": labelNext(nextMonth),
        onClick: handleNextClick
    }, (0, _reactDefault.default).createElement(components.Chevron, {
        disabled: nextMonth ? undefined : true,
        orientation: "right",
        className: classNames[(0, _uiJs.UI).Chevron]
    })));
}

},{"react":"IMRgT","../UI.js":"7f59g","../useDayPicker.js":"9p9gP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8K8u9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the button to navigate to the next month in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "NextMonthButton", ()=>NextMonthButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDayPickerJs = require("../useDayPicker.js");
function NextMonthButton(props) {
    const { components } = (0, _useDayPickerJs.useDayPicker)();
    return (0, _reactDefault.default).createElement(components.Button, {
        ...props
    });
}

},{"react":"IMRgT","../useDayPicker.js":"9p9gP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jjCLG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render an `option` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Option", ()=>Option);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Option(props) {
    return (0, _reactDefault.default).createElement("option", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"12KsO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the button to navigate to the previous month in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "PreviousMonthButton", ()=>PreviousMonthButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDayPickerJs = require("../useDayPicker.js");
function PreviousMonthButton(props) {
    const { components } = (0, _useDayPickerJs.useDayPicker)();
    return (0, _reactDefault.default).createElement(components.Button, {
        ...props
    });
}

},{"react":"IMRgT","../useDayPicker.js":"9p9gP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"il0Tx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the root element of the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Root", ()=>Root);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Root(props) {
    const { rootRef, ...rest } = props;
    return (0, _reactDefault.default).createElement("div", {
        ...rest,
        ref: rootRef
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3nqFT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a `select` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Select", ()=>Select);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Select(props) {
    return (0, _reactDefault.default).createElement("select", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1rkfG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a table row representing a week in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Week", ()=>Week);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Week(props) {
    const { week, ...trProps } = props;
    return (0, _reactDefault.default).createElement("tr", {
        ...trProps
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c4H2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a table header cell with the name of a weekday (e.g., "Mo", "Tu").
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Weekday", ()=>Weekday);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Weekday(props) {
    return (0, _reactDefault.default).createElement("th", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lscuI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the table row containing the weekday names.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Weekdays", ()=>Weekdays);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Weekdays(props) {
    return (0, _reactDefault.default).createElement("thead", {
        "aria-hidden": true
    }, (0, _reactDefault.default).createElement("tr", {
        ...props
    }));
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dB7kq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a table cell displaying the number of the week.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "WeekNumber", ()=>WeekNumber);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function WeekNumber(props) {
    const { week, ...thProps } = props;
    return (0, _reactDefault.default).createElement("th", {
        ...thProps
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"la6Al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the header cell for the week numbers column.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "WeekNumberHeader", ()=>WeekNumberHeader);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function WeekNumberHeader(props) {
    return (0, _reactDefault.default).createElement("th", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hfzB1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render the container for the weeks in the month grid.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "Weeks", ()=>Weeks);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Weeks(props) {
    return (0, _reactDefault.default).createElement("tbody", {
        ...props
    });
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bl3tD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a dropdown to navigate between years in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */ parcelHelpers.export(exports, "YearsDropdown", ()=>YearsDropdown);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDayPickerJs = require("../useDayPicker.js");
function YearsDropdown(props) {
    const { components } = (0, _useDayPickerJs.useDayPicker)();
    return (0, _reactDefault.default).createElement(components.Dropdown, {
        ...props
    });
}

},{"react":"IMRgT","../useDayPicker.js":"9p9gP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"laIPo":[function(require,module,exports,__globalThis) {
/**
 * Extracts `data-` attributes from the DayPicker props.
 *
 * This function collects all `data-` attributes from the props and adds
 * additional attributes based on the DayPicker configuration.
 *
 * @param props The DayPicker props.
 * @returns An object containing the `data-` attributes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDataAttributes", ()=>getDataAttributes);
function getDataAttributes(props) {
    const dataAttributes = {
        "data-mode": props.mode ?? undefined,
        "data-required": "required" in props ? props.required : undefined,
        "data-multiple-months": props.numberOfMonths && props.numberOfMonths > 1 || undefined,
        "data-week-numbers": props.showWeekNumber || undefined,
        "data-broadcast-calendar": props.broadcastCalendar || undefined,
        "data-nav-layout": props.navLayout || undefined
    };
    Object.entries(props).forEach(([key, val])=>{
        if (key.startsWith("data-")) dataAttributes[key] = val;
    });
    return dataAttributes;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"abzSU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the default class names for the UI elements.
 *
 * This function generates a mapping of default class names for various UI
 * elements, day flags, selection states, and animations.
 *
 * @returns An object containing the default class names.
 * @group Utilities
 */ parcelHelpers.export(exports, "getDefaultClassNames", ()=>getDefaultClassNames);
var _uiJs = require("../UI.js");
function getDefaultClassNames() {
    const classNames = {};
    for(const key in 0, _uiJs.UI)classNames[(0, _uiJs.UI)[key]] = `rdp-${(0, _uiJs.UI)[key]}`;
    for(const key in 0, _uiJs.DayFlag)classNames[(0, _uiJs.DayFlag)[key]] = `rdp-${(0, _uiJs.DayFlag)[key]}`;
    for(const key in 0, _uiJs.SelectionState)classNames[(0, _uiJs.SelectionState)[key]] = `rdp-${(0, _uiJs.SelectionState)[key]}`;
    for(const key in 0, _uiJs.Animation)classNames[(0, _uiJs.Animation)[key]] = `rdp-${(0, _uiJs.Animation)[key]}`;
    return classNames;
}

},{"../UI.js":"7f59g","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dgyb1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges custom formatters from the props with the default formatters.
 *
 * @param customFormatters The custom formatters provided in the DayPicker
 *   props.
 * @returns The merged formatters object.
 */ parcelHelpers.export(exports, "getFormatters", ()=>getFormatters);
var _indexJs = require("../formatters/index.js");
function getFormatters(customFormatters) {
    if (customFormatters?.formatMonthCaption && !customFormatters.formatCaption) customFormatters.formatCaption = customFormatters.formatMonthCaption;
    if (customFormatters?.formatYearCaption && !customFormatters.formatYearDropdown) customFormatters.formatYearDropdown = customFormatters.formatYearCaption;
    return {
        ..._indexJs,
        ...customFormatters
    };
}

},{"../formatters/index.js":"lmLwh","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lmLwh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatCaptionJs = require("./formatCaption.js");
parcelHelpers.exportAll(_formatCaptionJs, exports);
var _formatDayJs = require("./formatDay.js");
parcelHelpers.exportAll(_formatDayJs, exports);
var _formatMonthDropdownJs = require("./formatMonthDropdown.js");
parcelHelpers.exportAll(_formatMonthDropdownJs, exports);
var _formatWeekdayNameJs = require("./formatWeekdayName.js");
parcelHelpers.exportAll(_formatWeekdayNameJs, exports);
var _formatWeekNumberJs = require("./formatWeekNumber.js");
parcelHelpers.exportAll(_formatWeekNumberJs, exports);
var _formatWeekNumberHeaderJs = require("./formatWeekNumberHeader.js");
parcelHelpers.exportAll(_formatWeekNumberHeaderJs, exports);
var _formatYearDropdownJs = require("./formatYearDropdown.js");
parcelHelpers.exportAll(_formatYearDropdownJs, exports);

},{"./formatCaption.js":"ltLn0","./formatDay.js":"AvsXT","./formatMonthDropdown.js":"byY9V","./formatWeekdayName.js":"khJ3j","./formatWeekNumber.js":"dkT9M","./formatWeekNumberHeader.js":"dtzOI","./formatYearDropdown.js":"aO36G","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ltLn0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the caption of the month.
 *
 * @defaultValue Locale-specific month/year order (e.g., "November 2022").
 * @param month The date representing the month.
 * @param options Configuration options for the date library.
 * @param dateLib The date library to use for formatting. If not provided, a new
 *   instance is created.
 * @returns The formatted caption as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatCaption", ()=>formatCaption);
parcelHelpers.export(exports, "formatMonthCaption", ()=>formatMonthCaption);
var _dateLibJs = require("../classes/DateLib.js");
function formatCaption(month, options, dateLib) {
    const lib = dateLib ?? new (0, _dateLibJs.DateLib)(options);
    return lib.formatMonthYear(month);
}
const formatMonthCaption = formatCaption;

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"AvsXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the day date shown in the day cell.
 *
 * @defaultValue `d` (e.g., "1").
 * @param date The date to format.
 * @param options Configuration options for the date library.
 * @param dateLib The date library to use for formatting. If not provided, a new
 *   instance is created.
 * @returns The formatted day as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatDay", ()=>formatDay);
var _dateLibJs = require("../classes/DateLib.js");
function formatDay(date, options, dateLib) {
    return (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(date, "d");
}

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"byY9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the month for the dropdown option label.
 *
 * @defaultValue The localized full month name.
 * @param month The date representing the month.
 * @param dateLib The date library to use for formatting. Defaults to
 *   `defaultDateLib`.
 * @returns The formatted month name as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatMonthDropdown", ()=>formatMonthDropdown);
var _dateLibJs = require("../classes/DateLib.js");
function formatMonthDropdown(month, dateLib = (0, _dateLibJs.defaultDateLib)) {
    return dateLib.format(month, "LLLL");
}

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"khJ3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the name of a weekday to be displayed in the weekdays header.
 *
 * @defaultValue `cccccc` (e.g., "Mo" for Monday).
 * @param weekday The date representing the weekday.
 * @param options Configuration options for the date library.
 * @param dateLib The date library to use for formatting. If not provided, a new
 *   instance is created.
 * @returns The formatted weekday name as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatWeekdayName", ()=>formatWeekdayName);
var _dateLibJs = require("../classes/DateLib.js");
function formatWeekdayName(weekday, options, dateLib) {
    return (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(weekday, "cccccc");
}

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dkT9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the week number.
 *
 * @defaultValue The week number as a string, with a leading zero for single-digit numbers.
 * @param weekNumber The week number to format.
 * @param dateLib The date library to use for formatting. Defaults to
 *   `defaultDateLib`.
 * @returns The formatted week number as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatWeekNumber", ()=>formatWeekNumber);
var _dateLibJs = require("../classes/DateLib.js");
function formatWeekNumber(weekNumber, dateLib = (0, _dateLibJs.defaultDateLib)) {
    if (weekNumber < 10) return dateLib.formatNumber(`0${weekNumber.toLocaleString()}`);
    return dateLib.formatNumber(`${weekNumber.toLocaleString()}`);
}

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dtzOI":[function(require,module,exports,__globalThis) {
/**
 * Formats the header for the week number column.
 *
 * @defaultValue An empty string `""`.
 * @returns The formatted week number header as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatWeekNumberHeader", ()=>formatWeekNumberHeader);
function formatWeekNumberHeader() {
    return ``;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aO36G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats the year for the dropdown option label.
 *
 * @param year The year to format.
 * @param dateLib The date library to use for formatting. Defaults to
 *   `defaultDateLib`.
 * @returns The formatted year as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ parcelHelpers.export(exports, "formatYearDropdown", ()=>formatYearDropdown);
parcelHelpers.export(exports, "formatYearCaption", ()=>formatYearCaption);
var _dateLibJs = require("../classes/DateLib.js");
function formatYearDropdown(year, dateLib = (0, _dateLibJs.defaultDateLib)) {
    return dateLib.format(year, "yyyy");
}
const formatYearCaption = formatYearDropdown;

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1yqQn":[function(require,module,exports,__globalThis) {
/**
 * Returns the months to show in the dropdown.
 *
 * This function generates a list of months for the current year, formatted
 * using the provided formatter, and determines whether each month should be
 * disabled based on the navigation range.
 *
 * @param displayMonth The currently displayed month.
 * @param navStart The start date for navigation.
 * @param navEnd The end date for navigation.
 * @param formatters The formatters to use for formatting the month labels.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of dropdown options representing the months, or `undefined`
 *   if no months are available.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMonthOptions", ()=>getMonthOptions);
function getMonthOptions(displayMonth, navStart, navEnd, formatters, dateLib) {
    const { startOfMonth, startOfYear, endOfYear, eachMonthOfInterval, getMonth } = dateLib;
    const months = eachMonthOfInterval({
        start: startOfYear(displayMonth),
        end: endOfYear(displayMonth)
    });
    const options = months.map((month)=>{
        const label = formatters.formatMonthDropdown(month, dateLib);
        const value = getMonth(month);
        const disabled = navStart && month < startOfMonth(navStart) || navEnd && month > startOfMonth(navEnd) || false;
        return {
            value,
            label,
            disabled
        };
    });
    return options;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gZcYW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the computed style for a day based on its modifiers.
 *
 * This function merges the base styles for the day with any styles associated
 * with active modifiers.
 *
 * @param dayModifiers The modifiers applied to the day.
 * @param styles The base styles for the calendar elements.
 * @param modifiersStyles The styles associated with specific modifiers.
 * @returns The computed style for the day.
 */ parcelHelpers.export(exports, "getStyleForModifiers", ()=>getStyleForModifiers);
var _uiJs = require("../UI.js");
function getStyleForModifiers(dayModifiers, styles = {}, modifiersStyles = {}) {
    let style = {
        ...styles?.[(0, _uiJs.UI).Day]
    };
    Object.entries(dayModifiers).filter(([, active])=>active === true).forEach(([modifier])=>{
        style = {
            ...style,
            ...modifiersStyles?.[modifier]
        };
    });
    return style;
}

},{"../UI.js":"7f59g","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cbCV5":[function(require,module,exports,__globalThis) {
/**
 * Generates a series of 7 days, starting from the beginning of the week, to use
 * for formatting weekday names (e.g., Monday, Tuesday, etc.).
 *
 * @param dateLib The date library to use for date manipulation.
 * @param ISOWeek Whether to use ISO week numbering (weeks start on Monday).
 * @param broadcastCalendar Whether to use the broadcast calendar (weeks start
 *   on Monday, but may include adjustments for broadcast-specific rules).
 * @returns An array of 7 dates representing the weekdays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWeekdays", ()=>getWeekdays);
function getWeekdays(dateLib, ISOWeek, broadcastCalendar) {
    const today = dateLib.today();
    const start = broadcastCalendar ? dateLib.startOfBroadcastWeek(today, dateLib) : ISOWeek ? dateLib.startOfISOWeek(today) : dateLib.startOfWeek(today);
    const days = [];
    for(let i = 0; i < 7; i++){
        const day = dateLib.addDays(start, i);
        days.push(day);
    }
    return days;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iF2zD":[function(require,module,exports,__globalThis) {
/**
 * Returns the years to display in the dropdown.
 *
 * This function generates a list of years between the navigation start and end
 * dates, formatted using the provided formatter.
 *
 * @param navStart The start date for navigation.
 * @param navEnd The end date for navigation.
 * @param formatters The formatters to use for formatting the year labels.
 * @param dateLib The date library to use for date manipulation.
 * @param reverse If true, reverses the order of the years (descending).
 * @returns An array of dropdown options representing the years, or `undefined`
 *   if `navStart` or `navEnd` is not provided.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getYearOptions", ()=>getYearOptions);
function getYearOptions(navStart, navEnd, formatters, dateLib, reverse = false) {
    if (!navStart) return undefined;
    if (!navEnd) return undefined;
    const { startOfYear, endOfYear, eachYearOfInterval, getYear } = dateLib;
    const firstNavYear = startOfYear(navStart);
    const lastNavYear = endOfYear(navEnd);
    const years = eachYearOfInterval({
        start: firstNavYear,
        end: lastNavYear
    });
    if (reverse) years.reverse();
    return years.map((year)=>{
        const label = formatters.formatYearDropdown(year, dateLib);
        return {
            value: getYear(year),
            label,
            disabled: false
        };
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6y6xk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _labelDayButtonJs = require("./labelDayButton.js");
parcelHelpers.exportAll(_labelDayButtonJs, exports);
var _labelGridJs = require("./labelGrid.js");
parcelHelpers.exportAll(_labelGridJs, exports);
parcelHelpers.exportAll(_labelGridJs, exports);
var _labelGridcellJs = require("./labelGridcell.js");
parcelHelpers.exportAll(_labelGridcellJs, exports);
var _labelMonthDropdownJs = require("./labelMonthDropdown.js");
parcelHelpers.exportAll(_labelMonthDropdownJs, exports);
var _labelNavJs = require("./labelNav.js");
parcelHelpers.exportAll(_labelNavJs, exports);
var _labelNextJs = require("./labelNext.js");
parcelHelpers.exportAll(_labelNextJs, exports);
var _labelPreviousJs = require("./labelPrevious.js");
parcelHelpers.exportAll(_labelPreviousJs, exports);
var _labelWeekdayJs = require("./labelWeekday.js");
parcelHelpers.exportAll(_labelWeekdayJs, exports);
var _labelWeekNumberJs = require("./labelWeekNumber.js");
parcelHelpers.exportAll(_labelWeekNumberJs, exports);
var _labelWeekNumberHeaderJs = require("./labelWeekNumberHeader.js");
parcelHelpers.exportAll(_labelWeekNumberHeaderJs, exports);
var _labelYearDropdownJs = require("./labelYearDropdown.js");
parcelHelpers.exportAll(_labelYearDropdownJs, exports);

},{"./labelDayButton.js":"3QbF1","./labelGrid.js":"5vPgA","./labelGridcell.js":"6m7oB","./labelMonthDropdown.js":"31XPF","./labelNav.js":"jYgPm","./labelNext.js":"04whT","./labelPrevious.js":"9IzkW","./labelWeekday.js":"7Pk3i","./labelWeekNumber.js":"fMpVh","./labelWeekNumberHeader.js":"b2vSj","./labelYearDropdown.js":"5wSE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3QbF1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates the ARIA label for a day button.
 *
 * Use the `modifiers` argument to provide additional context for the label,
 * such as indicating if the day is "today" or "selected."
 *
 * @defaultValue The formatted date.
 * @param date - The date to format.
 * @param modifiers - The modifiers providing context for the day.
 * @param options - Optional configuration for the date formatting library.
 * @param dateLib - An optional instance of the date formatting library.
 * @returns The ARIA label for the day button.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ parcelHelpers.export(exports, "labelDayButton", ()=>labelDayButton);
parcelHelpers.export(exports, "labelDay", ()=>labelDay);
var _dateLibJs = require("../classes/DateLib.js");
function labelDayButton(date, modifiers, options, dateLib) {
    let label = (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(date, "PPPP");
    if (modifiers.today) label = `Today, ${label}`;
    if (modifiers.selected) label = `${label}, selected`;
    return label;
}
const labelDay = labelDayButton;

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5vPgA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates the ARIA label for the month grid, which is announced when entering
 * the grid.
 *
 * @defaultValue Locale-specific month/year order (e.g., "November 2022").
 * @param date - The date representing the month.
 * @param options - Optional configuration for the date formatting library.
 * @param dateLib - An optional instance of the date formatting library.
 * @returns The ARIA label for the month grid.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ parcelHelpers.export(exports, "labelGrid", ()=>labelGrid);
parcelHelpers.export(exports, "labelCaption", ()=>labelCaption);
var _dateLibJs = require("../classes/DateLib.js");
function labelGrid(date, options, dateLib) {
    const lib = dateLib ?? new (0, _dateLibJs.DateLib)(options);
    return lib.formatMonthYear(date);
}
const labelCaption = labelGrid;

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6m7oB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates the label for a day grid cell when the calendar is not interactive.
 *
 * @param date - The date to format.
 * @param modifiers - Optional modifiers providing context for the day.
 * @param options - Optional configuration for the date formatting library.
 * @param dateLib - An optional instance of the date formatting library.
 * @returns The label for the day grid cell.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ parcelHelpers.export(exports, "labelGridcell", ()=>labelGridcell);
var _dateLibJs = require("../classes/DateLib.js");
function labelGridcell(date, modifiers, options, dateLib) {
    let label = (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(date, "PPPP");
    if (modifiers?.today) label = `Today, ${label}`;
    return label;
}

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"31XPF":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the months dropdown.
 *
 * @defaultValue `"Choose the Month"`
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the months dropdown.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelMonthDropdown", ()=>labelMonthDropdown);
function labelMonthDropdown(_options) {
    return "Choose the Month";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jYgPm":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the navigation toolbar.
 *
 * @defaultValue `""`
 * @returns The ARIA label for the navigation toolbar.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelNav", ()=>labelNav);
function labelNav() {
    return "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"04whT":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the "next month" button.
 *
 * @defaultValue `"Go to the Next Month"`
 * @param month - The date representing the next month, or `undefined` if there
 *   is no next month.
 * @returns The ARIA label for the "next month" button.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelNext", ()=>labelNext);
function labelNext(_month) {
    return "Go to the Next Month";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9IzkW":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the "previous month" button.
 *
 * @defaultValue `"Go to the Previous Month"`
 * @param month - The date representing the previous month, or `undefined` if
 *   there is no previous month.
 * @returns The ARIA label for the "previous month" button.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelPrevious", ()=>labelPrevious);
function labelPrevious(_month) {
    return "Go to the Previous Month";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7Pk3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generates the ARIA label for a weekday column header.
 *
 * @defaultValue `"Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"`
 * @param date - The date representing the weekday.
 * @param options - Optional configuration for the date formatting library.
 * @param dateLib - An optional instance of the date formatting library.
 * @returns The ARIA label for the weekday column header.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ parcelHelpers.export(exports, "labelWeekday", ()=>labelWeekday);
var _dateLibJs = require("../classes/DateLib.js");
function labelWeekday(date, options, dateLib) {
    return (dateLib ?? new (0, _dateLibJs.DateLib)(options)).format(date, "cccc");
}

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fMpVh":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the week number cell (the first cell in a row).
 *
 * @defaultValue `Week ${weekNumber}`
 * @param weekNumber - The number of the week.
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the week number cell.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelWeekNumber", ()=>labelWeekNumber);
function labelWeekNumber(weekNumber, _options) {
    return `Week ${weekNumber}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"b2vSj":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the week number header element.
 *
 * @defaultValue `"Week Number"`
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the week number header.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelWeekNumberHeader", ()=>labelWeekNumberHeader);
function labelWeekNumberHeader(_options) {
    return "Week Number";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5wSE0":[function(require,module,exports,__globalThis) {
/**
 * Generates the ARIA label for the years dropdown.
 *
 * @defaultValue `"Choose the Year"`
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the years dropdown.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelYearDropdown", ()=>labelYearDropdown);
function labelYearDropdown(_options) {
    return "Choose the Year";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8Jv6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles animations for transitioning between months in the DayPicker
 * component.
 *
 * @private
 * @param rootElRef - A reference to the root element of the DayPicker
 *   component.
 * @param enabled - Whether animations are enabled.
 * @param options - Configuration options for the animation, including class
 *   names, months, focused day, and the date utility library.
 */ parcelHelpers.export(exports, "useAnimation", ()=>useAnimation);
var _react = require("react");
var _uiJs = require("./UI.js");
const asHtmlElement = (element)=>{
    if (element instanceof HTMLElement) return element;
    return null;
};
const queryMonthEls = (element)=>[
        ...element.querySelectorAll("[data-animated-month]") ?? []
    ];
const queryMonthEl = (element)=>asHtmlElement(element.querySelector("[data-animated-month]"));
const queryCaptionEl = (element)=>asHtmlElement(element.querySelector("[data-animated-caption]"));
const queryWeeksEl = (element)=>asHtmlElement(element.querySelector("[data-animated-weeks]"));
const queryNavEl = (element)=>asHtmlElement(element.querySelector("[data-animated-nav]"));
const queryWeekdaysEl = (element)=>asHtmlElement(element.querySelector("[data-animated-weekdays]"));
function useAnimation(rootElRef, enabled, { classNames, months, focused, dateLib }) {
    const previousRootElSnapshotRef = (0, _react.useRef)(null);
    const previousMonthsRef = (0, _react.useRef)(months);
    const animatingRef = (0, _react.useRef)(false);
    (0, _react.useLayoutEffect)(()=>{
        // get previous months before updating the previous months ref
        const previousMonths = previousMonthsRef.current;
        // update previous months ref for next effect trigger
        previousMonthsRef.current = months;
        if (!enabled || !rootElRef.current || // safety check because the ref can be set to anything by consumers
        !(rootElRef.current instanceof HTMLElement) || // validation required for the animation to work as expected
        months.length === 0 || previousMonths.length === 0 || months.length !== previousMonths.length) return;
        const isSameMonth = dateLib.isSameMonth(months[0].date, previousMonths[0].date);
        const isAfterPreviousMonth = dateLib.isAfter(months[0].date, previousMonths[0].date);
        const captionAnimationClass = isAfterPreviousMonth ? classNames[(0, _uiJs.Animation).caption_after_enter] : classNames[(0, _uiJs.Animation).caption_before_enter];
        const weeksAnimationClass = isAfterPreviousMonth ? classNames[(0, _uiJs.Animation).weeks_after_enter] : classNames[(0, _uiJs.Animation).weeks_before_enter];
        // get previous root element snapshot before updating the snapshot ref
        const previousRootElSnapshot = previousRootElSnapshotRef.current;
        // update snapshot for next effect trigger
        const rootElSnapshot = rootElRef.current.cloneNode(true);
        if (rootElSnapshot instanceof HTMLElement) {
            // if this effect is triggered while animating, we need to clean up the new root snapshot
            // to put it in the same state as when not animating, to correctly animate the next month change
            const currentMonthElsSnapshot = queryMonthEls(rootElSnapshot);
            currentMonthElsSnapshot.forEach((currentMonthElSnapshot)=>{
                if (!(currentMonthElSnapshot instanceof HTMLElement)) return;
                // remove the old month snapshots from the new root snapshot
                const previousMonthElSnapshot = queryMonthEl(currentMonthElSnapshot);
                if (previousMonthElSnapshot && currentMonthElSnapshot.contains(previousMonthElSnapshot)) currentMonthElSnapshot.removeChild(previousMonthElSnapshot);
                // remove animation classes from the new month snapshots
                const captionEl = queryCaptionEl(currentMonthElSnapshot);
                if (captionEl) captionEl.classList.remove(captionAnimationClass);
                const weeksEl = queryWeeksEl(currentMonthElSnapshot);
                if (weeksEl) weeksEl.classList.remove(weeksAnimationClass);
            });
            previousRootElSnapshotRef.current = rootElSnapshot;
        } else previousRootElSnapshotRef.current = null;
        if (animatingRef.current || isSameMonth || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
        focused) return;
        const previousMonthEls = previousRootElSnapshot instanceof HTMLElement ? queryMonthEls(previousRootElSnapshot) : [];
        const currentMonthEls = queryMonthEls(rootElRef.current);
        if (currentMonthEls?.every((el)=>el instanceof HTMLElement) && previousMonthEls && previousMonthEls.every((el)=>el instanceof HTMLElement)) {
            animatingRef.current = true;
            const cleanUpFunctions = [];
            // set isolation to isolate to isolate the stacking context during animation
            rootElRef.current.style.isolation = "isolate";
            // set z-index to 1 to ensure the nav is clickable over the other elements being animated
            const navEl = queryNavEl(rootElRef.current);
            if (navEl) navEl.style.zIndex = "1";
            currentMonthEls.forEach((currentMonthEl, index)=>{
                const previousMonthEl = previousMonthEls[index];
                if (!previousMonthEl) return;
                // animate new displayed month
                currentMonthEl.style.position = "relative";
                currentMonthEl.style.overflow = "hidden";
                const captionEl = queryCaptionEl(currentMonthEl);
                if (captionEl) captionEl.classList.add(captionAnimationClass);
                const weeksEl = queryWeeksEl(currentMonthEl);
                if (weeksEl) weeksEl.classList.add(weeksAnimationClass);
                // animate new displayed month end
                const cleanUp = ()=>{
                    animatingRef.current = false;
                    if (rootElRef.current) rootElRef.current.style.isolation = "";
                    if (navEl) navEl.style.zIndex = "";
                    if (captionEl) captionEl.classList.remove(captionAnimationClass);
                    if (weeksEl) weeksEl.classList.remove(weeksAnimationClass);
                    currentMonthEl.style.position = "";
                    currentMonthEl.style.overflow = "";
                    if (currentMonthEl.contains(previousMonthEl)) currentMonthEl.removeChild(previousMonthEl);
                };
                cleanUpFunctions.push(cleanUp);
                // animate old displayed month
                previousMonthEl.style.pointerEvents = "none";
                previousMonthEl.style.position = "absolute";
                previousMonthEl.style.overflow = "hidden";
                previousMonthEl.setAttribute("aria-hidden", "true");
                // hide the weekdays container of the old month and only the new one
                const previousWeekdaysEl = queryWeekdaysEl(previousMonthEl);
                if (previousWeekdaysEl) previousWeekdaysEl.style.opacity = "0";
                const previousCaptionEl = queryCaptionEl(previousMonthEl);
                if (previousCaptionEl) {
                    previousCaptionEl.classList.add(isAfterPreviousMonth ? classNames[(0, _uiJs.Animation).caption_before_exit] : classNames[(0, _uiJs.Animation).caption_after_exit]);
                    previousCaptionEl.addEventListener("animationend", cleanUp);
                }
                const previousWeeksEl = queryWeeksEl(previousMonthEl);
                if (previousWeeksEl) previousWeeksEl.classList.add(isAfterPreviousMonth ? classNames[(0, _uiJs.Animation).weeks_before_exit] : classNames[(0, _uiJs.Animation).weeks_after_exit]);
                currentMonthEl.insertBefore(previousMonthEl, currentMonthEl.firstChild);
            });
        }
    });
}

},{"react":"IMRgT","./UI.js":"7f59g","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6fZSL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the calendar object to work with the calendar in custom components.
 *
 * @private
 * @param props - The DayPicker props related to calendar configuration.
 * @param dateLib - The date utility library instance.
 * @returns The calendar object containing displayed days, weeks, months, and
 *   navigation methods.
 */ parcelHelpers.export(exports, "useCalendar", ()=>useCalendar);
var _react = require("react");
var _getDatesJs = require("./helpers/getDates.js");
var _getDaysJs = require("./helpers/getDays.js");
var _getDisplayMonthsJs = require("./helpers/getDisplayMonths.js");
var _getInitialMonthJs = require("./helpers/getInitialMonth.js");
var _getMonthsJs = require("./helpers/getMonths.js");
var _getNavMonthJs = require("./helpers/getNavMonth.js");
var _getNextMonthJs = require("./helpers/getNextMonth.js");
var _getPreviousMonthJs = require("./helpers/getPreviousMonth.js");
var _getWeeksJs = require("./helpers/getWeeks.js");
var _useControlledValueJs = require("./helpers/useControlledValue.js");
function useCalendar(props, dateLib) {
    const [navStart, navEnd] = (0, _getNavMonthJs.getNavMonths)(props, dateLib);
    const { startOfMonth, endOfMonth } = dateLib;
    const initialMonth = (0, _getInitialMonthJs.getInitialMonth)(props, navStart, navEnd, dateLib);
    const [firstMonth, setFirstMonth] = (0, _useControlledValueJs.useControlledValue)(initialMonth, // initialMonth is always computed from props.month if provided
    props.month ? initialMonth : undefined);
    // biome-ignore lint/correctness/useExhaustiveDependencies: change the initial month when the time zone changes.
    (0, _react.useEffect)(()=>{
        const newInitialMonth = (0, _getInitialMonthJs.getInitialMonth)(props, navStart, navEnd, dateLib);
        setFirstMonth(newInitialMonth);
    }, [
        props.timeZone
    ]);
    /** The months displayed in the calendar. */ const displayMonths = (0, _getDisplayMonthsJs.getDisplayMonths)(firstMonth, navEnd, props, dateLib);
    /** The dates displayed in the calendar. */ const dates = (0, _getDatesJs.getDates)(displayMonths, props.endMonth ? endOfMonth(props.endMonth) : undefined, props, dateLib);
    /** The Months displayed in the calendar. */ const months = (0, _getMonthsJs.getMonths)(displayMonths, dates, props, dateLib);
    /** The Weeks displayed in the calendar. */ const weeks = (0, _getWeeksJs.getWeeks)(months);
    /** The Days displayed in the calendar. */ const days = (0, _getDaysJs.getDays)(months);
    const previousMonth = (0, _getPreviousMonthJs.getPreviousMonth)(firstMonth, navStart, props, dateLib);
    const nextMonth = (0, _getNextMonthJs.getNextMonth)(firstMonth, navEnd, props, dateLib);
    const { disableNavigation, onMonthChange } = props;
    const isDayInCalendar = (day)=>weeks.some((week)=>week.days.some((d)=>d.isEqualTo(day)));
    const goToMonth = (date)=>{
        if (disableNavigation) return;
        let newMonth = startOfMonth(date);
        // if month is before start, use the first month instead
        if (navStart && newMonth < startOfMonth(navStart)) newMonth = startOfMonth(navStart);
        // if month is after endMonth, use the last month instead
        if (navEnd && newMonth > startOfMonth(navEnd)) newMonth = startOfMonth(navEnd);
        setFirstMonth(newMonth);
        onMonthChange?.(newMonth);
    };
    const goToDay = (day)=>{
        // is this check necessary?
        if (isDayInCalendar(day)) return;
        goToMonth(day.date);
    };
    const calendar = {
        months,
        weeks,
        days,
        navStart,
        navEnd,
        previousMonth,
        nextMonth,
        goToMonth,
        goToDay
    };
    return calendar;
}

},{"react":"IMRgT","./helpers/getDates.js":"5nFt1","./helpers/getDays.js":"3DnpF","./helpers/getDisplayMonths.js":"fBNW2","./helpers/getInitialMonth.js":"9I2bl","./helpers/getMonths.js":"gzY8Y","./helpers/getNavMonth.js":"eT33y","./helpers/getNextMonth.js":"eDtvr","./helpers/getPreviousMonth.js":"h6P7O","./helpers/getWeeks.js":"jh39U","./helpers/useControlledValue.js":"5XtBl","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5nFt1":[function(require,module,exports,__globalThis) {
/**
 * Returns all the dates to display in the calendar.
 *
 * This function calculates the range of dates to display based on the provided
 * display months, constraints, and calendar configuration.
 *
 * @param displayMonths The months to display in the calendar.
 * @param maxDate The maximum date to include in the range.
 * @param props The DayPicker props, including calendar configuration options.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of dates to display in the calendar.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDates", ()=>getDates);
function getDates(displayMonths, maxDate, props, dateLib) {
    const firstMonth = displayMonths[0];
    const lastMonth = displayMonths[displayMonths.length - 1];
    const { ISOWeek, fixedWeeks, broadcastCalendar } = props ?? {};
    const { addDays, differenceInCalendarDays, differenceInCalendarMonths, endOfBroadcastWeek, endOfISOWeek, endOfMonth, endOfWeek, isAfter, startOfBroadcastWeek, startOfISOWeek, startOfWeek } = dateLib;
    const startWeekFirstDate = broadcastCalendar ? startOfBroadcastWeek(firstMonth, dateLib) : ISOWeek ? startOfISOWeek(firstMonth) : startOfWeek(firstMonth);
    const endWeekLastDate = broadcastCalendar ? endOfBroadcastWeek(lastMonth) : ISOWeek ? endOfISOWeek(endOfMonth(lastMonth)) : endOfWeek(endOfMonth(lastMonth));
    const nOfDays = differenceInCalendarDays(endWeekLastDate, startWeekFirstDate);
    const nOfMonths = differenceInCalendarMonths(lastMonth, firstMonth) + 1;
    const dates = [];
    for(let i = 0; i <= nOfDays; i++){
        const date = addDays(startWeekFirstDate, i);
        if (maxDate && isAfter(date, maxDate)) break;
        dates.push(date);
    }
    // If fixed weeks is enabled, add the extra dates to the array
    const nrOfDaysWithFixedWeeks = broadcastCalendar ? 35 : 42;
    const extraDates = nrOfDaysWithFixedWeeks * nOfMonths;
    if (fixedWeeks && dates.length < extraDates) {
        const daysToAdd = extraDates - dates.length;
        for(let i = 0; i < daysToAdd; i++){
            const date = addDays(dates[dates.length - 1], 1);
            dates.push(date);
        }
    }
    return dates;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3DnpF":[function(require,module,exports,__globalThis) {
/**
 * Returns all the days belonging to the calendar by merging the days in the
 * weeks for each month.
 *
 * @param calendarMonths The array of calendar months.
 * @returns An array of `CalendarDay` objects representing all the days in the
 *   calendar.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDays", ()=>getDays);
function getDays(calendarMonths) {
    const initialDays = [];
    return calendarMonths.reduce((days, month)=>{
        const weekDays = month.weeks.reduce((weekDays, week)=>{
            return weekDays.concat(week.days.slice());
        }, initialDays.slice());
        return days.concat(weekDays.slice());
    }, initialDays.slice());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fBNW2":[function(require,module,exports,__globalThis) {
/**
 * Returns the months to display in the calendar.
 *
 * @param firstDisplayedMonth The first month currently displayed in the
 *   calendar.
 * @param calendarEndMonth The latest month the user can navigate to.
 * @param props The DayPicker props, including `numberOfMonths`.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of dates representing the months to display.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDisplayMonths", ()=>getDisplayMonths);
function getDisplayMonths(firstDisplayedMonth, calendarEndMonth, props, dateLib) {
    const { numberOfMonths = 1 } = props;
    const months = [];
    for(let i = 0; i < numberOfMonths; i++){
        const month = dateLib.addMonths(firstDisplayedMonth, i);
        if (calendarEndMonth && month > calendarEndMonth) break;
        months.push(month);
    }
    return months;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9I2bl":[function(require,module,exports,__globalThis) {
/**
 * Determines the initial month to display in the calendar based on the provided
 * props.
 *
 * This function calculates the starting month, considering constraints such as
 * `startMonth`, `endMonth`, and the number of months to display.
 *
 * @param props The DayPicker props, including navigation and date constraints.
 * @param dateLib The date library to use for date manipulation.
 * @returns The initial month to display.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInitialMonth", ()=>getInitialMonth);
function getInitialMonth(props, navStart, navEnd, dateLib) {
    const { month, defaultMonth, today = dateLib.today(), numberOfMonths = 1 } = props;
    let initialMonth = month || defaultMonth || today;
    const { differenceInCalendarMonths, addMonths, startOfMonth } = dateLib;
    if (navEnd && differenceInCalendarMonths(navEnd, initialMonth) < numberOfMonths - 1) {
        const offset = -1 * (numberOfMonths - 1);
        initialMonth = addMonths(navEnd, offset);
    }
    if (navStart && differenceInCalendarMonths(initialMonth, navStart) < 0) initialMonth = navStart;
    return startOfMonth(initialMonth);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gzY8Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the months to display in the calendar.
 *
 * This function generates `CalendarMonth` objects for each month to be
 * displayed, including their weeks and days, based on the provided display
 * months and dates.
 *
 * @param displayMonths The months (as dates) to display in the calendar.
 * @param dates The dates to display in the calendar.
 * @param props Options from the DayPicker props context.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of `CalendarMonth` objects representing the months to
 *   display.
 */ parcelHelpers.export(exports, "getMonths", ()=>getMonths);
var _indexJs = require("../classes/index.js");
function getMonths(displayMonths, dates, props, dateLib) {
    const { addDays, endOfBroadcastWeek, endOfISOWeek, endOfMonth, endOfWeek, getISOWeek, getWeek, startOfBroadcastWeek, startOfISOWeek, startOfWeek } = dateLib;
    const dayPickerMonths = displayMonths.reduce((months, month)=>{
        const firstDateOfFirstWeek = props.broadcastCalendar ? startOfBroadcastWeek(month, dateLib) : props.ISOWeek ? startOfISOWeek(month) : startOfWeek(month);
        const lastDateOfLastWeek = props.broadcastCalendar ? endOfBroadcastWeek(month) : props.ISOWeek ? endOfISOWeek(endOfMonth(month)) : endOfWeek(endOfMonth(month));
        /** The dates to display in the month. */ const monthDates = dates.filter((date)=>{
            return date >= firstDateOfFirstWeek && date <= lastDateOfLastWeek;
        });
        const nrOfDaysWithFixedWeeks = props.broadcastCalendar ? 35 : 42;
        if (props.fixedWeeks && monthDates.length < nrOfDaysWithFixedWeeks) {
            const extraDates = dates.filter((date)=>{
                const daysToAdd = nrOfDaysWithFixedWeeks - monthDates.length;
                return date > lastDateOfLastWeek && date <= addDays(lastDateOfLastWeek, daysToAdd);
            });
            monthDates.push(...extraDates);
        }
        const weeks = monthDates.reduce((weeks, date)=>{
            const weekNumber = props.ISOWeek ? getISOWeek(date) : getWeek(date);
            const week = weeks.find((week)=>week.weekNumber === weekNumber);
            const day = new (0, _indexJs.CalendarDay)(date, month, dateLib);
            if (!week) weeks.push(new (0, _indexJs.CalendarWeek)(weekNumber, [
                day
            ]));
            else week.days.push(day);
            return weeks;
        }, []);
        const dayPickerMonth = new (0, _indexJs.CalendarMonth)(month, weeks);
        months.push(dayPickerMonth);
        return months;
    }, []);
    if (!props.reverseMonths) return dayPickerMonths;
    else return dayPickerMonths.reverse();
}

},{"../classes/index.js":[["CalendarDay","9JVVC"],["CalendarMonth","j3F4M"],["CalendarWeek","TlmoG"]],"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9JVVC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a day displayed in the calendar.
 *
 * In DayPicker, a `CalendarDay` is a wrapper around a `Date` object that
 * provides additional information about the day, such as whether it belongs to
 * the displayed month.
 */ parcelHelpers.export(exports, "CalendarDay", ()=>CalendarDay);
var _dateLibJs = require("./DateLib.js");
class CalendarDay {
    constructor(date, displayMonth, dateLib = (0, _dateLibJs.defaultDateLib)){
        this.date = date;
        this.displayMonth = displayMonth;
        this.outside = Boolean(displayMonth && !dateLib.isSameMonth(date, displayMonth));
        this.dateLib = dateLib;
    }
    /**
     * Checks if this day is equal to another `CalendarDay`, considering both the
     * date and the displayed month.
     *
     * @param day The `CalendarDay` to compare with.
     * @returns `true` if the days are equal, otherwise `false`.
     */ isEqualTo(day) {
        return this.dateLib.isSameDay(day.date, this.date) && this.dateLib.isSameMonth(day.displayMonth, this.displayMonth);
    }
}

},{"./DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"j3F4M":[function(require,module,exports,__globalThis) {
/**
 * Represents a month in a calendar year.
 *
 * A `CalendarMonth` contains the weeks within the month and the date of the
 * month.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarMonth", ()=>CalendarMonth);
class CalendarMonth {
    constructor(month, weeks){
        this.date = month;
        this.weeks = weeks;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"TlmoG":[function(require,module,exports,__globalThis) {
/**
 * Represents a week in a calendar month.
 *
 * A `CalendarWeek` contains the days within the week and the week number.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarWeek", ()=>CalendarWeek);
class CalendarWeek {
    constructor(weekNumber, days){
        this.days = days;
        this.weekNumber = weekNumber;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eT33y":[function(require,module,exports,__globalThis) {
/**
 * Returns the start and end months for calendar navigation.
 *
 * @param props The DayPicker props, including navigation and layout options.
 * @param dateLib The date library to use for date manipulation.
 * @returns A tuple containing the start and end months for navigation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNavMonths", ()=>getNavMonths);
function getNavMonths(props, dateLib) {
    let { startMonth, endMonth } = props;
    const { startOfYear, startOfDay, startOfMonth, endOfMonth, addYears, endOfYear, newDate, today } = dateLib;
    // Handle deprecated code
    const { fromYear, toYear, fromMonth, toMonth } = props;
    if (!startMonth && fromMonth) startMonth = fromMonth;
    if (!startMonth && fromYear) startMonth = dateLib.newDate(fromYear, 0, 1);
    if (!endMonth && toMonth) endMonth = toMonth;
    if (!endMonth && toYear) endMonth = newDate(toYear, 11, 31);
    const hasYearDropdown = props.captionLayout === "dropdown" || props.captionLayout === "dropdown-years";
    if (startMonth) startMonth = startOfMonth(startMonth);
    else if (fromYear) startMonth = newDate(fromYear, 0, 1);
    else if (!startMonth && hasYearDropdown) startMonth = startOfYear(addYears(props.today ?? today(), -100));
    if (endMonth) endMonth = endOfMonth(endMonth);
    else if (toYear) endMonth = newDate(toYear, 11, 31);
    else if (!endMonth && hasYearDropdown) endMonth = endOfYear(props.today ?? today());
    return [
        startMonth ? startOfDay(startMonth) : startMonth,
        endMonth ? startOfDay(endMonth) : endMonth
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eDtvr":[function(require,module,exports,__globalThis) {
/**
 * Returns the next month the user can navigate to, based on the given options.
 *
 * The next month is not always the next calendar month:
 *
 * - If it is after the `calendarEndMonth`, it returns `undefined`.
 * - If paged navigation is enabled, it skips forward by the number of displayed
 *   months.
 *
 * @param firstDisplayedMonth The first month currently displayed in the
 *   calendar.
 * @param calendarEndMonth The latest month the user can navigate to.
 * @param options Navigation options, including `numberOfMonths` and
 *   `pagedNavigation`.
 * @param dateLib The date library to use for date manipulation.
 * @returns The next month, or `undefined` if navigation is not possible.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNextMonth", ()=>getNextMonth);
function getNextMonth(firstDisplayedMonth, calendarEndMonth, options, dateLib) {
    if (options.disableNavigation) return undefined;
    const { pagedNavigation, numberOfMonths = 1 } = options;
    const { startOfMonth, addMonths, differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? numberOfMonths : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarEndMonth) return addMonths(month, offset);
    const monthsDiff = differenceInCalendarMonths(calendarEndMonth, firstDisplayedMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    return addMonths(month, offset);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"h6P7O":[function(require,module,exports,__globalThis) {
/**
 * Returns the previous month the user can navigate to, based on the given
 * options.
 *
 * The previous month is not always the previous calendar month:
 *
 * - If it is before the `calendarStartMonth`, it returns `undefined`.
 * - If paged navigation is enabled, it skips back by the number of displayed
 *   months.
 *
 * @param firstDisplayedMonth The first month currently displayed in the
 *   calendar.
 * @param calendarStartMonth The earliest month the user can navigate to.
 * @param options Navigation options, including `numberOfMonths` and
 *   `pagedNavigation`.
 * @param dateLib The date library to use for date manipulation.
 * @returns The previous month, or `undefined` if navigation is not possible.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPreviousMonth", ()=>getPreviousMonth);
function getPreviousMonth(firstDisplayedMonth, calendarStartMonth, options, dateLib) {
    if (options.disableNavigation) return undefined;
    const { pagedNavigation, numberOfMonths } = options;
    const { startOfMonth, addMonths, differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? numberOfMonths ?? 1 : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarStartMonth) return addMonths(month, -offset);
    const monthsDiff = differenceInCalendarMonths(month, calendarStartMonth);
    if (monthsDiff <= 0) return undefined;
    return addMonths(month, -offset);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jh39U":[function(require,module,exports,__globalThis) {
/**
 * Returns an array of calendar weeks from an array of calendar months.
 *
 * @param months The array of calendar months.
 * @returns An array of calendar weeks.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWeeks", ()=>getWeeks);
function getWeeks(months) {
    const initialWeeks = [];
    return months.reduce((weeks, month)=>{
        return weeks.concat(month.weeks.slice());
    }, initialWeeks.slice());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5XtBl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A custom hook for managing both controlled and uncontrolled component states.
 *
 * This hook allows a component to support both controlled and uncontrolled
 * states by determining whether the `controlledValue` is provided. If it is
 * undefined, the hook falls back to using the internal state.
 *
 * @example
 *   // Uncontrolled usage
 *   const [value, setValue] = useControlledValue(0, undefined);
 *
 *   // Controlled usage
 *   const [value, setValue] = useControlledValue(0, props.value);
 *
 * @template T - The type of the value.
 * @param defaultValue The initial value for the uncontrolled state.
 * @param controlledValue The value for the controlled state. If undefined, the
 *   component will use the uncontrolled state.
 * @returns A tuple where the first element is the current value (either
 *   controlled or uncontrolled) and the second element is a setter function to
 *   update the value.
 */ parcelHelpers.export(exports, "useControlledValue", ()=>useControlledValue);
var _react = require("react");
function useControlledValue(defaultValue, controlledValue) {
    const [uncontrolledValue, setValue] = (0, _react.useState)(defaultValue);
    const value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"78xEB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages focus behavior for the DayPicker component, including setting,
 * moving, and blurring focus on calendar days.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param calendar - The calendar object containing the displayed days and
 *   months.
 * @param getModifiers - A function to retrieve modifiers for a given day.
 * @param isSelected - A function to check if a date is selected.
 * @param dateLib - The date utility library instance.
 * @returns An object containing focus-related methods and the currently focused
 *   day.
 */ parcelHelpers.export(exports, "useFocus", ()=>useFocus);
var _react = require("react");
var _calculateFocusTargetJs = require("./helpers/calculateFocusTarget.js");
var _getNextFocusJs = require("./helpers/getNextFocus.js");
function useFocus(props, calendar, getModifiers, isSelected, dateLib) {
    const { autoFocus } = props;
    const [lastFocused, setLastFocused] = (0, _react.useState)();
    const focusTarget = (0, _calculateFocusTargetJs.calculateFocusTarget)(calendar.days, getModifiers, isSelected || (()=>false), lastFocused);
    const [focusedDay, setFocused] = (0, _react.useState)(autoFocus ? focusTarget : undefined);
    const blur = ()=>{
        setLastFocused(focusedDay);
        setFocused(undefined);
    };
    const moveFocus = (moveBy, moveDir)=>{
        if (!focusedDay) return;
        const nextFocus = (0, _getNextFocusJs.getNextFocus)(moveBy, moveDir, focusedDay, calendar.navStart, calendar.navEnd, props, dateLib);
        if (!nextFocus) return;
        if (props.disableNavigation) {
            const isNextInCalendar = calendar.days.some((day)=>day.isEqualTo(nextFocus));
            if (!isNextInCalendar) return;
        }
        calendar.goToDay(nextFocus);
        setFocused(nextFocus);
    };
    const isFocusTarget = (day)=>{
        return Boolean(focusTarget?.isEqualTo(day));
    };
    const useFocus = {
        isFocusTarget,
        setFocused,
        focused: focusedDay,
        blur,
        moveFocus
    };
    return useFocus;
}

},{"react":"IMRgT","./helpers/calculateFocusTarget.js":"607jr","./helpers/getNextFocus.js":"gASLk","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"607jr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Calculates the focus target day based on priority.
 *
 * This function determines the day that should receive focus in the calendar,
 * prioritizing days with specific modifiers (e.g., "focused", "today") or
 * selection states.
 *
 * @param days The array of `CalendarDay` objects to evaluate.
 * @param getModifiers A function to retrieve the modifiers for a given day.
 * @param isSelected A function to determine if a day is selected.
 * @param lastFocused The last focused day, if any.
 * @returns The `CalendarDay` that should receive focus, or `undefined` if no
 *   focusable day is found.
 */ parcelHelpers.export(exports, "calculateFocusTarget", ()=>calculateFocusTarget);
var _uiJs = require("../UI.js");
var FocusTargetPriority;
(function(FocusTargetPriority) {
    FocusTargetPriority[FocusTargetPriority["Today"] = 0] = "Today";
    FocusTargetPriority[FocusTargetPriority["Selected"] = 1] = "Selected";
    FocusTargetPriority[FocusTargetPriority["LastFocused"] = 2] = "LastFocused";
    FocusTargetPriority[FocusTargetPriority["FocusedModifier"] = 3] = "FocusedModifier";
})(FocusTargetPriority || (FocusTargetPriority = {}));
/**
 * Determines if a day is focusable based on its modifiers.
 *
 * A day is considered focusable if it is not disabled, hidden, or outside the
 * displayed month.
 *
 * @param modifiers The modifiers applied to the day.
 * @returns `true` if the day is focusable, otherwise `false`.
 */ function isFocusableDay(modifiers) {
    return !modifiers[(0, _uiJs.DayFlag).disabled] && !modifiers[(0, _uiJs.DayFlag).hidden] && !modifiers[(0, _uiJs.DayFlag).outside];
}
function calculateFocusTarget(days, getModifiers, isSelected, lastFocused) {
    let focusTarget;
    let foundFocusTargetPriority = -1;
    for (const day of days){
        const modifiers = getModifiers(day);
        if (isFocusableDay(modifiers)) {
            if (modifiers[(0, _uiJs.DayFlag).focused] && foundFocusTargetPriority < FocusTargetPriority.FocusedModifier) {
                focusTarget = day;
                foundFocusTargetPriority = FocusTargetPriority.FocusedModifier;
            } else if (lastFocused?.isEqualTo(day) && foundFocusTargetPriority < FocusTargetPriority.LastFocused) {
                focusTarget = day;
                foundFocusTargetPriority = FocusTargetPriority.LastFocused;
            } else if (isSelected(day.date) && foundFocusTargetPriority < FocusTargetPriority.Selected) {
                focusTarget = day;
                foundFocusTargetPriority = FocusTargetPriority.Selected;
            } else if (modifiers[(0, _uiJs.DayFlag).today] && foundFocusTargetPriority < FocusTargetPriority.Today) {
                focusTarget = day;
                foundFocusTargetPriority = FocusTargetPriority.Today;
            }
        }
    }
    if (!focusTarget) // Return the first day that is focusable
    focusTarget = days.find((day)=>isFocusableDay(getModifiers(day)));
    return focusTarget;
}

},{"../UI.js":"7f59g","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gASLk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines the next focusable day in the calendar.
 *
 * This function recursively calculates the next focusable day based on the
 * movement direction and modifiers applied to the days.
 *
 * @param moveBy The unit of movement (e.g., "day", "week").
 * @param moveDir The direction of movement ("before" or "after").
 * @param refDay The currently focused day.
 * @param calendarStartMonth The earliest month the user can navigate to.
 * @param calendarEndMonth The latest month the user can navigate to.
 * @param props The DayPicker props, including modifiers and configuration
 *   options.
 * @param dateLib The date library to use for date manipulation.
 * @param attempt The current recursion attempt (used to limit recursion depth).
 * @returns The next focusable day, or `undefined` if no focusable day is found.
 */ parcelHelpers.export(exports, "getNextFocus", ()=>getNextFocus);
var _indexJs = require("../classes/index.js");
var _dateMatchModifiersJs = require("../utils/dateMatchModifiers.js");
var _getFocusableDateJs = require("./getFocusableDate.js");
function getNextFocus(moveBy, moveDir, refDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt = 0) {
    if (attempt > 365) // Limit the recursion to 365 attempts
    return undefined;
    const focusableDate = (0, _getFocusableDateJs.getFocusableDate)(moveBy, moveDir, refDay.date, calendarStartMonth, calendarEndMonth, props, dateLib);
    const isDisabled = Boolean(props.disabled && (0, _dateMatchModifiersJs.dateMatchModifiers)(focusableDate, props.disabled, dateLib));
    const isHidden = Boolean(props.hidden && (0, _dateMatchModifiersJs.dateMatchModifiers)(focusableDate, props.hidden, dateLib));
    const targetMonth = focusableDate;
    const focusDay = new (0, _indexJs.CalendarDay)(focusableDate, targetMonth, dateLib);
    if (!isDisabled && !isHidden) return focusDay;
    // Recursively attempt to find the next focusable date
    return getNextFocus(moveBy, moveDir, focusDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt + 1);
}

},{"../classes/index.js":"9JVVC","../utils/dateMatchModifiers.js":"6RjDL","./getFocusableDate.js":"gCw9e","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gCw9e":[function(require,module,exports,__globalThis) {
/**
 * Calculates the next date that should be focused in the calendar.
 *
 * This function determines the next focusable date based on the movement
 * direction, constraints, and calendar configuration.
 *
 * @param moveBy The unit of movement (e.g., "day", "week").
 * @param moveDir The direction of movement ("before" or "after").
 * @param refDate The reference date from which to calculate the next focusable
 *   date.
 * @param navStart The earliest date the user can navigate to.
 * @param navEnd The latest date the user can navigate to.
 * @param props The DayPicker props, including calendar configuration options.
 * @param dateLib The date library to use for date manipulation.
 * @returns The next focusable date.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFocusableDate", ()=>getFocusableDate);
function getFocusableDate(moveBy, moveDir, refDate, navStart, navEnd, props, dateLib) {
    const { ISOWeek, broadcastCalendar } = props;
    const { addDays, addMonths, addWeeks, addYears, endOfBroadcastWeek, endOfISOWeek, endOfWeek, max, min, startOfBroadcastWeek, startOfISOWeek, startOfWeek } = dateLib;
    const moveFns = {
        day: addDays,
        week: addWeeks,
        month: addMonths,
        year: addYears,
        startOfWeek: (date)=>broadcastCalendar ? startOfBroadcastWeek(date, dateLib) : ISOWeek ? startOfISOWeek(date) : startOfWeek(date),
        endOfWeek: (date)=>broadcastCalendar ? endOfBroadcastWeek(date) : ISOWeek ? endOfISOWeek(date) : endOfWeek(date)
    };
    let focusableDate = moveFns[moveBy](refDate, moveDir === "after" ? 1 : -1);
    if (moveDir === "before" && navStart) focusableDate = max([
        navStart,
        focusableDate
    ]);
    else if (moveDir === "after" && navEnd) focusableDate = min([
        navEnd,
        focusableDate
    ]);
    return focusableDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bim9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines the appropriate selection hook to use based on the selection mode
 * and returns the corresponding selection object.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns The selection object for the specified mode, or `undefined` if no
 *   mode is set.
 */ parcelHelpers.export(exports, "useSelection", ()=>useSelection);
var _useMultiJs = require("./selection/useMulti.js");
var _useRangeJs = require("./selection/useRange.js");
var _useSingleJs = require("./selection/useSingle.js");
function useSelection(props, dateLib) {
    const single = (0, _useSingleJs.useSingle)(props, dateLib);
    const multi = (0, _useMultiJs.useMulti)(props, dateLib);
    const range = (0, _useRangeJs.useRange)(props, dateLib);
    switch(props.mode){
        case "single":
            return single;
        case "multiple":
            return multi;
        case "range":
            return range;
        default:
            return undefined;
    }
}

},{"./selection/useMulti.js":"lP8bu","./selection/useRange.js":"2eXaH","./selection/useSingle.js":"k5Iqm","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lP8bu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook to manage multiple-date selection in the DayPicker component.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns An object containing the selected dates, a function to select dates,
 *   and a function to check if a date is selected.
 */ parcelHelpers.export(exports, "useMulti", ()=>useMulti);
var _useControlledValueJs = require("../helpers/useControlledValue.js");
function useMulti(props, dateLib) {
    const { selected: initiallySelected, required, onSelect } = props;
    const [internallySelected, setSelected] = (0, _useControlledValueJs.useControlledValue)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay } = dateLib;
    const isSelected = (date)=>{
        return selected?.some((d)=>isSameDay(d, date)) ?? false;
    };
    const { min, max } = props;
    const select = (triggerDate, modifiers, e)=>{
        let newDates = [
            ...selected ?? []
        ];
        if (isSelected(triggerDate)) {
            if (selected?.length === min) // Min value reached, do nothing
            return;
            if (required && selected?.length === 1) // Required value already selected do nothing
            return;
            newDates = selected?.filter((d)=>!isSameDay(d, triggerDate));
        } else if (selected?.length === max) // Max value reached, reset the selection to date
        newDates = [
            triggerDate
        ];
        else // Add the date to the selection
        newDates = [
            ...newDates,
            triggerDate
        ];
        if (!onSelect) setSelected(newDates);
        onSelect?.(newDates, triggerDate, modifiers, e);
        return newDates;
    };
    return {
        selected,
        select,
        isSelected
    };
}

},{"../helpers/useControlledValue.js":"5XtBl","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2eXaH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook to manage range selection in the DayPicker component.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns An object containing the selected range, a function to select a
 *   range, and a function to check if a date is within the range.
 */ parcelHelpers.export(exports, "useRange", ()=>useRange);
var _useControlledValueJs = require("../helpers/useControlledValue.js");
var _indexJs = require("../utils/index.js");
var _rangeIncludesDateJs = require("../utils/rangeIncludesDate.js");
function useRange(props, dateLib) {
    const { disabled, excludeDisabled, selected: initiallySelected, required, onSelect } = props;
    const [internallySelected, setSelected] = (0, _useControlledValueJs.useControlledValue)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const isSelected = (date)=>selected && (0, _rangeIncludesDateJs.rangeIncludesDate)(selected, date, false, dateLib);
    const select = (triggerDate, modifiers, e)=>{
        const { min, max } = props;
        const newRange = triggerDate ? (0, _indexJs.addToRange)(triggerDate, selected, min, max, required, dateLib) : undefined;
        if (excludeDisabled && disabled && newRange?.from && newRange.to) {
            if ((0, _indexJs.rangeContainsModifiers)({
                from: newRange.from,
                to: newRange.to
            }, disabled, dateLib)) {
                // if a disabled days is found, the range is reset
                newRange.from = triggerDate;
                newRange.to = undefined;
            }
        }
        if (!onSelect) setSelected(newRange);
        onSelect?.(newRange, triggerDate, modifiers, e);
        return newRange;
    };
    return {
        selected,
        select,
        isSelected
    };
}

},{"../helpers/useControlledValue.js":"5XtBl","../utils/index.js":[["addToRange","dKmLf"],["rangeContainsModifiers","cWZi8"]],"../utils/rangeIncludesDate.js":"aWwuo","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dKmLf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Adds a date to an existing range, considering constraints like minimum and
 * maximum range size.
 *
 * @param date - The date to add to the range.
 * @param initialRange - The initial range to which the date will be added.
 * @param min - The minimum number of days in the range.
 * @param max - The maximum number of days in the range.
 * @param required - Whether the range must always include at least one date.
 * @param dateLib - The date utility library instance.
 * @returns The updated date range, or `undefined` if the range is cleared.
 * @group Utilities
 */ parcelHelpers.export(exports, "addToRange", ()=>addToRange);
var _dateLibJs = require("../classes/DateLib.js");
function addToRange(date, initialRange, min = 0, max = 0, required = false, dateLib = (0, _dateLibJs.defaultDateLib)) {
    const { from, to } = initialRange || {};
    const { isSameDay, isAfter, isBefore } = dateLib;
    let range;
    if (!from && !to) // the range is empty, add the date
    range = {
        from: date,
        to: min > 0 ? undefined : date
    };
    else if (from && !to) {
        // adding date to an incomplete range
        if (isSameDay(from, date)) {
            // adding a date equal to the start of the range
            if (min === 0) range = {
                from,
                to: date
            };
            else if (required) range = {
                from,
                to: undefined
            };
            else range = undefined;
        } else if (isBefore(date, from)) // adding a date before the start of the range
        range = {
            from: date,
            to: from
        };
        else // adding a date after the start of the range
        range = {
            from,
            to: date
        };
    } else if (from && to) {
        // adding date to a complete range
        if (isSameDay(from, date) && isSameDay(to, date)) {
            // adding a date that is equal to both start and end of the range
            if (required) range = {
                from,
                to
            };
            else range = undefined;
        } else if (isSameDay(from, date)) // adding a date equal to the the start of the range
        range = {
            from,
            to: min > 0 ? undefined : date
        };
        else if (isSameDay(to, date)) // adding a dare equal to the end of the range
        range = {
            from: date,
            to: min > 0 ? undefined : date
        };
        else if (isBefore(date, from)) // adding a date before the start of the range
        range = {
            from: date,
            to: to
        };
        else if (isAfter(date, from)) // adding a date after the start of the range
        range = {
            from,
            to: date
        };
        else if (isAfter(date, to)) // adding a date after the end of the range
        range = {
            from,
            to: date
        };
        else throw new Error("Invalid range");
    }
    // check for min / max
    if (range?.from && range?.to) {
        const diff = dateLib.differenceInCalendarDays(range.to, range.from);
        if (max > 0 && diff > max) range = {
            from: date,
            to: undefined
        };
        else if (min > 1 && diff < min) range = {
            from: date,
            to: undefined
        };
    }
    return range;
}

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cWZi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a date range contains dates that match the given modifiers.
 *
 * @since 9.2.2
 * @param range - The date range to check.
 * @param modifiers - The modifiers to match against.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the range contains matching dates, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "rangeContainsModifiers", ()=>rangeContainsModifiers);
var _dateLibJs = require("../classes/DateLib.js");
var _dateMatchModifiersJs = require("./dateMatchModifiers.js");
var _rangeContainsDayOfWeekJs = require("./rangeContainsDayOfWeek.js");
var _rangeIncludesDateJs = require("./rangeIncludesDate.js");
var _rangeOverlapsJs = require("./rangeOverlaps.js");
var _typeguardsJs = require("./typeguards.js");
function rangeContainsModifiers(range, modifiers, dateLib = (0, _dateLibJs.defaultDateLib)) {
    const matchers = Array.isArray(modifiers) ? modifiers : [
        modifiers
    ];
    // Defer function matchers evaluation as they are the least performant.
    const nonFunctionMatchers = matchers.filter((matcher)=>typeof matcher !== "function");
    const nonFunctionMatchersResult = nonFunctionMatchers.some((matcher)=>{
        if (typeof matcher === "boolean") return matcher;
        if (dateLib.isDate(matcher)) return (0, _rangeIncludesDateJs.rangeIncludesDate)(range, matcher, false, dateLib);
        if ((0, _typeguardsJs.isDatesArray)(matcher, dateLib)) return matcher.some((date)=>(0, _rangeIncludesDateJs.rangeIncludesDate)(range, date, false, dateLib));
        if ((0, _typeguardsJs.isDateRange)(matcher)) {
            if (matcher.from && matcher.to) return (0, _rangeOverlapsJs.rangeOverlaps)(range, {
                from: matcher.from,
                to: matcher.to
            }, dateLib);
            return false;
        }
        if ((0, _typeguardsJs.isDayOfWeekType)(matcher)) return (0, _rangeContainsDayOfWeekJs.rangeContainsDayOfWeek)(range, matcher.dayOfWeek, dateLib);
        if ((0, _typeguardsJs.isDateInterval)(matcher)) {
            const isClosedInterval = dateLib.isAfter(matcher.before, matcher.after);
            if (isClosedInterval) return (0, _rangeOverlapsJs.rangeOverlaps)(range, {
                from: dateLib.addDays(matcher.after, 1),
                to: dateLib.addDays(matcher.before, -1)
            }, dateLib);
            return (0, _dateMatchModifiersJs.dateMatchModifiers)(range.from, matcher, dateLib) || (0, _dateMatchModifiersJs.dateMatchModifiers)(range.to, matcher, dateLib);
        }
        if ((0, _typeguardsJs.isDateAfterType)(matcher) || (0, _typeguardsJs.isDateBeforeType)(matcher)) return (0, _dateMatchModifiersJs.dateMatchModifiers)(range.from, matcher, dateLib) || (0, _dateMatchModifiersJs.dateMatchModifiers)(range.to, matcher, dateLib);
        return false;
    });
    if (nonFunctionMatchersResult) return true;
    const functionMatchers = matchers.filter((matcher)=>typeof matcher === "function");
    if (functionMatchers.length) {
        let date = range.from;
        const totalDays = dateLib.differenceInCalendarDays(range.to, range.from);
        for(let i = 0; i <= totalDays; i++){
            if (functionMatchers.some((matcher)=>matcher(date))) return true;
            date = dateLib.addDays(date, 1);
        }
    }
    return false;
}

},{"../classes/DateLib.js":"l7QE0","./dateMatchModifiers.js":"6RjDL","./rangeContainsDayOfWeek.js":"3P5V9","./rangeIncludesDate.js":"aWwuo","./rangeOverlaps.js":"jnNnB","./typeguards.js":"4HpfU","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3P5V9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a date range contains one or more specified days of the week.
 *
 * @since 9.2.2
 * @param range - The date range to check.
 * @param dayOfWeek - The day(s) of the week to check for (`0-6`, where `0` is
 *   Sunday).
 * @param dateLib - The date utility library instance.
 * @returns `true` if the range contains the specified day(s) of the week,
 *   otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "rangeContainsDayOfWeek", ()=>rangeContainsDayOfWeek);
var _dateLibJs = require("../classes/DateLib.js");
function rangeContainsDayOfWeek(range, dayOfWeek, dateLib = (0, _dateLibJs.defaultDateLib)) {
    const dayOfWeekArr = !Array.isArray(dayOfWeek) ? [
        dayOfWeek
    ] : dayOfWeek;
    let date = range.from;
    const totalDays = dateLib.differenceInCalendarDays(range.to, range.from);
    // iterate at maximum one week or the total days if the range is shorter than one week
    const totalDaysLimit = Math.min(totalDays, 6);
    for(let i = 0; i <= totalDaysLimit; i++){
        if (dayOfWeekArr.includes(date.getDay())) return true;
        date = dateLib.addDays(date, 1);
    }
    return false;
}

},{"../classes/DateLib.js":"l7QE0","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jnNnB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines if two date ranges overlap.
 *
 * @since 9.2.2
 * @param rangeLeft - The first date range.
 * @param rangeRight - The second date range.
 * @param dateLib - The date utility library instance.
 * @returns `true` if the ranges overlap, otherwise `false`.
 * @group Utilities
 */ parcelHelpers.export(exports, "rangeOverlaps", ()=>rangeOverlaps);
var _indexJs = require("../classes/index.js");
var _rangeIncludesDateJs = require("./rangeIncludesDate.js");
function rangeOverlaps(rangeLeft, rangeRight, dateLib = (0, _indexJs.defaultDateLib)) {
    return (0, _rangeIncludesDateJs.rangeIncludesDate)(rangeLeft, rangeRight.from, false, dateLib) || (0, _rangeIncludesDateJs.rangeIncludesDate)(rangeLeft, rangeRight.to, false, dateLib) || (0, _rangeIncludesDateJs.rangeIncludesDate)(rangeRight, rangeLeft.from, false, dateLib) || (0, _rangeIncludesDateJs.rangeIncludesDate)(rangeRight, rangeLeft.to, false, dateLib);
}

},{"../classes/index.js":"l7QE0","./rangeIncludesDate.js":"aWwuo","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"k5Iqm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook to manage single-date selection in the DayPicker component.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns An object containing the selected date, a function to select a date,
 *   and a function to check if a date is selected.
 */ parcelHelpers.export(exports, "useSingle", ()=>useSingle);
var _useControlledValueJs = require("../helpers/useControlledValue.js");
function useSingle(props, dateLib) {
    const { selected: initiallySelected, required, onSelect } = props;
    const [internallySelected, setSelected] = (0, _useControlledValueJs.useControlledValue)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay } = dateLib;
    const isSelected = (compareDate)=>{
        return selected ? isSameDay(selected, compareDate) : false;
    };
    const select = (triggerDate, modifiers, e)=>{
        let newDate = triggerDate;
        if (!required && selected && selected && isSameDay(triggerDate, selected)) // If the date is the same, clear the selection.
        newDate = undefined;
        if (!onSelect) setSelected(newDate);
        if (required) onSelect?.(newDate, triggerDate, modifiers, e);
        else onSelect?.(newDate, triggerDate, modifiers, e);
        return newDate;
    };
    return {
        selected,
        select,
        isSelected
    };
}

},{"../helpers/useControlledValue.js":"5XtBl","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iHziy":[function() {},{}],"bT1Cg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimePicker", ()=>TimePicker);
parcelHelpers.export(exports, "TimePickerPortal", ()=>TimePickerPortal);
parcelHelpers.export(exports, "TimePickerDesktop", ()=>TimePickerDesktop);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _creatable = require("react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
var _luxon = require("luxon");
var _dashboardUtils = require("../dashboard_utils");
const ONE_MINUTE_MS = 60000;
const ONE_HOUR_MS = ONE_MINUTE_MS * 60;
const one_day_ms = ONE_HOUR_MS * 24;
const FIFTEEN_MIN_MS = ONE_MINUTE_MS * 15;
const SELECT_OPTION_INTERVAL = FIFTEEN_MIN_MS;
function TimePicker(props) {
    if ((0, _dashboardUtils.DashboardUtils).IsMobileOS()) {
        const locale = _luxon.DateTime.local().locale;
        const value = msToTimeDropdownData(props.initial_value_ms, locale, true);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: props.disabled ? "input-disabled" : "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "mobile-date-picker",
                type: "time",
                value: value.label,
                onChange: (event)=>{
                    if (event.target?.valueAsDate) props.updateFunc(event.target.valueAsDate.getTime());
                },
                disabled: props.disabled
            })
        });
    } else return props.portal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimePickerPortal, {
        intial_value_ms: props.initial_value_ms,
        updateFunc: props.updateFunc,
        disabled: props.disabled
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimePickerDesktop, {
        intial_value_ms: props.initial_value_ms,
        updateFunc: props.updateFunc,
        disabled: props.disabled
    });
}
function localeUses24HourTime(langCode) {
    const meridien_value = new Intl.DateTimeFormat(langCode, {
        hour: "numeric"
    }).formatToParts(new Date()).find((part)=>part.type === "dayPeriod")?.value?.toLowerCase();
    return meridien_value !== "am" && meridien_value !== "pm";
}
function getTimesToDisplay() {
    const results = new Map();
    const locale = _luxon.DateTime.local().locale;
    const uses_24hr_time = localeUses24HourTime(locale);
    let current_ms = 0;
    while(current_ms < one_day_ms){
        const dropdown_data = msToTimeDropdownData(current_ms, locale, uses_24hr_time);
        results.set(dropdown_data.value, dropdown_data);
        current_ms += SELECT_OPTION_INTERVAL;
    }
    return results;
}
function padNumber(number) {
    if (number.toString().length === 1) return `0${number}`;
    return number.toString();
}
function msToTimeDropdownData(ms, locale, uses_24hr_time) {
    const current_hour = Math.floor(ms / ONE_HOUR_MS);
    const current_minute = Math.floor((ms - current_hour * ONE_HOUR_MS) / ONE_MINUTE_MS);
    const minute_string = padNumber(current_minute);
    let display_string;
    if (uses_24hr_time) {
        const hour_string = padNumber(current_hour);
        display_string = `${hour_string}:${minute_string}`;
    } else {
        const meridien = current_hour < 12 ? "am" : "pm";
        let hour_string;
        if (current_hour % 12 === 0) hour_string = "12";
        else hour_string = padNumber(current_hour % 12);
        display_string = `${hour_string}:${minute_string}${meridien}`;
    }
    return {
        value: ms,
        label: display_string
    };
}
function parseTime(time_input) {
    const locale = _luxon.DateTime.local().locale;
    const uses_24hr_time = localeUses24HourTime(locale);
    const time_components = time_input.split(":");
    const hour_raw = time_components[0];
    if (!hour_raw || hour_raw.length === 0 || hour_raw.length > 2) return;
    let parsed_hour = Number.parseInt(hour_raw);
    if (Number.isNaN(parsed_hour)) return;
    if (parsed_hour < 0) return;
    if (uses_24hr_time) {
        if (parsed_hour >= 24) return;
    } else {
        if (parsed_hour > 12 || parsed_hour === 0) return;
    }
    const minute_raw = time_components[1]?.substring(0, 2);
    if (!minute_raw || minute_raw.length < 2) return;
    const parsed_minute = Number.parseInt(minute_raw);
    if (Number.isNaN(parsed_minute)) return;
    if (parsed_minute < 0 || parsed_minute >= 60) return;
    if (uses_24hr_time) {
        const ms = parsed_hour * ONE_HOUR_MS + parsed_minute * ONE_MINUTE_MS;
        return msToTimeDropdownData(ms, locale, uses_24hr_time);
    } else {
        let meridien_raw = time_components[1]?.substring(2)?.toLowerCase();
        if (parsed_hour === 12) parsed_hour = 0;
        let ms;
        if (meridien_raw.includes("pm")) ms = ONE_HOUR_MS * 12 + parsed_hour * ONE_HOUR_MS + parsed_minute * ONE_MINUTE_MS;
        else ms = parsed_hour * ONE_HOUR_MS + parsed_minute * ONE_MINUTE_MS;
        return msToTimeDropdownData(ms, locale, uses_24hr_time);
    }
}
function getIndexToInsertNewTimeAt(new_time_ms, existing_options) {
    let start_index = 0;
    let end_index = existing_options.length - 1;
    while(start_index < end_index){
        const current_index = Math.floor((start_index + end_index) / 2);
        const current_value = existing_options[current_index];
        if (current_value.value <= new_time_ms) start_index = current_index + 1;
        else end_index = current_index - 1;
    }
    const value = existing_options[start_index];
    return new_time_ms < value.value ? start_index : start_index + 1;
}
function TimePickerPortal(props) {
    const containerRef = (0, _react.useRef)(null);
    // Create the desktop picker but using a state handler to manage the selected time
    const [selectedTime, setSelectedTime] = (0, _react.useState)(null);
    const times_to_display_map = getTimesToDisplay();
    const times_to_display_array = [];
    times_to_display_map.forEach((val)=>times_to_display_array.push(val));
    // Setup the time picker on first render
    (0, _react.useEffect)(()=>{
        if (props.intial_value_ms != null) {
            // get ms ignoring ms and seconds
            const true_ms = _luxon.DateTime.fromMillis(props.intial_value_ms).set({
                second: 0,
                millisecond: 0
            }).toMillis() % one_day_ms;
            // Find the closest option
            const locale = _luxon.DateTime.local().locale;
            const uses_24hr_time = localeUses24HourTime(locale);
            const time_data = msToTimeDropdownData(true_ms, locale, uses_24hr_time);
            setSelectedTime(time_data);
        }
    }, [
        props.intial_value_ms
    ]);
    const handleChange = (time)=>{
        if (time) {
            setSelectedTime(time);
            props.updateFunc(time.value);
        }
    };
    const handleMenuOpen = ()=>{
        // Scroll the selected element into view when menu opens
        setTimeout(()=>{
            const selectedElement = document.querySelector(".sesh-dropdown__option--is-selected");
            if (selectedElement) selectedElement.scrollIntoView({
                behavior: "auto",
                block: "center"
            });
        }, 0);
    };
    const isValidNewOption = (input_value)=>{
        const parsed_time_data = parseTime(input_value);
        return Boolean(parsed_time_data) && !times_to_display_map.has(parsed_time_data.value);
    };
    const formatCreateLabel = (input_value)=>{
        return parseTime(input_value)?.label;
    };
    const onCreateOption = (input_value)=>{
        const parsed_time_data = parseTime(input_value);
        if (!parsed_time_data) return;
        handleChange(parsed_time_data);
    };
    // Custom styles for react-select to use portaled menu
    const customStyles = {
        menu: (provided)=>({
                ...provided,
                zIndex: 9999
            }),
        menuPortal: (provided)=>({
                ...provided,
                zIndex: 9999
            })
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "has-text-left",
        ref: containerRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creatableDefault.default), {
            isDisabled: props.disabled,
            inputId: "select-input",
            classNamePrefix: "sesh-dropdown",
            value: times_to_display_array.find((val)=>val.value === props.intial_value_ms),
            isSearchable: true,
            options: times_to_display_array,
            onChange: handleChange,
            onMenuOpen: handleMenuOpen,
            isValidNewOption: isValidNewOption,
            onCreateOption: onCreateOption,
            formatCreateLabel: formatCreateLabel,
            styles: customStyles,
            menuPortalTarget: document.body,
            menuPosition: "fixed",
            menuPlacement: "auto"
        })
    });
}
class TimePickerDesktop extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        const times_to_display_map = getTimesToDisplay();
        const times_to_display_array = [];
        times_to_display_map.forEach((val)=>times_to_display_array.push(val));
        let initial_value;
        if (this.props.intial_value_ms != null) {
            // get ms ignoring ms and seconds
            const true_ms = _luxon.DateTime.fromMillis(this.props.intial_value_ms).set({
                second: 0,
                millisecond: 0
            }).toMillis() % one_day_ms;
            if (times_to_display_map.has(true_ms)) initial_value = times_to_display_map.get(true_ms);
            else {
                const index_to_insert_at = getIndexToInsertNewTimeAt(true_ms, times_to_display_array);
                const locale = _luxon.DateTime.local().locale;
                const uses_24hr_time = localeUses24HourTime(locale);
                initial_value = msToTimeDropdownData(true_ms, locale, uses_24hr_time);
                times_to_display_array.splice(index_to_insert_at, 0, initial_value);
            }
        } else initial_value = times_to_display_array[0];
        this.state = {
            previous_option: undefined,
            selected_time: initial_value,
            time_options: times_to_display_array,
            time_options_map: times_to_display_map
        };
        this.handleChange = this.handleChange.bind(this);
        this.onCreateOption = this.onCreateOption.bind(this);
        this.isValidNewOption = this.isValidNewOption.bind(this);
    }
    handleChange(date) {
        this.setState({
            selected_time: date
        });
        this.props.updateFunc(date.value);
    }
    formatCreateLabel(input_value) {
        return parseTime(input_value)?.label;
    }
    onCreateOption(input_value) {
        const parsed_time_data = parseTime(input_value);
        if (!parsed_time_data) return;
        this.setState((prevState)=>{
            const index_to_insert_at = getIndexToInsertNewTimeAt(parsed_time_data.value, this.state.time_options);
            prevState.time_options.splice(index_to_insert_at, 0, parsed_time_data);
            prevState.time_options_map.set(parsed_time_data.value, parsed_time_data);
            this.props.updateFunc(parsed_time_data.value);
            return {
                ...prevState,
                selected_time: parsed_time_data
            };
        });
    }
    isValidNewOption(input_value) {
        const parsed_time_data = parseTime(input_value);
        return Boolean(parsed_time_data) && !this.state.time_options_map.has(parsed_time_data.value);
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "has-text-left",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creatableDefault.default), {
                isDisabled: this.props.disabled,
                inputId: "select-input",
                classNamePrefix: "sesh-dropdown",
                value: this.state.selected_time,
                isSearchable: true,
                options: this.state.time_options,
                onChange: this.handleChange,
                isValidNewOption: this.isValidNewOption,
                onCreateOption: this.onCreateOption,
                formatCreateLabel: this.formatCreateLabel
            })
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-select/creatable":"iiR0X","luxon":"fLWpi","../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iiR0X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreatable", ()=>(0, _useCreatableFf70B556EsmJs.u));
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _select6Efcc53AEsmJs = require("../../dist/Select-6efcc53a.esm.js");
var _useStateManager7E1E8489EsmJs = require("../../dist/useStateManager-7e1e8489.esm.js");
var _useCreatableFf70B556EsmJs = require("../../dist/useCreatable-ff70b556.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _index9F7Dc477EsmJs = require("../../dist/index-9f7dc477.esm.js");
var _react1 = require("@emotion/react");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _typeof = require("@babel/runtime/helpers/typeof");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _memoizeOne = require("memoize-one");
var CreatableSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var creatableProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    var selectProps = (0, _useCreatableFf70B556EsmJs.u)(creatableProps);
    return /*#__PURE__*/ _react.createElement((0, _select6Efcc53AEsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, selectProps));
});
exports.default = CreatableSelect;

},{"@babel/runtime/helpers/esm/extends":"lIuHI","react":"IMRgT","../../dist/Select-6efcc53a.esm.js":"5hglB","../../dist/useStateManager-7e1e8489.esm.js":"96guW","../../dist/useCreatable-ff70b556.esm.js":"jbtYN","@babel/runtime/helpers/objectSpread2":"bRaaz","@babel/runtime/helpers/classCallCheck":"fcShU","@babel/runtime/helpers/createClass":"vMnDx","@babel/runtime/helpers/inherits":"6dnmI","@babel/runtime/helpers/createSuper":"5kRad","@babel/runtime/helpers/toConsumableArray":"iebyH","../../dist/index-9f7dc477.esm.js":"j5lp9","@emotion/react":"lH1pG","@babel/runtime/helpers/taggedTemplateLiteral":"46qqA","@babel/runtime/helpers/objectWithoutProperties":"9oMCs","@babel/runtime/helpers/slicedToArray":"645an","@babel/runtime/helpers/typeof":"5h97i","@babel/runtime/helpers/defineProperty":"a1zHA","react-dom":"fODdr","@floating-ui/dom":"2hhpa","use-isomorphic-layout-effect":"6icBW","memoize-one":"5mMU6","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jbtYN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useCreatable);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _index9F7Dc477EsmJs = require("./index-9f7dc477.esm.js");
var _select6Efcc53AEsmJs = require("./Select-6efcc53a.esm.js");
var _excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function useCreatable(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, _select6Efcc53AEsmJs.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, _select6Efcc53AEsmJs.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, _react.useMemo)(function() {
        return isValidNewOption(inputValue, (0, _index9F7Dc477EsmJs.I)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, _react.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, _toConsumableArrayDefault.default)(propsOptions)) : [].concat((0, _toConsumableArrayDefault.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, _react.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, _index9F7Dc477EsmJs.D)(isMulti, [].concat((0, _toConsumableArrayDefault.default)((0, _index9F7Dc477EsmJs.I)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"dItc3","@babel/runtime/helpers/esm/toConsumableArray":"f1HoU","@babel/runtime/helpers/esm/objectWithoutProperties":"fBqaP","react":"IMRgT","./index-9f7dc477.esm.js":"j5lp9","./Select-6efcc53a.esm.js":"5hglB","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"befXR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshTextInput", ()=>SeshTextInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _seshTextRawInput = require("./sesh_text_raw_input");
function SeshTextInput(props) {
    const input = props.input_element_override ?? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextRawInput.SeshTextRawInput), {
        ...props.input_props
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `flex flex-col ${props.className ?? ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "field",
            children: [
                props.label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    className: "label",
                    children: props.label
                }),
                props.help_text && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "help mb-1",
                    children: props.help_text
                }),
                input,
                props.error_text && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "help error-text is-pulled-right",
                    children: props.error_text
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","./sesh_text_raw_input":"7BBPX","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7BBPX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshTextRawInput", ()=>SeshTextRawInput);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function SeshTextRawInput(props) {
    const [is_focused, setIsFocused] = (0, _react.useState)(false);
    const [is_hovered, setIsHovered] = (0, _react.useState)(false);
    const { right_children, ...input_props } = props;
    // TODO: handle focus on that child input
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("flex h-10 rounded-[4px] border-2  bg-base-dark text-content-primary outline-none ", props.className, {
            "input-disabled": props.disabled,
            "border-sesh-primary shadow-input-focus": is_focused,
            "border-content-secondary hover:border-sesh-dark": !is_focused
        }),
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                ...input_props,
                className: "w-full border-none bg-transparent px-[11px] py-[7px] outline-none",
                onFocus: ()=>setIsFocused(true),
                onBlur: ()=>setIsFocused(false),
                type: "text",
                value: props.value ?? "",
                placeholder: props.placeholder,
                maxLength: props.maxLength,
                onChange: props.onChange
            }),
            right_children && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-auto",
                children: right_children(is_hovered, is_focused)
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"e6cg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerButton", ()=>DatePickerButton);
parcelHelpers.export(exports, "DateForm", ()=>DateForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _chronoNode = require("chrono-node");
var _chronoNodeDefault = parcelHelpers.interopDefault(_chronoNode);
var _luxon = require("luxon");
var _timeFormatUtils = require("../../../../common/time_format_utils");
var _dashboardUtils = require("../dashboard_utils");
var _dateTimePicker = require("./date_time_picker");
var _seshTextInput = require("./improved_components/base_components/sesh_text_input");
var _seshTextRawInput = require("./improved_components/base_components/sesh_text_raw_input");
function DatePickerButton(props) {
    const [isActive, setIsActive] = (0, _react.useState)(false);
    const [date, setDate] = (0, _react.useState)(props.initial_date);
    const modal_body = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "columns is-mobile is-multiline is-centered",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-two-thirds-tablet is-full-mobile is-centered",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePicker.DateTimePicker), {
                    updateFunc: (date)=>setDate(date),
                    initial_value: date,
                    disable_past_days: !props.allow_past_days
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "is-pulled-right",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `button dashboard-primary-button--tiny is-size-6 has-text-right`,
                        type: "submit",
                        onClick: (e)=>{
                            e.preventDefault();
                            props.onSubmit(date);
                            setIsActive(false);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "has-text-weight-bold",
                            children: "Confirm"
                        })
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex h-full w-full items-center p-2 text-2xl",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    onClick: ()=>{
                        setIsActive(true);
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "far fa-calendar-alt text-sesh-primary hover:cursor-pointer hover:text-sesh-dark"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
                is_active: isActive,
                onClose: (e)=>{
                    e.preventDefault();
                    setIsActive(false);
                },
                title: "Date Picker",
                allow_overflow: true,
                subtitle: props.modal_subtitle,
                content: modal_body
            })
        ]
    });
}
class DateForm extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        let initial_date = props.initial_value;
        let initial_value = initial_date ? (0, _timeFormatUtils.time_format_utils).format_time_verbose_without_until(initial_date.setZone(props.personal_zone), null, this.props.use_24h_clock) : "";
        this.state = {
            value: initial_value,
            utc_date: props.initial_value
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    // TODO: Storing redundant state on both this form and its parent, fix??
    handleInputChange(event) {
        this.props.onInputChange?.(event.target.value);
        this.updateDate(event.target.value);
    }
    updateDateFromPicker(date) {
        const luxon_date = _luxon.DateTime.fromJSDate(date);
        const value = (0, _timeFormatUtils.time_format_utils).format_time_from_date_picker(luxon_date);
        this.props.onInputChange?.(value);
        const utc_date = luxon_date.toUTC();
        this.setState({
            value,
            utc_date
        });
        this.props.updateFunc(utc_date);
    }
    updateDate(str) {
        const message_timestamp_luxon = _luxon.DateTime.fromJSDate(new Date()).toLocal();
        const local_timezone = _luxon.DateTime.local().zone;
        const user_timezone = _luxon.IANAZone.create(this.props.personal_zone);
        const user_timezone_offset = -local_timezone.offset(message_timestamp_luxon.toMillis());
        const guild_timezone_offset = -user_timezone.offset(message_timestamp_luxon.toMillis());
        let chrono_results = (0, _chronoNodeDefault.default).parse(str, message_timestamp_luxon.plus({
            minutes: user_timezone_offset - guild_timezone_offset
        }).toJSDate(), {
            forwardDate: true
        });
        let chrono_result = chrono_results[0];
        if (this.props.use_24h_clock) (0, _timeFormatUtils.time_format_utils).refine_to_24_hour_clock(chrono_result);
        const start_time_parse_success = chrono_results !== undefined && chrono_result !== undefined && chrono_result.start !== undefined;
        let luxon_date = null;
        if (start_time_parse_success) {
            if (chrono_result.start.isCertain("timezoneOffset")) luxon_date = _luxon.DateTime.fromJSDate(chrono_result.start.date()).toUTC(chrono_result.start.get("timezoneOffset"));
            else luxon_date = _luxon.DateTime.fromJSDate(chrono_result.start.date()).minus(_luxon.Duration.fromObject({
                minutes: user_timezone_offset - guild_timezone_offset
            })).toUTC();
            if (!luxon_date.isValid) luxon_date = null;
        }
        this.setState({
            value: str,
            utc_date: luxon_date
        });
        this.props.updateFunc(luxon_date);
    }
    componentWillUnmount() {
        this.props.updateFunc(null);
    }
    render() {
        let start_time_personal;
        let start_time_guild;
        if (this.state.utc_date) {
            start_time_personal = this.state.utc_date.setZone(this.props.personal_zone);
            start_time_guild = this.state.utc_date.setZone(this.props.guild_zone);
        } else {
            start_time_personal = _luxon.DateTime.local();
            start_time_guild = _luxon.DateTime.local();
        }
        const timezone_abbr_personal = (0, _timeFormatUtils.time_format_utils).get_timezone_abbr(start_time_personal, this.props.personal_zone);
        const timezone_abbr_guild = (0, _timeFormatUtils.time_format_utils).get_timezone_abbr(start_time_guild, this.props.guild_zone);
        let does_personal_timezone_match_guild = (0, _timeFormatUtils.time_format_utils).areTimezonesEquivalent(this.props.personal_zone, this.props.guild_zone, this.state.utc_date);
        let timezone_delta_message = null;
        does_personal_timezone_match_guild;
        let output_message = null;
        const is_field_empty = !this.state.value || this.state.value.length === 0;
        const is_time_valid = Boolean(this.state.utc_date);
        if (!is_field_empty) {
            if (is_time_valid) {
                let guild_time_text;
                if (this.props.display_text) guild_time_text = (0, _timeFormatUtils.time_format_utils).format_time_verbose(start_time_guild, null, null, this.props.use_24h_clock);
                else guild_time_text = (0, _timeFormatUtils.time_format_utils).format_time_verbose(start_time_guild, this.props.personal_zone, null, this.props.use_24h_clock);
                let success_message;
                if (does_personal_timezone_match_guild) success_message = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        this.props.display_text && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                children: [
                                    this.props.display_text,
                                    " (",
                                    timezone_abbr_guild,
                                    ")"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: ` ${guild_time_text}`
                        })
                    ]
                });
                else {
                    const is_same_day = start_time_personal.hasSame(start_time_guild, "day");
                    if (is_same_day) {
                        const dual_timezone_text = (0, _timeFormatUtils.time_format_utils).format_time_verbose_dual_timezone(start_time_personal, this.props.personal_zone, this.props.guild_zone, this.props.use_24h_clock);
                        success_message = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                        children: this.props.display_text
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: ` ${dual_timezone_text}`
                                })
                            ]
                        });
                    } else {
                        const local_time_text = (0, _timeFormatUtils.time_format_utils).format_time_verbose(start_time_personal, null, null, this.props.use_24h_clock);
                        success_message = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "output-time",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                                children: [
                                                    "Local time (",
                                                    timezone_abbr_personal,
                                                    ")"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: ` ${local_time_text}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "output-time",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                                children: [
                                                    "Server time (",
                                                    timezone_abbr_guild,
                                                    ")"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: ` ${guild_time_text}`
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                }
                const in_future = this.state.utc_date.toMillis() > new Date().getTime();
                if (in_future) output_message = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "success-note mt-4",
                    children: success_message
                });
                else output_message = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "error-note mt-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "error-text has-text-weight-bold",
                            children: "Invalid Input: Time in past"
                        }),
                        success_message
                    ]
                });
            } else output_message = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "error-note mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Could not parse time"
                })
            });
        }
        let inputClassName = "input";
        if (this.props.disabled) inputClassName += " input-disabled";
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            id: this.props.id,
            className: "field",
            children: [
                this.props.name && (0, _dashboardUtils.DashboardUtils).CreateHeaderAndInfoButton(this.props.name, this.props.info, undefined, undefined, undefined, undefined, this.props.disabled),
                timezone_delta_message,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "columns is-mobile is-vcentered is-gapless",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-full",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextInput.SeshTextInput), {
                                input_element_override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshTextRawInput.SeshTextRawInput), {
                                    placeholder: this.props.placeholder,
                                    type: "text",
                                    value: this.state.value,
                                    onChange: this.handleInputChange,
                                    disabled: this.props.disabled,
                                    right_children: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "h-full w-full",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatePickerButton, {
                                                initial_date: this.state.utc_date?.toJSDate() ?? new Date(),
                                                onSubmit: (date)=>{
                                                    this.updateDateFromPicker(date);
                                                },
                                                modal_subtitle: "Select the event time using your local timezone"
                                            }, this.state.utc_date?.toISO())
                                        })
                                }),
                                input_props: {}
                            })
                        })
                    })
                }),
                output_message
            ]
        });
    }
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","chrono-node":"jT2kU","luxon":"fLWpi","../../../../common/time_format_utils":"g0uQN","../dashboard_utils":"jvA8A","./date_time_picker":"c4mcO","./improved_components/base_components/sesh_text_input":"befXR","./improved_components/base_components/sesh_text_raw_input":"7BBPX","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}]},[], null, "parcelRequire7ff5", {})

//# sourceMappingURL=dashboard.1bfe8c0d.js.map
